// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: `${string}://${string}` | (string & {})
}

/**
 * * `ORD` - ORD
 * * `FULLPAID` - FULLPAID
 * * `PARTPAID` - PARTPAID
 * * `DEFER` - DEFER
 * * `EQU` - EQU
 * * `PAIDSUBSHS` - PAIDSUBSHS
 * * `STAPLED` - STAPLED
 * * `REDEM` - REDEM
 * * `ORDSUBR` - ORDSUBR
 * * `PRF` - PRF
 * * `PREFERRED` - PREFERRED
 * * `CPR` - CPR
 * * `CUM` - CUM
 * * `NONCUM` - NONCUM
 * * `REDEEM` - REDEEM
 * * `PRFSUBR` - PRFSUBR
 * * `ADR` - ADR
 * * `DRC` - DRC
 * * `GDR` - GDR
 * * `BDR` - BDR
 * * `CEDEAR` - CEDEAR
 * * `CHESS` - CHESS
 * * `DEPOSITSHS` - DEPOSITSHS
 */
export const AssetClassEnum = {
  ORD: 'ORD',
  FULLPAID: 'FULLPAID',
  PARTPAID: 'PARTPAID',
  DEFER: 'DEFER',
  EQU: 'EQU',
  PAIDSUBSHS: 'PAIDSUBSHS',
  STAPLED: 'STAPLED',
  REDEM: 'REDEM',
  ORDSUBR: 'ORDSUBR',
  PRF: 'PRF',
  PREFERRED: 'PREFERRED',
  CPR: 'CPR',
  CUM: 'CUM',
  NONCUM: 'NONCUM',
  REDEEM: 'REDEEM',
  PRFSUBR: 'PRFSUBR',
  ADR: 'ADR',
  DRC: 'DRC',
  GDR: 'GDR',
  BDR: 'BDR',
  CEDEAR: 'CEDEAR',
  CHESS: 'CHESS',
  DEPOSITSHS: 'DEPOSITSHS',
} as const

/**
 * * `ORD` - ORD
 * * `FULLPAID` - FULLPAID
 * * `PARTPAID` - PARTPAID
 * * `DEFER` - DEFER
 * * `EQU` - EQU
 * * `PAIDSUBSHS` - PAIDSUBSHS
 * * `STAPLED` - STAPLED
 * * `REDEM` - REDEM
 * * `ORDSUBR` - ORDSUBR
 * * `PRF` - PRF
 * * `PREFERRED` - PREFERRED
 * * `CPR` - CPR
 * * `CUM` - CUM
 * * `NONCUM` - NONCUM
 * * `REDEEM` - REDEEM
 * * `PRFSUBR` - PRFSUBR
 * * `ADR` - ADR
 * * `DRC` - DRC
 * * `GDR` - GDR
 * * `BDR` - BDR
 * * `CEDEAR` - CEDEAR
 * * `CHESS` - CHESS
 * * `DEPOSITSHS` - DEPOSITSHS
 */
export type AssetClassEnum = (typeof AssetClassEnum)[keyof typeof AssetClassEnum]

export type AssignProposalCategoryRequest = {
  /**
   * The proxy intermediary this category belongs to.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * The id of the transparency proposal this category belongs to.
   */
  transparency_proposal_id: string
  /**
   * The free-text category to assign to the proposal. An empty category deletes any existing category for the proposal. Max length 100 characters.
   */
  proposal_category: string
}

export type AssignProposalCategoryResponse = {
  /**
   * The proxy intermediary this category belongs to.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * The id of the transparency proposal this category refers to.
   */
  transparency_proposal_id: string
  /**
   * The free-text category assigned to the proposal.
   */
  proposal_category: string
}

export type AssignProposalLabelRequest = {
  /**
   * The proxy intermediary from which this label was sourced.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * The label used by the proxy intermediary to identify the proposal, stored as-is. An empty label deletes any existing label for the proposal. Max length 100 characters.
   */
  proposal_label: string
  /**
   * The resource name of the transparency proposal, in the format 'organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}'.
   */
  transparency_proposal_name: string
  /**
   * DEPRECATED. Use the ProposalCategory entity. The ISS category code for the proposal (e.g. 'M0276'), stored as-is.
   *
   * @deprecated
   */
  proposal_category?: string
  /**
   * The fields to update on an existing label. An empty mask updates the label; the deprecated proposal_category is no longer written.
   */
  update_mask?: Array<UpdateMaskEnum>
}

export type AssignProposalLabelResponse = {
  /**
   * The proxy intermediary from which this label was sourced.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * The assigned proposal label.
   */
  proposal_label: string
  /**
   * The resource name of the transparency proposal this label refers to.
   */
  transparency_proposal_name: string
  /**
   * DEPRECATED. Use the ProposalCategory entity. The ISS category code for the proposal.
   *
   * @deprecated
   */
  proposal_category: string
}

export type AuditEvent = {
  /**
   * The audit event resource name, of the form 'auditEvents/{uuid}'.
   */
  readonly name: string
  /**
   * The name of the entity that was audited, in the form '{entity_name}/{entity_id}/...' e.g. 'organizations/{uuid}/generalMeetings/{uuid}'.
   */
  readonly entity_name: string
  /**
   * The original entity, serialised into JSON. '{}' when there is no original entity.
   */
  readonly original_entity_json: string
  /**
   * The difference between the original entity and the new entity, as a JSON merge patch (RFC 7396). '{}' when there is no patch.
   */
  readonly patch_json: string
  /**
   * The time the audit event was created.
   */
  readonly create_time: Date
  /**
   * The name of the endpoint that triggered the change to the data entity.
   */
  readonly endpoint_name: string
  /**
   * The pseudonymous identifier of the user that triggered the change to the data entity.
   */
  readonly username: string
}

/**
 * Request body for searching audit events.
 *
 * Domain validation (entity name and audit event name formats) is delegated
 * to the filter so behaviour matches the previous query-param-based list
 * endpoint exactly; this serializer only validates the request shape.
 */
export type AuditEventSearchRequestRequest = {
  entity_name?: string
  audit_event_names?: Array<string>
}

/**
 * * `institutional` - Institutional
 * * `retail` - Retail
 * * `retail_ptv` - Retail PTV
 */
export const AvailableToInvestorTypeEnum = {
  INSTITUTIONAL: 'institutional',
  RETAIL: 'retail',
  RETAIL_PTV: 'retail_ptv',
} as const

/**
 * * `institutional` - Institutional
 * * `retail` - Retail
 * * `retail_ptv` - Retail PTV
 */
export type AvailableToInvestorTypeEnum = (typeof AvailableToInvestorTypeEnum)[keyof typeof AvailableToInvestorTypeEnum]

export type Ballot = {
  /**
   * Unique identifier of the ballot, stable across all versions.
   */
  id: string
  /**
   * Resource name of the ballot, in the format 'proxyIntermediaries/{uuid}/ballots/{uuid}'.
   */
  name: string
  /**
   * Unique identifier of the meeting this ballot is for.
   */
  proxy_intermediary_meeting_id: string
  /**
   * Resource name of the meeting this ballot is for, 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  proxy_intermediary_meeting_name: string
  /**
   * The proxy intermediary this ballot belongs to, as a typed enum.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum | null
  /**
   * The identifier of the ballot in the proxy intermediary's system (in Broadridge's ProxyEdge the 'Control Number'). Maximum length 250 characters.
   */
  external_id: string
  /**
   * The time the ballot was created in Tumelo's system, stable across all versions.
   */
  create_time: Date
  /**
   * The time this version of the ballot was created (equivalent to an update time).
   */
  version_create_time: Date
  /**
   * Unique identifier of this version of the ballot; changes each time the ballot is updated.
   */
  version_id: string
  /**
   * Whether this version is the current, visible state of the ballot.
   */
  version_is_current: boolean
  /**
   * Public security ID of the security that gives rise to this ballot, in the form 'securityIDTypes/{type}/securityIDs/{value}'.
   */
  owned_public_security_id: string
  /**
   * The custodian account this ballot is for.
   */
  custodian_account: CustodianAccountReference
  /**
   * The time the ballot was cancelled; set when it should no longer be considered active.
   */
  cancel_time: Date | null
  /**
   * Number of shares eligible for voting, excluding shares on loan or otherwise ineligible.
   */
  eligible_shares: bigint
  /**
   * The date and time votes are to be submitted to the proxy intermediary by for this ballot.
   */
  submission_deadline: Date
  /**
   * The date and time the ballot is valid for. A valid_time before the most recent one is not visible.
   */
  valid_time: Date
  /**
   * Computed deadlines for this ballot version.
   */
  deadlines: Deadlines | null
  /**
   * The id (SHA256 hash) of the proposal set this ballot's votes apply to.
   */
  proposal_set_id: string | null
  /**
   * The id of the agenda this ballot is for in Broadridge's system.
   */
  broadridge_agenda_id: string | null
  /**
   * Whether voted shares are blocked from trading until the vote is revoked. Applies to global markets.
   */
  is_blocking: boolean
}

/**
 * * `BALLOT_CANCELLED_FILTER_ALL` - BALLOT_CANCELLED_FILTER_ALL
 * * `BALLOT_CANCELLED_FILTER_NOT_CANCELLED` - BALLOT_CANCELLED_FILTER_NOT_CANCELLED
 * * `BALLOT_CANCELLED_FILTER_CANCELLED` - BALLOT_CANCELLED_FILTER_CANCELLED
 */
export const BallotCancelledFilterEnum = {
  BALLOT_CANCELLED_FILTER_ALL: 'BALLOT_CANCELLED_FILTER_ALL',
  BALLOT_CANCELLED_FILTER_NOT_CANCELLED: 'BALLOT_CANCELLED_FILTER_NOT_CANCELLED',
  BALLOT_CANCELLED_FILTER_CANCELLED: 'BALLOT_CANCELLED_FILTER_CANCELLED',
} as const

/**
 * * `BALLOT_CANCELLED_FILTER_ALL` - BALLOT_CANCELLED_FILTER_ALL
 * * `BALLOT_CANCELLED_FILTER_NOT_CANCELLED` - BALLOT_CANCELLED_FILTER_NOT_CANCELLED
 * * `BALLOT_CANCELLED_FILTER_CANCELLED` - BALLOT_CANCELLED_FILTER_CANCELLED
 */
export type BallotCancelledFilterEnum = (typeof BallotCancelledFilterEnum)[keyof typeof BallotCancelledFilterEnum]

/**
 * Serializer for BallotEntitlement responses.
 */
export type BallotEntitlement = {
  readonly id: string
  proxy_intermediary_ballot_id: string
  investor_account_id: string
  readonly ballot_breakdown_metadata_id: string | null
  ballot_proportion: number
  investor_supported_issued_instrument_id?: string | null
  investor_policy_supported_issued_instrument_id?: string | null
  fund_manager_policy_supported_issued_instrument_id?: string | null
  readonly create_time: Date
  readonly update_time: Date
  invalid_time?: Date | null
}

/**
 * Serializer for ballot voting information.
 */
export type BallotInvestorsCanVote = {
  /**
   * Number of investor accounts expected to vote on this ballot
   */
  num_investor_accounts_expected_to_vote: number
  /**
   * List of investor accounts expected to vote with their fund proportions
   */
  investor_accounts: Array<InvestorAccountVoteInfo>
  /**
   * Whether this ballot requires investigation due to potentially missing or inaccurate entitlements
   */
  requires_investigation: boolean
  /**
   * Reason why investigation is required (empty if not required)
   */
  requires_investigation_reason: string
}

export type BallotListResponse = {
  /**
   * The ballots.
   */
  ballots: Array<Ballot>
}

export type BallotProposal = {
  /**
   * Unique identifier for the proposal
   */
  readonly id: string
  /**
   * The SHA256 hash of the Proposals in the set. Fields hashed: proxy_intermediary_meeting_id,broadridge_agenda_id, label, text, voting_options, source, management_recommendation,sequence_number, is_opposition, director_number, vote_group, vote_group_max_for, vote_group_max,category_code, withdrawn
   */
  proposal_set_id: string
  /**
   * The alphanumeric label for the proposal within the meeting. eg (1a, A, 1)
   */
  label: string
  /**
   * The human-readable text of the proposal.
   */
  text: string
  /**
   * The set of valid voting options for this proposal.
   */
  voting_options: Array<ProxyIntermediaryVotingOptionsEnum>
  /**
   * The tenant's current instruction on this proposal for the ballot being listed; null when the proposal has not been instructed.
   */
  voting_instruction: BallotProposalVotingInstruction | null
  /**
   * The proposal's category; null when the proposal has not been categorised.
   */
  category: PiProposalCategoryEnum | null
  /**
   * The proposal's subcategory; null when it has none or has not been categorised.
   */
  subcategory: PiProposalSubcategoryEnum | null
  /**
   * The topics the proposal relates to; null when the proposal has not been categorised.
   */
  readonly topics: Array<PiProposalTopicEnum> | null
  /**
   * Who proposed this: 'management' or 'shareholder'.
   *
   * * `management` - Management
   * * `shareholder` - Shareholder
   */
  source: ProxyIntermediaryProposalSourceEnum
  /**
   * The management voting recommendation (e.g. 'for', 'against').
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `no_action` - No Action
   * * `do_not_vote` - Do Not Vote
   */
  management_recommendation?: ProxyIntermediaryVotingOptionsEnum | null
  /**
   * The ordering sequence for the proposals from the proxy intermediary
   */
  sequence_number?: number | null
}

/**
 * How a proposal is currently instructed, as carried on the proposal it belongs to.
 */
export type BallotProposalVotingInstruction = {
  /**
   * How the tenant instructed the proposal.
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `no_action` - No Action
   * * `do_not_vote` - Do Not Vote
   */
  response: ProxyIntermediaryVotingOptionsEnum
  /**
   * How the instruction was arrived at: 'automatic' or 'manual'.
   *
   * * `automatic` - Automatic
   * * `manual` - Manual
   */
  vote_method: VoteMethodEnum
  /**
   * Time the instruction last changed.
   */
  readonly update_time: Date
}

export type BallotProposalsResponse = {
  proposals: Array<BallotProposal>
}

export type BallotStampSearchRequestRequest = {
  /**
   * Restrict to stamps recorded against this proxy intermediary ballot.
   */
  pi_ballot_id?: string
  /**
   * Restrict to stamps recording this rule's findings.
   */
  rule_id?: string
  /**
   * Restrict to stamps the rule matched through this custody account group.
   */
  custody_account_group_id?: string
  /**
   * Restrict to stamps asserting this.
   *
   * * `conflict_of_interest` - Conflict Of Interest
   * * `do_not_vote` - Do Not Vote
   * * `membership` - Membership
   */
  stamp_type?: StampTypeEnum
}

/**
 * * `STATUS_BALLOT_INVALID` - STATUS_BALLOT_INVALID
 * * `STATUS_BALLOT_CREATED` - STATUS_BALLOT_CREATED
 * * `STATUS_BALLOT_UPDATED` - STATUS_BALLOT_UPDATED
 * * `STATUS_BALLOT_NO_OPERATION` - STATUS_BALLOT_NO_OPERATION
 */
export const BallotStatusEnum = {
  STATUS_BALLOT_INVALID: 'STATUS_BALLOT_INVALID',
  STATUS_BALLOT_CREATED: 'STATUS_BALLOT_CREATED',
  STATUS_BALLOT_UPDATED: 'STATUS_BALLOT_UPDATED',
  STATUS_BALLOT_NO_OPERATION: 'STATUS_BALLOT_NO_OPERATION',
} as const

/**
 * * `STATUS_BALLOT_INVALID` - STATUS_BALLOT_INVALID
 * * `STATUS_BALLOT_CREATED` - STATUS_BALLOT_CREATED
 * * `STATUS_BALLOT_UPDATED` - STATUS_BALLOT_UPDATED
 * * `STATUS_BALLOT_NO_OPERATION` - STATUS_BALLOT_NO_OPERATION
 */
export type BallotStatusEnum = (typeof BallotStatusEnum)[keyof typeof BallotStatusEnum]

export type BallotUpsertRequest = {
  /**
   * The identifier of the ballot in the proxy intermediary's system (in Broadridge's ProxyEdge the 'Control Number'). Maximum length 250 characters.
   */
  external_id: string
  /**
   * Public security ID of the security that gives rise to this ballot, in the form 'securityIDTypes/{type}/securityIDs/{value}'.
   */
  owned_public_security_id?: string
  /**
   * The custodian account this ballot is for.
   */
  custodian_account: CustodianAccountReferenceRequest
  /**
   * Number of shares eligible for voting, excluding shares on loan or otherwise ineligible.
   */
  eligible_shares: bigint
  /**
   * The date and time votes are to be submitted to the proxy intermediary by for this ballot.
   */
  submission_deadline: Date
  /**
   * The date and time the ballot is valid for. A valid_time before the most recent one is not visible.
   */
  valid_time: Date
  /**
   * Set to cancel the ballot; a cancelled ballot should no longer be considered active.
   */
  cancel_time?: Date | null
  /**
   * The id (SHA256 hash) of the proposal set this ballot's votes apply to.
   */
  proposal_set_id?: string | null
  /**
   * The id of the agenda this ballot is for in Broadridge's system.
   */
  broadridge_agenda_id?: string | null
  /**
   * Whether voted shares are blocked from trading until the vote is revoked. Applies to global markets.
   */
  is_blocking?: boolean
}

export type BatchIsinsToOrganizationNamesRequestRequest = {
  isins: Array<string>
  only_with_voting_rights?: boolean
}

export type BatchIsinsToOrganizationNamesResponse = {
  isins_to_organization_names: {
    [key: string]: string
  }
}

export type BatchVoterWithHoldingsInputRequest = {
  /**
   * List of voters with their holdings
   */
  voters: Array<VoterWithHoldingsInputRequest>
}

export type BatchVoterWithHoldingsResponse = {
  /**
   * Newly created voters
   */
  created: Array<VoterResponse>
  /**
   * Updated voters
   */
  updated: Array<VoterResponse>
}

/**
 * * `refer` - Refer
 * * `not_refer` - Not Refer
 */
export const BeaconReferStatusEnum = { REFER: 'refer', NOT_REFER: 'not_refer' } as const

/**
 * * `refer` - Refer
 * * `not_refer` - Not Refer
 */
export type BeaconReferStatusEnum = (typeof BeaconReferStatusEnum)[keyof typeof BeaconReferStatusEnum]

/**
 * * `for` - For
 * * `against` - Against
 * * `withhold` - Withhold
 * * `abstain` - Abstain
 * * `1_year` - One Year
 * * `2_year` - Two Year
 * * `3_year` - Three Year
 * * `no_applicable_rule` - No Applicable Rule
 * * `no_vote_outcome` - No Vote Outcome
 */
export const BeaconVoteOutcomeEnum = {
  FOR: 'for',
  AGAINST: 'against',
  WITHHOLD: 'withhold',
  ABSTAIN: 'abstain',
  '1_YEAR': '1_year',
  '2_YEAR': '2_year',
  '3_YEAR': '3_year',
  NO_APPLICABLE_RULE: 'no_applicable_rule',
  NO_VOTE_OUTCOME: 'no_vote_outcome',
} as const

/**
 * * `for` - For
 * * `against` - Against
 * * `withhold` - Withhold
 * * `abstain` - Abstain
 * * `1_year` - One Year
 * * `2_year` - Two Year
 * * `3_year` - Three Year
 * * `no_applicable_rule` - No Applicable Rule
 * * `no_vote_outcome` - No Vote Outcome
 */
export type BeaconVoteOutcomeEnum = (typeof BeaconVoteOutcomeEnum)[keyof typeof BeaconVoteOutcomeEnum]

/**
 * * `tumelo` - tumelo
 * * `wikipedia` - wikipedia
 */
export const BioSourceEnum = { TUMELO: 'tumelo', WIKIPEDIA: 'wikipedia' } as const

/**
 * * `tumelo` - tumelo
 * * `wikipedia` - wikipedia
 */
export type BioSourceEnum = (typeof BioSourceEnum)[keyof typeof BioSourceEnum]

/**
 * Response serializer for ballot breakdown computation result.
 */
export type BreakdownResponse = {
  /**
   * Breakdown metadata including ballot ID, security ISIN, and filters
   */
  metadata: {
    [key: string]: unknown
  }
  /**
   * Statistics about the breakdown (node counts, edge counts, etc.)
   */
  statistics: {
    [key: string]: unknown
  }
  /**
   * NetworkX graph in node-link JSON format
   */
  graph: {
    [key: string]: unknown
  }
}

export type CastVoteRequestRequest = {
  /**
   * Proposals and vote instructions for the ballot; the proposal set must be covered exactly.
   */
  proposal_votes: Array<ProposalVoteRequest>
}

export type CastVoteResponse = {
  instructions: Array<DirectVoteInstruction>
}

/**
 * Individual component difference in a composition
 */
export type ComponentDiff = {
  /**
   * Name of the organization
   */
  organization_name?: string | null
  /**
   * ISIN identifier for the holding
   */
  isin: string
  /**
   * Holding's Classification of Financial Instruments (CFI) code
   */
  cfi?: string | null
  /**
   * Status of the component (UNCHANGED, ADDED, or REMOVED)
   *
   * * `UNCHANGED` - UNCHANGED
   * * `ADDED` - ADDED
   * * `REMOVED` - REMOVED
   * * `FILTERED` - FILTERED
   */
  status: ComponentDiffStatusEnum
  /**
   * Reasons why the component was filtered
   */
  filter_reasons: Array<FilterReasonsEnum>
  /**
   * Name of the voting policy in format 'votingPolicies/{uuid}'
   */
  voting_policy_name?: string | null
  /**
   * Start date of this component diff
   */
  start_date: Date
}

/**
 * Individual component difference in a composition
 */
export type ComponentDiffRequest = {
  /**
   * Name of the organization
   */
  organization_name?: string | null
  /**
   * ISIN identifier for the holding
   */
  isin: string
  /**
   * Holding's Classification of Financial Instruments (CFI) code
   */
  cfi?: string | null
  /**
   * Status of the component (UNCHANGED, ADDED, or REMOVED)
   *
   * * `UNCHANGED` - UNCHANGED
   * * `ADDED` - ADDED
   * * `REMOVED` - REMOVED
   * * `FILTERED` - FILTERED
   */
  status: ComponentDiffStatusEnum
  /**
   * Reasons why the component was filtered
   */
  filter_reasons: Array<FilterReasonsEnum>
  /**
   * Name of the voting policy in format 'votingPolicies/{uuid}'
   */
  voting_policy_name?: string | null
  /**
   * Start date of this component diff
   */
  start_date: Date
}

/**
 * * `UNCHANGED` - UNCHANGED
 * * `ADDED` - ADDED
 * * `REMOVED` - REMOVED
 * * `FILTERED` - FILTERED
 */
export const ComponentDiffStatusEnum = {
  UNCHANGED: 'UNCHANGED',
  ADDED: 'ADDED',
  REMOVED: 'REMOVED',
  FILTERED: 'FILTERED',
} as const

/**
 * * `UNCHANGED` - UNCHANGED
 * * `ADDED` - ADDED
 * * `REMOVED` - REMOVED
 * * `FILTERED` - FILTERED
 */
export type ComponentDiffStatusEnum = (typeof ComponentDiffStatusEnum)[keyof typeof ComponentDiffStatusEnum]

/**
 * Response serializer for composition differences
 */
export type CompositionDifferenceResponse = {
  /**
   * Name of the investor who holds this diff
   */
  investor_name: string
  /**
   * List of component differences
   */
  components: Array<ComponentDiff>
}

/**
 * * `institutional` - institutional
 * * `retail` - retail
 * * `all` - all
 */
export const ComputeBreakdownRequestInvestorTypeEnum = {
  INSTITUTIONAL: 'institutional',
  RETAIL: 'retail',
  ALL: 'all',
} as const

/**
 * * `institutional` - institutional
 * * `retail` - retail
 * * `all` - all
 */
export type ComputeBreakdownRequestInvestorTypeEnum =
  (typeof ComputeBreakdownRequestInvestorTypeEnum)[keyof typeof ComputeBreakdownRequestInvestorTypeEnum]

/**
 * Request serializer for computing ballot breakdown.
 */
export type ComputeBreakdownRequestRequest = {
  /**
   * ID of the proxy intermediary ballot
   */
  proxy_intermediary_ballot_id: string
  /**
   * Start of the validity window (ISO 8601 format). If not provided, defaults to VAT - 1 day
   */
  valid_from?: Date | null
  /**
   * End of the validity window (ISO 8601 format). If not provided, defaults to VAT
   */
  valid_to?: Date | null
  /**
   * Type of investor: 'institutional', 'retail', or 'all' for all investor types
   *
   * * `institutional` - institutional
   * * `retail` - retail
   * * `all` - all
   */
  investor_type: ComputeBreakdownRequestInvestorTypeEnum
}

export type CreateProposalRequest = {
  /**
   * The proxy intermediary meeting this proposal belongs to.
   */
  proxy_intermediary_meeting_id: string
  /**
   * The id of the agenda these proposals were sourced from in Broadridge's system.
   */
  broadridge_agenda_id?: string | null
  /**
   * The alphanumeric label for the proposal within the meeting. eg (1a, A, 1)
   */
  label: string
  /**
   * The human-readable text of the proposal.
   */
  text: string
  /**
   * The set of valid voting options for this proposal.
   */
  voting_options?: Array<ProxyIntermediaryVotingOptionsEnum>
  /**
   * Who proposed this: 'management' or 'shareholder'.
   *
   * * `management` - Management
   * * `shareholder` - Shareholder
   */
  source: ProxyIntermediaryProposalSourceEnum
  /**
   * The management voting recommendation (e.g. 'for', 'against').
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `no_action` - No Action
   * * `do_not_vote` - Do Not Vote
   */
  management_recommendation?: ProxyIntermediaryVotingOptionsEnum | null
  /**
   * The ordering sequence for the proposals from the proxy intermediary
   */
  sequence_number?: number | null
  /**
   * Whether the proposal was put to the meeting by an opposing party rather than by the issuer.
   */
  is_opposition?: boolean
  /**
   * The position of the director within a slate election, as reported by the proxy intermediary.
   */
  director_number?: number | null
  /**
   * The identifier of the group of proposals this proposal is voted within. Proposals sharing a group share a limit on how many of them may be voted.
   */
  vote_group?: number | null
  /**
   * The maximum number of proposals in the vote group that may be voted 'for'.
   */
  vote_group_max_for?: number | null
  /**
   * The maximum number of proposals in the vote group that may be voted, whatever the voting option.
   */
  vote_group_max?: number | null
  /**
   * The category code of the proposal.
   */
  category_code?: string | null
  /**
   * Whether the proxy intermediary reported the proposal as withdrawn from the meeting's agenda.
   */
  withdrawn?: boolean
}

export type CreateProposalsRequest = {
  /**
   * The proposals to create.
   */
  proposals: Array<CreateProposalRequest>
}

export type CreateProposalsResponse = {
  proposals: Array<ProxyIntermediaryProposal>
}

/**
 * * `CURRENTLY_VOTABLE_FILTER_UNSPECIFIED` - CURRENTLY_VOTABLE_FILTER_UNSPECIFIED
 * * `CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE
 * * `CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE
 */
export const CurrentlyVotableFilterEnum = {
  CURRENTLY_VOTABLE_FILTER_UNSPECIFIED: 'CURRENTLY_VOTABLE_FILTER_UNSPECIFIED',
  CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE: 'CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE',
  CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE: 'CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE',
} as const

/**
 * * `CURRENTLY_VOTABLE_FILTER_UNSPECIFIED` - CURRENTLY_VOTABLE_FILTER_UNSPECIFIED
 * * `CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE
 * * `CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE
 */
export type CurrentlyVotableFilterEnum = (typeof CurrentlyVotableFilterEnum)[keyof typeof CurrentlyVotableFilterEnum]

export type CustodianAccountReference = {
  /**
   * Unique, unchanging identifier for the custodian.
   */
  custodian_id: string
  /**
   * The account number of the custodian account.
   */
  account_number: string
  /**
   * The title of the custodian for display purposes.
   */
  custodian_title?: string
}

export type CustodianAccountReferenceRequest = {
  /**
   * Unique, unchanging identifier for the custodian.
   */
  custodian_id: string
  /**
   * The account number of the custodian account.
   */
  account_number: string
  /**
   * The title of the custodian for display purposes.
   */
  custodian_title?: string
}

export type CustodyAccount = {
  /**
   * Unique identifier for the custody account.
   */
  readonly id: string
  /**
   * The proxy intermediary that reported this custody account.
   */
  proxy_intermediary_id: string
  /**
   * Identifier of the custodian (institution) holding the account within the proxy intermediary
   *
   * also known as custodian_account_id.
   */
  custodian_id: string
  /**
   * Account number identifying the asset owner's account (e.g. a fund) at the custodian holding it, as reported by a proxy intermediary. Unique only in combination with the custodian within the reporting proxy intermediary.
   */
  custodian_account_number: string
  /**
   * title of the custodian account for display purposes.
   */
  title: string
  /**
   * The time the custody account was created.
   */
  readonly create_time: Date
  /**
   * The time the custody account was last updated.
   */
  readonly update_time: Date
}

/**
 * A custody account group of the acting tenant; the tenant is taken from the request, never the body.
 */
export type CustodyAccountGroup = {
  /**
   * Unique identifier for the custody account group.
   */
  readonly id: string
  /**
   * Free-text label that names the group within its tenant.
   */
  title: string
  /**
   * The time the group was created.
   */
  readonly create_time: Date
  /**
   * The time the group was last updated.
   */
  readonly update_time: Date
}

/**
 * Read/write serializer for the current version of one custody account's place in a group.
 */
export type CustodyAccountGroupMembership = {
  /**
   * Identity id of the membership, stable across versions.
   */
  readonly id: string
  /**
   * Id of this version row.
   */
  readonly version_id: string
  /**
   * The custody account group the account belongs to.
   */
  group_id: string
  /**
   * The custody account that belongs to the group.
   */
  custody_account_id: string
  /**
   * Monotonic version number of this membership.
   */
  readonly version_number: number
  /**
   * Time the account joined the group.
   */
  readonly create_time: Date
  /**
   * Time the account was removed from the group; null while it is still a member.
   */
  readonly delete_time: Date | null
}

/**
 * Read/write serializer for the current version of one custody account's place in a group.
 */
export type CustodyAccountGroupMembershipRequest = {
  /**
   * The custody account group the account belongs to.
   */
  group_id: string
  /**
   * The custody account that belongs to the group.
   */
  custody_account_id: string
}

export type CustodyAccountGroupMembershipSearchRequestRequest = {
  /**
   * Restrict to memberships of this custody account group.
   */
  group_id?: string
  /**
   * Restrict to memberships holding this custody account.
   */
  custody_account_id?: string
  /**
   * Include the memberships that have been removed, alongside the current ones.
   */
  include_removed?: boolean
}

/**
 * A custody account group of the acting tenant; the tenant is taken from the request, never the body.
 */
export type CustodyAccountGroupRequest = {
  /**
   * Free-text label that names the group within its tenant.
   */
  title: string
}

export type CustodyAccountGroupSearchRequestRequest = {
  /**
   * Filter by group title - exact match.
   */
  title?: string
}

export type CustodyAccountRequest = {
  /**
   * The proxy intermediary that reported this custody account.
   */
  proxy_intermediary_id: string
  /**
   * Identifier of the custodian (institution) holding the account within the proxy intermediary
   *
   * also known as custodian_account_id.
   */
  custodian_id: string
  /**
   * Account number identifying the asset owner's account (e.g. a fund) at the custodian holding it, as reported by a proxy intermediary. Unique only in combination with the custodian within the reporting proxy intermediary.
   */
  custodian_account_number: string
  /**
   * title of the custodian account for display purposes.
   */
  title: string
}

export type CustodyAccountSearchRequestRequest = {
  /**
   * Filter by proxy intermediary identifier - exact match.
   */
  proxy_intermediary_id?: string
  /**
   * Filter by custodian identifier - exact match.
   */
  custodian_id?: string
  /**
   * Filter by custodian account number - exact match.
   */
  custodian_account_number?: string
}

export type CustodyAccountTenantLink = {
  /**
   * Unique identifier for the custody account tenant link.
   */
  readonly id: string
  /**
   * The tenant that owns the custody account.
   */
  tenant: string
  /**
   * The custody account owned by the tenant.
   */
  custody_account: string
  /**
   * The time the link was created.
   */
  readonly create_time: Date
  /**
   * The time the link was last updated.
   */
  readonly update_time: Date
}

export type CustodyAccountTenantLinkRequestRequest = {
  /**
   * Unique identifier for the Tenant
   */
  tenant: string
  /**
   * Unique identifier for the custody account.
   */
  custody_account: string
}

export type CustodyAccountTenantLinkUnlinkRequestRequest = {
  /**
   * Unique identifier for the custody account.
   */
  custody_account: string
}

/**
 * Read/write serializer for the current version of a custody account voting policy selection.
 */
export type CustodyAccountVotingPolicySelection = {
  /**
   * Identity id of the selection, stable across versions.
   */
  readonly id: string
  /**
   * Id of this version row.
   */
  readonly version_id: string
  /**
   * The tenant that votes under this policy selection.
   */
  tenant_id: string
  /**
   * The custody account the voting policy applies to. Immutable once set.
   */
  custody_account_id: string
  /**
   * The voting policy the custody account votes under.
   */
  voting_policy_id: string
  /**
   * Monotonic version number of this selection.
   */
  readonly version_number: number
  /**
   * Time this selection version was created.
   */
  readonly create_time: Date
}

/**
 * Read/write serializer for the current version of a custody account voting policy selection.
 */
export type CustodyAccountVotingPolicySelectionRequest = {
  /**
   * The tenant that votes under this policy selection.
   */
  tenant_id: string
  /**
   * The custody account the voting policy applies to. Immutable once set.
   */
  custody_account_id: string
  /**
   * The voting policy the custody account votes under.
   */
  voting_policy_id: string
}

export type CustodyAccountVotingPolicySelectionSearchRequestRequest = {
  /**
   * Restrict to selections for this tenant.
   */
  tenant_id?: string
  /**
   * Restrict to selections for this custody account.
   */
  custody_account_id?: string
  /**
   * Restrict to selections for this voting policy.
   */
  voting_policy_id?: string
}

export type Deadlines = {
  /**
   * Unique identifier of this ballot deadlines record.
   */
  id: string
  /**
   * The submission deadline adjusted by the voting-deadline working-day offset.
   */
  investor_voting_deadline: Date
  /**
   * The earliest of the meeting's record date (if present) or the investor voting deadline adjusted by the minimum vote-allocation offset.
   */
  vote_allocation_time: Date
  /**
   * The vote allocation time adjusted by the vote allocation window working-day offset.
   */
  vote_allocation_window_start_time: Date
  /**
   * When this ballot's deadlines were initially calculated.
   */
  created_at: Date
}

/**
 * * `PROPOSAL_OUTCOME_DECISION_FOR` - PROPOSAL_OUTCOME_DECISION_FOR
 * * `PROPOSAL_OUTCOME_DECISION_AGAINST` - PROPOSAL_OUTCOME_DECISION_AGAINST
 * * `PROPOSAL_OUTCOME_DECISION_WITHDRAWN` - PROPOSAL_OUTCOME_DECISION_WITHDRAWN
 * * `PROPOSAL_OUTCOME_DECISION_ONE_YEAR` - PROPOSAL_OUTCOME_DECISION_ONE_YEAR
 * * `PROPOSAL_OUTCOME_DECISION_TWO_YEARS` - PROPOSAL_OUTCOME_DECISION_TWO_YEARS
 * * `PROPOSAL_OUTCOME_DECISION_THREE_YEARS` - PROPOSAL_OUTCOME_DECISION_THREE_YEARS
 */
export const DecisionEnum = {
  PROPOSAL_OUTCOME_DECISION_FOR: 'PROPOSAL_OUTCOME_DECISION_FOR',
  PROPOSAL_OUTCOME_DECISION_AGAINST: 'PROPOSAL_OUTCOME_DECISION_AGAINST',
  PROPOSAL_OUTCOME_DECISION_WITHDRAWN: 'PROPOSAL_OUTCOME_DECISION_WITHDRAWN',
  PROPOSAL_OUTCOME_DECISION_ONE_YEAR: 'PROPOSAL_OUTCOME_DECISION_ONE_YEAR',
  PROPOSAL_OUTCOME_DECISION_TWO_YEARS: 'PROPOSAL_OUTCOME_DECISION_TWO_YEARS',
  PROPOSAL_OUTCOME_DECISION_THREE_YEARS: 'PROPOSAL_OUTCOME_DECISION_THREE_YEARS',
} as const

/**
 * * `PROPOSAL_OUTCOME_DECISION_FOR` - PROPOSAL_OUTCOME_DECISION_FOR
 * * `PROPOSAL_OUTCOME_DECISION_AGAINST` - PROPOSAL_OUTCOME_DECISION_AGAINST
 * * `PROPOSAL_OUTCOME_DECISION_WITHDRAWN` - PROPOSAL_OUTCOME_DECISION_WITHDRAWN
 * * `PROPOSAL_OUTCOME_DECISION_ONE_YEAR` - PROPOSAL_OUTCOME_DECISION_ONE_YEAR
 * * `PROPOSAL_OUTCOME_DECISION_TWO_YEARS` - PROPOSAL_OUTCOME_DECISION_TWO_YEARS
 * * `PROPOSAL_OUTCOME_DECISION_THREE_YEARS` - PROPOSAL_OUTCOME_DECISION_THREE_YEARS
 */
export type DecisionEnum = (typeof DecisionEnum)[keyof typeof DecisionEnum]

export type DeleteProposalSetRequest = {
  /**
   * The id of the proposal set to delete.
   */
  proposal_set_id: string
}

/**
 * * `TUMELO` - TUMELO
 * * `PIRC` - PIRC
 * * `GLASS_LEWIS` - GLASS_LEWIS
 * * `MINERVA` - MINERVA
 * * `ISS` - ISS
 * * `EOS` - EOS
 * * `ISS_RETAIL` - ISS_RETAIL
 */
export const DiffFormatEnum = {
  TUMELO: 'TUMELO',
  PIRC: 'PIRC',
  GLASS_LEWIS: 'GLASS_LEWIS',
  MINERVA: 'MINERVA',
  ISS: 'ISS',
  EOS: 'EOS',
  ISS_RETAIL: 'ISS_RETAIL',
} as const

/**
 * * `TUMELO` - TUMELO
 * * `PIRC` - PIRC
 * * `GLASS_LEWIS` - GLASS_LEWIS
 * * `MINERVA` - MINERVA
 * * `ISS` - ISS
 * * `EOS` - EOS
 * * `ISS_RETAIL` - ISS_RETAIL
 */
export type DiffFormatEnum = (typeof DiffFormatEnum)[keyof typeof DiffFormatEnum]

/**
 * Read serializer for the current version of a direct vote instruction.
 */
export type DirectVoteInstruction = {
  /**
   * Identity id of the instruction, stable across versions.
   */
  readonly id: string
  /**
   * Id of this version row.
   */
  readonly version_id: string
  /**
   * The tenant the instruction was cast on behalf of.
   */
  readonly tenant_id: string
  /**
   * The proxy intermediary ballot the instruction was cast against.
   */
  readonly pi_ballot_id: string
  /**
   * The proxy intermediary proposal the instruction was cast on.
   */
  readonly pi_proposal_id: string
  /**
   * How the tenant instructed the proposal.
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `no_action` - No Action
   * * `do_not_vote` - Do Not Vote
   */
  response: ProxyIntermediaryVotingOptionsEnum
  /**
   * How the instruction was arrived at: 'automatic' or 'manual'.
   *
   * * `automatic` - Automatic
   * * `manual` - Manual
   */
  vote_method: VoteMethodEnum
  /**
   * Identifies the set of instructions written by one cast of the ballot.
   */
  readonly vote_instruction_set_id: string
  /**
   * Monotonic version number of this instruction.
   */
  readonly version_number: number
  /**
   * Time this instruction version was created.
   */
  readonly create_time: Date
}

/**
 * Read serializer for the current version of a ballot stamp.
 *
 * The tenant is taken from the acting-tenant header rather than the body, so it is not a field.
 */
export type DirectVotingBallotStamp = {
  /**
   * Identity id of the stamp, stable across versions.
   */
  readonly id: string
  /**
   * Id of this version row.
   */
  readonly version_id: string
  /**
   * Identity id of the proxy intermediary ballot the stamp was recorded against.
   */
  readonly pi_ballot_id: string
  /**
   * Identity id of the rule whose finding the stamp records.
   */
  readonly rule_id: string
  /**
   * Id of the custody account group the rule matched the ballot through, or null when it did not match through a group.
   */
  readonly custody_account_group_id: string | null
  /**
   * What the stamp asserts about the ballot: 'conflict_of_interest', 'do_not_vote' or 'membership'.
   *
   * * `conflict_of_interest` - Conflict Of Interest
   * * `do_not_vote` - Do Not Vote
   * * `membership` - Membership
   */
  stamp_type: StampTypeEnum
  /**
   * The human-facing label the stamp carries: the group's title for a 'membership' stamp, null for the other types. Never holds personally identifiable information.
   */
  readonly stamp_label: string | null
  /**
   * Monotonic version number of this stamp.
   */
  readonly version_number: number
  /**
   * Time this stamp version was created.
   */
  readonly create_time: Date
}

/**
 * Current version of a ballot workflow item; ``id`` is the identity, stable across versions.
 *
 * ``pi_ballot_id`` and ``custody_account_group_id`` are fixed once the item is created.
 * ``assigned_by_id`` is never written by the caller: the server records the acting user whenever
 * ``assigned_to_id`` changes.
 */
export type DirectVotingBallotWorkflowItem = {
  /**
   * Identity id of the workflow item, stable across versions.
   */
  readonly id: string
  /**
   * Id of this version row.
   */
  readonly version_id: string
  /**
   * Identity id of the proxy intermediary ballot the workflow item tracks. Immutable once set.
   */
  pi_ballot_id: string
  /**
   * Id of the acting tenant's custody account group the item covers the ballot for, or null for the ballot as a whole. Immutable once set.
   */
  custody_account_group_id?: string | null
  /**
   * Whether the ballot must be reviewed before it is instructed. Defaults to false.
   */
  review_required?: boolean
  /**
   * Id of the acting tenant's user the ballot is assigned to, or null to leave it unassigned.
   */
  assigned_to_id?: string | null
  /**
   * Id of the user who made the current assignment, or null when the ballot is unassigned.
   */
  readonly assigned_by_id: string | null
  /**
   * Monotonic version number of this workflow item.
   */
  readonly version_number: number
  /**
   * Time this workflow item version was created.
   */
  readonly create_time: Date
}

/**
 * Current version of a ballot workflow item; ``id`` is the identity, stable across versions.
 *
 * ``pi_ballot_id`` and ``custody_account_group_id`` are fixed once the item is created.
 * ``assigned_by_id`` is never written by the caller: the server records the acting user whenever
 * ``assigned_to_id`` changes.
 */
export type DirectVotingBallotWorkflowItemRequest = {
  /**
   * Identity id of the proxy intermediary ballot the workflow item tracks. Immutable once set.
   */
  pi_ballot_id: string
  /**
   * Id of the acting tenant's custody account group the item covers the ballot for, or null for the ballot as a whole. Immutable once set.
   */
  custody_account_group_id?: string | null
  /**
   * Whether the ballot must be reviewed before it is instructed. Defaults to false.
   */
  review_required?: boolean
  /**
   * Id of the acting tenant's user the ballot is assigned to, or null to leave it unassigned.
   */
  assigned_to_id?: string | null
}

export type DirectVotingBallotWorkflowItemSearchRequestRequest = {
  /**
   * Restrict to the workflow item tracking this proxy intermediary ballot.
   */
  pi_ballot_id?: string
  /**
   * Restrict to items for this custody account group, or null for ballot-level items.
   */
  custody_account_group_id?: string | null
  /**
   * Restrict to items that do (true) or do not (false) require review.
   */
  review_required?: boolean
  /**
   * Restrict to items assigned to this user.
   */
  assigned_to_id?: string
  /**
   * Restrict to items whose current assignment this user made.
   */
  assigned_by_id?: string
  /**
   * Restrict to items that are assigned to someone (true) or unassigned (false).
   */
  assigned?: boolean
}

/**
 * Current version of a Beacon rule output with its current proposal results.
 *
 * An instance must come from ``beacon_rule_outputs``, which prefetches the proposal results this reads.
 */
export type DirectVotingBeaconRuleOutput = {
  /**
   * Identity id of the rule output, stable across versions.
   */
  readonly id: string
  /**
   * Id of this version row.
   */
  readonly version_id: string
  /**
   * Identity id of the proxy intermediary ballot Beacon evaluated.
   */
  readonly pi_ballot_id: string
  /**
   * The id (SHA256 hash) of the proposal set the evaluated ballot version pointed at.
   */
  readonly proposal_set_id: string
  /**
   * Whether Beacon referred the ballot for review: 'refer' when any of its proposals was referred, 'not_refer' otherwise.
   *
   * * `refer` - Refer
   * * `not_refer` - Not Refer
   */
  refer_status: BeaconReferStatusEnum
  /**
   * The id of the Beacon voting policy result this output was reported from. Opaque here: it names a record in Beacon, not one in this database.
   */
  readonly beacon_voting_policy_result_id: string
  /**
   * Monotonic version number of this output.
   */
  readonly version_number: number
  /**
   * Time this output version was created.
   */
  readonly create_time: Date
  /**
   * The output's current proposal results, ordered by proposal sequence number.
   */
  readonly proposals: Array<DirectVotingBeaconRuleOutputProposal>
}

export type DirectVotingBeaconRuleOutputProposal = {
  /**
   * Identity id of the proposal result, stable across versions.
   */
  readonly id: string
  /**
   * Id of the proxy intermediary proposal the result is for.
   */
  readonly pi_proposal_id: string
  /**
   * The proposal's label within its proposal set, e.g. '1a'.
   */
  readonly proposal_label: string
  /**
   * The overall vote outcome Beacon reached for the proposal, in Beacon's vocabulary.
   *
   * * `for` - For
   * * `against` - Against
   * * `withhold` - Withhold
   * * `abstain` - Abstain
   * * `1_year` - One Year
   * * `2_year` - Two Year
   * * `3_year` - Three Year
   * * `no_applicable_rule` - No Applicable Rule
   * * `no_vote_outcome` - No Vote Outcome
   */
  outcome: BeaconVoteOutcomeEnum
  /**
   * Whether Beacon referred the proposal for review: 'refer' or 'not_refer'.
   *
   * * `refer` - Refer
   * * `not_refer` - Not Refer
   */
  refer_status: BeaconReferStatusEnum
  /**
   * Beacon's free-text explanation of the outcome, or null when it gave none. Describes the proposal, never a person.
   */
  readonly rationale: string | null
  /**
   * Monotonic version number of this proposal result.
   */
  readonly version_number: number
  /**
   * Time this proposal result version was created.
   */
  readonly create_time: Date
}

export type DirectVotingBeaconRuleOutputProposalResultRequest = {
  /**
   * Id of the proxy intermediary proposal Beacon evaluated; must be a proposal in the output's proposal set.
   */
  pi_proposal_id: string
  /**
   * The overall vote outcome Beacon reached for the proposal, in Beacon's vocabulary.
   *
   * * `for` - For
   * * `against` - Against
   * * `withhold` - Withhold
   * * `abstain` - Abstain
   * * `1_year` - One Year
   * * `2_year` - Two Year
   * * `3_year` - Three Year
   * * `no_applicable_rule` - No Applicable Rule
   * * `no_vote_outcome` - No Vote Outcome
   */
  outcome: BeaconVoteOutcomeEnum
  /**
   * Whether Beacon referred the proposal for review.
   *
   * * `refer` - Refer
   * * `not_refer` - Not Refer
   */
  refer_status: BeaconReferStatusEnum
  /**
   * Beacon's free-text explanation of the outcome. Omitted or null records no rationale, clearing one stored earlier.
   */
  rationale?: string | null
}

export type DirectVotingBeaconRuleOutputSearchRequestRequest = {
  /**
   * Restrict to outputs for this proxy intermediary ballot.
   */
  pi_ballot_id?: string
  /**
   * Restrict to outputs for this proposal set.
   */
  proposal_set_id?: string
  /**
   * Restrict to outputs with this refer status.
   *
   * * `refer` - Refer
   * * `not_refer` - Not Refer
   */
  refer_status?: BeaconReferStatusEnum
}

/**
 * One whole Beacon evaluation of a ballot.
 *
 * The output's ``refer_status`` is derived from its proposals', so a ``refer_status`` sent at the top
 * level is ignored.
 */
export type DirectVotingBeaconRuleOutputUpsertRequest = {
  /**
   * Identity id of the proxy intermediary ballot Beacon evaluated.
   */
  pi_ballot_id: string
  /**
   * The id of the proposal set the evaluated ballot version pointed at; a past version's set is accepted.
   */
  proposal_set_id: string
  /**
   * The id of the Beacon voting policy result this output was reported from.
   */
  beacon_voting_policy_result_id: string
  /**
   * What Beacon concluded about each proposal it evaluated, at most once per proposal. Every pi_proposal_id must name a proposal in the proposal set, but the set need not be covered: a current result whose proposal is left out is closed.
   */
  proposals: Array<DirectVotingBeaconRuleOutputProposalResultRequest>
}

/**
 * * `custody_account_group_membership` - Custody Account Group Membership
 * * `conflict_of_interest` - Conflict Of Interest
 * * `do_not_vote` - Do Not Vote
 * * `custody_account_group_isin_watchlist` - Custody Account Group Isin Watchlist
 * * `custody_account_group_watchlist` - Custody Account Group Watchlist
 * * `policy_refer` - Policy Refer
 */
export const DirectVotingRuleTypeEnum = {
  CUSTODY_ACCOUNT_GROUP_MEMBERSHIP: 'custody_account_group_membership',
  CONFLICT_OF_INTEREST: 'conflict_of_interest',
  DO_NOT_VOTE: 'do_not_vote',
  CUSTODY_ACCOUNT_GROUP_ISIN_WATCHLIST: 'custody_account_group_isin_watchlist',
  CUSTODY_ACCOUNT_GROUP_WATCHLIST: 'custody_account_group_watchlist',
  POLICY_REFER: 'policy_refer',
} as const

/**
 * * `custody_account_group_membership` - Custody Account Group Membership
 * * `conflict_of_interest` - Conflict Of Interest
 * * `do_not_vote` - Do Not Vote
 * * `custody_account_group_isin_watchlist` - Custody Account Group Isin Watchlist
 * * `custody_account_group_watchlist` - Custody Account Group Watchlist
 * * `policy_refer` - Policy Refer
 */
export type DirectVotingRuleTypeEnum = (typeof DirectVotingRuleTypeEnum)[keyof typeof DirectVotingRuleTypeEnum]

/**
 * Read/write serializer for the current version of a rule.
 *
 * The tenant is taken from the acting-tenant header rather than the body, so it is not a field.
 */
export type DirectVotingRulesEngineRule = {
  /**
   * Identity id of the rule, stable across versions.
   */
  readonly id: string
  /**
   * Id of this version row.
   */
  readonly version_id: string
  /**
   * Identity id of the rules list the rule belongs to. Fixed once the rule is created.
   */
  rules_list_id: string
  /**
   * Free-text label that names the rule.
   */
  title: string
  /**
   * Which parameter model and processor the rule's engine applies to its params.
   *
   * * `custody_account_group_membership` - Custody Account Group Membership
   * * `conflict_of_interest` - Conflict Of Interest
   * * `do_not_vote` - Do Not Vote
   * * `custody_account_group_isin_watchlist` - Custody Account Group Isin Watchlist
   * * `custody_account_group_watchlist` - Custody Account Group Watchlist
   * * `policy_refer` - Policy Refer
   */
  rule_type: DirectVotingRuleTypeEnum
  /**
   * JSON object holding the rule's parameters. Its contents are interpreted by the engine that evaluates the rule, not here.
   */
  params?: unknown
  /**
   * Monotonic version number of this rule.
   */
  readonly version_number: number
  /**
   * Time this rule version was created.
   */
  readonly create_time: Date
}

/**
 * Read/write serializer for the current version of a rule.
 *
 * The tenant is taken from the acting-tenant header rather than the body, so it is not a field.
 */
export type DirectVotingRulesEngineRuleRequest = {
  /**
   * Identity id of the rules list the rule belongs to. Fixed once the rule is created.
   */
  rules_list_id: string
  /**
   * Free-text label that names the rule.
   */
  title: string
  /**
   * Which parameter model and processor the rule's engine applies to its params.
   *
   * * `custody_account_group_membership` - Custody Account Group Membership
   * * `conflict_of_interest` - Conflict Of Interest
   * * `do_not_vote` - Do Not Vote
   * * `custody_account_group_isin_watchlist` - Custody Account Group Isin Watchlist
   * * `custody_account_group_watchlist` - Custody Account Group Watchlist
   * * `policy_refer` - Policy Refer
   */
  rule_type: DirectVotingRuleTypeEnum
  /**
   * JSON object holding the rule's parameters. Its contents are interpreted by the engine that evaluates the rule, not here.
   */
  params?: unknown
}

export type DirectVotingRulesEngineRuleSearchRequestRequest = {
  /**
   * Restrict to rules held by this rules list.
   */
  rules_list_id?: string
  /**
   * Restrict to rules of this type.
   *
   * * `custody_account_group_membership` - Custody Account Group Membership
   * * `conflict_of_interest` - Conflict Of Interest
   * * `do_not_vote` - Do Not Vote
   * * `custody_account_group_isin_watchlist` - Custody Account Group Isin Watchlist
   * * `custody_account_group_watchlist` - Custody Account Group Watchlist
   * * `policy_refer` - Policy Refer
   */
  rule_type?: DirectVotingRuleTypeEnum
}

/**
 * Read/write serializer for the current version of a rules list.
 *
 * The tenant is taken from the acting-tenant header rather than the body, so it is not a field.
 */
export type DirectVotingRulesEngineRulesList = {
  /**
   * Identity id of the rules list, stable across versions.
   */
  readonly id: string
  /**
   * Id of this version row.
   */
  readonly version_id: string
  /**
   * The rules engine that evaluates the list's rules. Fixed once the list is created.
   *
   * * `ballot_stamping` - Ballot Stamping
   * * `ballot_review` - Ballot Review
   */
  rules_engine: RulesEngineEnum
  /**
   * Free-text label that names the list within its engine.
   */
  title: string
  /**
   * Monotonic version number of this rules list.
   */
  readonly version_number: number
  /**
   * Time this rules list version was created.
   */
  readonly create_time: Date
}

/**
 * Read/write serializer for the current version of a rules list.
 *
 * The tenant is taken from the acting-tenant header rather than the body, so it is not a field.
 */
export type DirectVotingRulesEngineRulesListRequest = {
  /**
   * The rules engine that evaluates the list's rules. Fixed once the list is created.
   *
   * * `ballot_stamping` - Ballot Stamping
   * * `ballot_review` - Ballot Review
   */
  rules_engine: RulesEngineEnum
  /**
   * Free-text label that names the list within its engine.
   */
  title: string
}

export type DirectVotingRulesEngineRulesListSearchRequestRequest = {
  /**
   * Restrict to rules lists evaluated by this rules engine.
   *
   * * `ballot_stamping` - Ballot Stamping
   * * `ballot_review` - Ballot Review
   */
  rules_engine?: RulesEngineEnum
  /**
   * Filter by rules list title - exact match.
   */
  title?: string
}

/**
 * Read/write serializer for the current version of a watchlist.
 *
 * The tenant is taken from the acting-tenant header rather than the body, so it is not a field.
 */
export type DirectVotingWatchlist = {
  /**
   * Identity id of the watchlist, stable across versions.
   */
  readonly id: string
  /**
   * Id of this version row.
   */
  readonly version_id: string
  /**
   * Free-text label that names the watchlist within its tenant.
   */
  title: string
  /**
   * Optional free-text account of what the watchlist tracks.
   */
  description?: string | null
  /**
   * Monotonic version number of this watchlist.
   */
  readonly version_number: number
  /**
   * Time this watchlist version was created.
   */
  readonly create_time: Date
}

/**
 * Read/write serializer for one version of an issuer's place on a watchlist.
 *
 * ``issuer_id`` is write-only; a response names the issuer under ``issuer``, so an instance must
 * come from ``watchlist_items``, which carries the annotations it reads.
 */
export type DirectVotingWatchlistItem = {
  /**
   * Identity id of the watchlist item, stable across versions.
   */
  readonly id: string
  /**
   * Id of this version row.
   */
  readonly version_id: string
  /**
   * Identity id of the watchlist the issuer is on.
   */
  watchlist_id: string
  /**
   * The issuer on the watchlist.
   */
  issuer: DirectVotingWatchlistItemIssuer
  /**
   * Monotonic version number of this watchlist item.
   */
  readonly version_number: number
  /**
   * Time the issuer was put on the watchlist.
   */
  readonly create_time: Date
}

/**
 * Issuers to put on one watchlist.
 *
 * ``issuer_ids`` validates to the distinct ids in first-occurrence order.
 */
export type DirectVotingWatchlistItemBatchUpsertRequest = {
  /**
   * Identity id of the watchlist to put the issuers on.
   */
  watchlist_id: string
  /**
   * Identity ids of the issuers to put on the watchlist, at most 1000. A repeated id is ignored.
   */
  issuer_ids: Array<string>
}

export type DirectVotingWatchlistItemBatchUpsertResponse = {
  /**
   * The current item of each issuer on the watchlist, in the order the request named them.
   */
  items: Array<DirectVotingWatchlistItem>
}

/**
 * The issuer on a watchlist item, named as its current version names it.
 *
 * Reads the ``issuer_*`` annotations ``watchlist_items`` puts on each item.
 */
export type DirectVotingWatchlistItemIssuer = {
  /**
   * Identity id of the issuer, stable across versions.
   */
  readonly id: string
  /**
   * The issuer's common name; null when unknown.
   */
  readonly display_name: string | null
  /**
   * The issuer's registered legal name; null when unknown.
   */
  readonly legal_name: string | null
  /**
   * The LSEG OrgPermID of the issuer.
   */
  readonly org_perm_id: string
}

/**
 * Read/write serializer for one version of an issuer's place on a watchlist.
 *
 * ``issuer_id`` is write-only; a response names the issuer under ``issuer``, so an instance must
 * come from ``watchlist_items``, which carries the annotations it reads.
 */
export type DirectVotingWatchlistItemRequest = {
  /**
   * Identity id of the watchlist the issuer is on.
   */
  watchlist_id: string
}

export type DirectVotingWatchlistItemSearchRequestRequest = {
  /**
   * Restrict to items on this watchlist.
   */
  watchlist_id?: string
  /**
   * Restrict to items holding this issuer.
   */
  issuer_id?: string
}

/**
 * Read/write serializer for the current version of a watchlist.
 *
 * The tenant is taken from the acting-tenant header rather than the body, so it is not a field.
 */
export type DirectVotingWatchlistRequest = {
  /**
   * Free-text label that names the watchlist within its tenant.
   */
  title: string
  /**
   * Optional free-text account of what the watchlist tracks.
   */
  description?: string | null
}

export type DirectVotingWatchlistSearchRequestRequest = {
  /**
   * Filter by watchlist title - exact match.
   */
  title?: string
}

/**
 * * `ASC` - ASC
 * * `DESC` - DESC
 */
export const DirectionEnum = { ASC: 'ASC', DESC: 'DESC' } as const

/**
 * * `ASC` - ASC
 * * `DESC` - DESC
 */
export type DirectionEnum = (typeof DirectionEnum)[keyof typeof DirectionEnum]

export type Exchange = {
  readonly id: string
  /**
   * The exchange's ISO 10383 MIC code.
   */
  readonly code: string
  /**
   * The name of the exchange.
   */
  readonly name: string | null
  /**
   * The country the exchange operates in. ISO 3166-1 alpha-2 country code.
   */
  readonly country: string | null
}

/**
 * Serializer for export result response.
 */
export type ExportResult = {
  /**
   * S3 bucket name where the exported CSV file is stored
   */
  s3_bucket: string
  /**
   * S3 key (path) of the exported CSV file
   */
  s3_key: string
  /**
   * Number of rows exported (0 if unavailable)
   */
  row_count: number
  /**
   * Timestamp when export was executed
   */
  exported_at: Date
}

export type ExternalMeetingId = {
  /**
   * Unique identifier for this external meeting ID mapping.
   */
  id: string
  /**
   * The identifier used by the external provider.
   */
  external_meeting_id: string
  /**
   * The name of the external provider (e.g. EDI, Broadridge).
   */
  provider: string
  /**
   * The UUID of the internal general meeting.
   */
  general_meeting_id: string
  /**
   * The time this mapping was created.
   */
  create_time: Date
}

export type ExternalMeetingIdCreateRequest = {
  /**
   * The identifier used by the external provider.
   */
  external_meeting_id: string
  /**
   * The name of the external provider (e.g. EDI, Broadridge).
   */
  provider: string
  /**
   * The UUID of the internal general meeting.
   */
  general_meeting_id: string
}

export type FetchByVersionIdsRequestRequest = {
  /**
   * The version ids of the ballots to fetch.
   */
  ids: Array<string>
}

export type FetchLatestBroadridgeProposalSetRequest = {
  /**
   * The id of the Broadridge agenda the proposal set was sourced from.
   */
  broadridge_agenda_id: string
}

export type FetchLatestBroadridgeProposalSetResponse = {
  /**
   * The id of the proposal set sourced from the Broadridge agenda.
   */
  proposal_set_id: string
}

export type FetchLatestProxymityProposalSetRequest = {
  /**
   * The id of the meeting in Proxymity's system, as stored on the meeting's external_id.
   */
  proxy_intermediary_meeting_external_id: string
}

export type FetchLatestProxymityProposalSetResponse = {
  /**
   * The id of the latest proposal set for the Proxymity meeting.
   */
  proposal_set_id: string
}

export type FetchMinimalInstrumentsRequestRequest = {
  isins: Array<string>
}

export type FetchMinimalInstrumentsResponse = {
  instruments: Array<MinimalInstrument>
}

export type FetchProposalLabelsRequest = {
  /**
   * The proxy intermediary to fetch labels for.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * The resource names of the transparency proposals to fetch labels for, each in the format 'organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}'.
   */
  transparency_proposal_names: Array<string>
}

export type FetchProposalLabelsResponse = {
  /**
   * The proxy intermediary the labels were fetched for.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * Map of transparency proposal name to its label. Proposals without a label are omitted.
   */
  proposal_name_and_label: {
    [key: string]: string
  }
  /**
   * DEPRECATED. Use the ProposalCategory entity. Map of transparency proposal name to its category. Proposals without a label are omitted.
   *
   * @deprecated
   */
  proposal_name_and_category: {
    [key: string]: string
  }
}

/**
 * * `NEW_PORTFOLIO_INVESTMENT` - NEW_PORTFOLIO_INVESTMENT
 * * `NOT_HELD_IN_PORTFOLIO` - NOT_HELD_IN_PORTFOLIO
 * * `POA_MARKET` - POA_MARKET
 * * `NON_SPLIT_VOTING_COUNTRY` - NON_SPLIT_VOTING_COUNTRY
 * * `OUT_OF_SCOPE_ISIN` - OUT_OF_SCOPE_ISIN
 * * `UNSUPPORTED_CFI_CODE` - UNSUPPORTED_CFI_CODE
 */
export const FilterReasonsEnum = {
  NEW_PORTFOLIO_INVESTMENT: 'NEW_PORTFOLIO_INVESTMENT',
  NOT_HELD_IN_PORTFOLIO: 'NOT_HELD_IN_PORTFOLIO',
  POA_MARKET: 'POA_MARKET',
  NON_SPLIT_VOTING_COUNTRY: 'NON_SPLIT_VOTING_COUNTRY',
  OUT_OF_SCOPE_ISIN: 'OUT_OF_SCOPE_ISIN',
  UNSUPPORTED_CFI_CODE: 'UNSUPPORTED_CFI_CODE',
} as const

/**
 * * `NEW_PORTFOLIO_INVESTMENT` - NEW_PORTFOLIO_INVESTMENT
 * * `NOT_HELD_IN_PORTFOLIO` - NOT_HELD_IN_PORTFOLIO
 * * `POA_MARKET` - POA_MARKET
 * * `NON_SPLIT_VOTING_COUNTRY` - NON_SPLIT_VOTING_COUNTRY
 * * `OUT_OF_SCOPE_ISIN` - OUT_OF_SCOPE_ISIN
 * * `UNSUPPORTED_CFI_CODE` - UNSUPPORTED_CFI_CODE
 */
export type FilterReasonsEnum = (typeof FilterReasonsEnum)[keyof typeof FilterReasonsEnum]

export type FiscalYear = {
  /**
   * Identity id of the fiscal year, stable across versions.
   */
  readonly id: string
  /**
   * Id of this version row.
   */
  readonly version_id: string
  /**
   * Identity id of the issuer the period is reported for.
   */
  readonly issuer_id: string
  /**
   * The last day of the fiscal period the figures are reported for.
   */
  readonly period_end_date: Date
  /**
   * The fiscal year the period belongs to, as the issuer labels it.
   */
  readonly fiscal_year: number | null
  /**
   * The calendar month the issuer's fiscal year ends in, 1 to 12.
   */
  readonly fiscal_year_end_month: number | null
  /**
   * The date of the financial statement the figures are taken from.
   */
  readonly statement_date: Date | null
  /**
   * The date the issuer announced the period's results.
   */
  readonly announced_date: Date | null
  /**
   * Whether the figures are preliminary rather than from audited accounts.
   */
  readonly is_preliminary: boolean | null
  /**
   * Whether the period is a transition period from a change of fiscal year end.
   */
  readonly is_transition_period: boolean | null
  /**
   * Whether a balance sheet was reported for the period.
   */
  readonly has_balance_sheet: boolean | null
  /**
   * The currency the monetary figures are reported in. ISO 4217 currency code.
   */
  readonly currency: string | null
  /**
   * Debt due within one year, excluding the current portion of long-term debt.
   */
  readonly short_term_debt: string | null
  /**
   * The portion of long-term debt due within one year.
   */
  readonly current_portion_long_term_debt: string | null
  /**
   * Debt due after more than one year.
   */
  readonly long_term_debt: string | null
  /**
   * Total shareholders' equity.
   */
  readonly total_equity: string | null
  /**
   * Redeemable non-controlling interests.
   */
  readonly redeemable_nci: string | null
  /**
   * Redeemable preferred stock.
   */
  readonly redeemable_preferred: string | null
  /**
   * Total liabilities.
   */
  readonly total_liabilities: string | null
  /**
   * Total assets.
   */
  readonly total_assets: string | null
  /**
   * The basic weighted average number of shares outstanding over the period.
   */
  readonly basic_weighted_avg_shares: bigint | null
  /**
   * The number of shares outstanding at the period end.
   */
  readonly period_end_shares: bigint | null
  /**
   * The factor that adjusts the period's share counts for splits since the period end.
   */
  readonly split_adjustment_factor: string | null
  /**
   * The date of the most recent split the adjustment factor accounts for.
   */
  readonly split_adjustment_date: Date | null
  /**
   * The number of shares outstanding in the issuer's first share class.
   */
  readonly class_1_shares: string | null
  /**
   * The number of primary shares one share of the first class converts to.
   */
  readonly class_1_conversion_factor: string | null
  /**
   * The ISIN of the issuer's first share class.
   */
  readonly class_1_isin: string | null
  /**
   * The number of shares outstanding in the issuer's second share class.
   */
  readonly class_2_shares: string | null
  /**
   * The number of primary shares one share of the second class converts to.
   */
  readonly class_2_conversion_factor: string | null
  /**
   * The ISIN of the issuer's second share class.
   */
  readonly class_2_isin: string | null
  /**
   * The number of shares outstanding in the issuer's third share class.
   */
  readonly class_3_shares: string | null
  /**
   * The number of primary shares one share of the third class converts to.
   */
  readonly class_3_conversion_factor: string | null
  /**
   * The ISIN of the issuer's third share class.
   */
  readonly class_3_isin: string | null
  /**
   * The number of shares outstanding in the issuer's fourth share class.
   */
  readonly class_4_shares: string | null
  /**
   * The number of primary shares one share of the fourth class converts to.
   */
  readonly class_4_conversion_factor: string | null
  /**
   * The ISIN of the issuer's fourth share class.
   */
  readonly class_4_isin: string | null
  /**
   * Whether the issuer has a policy to reduce its emissions.
   */
  readonly policy_emissions: boolean | null
  /**
   * Whether the total CO2e figure is estimated rather than reported.
   */
  readonly co2e_total_is_estimate: boolean | null
  /**
   * Whether the ESG figures cover only part of the period.
   */
  readonly esg_period_incomplete: boolean | null
  /**
   * Scope 1 emissions, in tonnes of CO2 equivalent.
   */
  readonly co2e_scope1_tonnes: string | null
  /**
   * Scope 2 emissions, in tonnes of CO2 equivalent.
   */
  readonly co2e_scope2_tonnes: string | null
  /**
   * Total scope 1 and 2 emissions, in tonnes of CO2 equivalent.
   */
  readonly co2e_total_tonnes: string | null
  /**
   * Total emissions in tonnes of CO2 equivalent per million USD of revenue.
   */
  readonly co2e_per_usd_m_revenue: string | null
  /**
   * The method used to estimate the total CO2e figure, when it is an estimate.
   */
  readonly co2e_estimation_method: string | null
  /**
   * The date the ESG figures were received from the data provider.
   */
  readonly esg_received_date: Date | null
  /**
   * Monotonic version number of this fiscal year.
   */
  readonly version_number: number
  /**
   * Time this fiscal year version was created.
   */
  readonly create_time: Date
}

/**
 * The issuer whose fiscal years to list, named by exactly one of its two ids.
 */
export type FiscalYearSearchRequestRequest = {
  /**
   * Identity id of the issuer whose fiscal years to return.
   */
  issuer_id?: string
  /**
   * LSEG OrgPermID of the issuer whose fiscal years to return.
   */
  org_perm_id?: string
}

/**
 * A fiscal year to write, resolved by the issuer and the period it ends.
 *
 * A field left out carries forward from the current version and a field sent
 * as null is set to null.
 */
export type FiscalYearUpsertRequestRequest = {
  /**
   * Identity id of the issuer the period is reported for.
   */
  issuer_id: string
  /**
   * The last day of the fiscal period the figures are reported for.
   */
  period_end_date: Date
  /**
   * The fiscal year the period belongs to, as the issuer labels it.
   */
  fiscal_year?: number | null
  /**
   * The calendar month the issuer's fiscal year ends in, 1 to 12.
   */
  fiscal_year_end_month?: number | null
  /**
   * The date of the financial statement the figures are taken from.
   */
  statement_date?: Date | null
  /**
   * The date the issuer announced the period's results.
   */
  announced_date?: Date | null
  /**
   * Whether the figures are preliminary rather than from audited accounts.
   */
  is_preliminary?: boolean | null
  /**
   * Whether the period is a transition period from a change of fiscal year end.
   */
  is_transition_period?: boolean | null
  /**
   * Whether a balance sheet was reported for the period.
   */
  has_balance_sheet?: boolean | null
  /**
   * The currency the monetary figures are reported in. ISO 4217 currency code.
   */
  currency?: string | null
  /**
   * Debt due within one year, excluding the current portion of long-term debt.
   */
  short_term_debt?: string | null
  /**
   * The portion of long-term debt due within one year.
   */
  current_portion_long_term_debt?: string | null
  /**
   * Debt due after more than one year.
   */
  long_term_debt?: string | null
  /**
   * Total shareholders' equity.
   */
  total_equity?: string | null
  /**
   * Redeemable non-controlling interests.
   */
  redeemable_nci?: string | null
  /**
   * Redeemable preferred stock.
   */
  redeemable_preferred?: string | null
  /**
   * Total liabilities.
   */
  total_liabilities?: string | null
  /**
   * Total assets.
   */
  total_assets?: string | null
  /**
   * The basic weighted average number of shares outstanding over the period.
   */
  basic_weighted_avg_shares?: bigint | null
  /**
   * The number of shares outstanding at the period end.
   */
  period_end_shares?: bigint | null
  /**
   * The factor that adjusts the period's share counts for splits since the period end.
   */
  split_adjustment_factor?: string | null
  /**
   * The date of the most recent split the adjustment factor accounts for.
   */
  split_adjustment_date?: Date | null
  /**
   * The number of shares outstanding in the issuer's first share class.
   */
  class_1_shares?: string | null
  /**
   * The number of primary shares one share of the first class converts to.
   */
  class_1_conversion_factor?: string | null
  /**
   * The ISIN of the issuer's first share class.
   */
  class_1_isin?: string | null
  /**
   * The number of shares outstanding in the issuer's second share class.
   */
  class_2_shares?: string | null
  /**
   * The number of primary shares one share of the second class converts to.
   */
  class_2_conversion_factor?: string | null
  /**
   * The ISIN of the issuer's second share class.
   */
  class_2_isin?: string | null
  /**
   * The number of shares outstanding in the issuer's third share class.
   */
  class_3_shares?: string | null
  /**
   * The number of primary shares one share of the third class converts to.
   */
  class_3_conversion_factor?: string | null
  /**
   * The ISIN of the issuer's third share class.
   */
  class_3_isin?: string | null
  /**
   * The number of shares outstanding in the issuer's fourth share class.
   */
  class_4_shares?: string | null
  /**
   * The number of primary shares one share of the fourth class converts to.
   */
  class_4_conversion_factor?: string | null
  /**
   * The ISIN of the issuer's fourth share class.
   */
  class_4_isin?: string | null
  /**
   * Whether the issuer has a policy to reduce its emissions.
   */
  policy_emissions?: boolean | null
  /**
   * Whether the total CO2e figure is estimated rather than reported.
   */
  co2e_total_is_estimate?: boolean | null
  /**
   * Whether the ESG figures cover only part of the period.
   */
  esg_period_incomplete?: boolean | null
  /**
   * Scope 1 emissions, in tonnes of CO2 equivalent.
   */
  co2e_scope1_tonnes?: string | null
  /**
   * Scope 2 emissions, in tonnes of CO2 equivalent.
   */
  co2e_scope2_tonnes?: string | null
  /**
   * Total scope 1 and 2 emissions, in tonnes of CO2 equivalent.
   */
  co2e_total_tonnes?: string | null
  /**
   * Total emissions in tonnes of CO2 equivalent per million USD of revenue.
   */
  co2e_per_usd_m_revenue?: string | null
  /**
   * The method used to estimate the total CO2e figure, when it is an estimate.
   */
  co2e_estimation_method?: string | null
  /**
   * The date the ESG figures were received from the data provider.
   */
  esg_received_date?: Date | null
}

export type FiscalYearUpsertResponse = {
  /**
   * The stable id of the fiscal year, unchanged across versions.
   */
  readonly fiscal_year_id: string
  /**
   * Whether the fiscal year was created, versioned, left unchanged, or ignored because final figures are already held for the period.
   *
   * * `STATUS_CREATED` - STATUS_CREATED
   * * `STATUS_UPDATED` - STATUS_UPDATED
   * * `STATUS_NO_OPERATION` - STATUS_NO_OPERATION
   * * `STATUS_PRELIMINARY_IGNORED` - STATUS_PRELIMINARY_IGNORED
   */
  status: FiscalYearUpsertStatusEnum
}

/**
 * * `STATUS_CREATED` - STATUS_CREATED
 * * `STATUS_UPDATED` - STATUS_UPDATED
 * * `STATUS_NO_OPERATION` - STATUS_NO_OPERATION
 * * `STATUS_PRELIMINARY_IGNORED` - STATUS_PRELIMINARY_IGNORED
 */
export const FiscalYearUpsertStatusEnum = {
  STATUS_CREATED: 'STATUS_CREATED',
  STATUS_UPDATED: 'STATUS_UPDATED',
  STATUS_NO_OPERATION: 'STATUS_NO_OPERATION',
  STATUS_PRELIMINARY_IGNORED: 'STATUS_PRELIMINARY_IGNORED',
} as const

/**
 * * `STATUS_CREATED` - STATUS_CREATED
 * * `STATUS_UPDATED` - STATUS_UPDATED
 * * `STATUS_NO_OPERATION` - STATUS_NO_OPERATION
 * * `STATUS_PRELIMINARY_IGNORED` - STATUS_PRELIMINARY_IGNORED
 */
export type FiscalYearUpsertStatusEnum = (typeof FiscalYearUpsertStatusEnum)[keyof typeof FiscalYearUpsertStatusEnum]

export type Fund = {
  /**
   * The name of the fund in the format of 'funds/{uuid}'
   */
  readonly name: string
  /**
   * The fund ID
   */
  id: string
  /**
   * The product that the fund exists in
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
  /**
   * The creation time of the fund
   */
  create_time: Date
  /**
   * The update time of the fund
   */
  update_time: Date
  /**
   * The title of the fund
   */
  title: string
  /**
   * The name of the fund manager that manages the fund, in the format 'fundManagers/{uuid}'
   */
  readonly fund_manager_name: string
  /**
   * The base currency of the fund. Currency is a letter code designator specified in ISO 4217, plus some additional non-ISO codes
   */
  base_currency: string | null
  /**
   * The external identifier for the fund
   */
  external_id: string | null
  /**
   * If true this signifies that the fund supports pass through voting to both institutional and retail investors. A fund must have this set in order for the vote engine to issue pass through voting entitlements for organizations owned through this fund.
   */
  institutional_pass_through_voting_enabled: boolean
  /**
   * If true this signifies that we should be receiving quantification and composition data daily for this fund and therefore it is deemed data ready.
   */
  data_ready: boolean
  /**
   * Custodian identifiers, or null when the fund has none.
   */
  custodian_identifiers: FundCustodianIdentifiers | null
  /**
   * Identifiers within the proxy intermediary, or null when the fund has none.
   */
  proxy_intermediary_identifiers: FundProxyIntermediaryIdentifiers | null
  /**
   * Custodian region is used to identify the public holidays for custodian accounts. It is a CAPITALISED 3-letter code as defined by ISO 3166-1 A-3.
   */
  custodian_region: string | null
}

/**
 * Set of identifiers used to identify the custodian and account id of the custodian.
 *
 * As a pair these identifiers should be unique for a specific Fund:
 * - The custodian_external_id may be shared across multiple funds.
 * - The custodian_account_external_id should be unique across funds for the same custodian.
 * - The custodian_account_external_id may be repeated across multiple funds if the
 * custodian_external_id is different.
 */
export type FundCustodianIdentifiers = {
  /**
   * The identifier/title for the custodian of the fund. This identifies the custodian and may take the form of a name such as 'State Street' or 'Fidelity'. Limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  custodian_external_id?: string
  /**
   * The identifier for the custodian global account. Unique across funds for the same custodian. Limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  custodian_account_external_id?: string
}

/**
 * Set of identifiers used to identify the custodian and account id of the custodian.
 *
 * As a pair these identifiers should be unique for a specific Fund:
 * - The custodian_external_id may be shared across multiple funds.
 * - The custodian_account_external_id should be unique across funds for the same custodian.
 * - The custodian_account_external_id may be repeated across multiple funds if the
 * custodian_external_id is different.
 */
export type FundCustodianIdentifiersRequest = {
  /**
   * The identifier/title for the custodian of the fund. This identifies the custodian and may take the form of a name such as 'State Street' or 'Fidelity'. Limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  custodian_external_id?: string
  /**
   * The identifier for the custodian global account. Unique across funds for the same custodian. Limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  custodian_account_external_id?: string
}

export type FundManager = {
  readonly name: string
  id: string
  title: string
  product: ProductEnum
  website_url: string | null
  logo_url: string | null
  logo_thumbnail_url: string | null
  relationship_owner: string | null
  create_time: Date
  update_time: Date
}

export type FundManagerPolicy = {
  /**
   * Resource name in the format 'fundManagers/{uuid}/policies/{filename}.pdf'.
   */
  name: string
  /**
   * The policy title: the filename without the '.pdf' extension.
   */
  title: string
  /**
   * The URL of the policy document.
   */
  url: string
  /**
   * Timestamp when the policy was last updated.
   */
  update_time: Date
  /**
   * Presigned S3 URL providing unauthenticated access to the PDF for 24 hours.
   */
  signed_url: string
}

/**
 * Wrapper response for the unpaginated list of a fund manager's policies.
 */
export type FundManagerPolicyListResponse = {
  policies: Array<FundManagerPolicy>
}

export type FundManagerPolicySii = {
  readonly name: string
  fund_manager_name: string
  voting_policy_name: string
  public_security_id_name: string
  create_time: Date
  delete_time?: Date | null
  valid_from: Date
  valid_to?: Date | null
}

export type FundManagerPolicySiiBatchCreateRequest = {
  fund_manager_name: string
  voting_policy_name: string
  instruments: Array<FundManagerPolicySiiInputRequest>
}

export type FundManagerPolicySiiBatchDeleteRequest = {
  names: Array<string>
}

/**
 * An instrument with an associated validity period, used as input for batch create operations.
 */
export type FundManagerPolicySiiInputRequest = {
  public_security_id_name: string
  valid_from: Date
  valid_to?: Date | null
}

export type FundManagerPolicySiiResponse = {
  items: Array<FundManagerPolicySii>
}

/**
 * Request body for searching fund manager policy supported issued instruments.
 *
 * Domain validation (name formats, datetime parsing) is delegated to the
 * filter so behaviour matches the previous query-param-based list endpoint
 * exactly; this serializer only validates the request shape.
 */
export type FundManagerPolicySiiSearchRequestRequest = {
  fund_manager_names?: Array<string>
  voting_policy_names?: Array<string>
  public_security_id_names?: Array<string>
  valid_to_after?: string
  valid_to_before?: string
  valid_from_after?: string
  valid_from_before?: string
  include_deleted?: boolean
}

/**
 * A public security identifier describing the type and ID value of a public fund holding.
 */
export type FundManagerPublicSecurityId = {
  /**
   * The name of the public security ID, in the format 'securityIDTypes/{type}/securityIDs/{value}'.
   */
  name: string
  /**
   * The creation time of the public security ID.
   */
  create_time: Date
}

/**
 * Request body for searching public security IDs.
 */
export type FundManagerPublicSecurityIdSearchRequestRequest = {
  /**
   * Filter by fund variant names, each in the format 'funds/{uuid}/variants/{uuid}'.
   */
  fund_variant_names?: Array<string>
  /**
   * Filter by public security ID type names, each in the format 'securityIDTypes/{type}'.
   */
  public_security_id_type_names?: Array<string>
  /**
   * Filter by public security ID names, each in the format 'securityIDTypes/{type}/securityIDs/{value}'.
   */
  names?: Array<string>
  /**
   * Filter by public security ID values.
   */
  values?: Array<string>
  /**
   * Filter by whether the public security ID is linked to a fund variant: ALL applies no filter, LINKED selects linked IDs, UNLINKED selects unlinked IDs.
   *
   * * `ALL` - ALL
   * * `LINKED` - LINKED
   * * `UNLINKED` - UNLINKED
   */
  linked?: SecurityIdLinkedFilterEnum
  /**
   * Case-insensitive substring match on the public security ID value.
   */
  search_value?: string
}

export type FundManagerPublicSecurityIdWriteRequest = {
  /**
   * The name of the public security ID to create, in the format 'securityIDTypes/{type}/securityIDs/{value}'.
   */
  name: string
}

/**
 * Request body for searching fund managers.
 *
 * Domain validation (name format) is delegated to the filter so behaviour
 * matches the previous query-param-based list endpoint exactly; this
 * serializer only validates the request shape.
 */
export type FundManagerSearchRequestRequest = {
  names?: Array<string>
  search_title?: string
  relationship_owners?: Array<string>
  product?: ProductEnum
}

export type FundManagerSupportedIssuedInstrumentsQueryRequest = {
  /**
   * List of component differences
   */
  components: Array<ComponentDiffRequest>
  /**
   * Date at which the supported instruments take effect
   */
  recomposition_date: Date
  /**
   * Fund manager resource name in format 'fundManagers/<uuid>'
   */
  fund_manager_name: string
  /**
   * List of voting policy names in format 'votingPolicies/<uuid>'
   */
  voting_policy_names: Array<string>
}

/**
 * Serializer for FundManagerSupportedVotingPolicy responses.
 */
export type FundManagerSupportedVotingPolicy = {
  readonly id: string
  readonly fund_manager_id: string
  /**
   * UUID primary key. The resource name is `votingPolicies/{id}`.
   */
  readonly voting_policy_id: string
  readonly create_time: Date
  readonly update_time: Date
}

/**
 * Request serializer for batch upserting fund manager supported policies.
 */
export type FundManagerSupportedVotingPolicyBatchUpsertRequest = {
  /**
   * List of fund manager / voting policy links to upsert
   */
  policies: Array<FundManagerSupportedVotingPolicyItemRequest>
}

/**
 * Response serializer for batch upserting fund manager supported policies.
 */
export type FundManagerSupportedVotingPolicyBatchUpsertResponse = {
  policies: Array<FundManagerSupportedVotingPolicy>
}

/**
 * Serializer for historical FundManagerSupportedVotingPolicy records.
 */
export type FundManagerSupportedVotingPolicyHistorical = {
  id: string
  fund_manager_id: string
  voting_policy_id: string
  create_time: Date
  update_time: Date
  /**
   * Present on as_of queries: the datetime this historical record was captured
   */
  history_date?: Date
}

/**
 * Serializer for a single fund manager / voting policy link.
 */
export type FundManagerSupportedVotingPolicyItemRequest = {
  /**
   * UUID of the FundManager
   */
  fund_manager_id: string
  /**
   * UUID of the VotingPolicy
   */
  voting_policy_id: string
}

export type FundManagerWriteRequest = {
  title: string
  product: ProductEnum
  website_url?: string | null
  logo_url?: string | null
  logo_thumbnail_url?: string | null
  relationship_owner?: string | null
}

/**
 * Set of identifiers for proxy intermediary accounts.
 *
 * Proxymity, ProxyEdge and ProxyExchange are currently supported.
 */
export type FundProxyIntermediaryIdentifiers = {
  /**
   * List of proxy edge account ids for the fund, unique across funds. Each id is limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  proxyedge_external_ids?: Array<string>
  /**
   * List of proxymity account ids for the fund, unique across funds. Each id is limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  proxymity_external_ids?: Array<string>
  /**
   * List of proxyexchange account ids for the fund, unique across funds. Each id is limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  proxyexchange_external_ids?: Array<string>
}

/**
 * Set of identifiers for proxy intermediary accounts.
 *
 * Proxymity, ProxyEdge and ProxyExchange are currently supported.
 */
export type FundProxyIntermediaryIdentifiersRequest = {
  /**
   * List of proxy edge account ids for the fund, unique across funds. Each id is limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  proxyedge_external_ids?: Array<string>
  /**
   * List of proxymity account ids for the fund, unique across funds. Each id is limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  proxymity_external_ids?: Array<string>
  /**
   * List of proxyexchange account ids for the fund, unique across funds. Each id is limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  proxyexchange_external_ids?: Array<string>
}

export type FundQuantificationSnapshot = {
  /**
   * The name of the snapshot in the format 'funds/{uuid}/quantificationSnapshots/{uuid}'.
   */
  readonly name: string
  /**
   * The time at which the snapshot was valid.
   */
  valid_time: Date
  /**
   * The quantification of the fund.
   */
  fund_quantification: Quantification
  /**
   * The quantifications of all the variants of the fund.
   */
  readonly fund_variant_quantifications: Array<FundVariantQuantificationSet>
  /**
   * The creation time of the snapshot.
   */
  create_time: Date
  /**
   * The product that the quantification snapshot is associated with.
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
}

/**
 * Request body for searching fund quantification snapshots.
 *
 * Results are ordered by valid time descending, id descending.
 */
export type FundQuantificationSnapshotSearchRequestRequest = {
  /**
   * Filter by snapshot resource names, each in the format 'funds/{uuid}/quantificationSnapshots/{uuid}'.
   */
  names?: Array<string>
  /**
   * Filter by fund resource names, each in the format 'funds/{uuid}'.
   */
  fund_names?: Array<string>
  /**
   * Filter for snapshots valid at or after this timestamp (inclusive).
   */
  valid_time_after?: Date
  /**
   * Filter for snapshots valid before this timestamp (exclusive).
   */
  valid_time_before?: Date
  /**
   * The product to query for snapshots.
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
}

/**
 * Request body for creating a fund quantification snapshot.
 *
 * The generated name and create time are server-assigned and ignored on write.
 */
export type FundQuantificationSnapshotWriteRequest = {
  /**
   * The time at which the snapshot was valid. Records the time at which the snapshot was calculated by the fund administrator.
   */
  valid_time: Date
  /**
   * The quantification of the fund.
   */
  fund_quantification: QuantificationRequest
  /**
   * The quantifications of all the variants of the fund. The sum of all quantifications of the same unit type as the fund must be less than or equal to the fund quantification.
   */
  fund_variant_quantifications?: Array<FundVariantQuantificationSetRequest>
  /**
   * The product that the quantification snapshot is associated with.
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
}

/**
 * Request body for searching funds.
 *
 * Results are ordered by create time descending, id descending.
 */
export type FundSearchRequestRequest = {
  /**
   * Filter by fund manager resource names, each in the format 'fundManagers/{uuid}'.
   */
  fund_manager_names?: Array<string>
  /**
   * Filter by fund resource names, each in the format 'funds/{uuid}'.
   */
  names?: Array<string>
  /**
   * Case-insensitive substring match on the fund title.
   */
  search_title?: string
  /**
   * Filter by fund external ids.
   */
  external_ids?: Array<string>
  /**
   * Filter for whether the fund supports pass through voting for institutional investors. Omit (or pass null) to match all funds.
   */
  institutional_pass_through_voting_enabled?: boolean | null
  /**
   * The product to query for funds.
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
  /**
   * Filter for proxymity account ids.
   */
  proxymity_account_external_ids?: Array<string>
  /**
   * Filter for proxy edge account ids.
   */
  proxy_edge_account_external_ids?: Array<string>
  /**
   * Filter for proxy exchange account ids.
   */
  proxyexchange_account_external_ids?: Array<string>
  /**
   * Filter for custodian external ids.
   */
  custodian_external_ids?: Array<string>
  /**
   * Filter for custodian account ids. Note that using this filter without the custodian_external_ids filter may return multiple funds if there are multiple custodians with the same account id.
   */
  custodian_account_ids?: Array<string>
  /**
   * Matches custodian account ids that contain the search string. As an example, a search string of 'bcd' would match 'abcde', 'abcd' and 'bcde'.
   */
  search_custodian_account_id?: string
  /**
   * Matches proxymity account ids that contain the search string.
   */
  search_proxymity_account_external_id?: string
  /**
   * Matches proxy edge account ids that contain the search string.
   */
  search_proxy_edge_account_external_id?: string
  /**
   * Matches proxy exchange account ids that contain the search string.
   */
  search_proxyexchange_account_external_id?: string
}

/**
 * A fund variant is a wrapper for a fund, allowing a single fund to be represented with a
 * variety of differing titles and security IDs.
 */
export type FundVariant = {
  /**
   * The name of the variant, in the format 'funds/{uuid}/variants/{uuid}'
   */
  readonly name: string
  /**
   * The fund variant ID
   */
  id: string
  /**
   * The product that the fund variant exists in
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
  /**
   * The title of the fund variant
   */
  title: string
  /**
   * The classification of financial instruments: an uppercase six-letter code describing the structure and function of the instrument.
   */
  cfi: string | null
  /**
   * The closest MIFIR code from the current CFI code, set to 'SHRS' when CFI empty, defaults to 'OTHE' when no match found.
   */
  readonly mifir_code: string
  /**
   * The names of the public security IDs the fund variant is linked to, each in the format 'securityIDTypes/{type}/securityIDs/{value}'.
   */
  readonly public_security_id_names: Array<string>
  /**
   * The names of the custom security IDs the fund variant is linked to, each in the format '{fundManagers|providers}/{uuid}/securityIDTypes/{type}/securityIDs/{uuid}'.
   */
  readonly custom_security_id_names: Array<string>
  /**
   * The creation time of the fund variant
   */
  create_time: Date
  /**
   * The update time of the fund variant
   */
  update_time: Date
}

/**
 * All quantifications of a single fund variant within a snapshot.
 */
export type FundVariantQuantificationSet = {
  /**
   * The name of the fund variant, in the format 'funds/{uuid}/variants/{uuid}'.
   */
  fund_variant_name: string
  /**
   * All quantifications of the fund variant. Must include a quantification of the same unit type as the fund quantification, and cannot repeat a unit type.
   */
  quantifications: Array<Quantification>
}

/**
 * All quantifications of a single fund variant within a snapshot.
 */
export type FundVariantQuantificationSetRequest = {
  /**
   * The name of the fund variant, in the format 'funds/{uuid}/variants/{uuid}'.
   */
  fund_variant_name: string
  /**
   * All quantifications of the fund variant. Must include a quantification of the same unit type as the fund quantification, and cannot repeat a unit type.
   */
  quantifications: Array<QuantificationRequest>
}

/**
 * Request body for searching fund variants.
 *
 * The parent fund filter (`fund_name`) is optional: omitting it searches across
 * all funds (the wildcard parent 'funds/-'). Results are ordered by fund id,
 * title, id.
 */
export type FundVariantSearchRequestRequest = {
  /**
   * Optional parent fund 'funds/{uuid}'. Omit to search across all funds.
   */
  fund_name?: string
  /**
   * Filter by fund variant names, each in the format 'funds/{uuid}/variants/{uuid}'.
   */
  names?: Array<string>
  /**
   * The names of the public security IDs the fund variant is linked to, each in the format 'securityIDTypes/{type}/securityIDs/{value}'.
   */
  public_security_id_names?: Array<string>
  /**
   * The names of the custom security IDs the fund variant is linked to, each in the format '{fundManagers|providers}/{uuid}/securityIDTypes/{type}/securityIDs/{uuid}'.
   */
  custom_security_id_names?: Array<string>
  /**
   * Filter by security ID names that may be either public or custom.
   */
  security_id_names?: Array<string>
  /**
   * Filter by fund manager resource names, each in the format 'fundManagers/{uuid}'.
   */
  fund_manager_names?: Array<string>
  /**
   * Case-insensitive substring match on the fund variant title.
   */
  search_title?: string
  /**
   * Filter by product. Omit to search across all products.
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product?: ProductEnum
}

export type FundVariantWriteRequest = {
  /**
   * The name of the parent fund, in the format 'funds/{uuid}'
   */
  fund_name: string
  /**
   * The title of the fund variant
   */
  title: string
  /**
   * The product that the fund variant exists in. Defaults to PTV.
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product?: ProductEnum
  /**
   * The classification of financial instruments: a six-letter code. Stored upper-cased; omit or leave blank when the variant has no CFI.
   */
  cfi?: string
  /**
   * The names of the public security IDs the fund variant is linked to, each in the format 'securityIDTypes/{type}/securityIDs/{value}'.
   */
  public_security_id_names?: Array<string>
  /**
   * The names of the custom security IDs the fund variant is linked to, each in the format '{fundManagers|providers}/{uuid}/securityIDTypes/{type}/securityIDs/{uuid}'.
   */
  custom_security_id_names?: Array<string>
}

export type FundWriteRequest = {
  /**
   * The title of the fund
   */
  title: string
  /**
   * The name of the fund manager that manages the fund, in the format 'fundManagers/{uuid}'
   */
  fund_manager_name: string
  /**
   * The product that the fund exists in
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
  /**
   * The base currency of the fund. Currency is a letter code designator specified in ISO 4217, plus some additional non-ISO codes
   */
  base_currency?: string | null
  /**
   * The external identifier for the fund
   */
  external_id?: string | null
  /**
   * If true this signifies that the fund supports pass through voting to both institutional and retail investors.
   */
  institutional_pass_through_voting_enabled?: boolean
  /**
   * If true this signifies that we should be receiving quantification and composition data daily for this fund and therefore it is deemed data ready.
   */
  data_ready?: boolean
  /**
   * Custodian identifiers
   */
  custodian_identifiers?: FundCustodianIdentifiersRequest | null
  /**
   * Identifiers within the proxy intermediary
   */
  proxy_intermediary_identifiers?: FundProxyIntermediaryIdentifiersRequest | null
  /**
   * Custodian region is used to identify the public holidays for custodian accounts. It is a CAPITALISED 3-letter code as defined by ISO 3166-1 A-3.
   */
  custodian_region?: string | null
}

/**
 * Response shape for a GeneralMeeting.
 *
 * Takes the dict produced by services.build_general_meeting_view (or
 * build_general_meeting_views). The service layer is responsible for
 * assembling that dict from the GeneralMeeting row.
 */
export type GeneralMeeting = {
  /**
   * The general meeting resource name, of the form 'organizations/{uuid}/generalMeetings/{uuid}'.
   */
  readonly name: string
  /**
   * The name of the organization that this general meeting is for, of the form 'organizations/{uuid}'.
   */
  organization_name: string
  /**
   * The type of the general meeting.
   *
   * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
   * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
   * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
   * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
   * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
   * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
   * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
   * * `GENERAL_MEETING_TYPE_INVALID` - GENERAL_MEETING_TYPE_INVALID
   */
  type: GeneralMeetingTypeEnum
  /**
   * The date of the general meeting.
   */
  meeting_date: Date
  /**
   * The time the general meeting was created.
   */
  readonly create_time: Date
  /**
   * The time the general meeting was last updated.
   */
  readonly update_time: Date
  /**
   * The time the general meeting became invalid.
   */
  invalid_time: Date | null
  /**
   * The time the general meeting was announced.
   */
  announcement_time: Date | null
  /**
   * The EDI event ID for the general meeting as presented in the EDI Worldwide Corporate Actions service.
   */
  edi_event_id: string | null
  /**
   * URL of the official general meeting announcement.
   */
  announcement_url: string | null
  /**
   * URL linking to a page containing the proxy notice of the general meeting.
   */
  proxy_notice_url: string | null
  /**
   * URL of the official results for the general meeting.
   */
  results_url: string | null
  /**
   * The record date for the general meeting: the date on which shareholders must have owned shares in order to be eligible to vote.
   */
  record_date: Date | null
  /**
   * The record date for the general meeting as reported by EDI.
   */
  edi_record_date: Date | null
  /**
   * The time voting was enabled for the general meeting. Null if voting is not enabled.
   */
  readonly voting_enabled_time: Date | null
  /**
   * Whether voting is enabled for this general meeting.
   */
  voting_enabled: boolean
  /**
   * The time the EDI agenda pipelines were disabled. Null if pipelines are enabled.
   */
  readonly disable_edi_agenda_pipeline_updates_time: Date | null
  /**
   * Whether the EDI agenda pipelines are disabled for this general meeting.
   */
  disable_edi_agenda_pipeline_updates: boolean
  /**
   * The proxy submission deadlines for the general meeting.
   */
  proxy_submission: ProxySubmission | null
  /**
   * Index to distinguish duplicated general meetings for the same organization, meeting date and meeting type. Defaults to 0.
   */
  duplicate_index: number
}

/**
 * Request body for searching general meetings.
 *
 * Every filter is typed here so the generated clients get accurate types.
 * Name-format validation is delegated to the service, where a malformed name
 * surfaces as a 400.
 */
export type GeneralMeetingSearchRequestRequest = {
  /**
   * Filter to general meetings whose organization matches this name ('organizations/{uuid}').
   */
  parent_name?: string
  /**
   * Filter to general meetings for any of these organizations ('organizations/{uuid}').
   */
  organization_names?: Array<string>
  /**
   * Filter to general meetings with any of these names ('organizations/{uuid}/generalMeetings/{uuid}').
   */
  general_meeting_names?: Array<string>
  /**
   * Filter to general meetings with any of these UUIDs.
   */
  general_meeting_ids?: Array<string>
  /**
   * Filter to general meetings with any of these EDI event IDs.
   */
  edi_event_ids?: Array<string>
  /**
   * Filter to general meetings occurring on or after this time.
   */
  meeting_date_after?: Date
  /**
   * Filter to general meetings occurring strictly before this time.
   */
  meeting_date_before?: Date
  /**
   * Filter to general meetings with a record date on or after this time.
   */
  record_date_after?: Date
  /**
   * Filter to general meetings with a record date strictly before this time.
   */
  record_date_before?: Date
  /**
   * Filter to general meetings created on or after this time.
   */
  create_time_after?: Date
  /**
   * Filter on validity (presence of invalid_time): 'VALID' for meetings without an invalid_time, 'NOT_VALID' for meetings with one, 'ALL' (or omitted) for both.
   *
   * * `VALID` - VALID
   * * `NOT_VALID` - NOT_VALID
   * * `ALL` - ALL
   */
  valid?: ValidEnum
  /**
   * When true, restrict to general meetings that have voting enabled.
   */
  only_voting_enabled?: boolean
  /**
   * Filter to general meetings with voting enabled on or after this time.
   */
  voting_enabled_after?: Date
  /**
   * Filter to general meetings with voting enabled strictly before this time.
   */
  voting_enabled_before?: Date
}

/**
 * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
 * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
 * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
 * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
 * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
 * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
 * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
 * * `GENERAL_MEETING_TYPE_INVALID` - GENERAL_MEETING_TYPE_INVALID
 */
export const GeneralMeetingTypeEnum = {
  GENERAL_MEETING_TYPE_ANNUAL: 'GENERAL_MEETING_TYPE_ANNUAL',
  GENERAL_MEETING_TYPE_BOND_HOLDER: 'GENERAL_MEETING_TYPE_BOND_HOLDER',
  GENERAL_MEETING_TYPE_COURT_ORDERED: 'GENERAL_MEETING_TYPE_COURT_ORDERED',
  GENERAL_MEETING_TYPE_EXTRAORDINARY: 'GENERAL_MEETING_TYPE_EXTRAORDINARY',
  GENERAL_MEETING_TYPE_GENERAL: 'GENERAL_MEETING_TYPE_GENERAL',
  GENERAL_MEETING_TYPE_POSTAL_BALLOT: 'GENERAL_MEETING_TYPE_POSTAL_BALLOT',
  GENERAL_MEETING_TYPE_SPECIAL: 'GENERAL_MEETING_TYPE_SPECIAL',
  GENERAL_MEETING_TYPE_INVALID: 'GENERAL_MEETING_TYPE_INVALID',
} as const

/**
 * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
 * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
 * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
 * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
 * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
 * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
 * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
 * * `GENERAL_MEETING_TYPE_INVALID` - GENERAL_MEETING_TYPE_INVALID
 */
export type GeneralMeetingTypeEnum = (typeof GeneralMeetingTypeEnum)[keyof typeof GeneralMeetingTypeEnum]

/**
 * Write shape for both POST (create) and PATCH (partial update).
 *
 * Required-ness is enforced by passing ``partial=True`` for PATCH at the view
 * layer. Generated fields (``name``, ``create_time``, ``update_time``, the
 * ``*_time`` columns derived from the boolean flags) are not writable.
 *
 * The proxy-deadline-before-meeting-date constraint depends on the resulting
 * (merged) entity, so it is enforced in the service rather than here.
 */
export type GeneralMeetingWriteRequest = {
  /**
   * The name of the organization that this general meeting is for, of the form 'organizations/{uuid}'.
   */
  organization_name: string
  /**
   * The type of the general meeting.
   *
   * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
   * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
   * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
   * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
   * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
   * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
   * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
   */
  type: GeneralMeetingWriteTypeEnum
  /**
   * The date of the general meeting.
   */
  meeting_date: Date
  /**
   * The time the general meeting became invalid.
   */
  invalid_time?: Date | null
  /**
   * The time the general meeting was announced.
   */
  announcement_time?: Date | null
  /**
   * The EDI event ID for the general meeting as presented in the EDI Worldwide Corporate Actions service.
   */
  edi_event_id?: string | null
  /**
   * URL of the official general meeting announcement.
   */
  announcement_url?: string | null
  /**
   * URL linking to a page containing the proxy notice of the general meeting.
   */
  proxy_notice_url?: string | null
  /**
   * URL of the official results for the general meeting.
   */
  results_url?: string | null
  /**
   * The record date for the general meeting: the date on which shareholders must have owned shares in order to be eligible to vote.
   */
  record_date?: Date | null
  /**
   * The record date for the general meeting as reported by EDI.
   */
  edi_record_date?: Date | null
  /**
   * Set to true if voting should be enabled for this general meeting.
   */
  voting_enabled?: boolean
  /**
   * Set to true if the EDI agenda pipelines should be disabled for this general meeting.
   */
  disable_edi_agenda_pipeline_updates?: boolean
  /**
   * The proxy submission deadlines for the general meeting.
   */
  proxy_submission?: ProxySubmissionRequest | null
  /**
   * Index to distinguish duplicated general meetings for the same organization, meeting date and meeting type. Defaults to 0.
   */
  duplicate_index?: number
}

/**
 * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
 * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
 * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
 * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
 * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
 * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
 * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
 */
export const GeneralMeetingWriteTypeEnum = {
  GENERAL_MEETING_TYPE_ANNUAL: 'GENERAL_MEETING_TYPE_ANNUAL',
  GENERAL_MEETING_TYPE_BOND_HOLDER: 'GENERAL_MEETING_TYPE_BOND_HOLDER',
  GENERAL_MEETING_TYPE_COURT_ORDERED: 'GENERAL_MEETING_TYPE_COURT_ORDERED',
  GENERAL_MEETING_TYPE_EXTRAORDINARY: 'GENERAL_MEETING_TYPE_EXTRAORDINARY',
  GENERAL_MEETING_TYPE_GENERAL: 'GENERAL_MEETING_TYPE_GENERAL',
  GENERAL_MEETING_TYPE_POSTAL_BALLOT: 'GENERAL_MEETING_TYPE_POSTAL_BALLOT',
  GENERAL_MEETING_TYPE_SPECIAL: 'GENERAL_MEETING_TYPE_SPECIAL',
} as const

/**
 * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
 * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
 * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
 * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
 * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
 * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
 * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
 */
export type GeneralMeetingWriteTypeEnum = (typeof GeneralMeetingWriteTypeEnum)[keyof typeof GeneralMeetingWriteTypeEnum]

export type GetOrganizationByIdentifierRequestRequest = {
  identifier: OrganizationIdentifierRequest
}

export type Holding = {
  /**
   * Unique identifier for the holdings record
   */
  readonly id: string
  /**
   * ISIN (International Securities Identification Number). Must be 12-character alphanumeric code.
   */
  isin?: string | null
  /**
   * Number of shares held
   */
  settled_quantity: number
  /**
   * CUSIP (Committee on Uniform Securities Identification Procedures) number. A 9-character alphanumeric code that identifies North American financial securities.
   */
  cusip: string
  /**
   * When the holdings record is valid
   */
  valid_time: Date
  /**
   * When the holdings record was created
   */
  readonly create_time: Date
  /**
   * When the holdings record was last updated
   */
  readonly update_time: Date
  /**
   * Reference to the voter owning the holdings
   */
  voter_id: string
}

/**
 * Serializer for creating holdings (without voter_id).
 */
export type HoldingInputRequest = {
  /**
   * ISIN (International Securities Identification Number). Must be 12-character alphanumeric code.
   */
  isin?: string | null
  /**
   * Number of shares held
   */
  settled_quantity: number
  /**
   * CUSIP (Committee on Uniform Securities Identification Procedures) number. A 9-character alphanumeric code that identifies North American financial securities.
   */
  cusip: string
  /**
   * When the holdings record is valid
   */
  valid_time: Date
}

export type HoldingResponse = {
  /**
   * List of holdings for the voter
   */
  holdings: Array<Holding>
}

/**
 * * `duns` - duns
 * * `edi_issuer_id` - edi_issuer_id
 * * `lei` - lei
 */
export const IdentifierTypeEnum = {
  DUNS: 'duns',
  EDI_ISSUER_ID: 'edi_issuer_id',
  LEI: 'lei',
} as const

/**
 * * `duns` - duns
 * * `edi_issuer_id` - edi_issuer_id
 * * `lei` - lei
 */
export type IdentifierTypeEnum = (typeof IdentifierTypeEnum)[keyof typeof IdentifierTypeEnum]

/**
 * * `tumelo_gcip` - Tumelo Gcip
 * * `tumelo_entra` - Tumelo Entra
 * * `tumelo_cognito` - Tumelo Cognito
 */
export const IdentitySourceEnum = {
  TUMELO_GCIP: 'tumelo_gcip',
  TUMELO_ENTRA: 'tumelo_entra',
  TUMELO_COGNITO: 'tumelo_cognito',
} as const

/**
 * * `tumelo_gcip` - Tumelo Gcip
 * * `tumelo_entra` - Tumelo Entra
 * * `tumelo_cognito` - Tumelo Cognito
 */
export type IdentitySourceEnum = (typeof IdentitySourceEnum)[keyof typeof IdentitySourceEnum]

export type Industry = {
  naics_2017: IndustryNaics
}

export type IndustryNaics = {
  code: string
  readonly title: string | null
}

export type IndustryNaicsRequest = {
  code: string
}

export type IndustryRequest = {
  naics_2017: IndustryNaicsRequest
}

export type Instrument = {
  /**
   * Resource name of the instrument, in the format `instruments/{isin}`.
   */
  readonly name: string
  /**
   * The ISIN of the instrument as defined by ISO 6166. Used as the identifier; it is part of the resource name and so cannot be updated.
   */
  isin: string
  /**
   * A string name representation of the fund. May be thought of as the Issuer Name concatenated with the Name of the instrument.
   */
  title: string
  /**
   * The 4-letter capital MiFIR identifier code describing the kind of financial instrument, which may be equity or non-equity. Values are: SHRS, ETFS, DPRS, CRFT, OTHE, SDRV, SFPS, BOND, ETCS, ETNS, EMAL, DERV.
   */
  mifir_identifier_code: string
  /**
   * Whether the instrument can be broken down.
   */
  is_composite: boolean
  /**
   * The Classification of Financial Instruments — an uppercase six-letter code describing the structure and function of the instrument.
   */
  cfi: string | null
  /**
   * Resource names of public security IDs identifying this instrument (allowed types: sedol, cusip, cin), in the format `securityIDTypes/{type}/securityIDs/{value}`.
   */
  readonly public_security_id_names: Array<string>
}

/**
 * * `isin` - ISIN
 * * `cusip` - CUSIP
 */
export const InstrumentIdentifierTypeEnum = { ISIN: 'isin', CUSIP: 'cusip' } as const

/**
 * * `isin` - ISIN
 * * `cusip` - CUSIP
 */
export type InstrumentIdentifierTypeEnum =
  (typeof InstrumentIdentifierTypeEnum)[keyof typeof InstrumentIdentifierTypeEnum]

/**
 * Request body for searching instruments.
 *
 * Domain validation (ISIN, MiFIR, PSID name formats) is delegated to the
 * filter so behaviour matches the previous query-param-based list endpoint
 * exactly; this serializer only validates the request shape.
 */
export type InstrumentSearchRequestRequest = {
  isins?: Array<string>
  mifir_codes?: Array<string>
  public_security_id_names?: Array<string>
  search?: string
  is_composite?: boolean
  only_with_voting_rights?: boolean
}

/**
 * Write shape for the instrument upsert endpoint.
 *
 * A field left out carries forward from the current version. Each measure is
 * optional and carries the date it is valid for; one left out is not written.
 */
export type InstrumentUpsertRequestRequest = {
  /**
   * The identifier value, in the format given by identifier_type.
   */
  identifier: string
  /**
   * The kind of identifier held in identifier.
   *
   * * `isin` - ISIN
   * * `cusip` - CUSIP
   */
  identifier_type: InstrumentIdentifierTypeEnum
  /**
   * The stable id of the issuer that issued the instrument.
   */
  issuer_id: string
  /**
   * The LSEG InstrPermID for the instrument.
   */
  instr_perm_id: string
  /**
   * Whether the instrument is currently active.
   */
  is_active?: boolean
  /**
   * Whether this is the issuer's primary instrument.
   */
  is_primary_instrument?: boolean
  /**
   * The asset class of the instrument. LSEG asset-class code.
   *
   * * `ORD` - ORD
   * * `FULLPAID` - FULLPAID
   * * `PARTPAID` - PARTPAID
   * * `DEFER` - DEFER
   * * `EQU` - EQU
   * * `PAIDSUBSHS` - PAIDSUBSHS
   * * `STAPLED` - STAPLED
   * * `REDEM` - REDEM
   * * `ORDSUBR` - ORDSUBR
   * * `PRF` - PRF
   * * `PREFERRED` - PREFERRED
   * * `CPR` - CPR
   * * `CUM` - CUM
   * * `NONCUM` - NONCUM
   * * `REDEEM` - REDEEM
   * * `PRFSUBR` - PRFSUBR
   * * `ADR` - ADR
   * * `DRC` - DRC
   * * `GDR` - GDR
   * * `BDR` - BDR
   * * `CEDEAR` - CEDEAR
   * * `CHESS` - CHESS
   * * `DEPOSITSHS` - DEPOSITSHS
   */
  asset_class?: AssetClassEnum | null
  /**
   * The instrument's shares outstanding.
   */
  outstanding_shares?: OutstandingSharesUpsertRequest
  /**
   * The instrument's total shareholder return.
   */
  total_shareholder_return?: TotalShareholderReturnUpsertRequest
}

export type InstrumentUpsertResponse = {
  /**
   * The stable id of the instrument, for linking its measures to it.
   */
  instrument_id: string
  /**
   * Whether the instrument was created, versioned, or left unchanged.
   *
   * * `STATUS_CREATED` - STATUS_CREATED
   * * `STATUS_UPDATED` - STATUS_UPDATED
   * * `STATUS_NO_OPERATION` - STATUS_NO_OPERATION
   */
  instrument_status: UpsertStatusEnum
  /**
   * Whether the share count was created, updated, left unchanged, or not sent.
   *
   * * `STATUS_CREATED` - STATUS_CREATED
   * * `STATUS_UPDATED` - STATUS_UPDATED
   * * `STATUS_NO_OPERATION` - STATUS_NO_OPERATION
   * * `STATUS_NOT_SUPPLIED` - STATUS_NOT_SUPPLIED
   */
  outstanding_shares_status: MeasureUpsertStatusEnum
  /**
   * Whether the return was created, updated, left unchanged, or not sent.
   *
   * * `STATUS_CREATED` - STATUS_CREATED
   * * `STATUS_UPDATED` - STATUS_UPDATED
   * * `STATUS_NO_OPERATION` - STATUS_NO_OPERATION
   * * `STATUS_NOT_SUPPLIED` - STATUS_NOT_SUPPLIED
   */
  total_shareholder_return_status: MeasureUpsertStatusEnum
}

export type InstrumentWriteRequest = {
  /**
   * The ISIN of the instrument as defined by ISO 6166. Used as the identifier; it is part of the resource name and so cannot be updated.
   */
  isin?: string
  /**
   * A string name representation of the fund. May be thought of as the Issuer Name concatenated with the Name of the instrument.
   */
  title: string
  /**
   * The 4-letter capital MiFIR identifier code describing the kind of financial instrument, which may be equity or non-equity. Values are: SHRS, ETFS, DPRS, CRFT, OTHE, SDRV, SFPS, BOND, ETCS, ETNS, EMAL, DERV.
   */
  mifir_identifier_code: string
  /**
   * Whether the instrument can be broken down.
   */
  is_composite: boolean
  /**
   * The Classification of Financial Instruments — an uppercase six-letter code describing the structure and function of the instrument.
   */
  cfi?: string | null
  /**
   * Resource names of public security IDs identifying this instrument (allowed types: sedol, cusip, cin), in the format `securityIDTypes/{type}/securityIDs/{value}`.
   */
  public_security_id_names?: Array<string>
}

/**
 * Serializer for individual investor account voting information.
 */
export type InvestorAccountVoteInfo = {
  /**
   * Unique identifier of the habitat for the investor account
   */
  habitat_id: string
  /**
   * Unique identifier of the investor account
   */
  investor_account_id: string
  /**
   * Unique identifier of the investor
   */
  investor_id: string
  /**
   * External identifier of the investor (displayable)
   */
  investor_external_id: string
  /**
   * Investor type: 'institutional', 'retail_ptv', or 'unknown'
   */
  investor_type: string
  /**
   * Combined fund proportion from the ballot breakdown graph. Null for accounts not in breakdown.
   */
  ballot_combined_fund_proportion?: number | null
  /**
   * Whether this investor has manual votes. Null when no meeting entitlement data is available.
   */
  has_manual_votes?: boolean | null
  /**
   * Whether this investor account is expected to vote based on the breakdown, and their SIIs. False for accounts not in the breakdown (they have validated entitlements we didn't expect).
   */
  expected_to_vote: boolean
  /**
   * Number of validated meeting entitlements expected for this investor account on this ballot. For accounts not in the breakdown but with validated entitlements, defaults to the count of their validated entitlement IDs (they have entitlements we didn't expect based on the breakdown).
   */
  expected_validated_meeting_entitlements: number
  /**
   * Combined fund proportion from validated meeting entitlement (None when no validated entitlement)
   */
  meeting_entitlement_combined_fund_proportion?: number | null
  /**
   * List of validated meeting entitlement IDs associated with this investor account for this ballot
   */
  validated_meeting_entitlement_ids: Array<string>
}

export type InvestorPolicySii = {
  readonly name: string
  voting_policy_name: string
  public_security_id_name: string
  create_time: Date
  delete_time?: Date | null
  valid_from: Date
  valid_to?: Date | null
}

export type InvestorPolicySiiBatchCreateRequest = {
  investor_name: string
  voting_policy_name: string
  instruments: Array<InvestorPolicySiiInputRequest>
}

export type InvestorPolicySiiBatchDeleteRequest = {
  names: Array<string>
}

/**
 * An instrument with an associated validity period, used as input for batch create operations.
 */
export type InvestorPolicySiiInputRequest = {
  public_security_id_name: string
  valid_from: Date
  valid_to?: Date | null
}

export type InvestorPolicySiiResponse = {
  items: Array<InvestorPolicySii>
}

/**
 * Request body for searching investor policy supported issued instruments.
 *
 * Domain validation (name formats, datetime parsing) is delegated to the
 * filter so behaviour matches the previous query-param-based list endpoint
 * exactly; this serializer only validates the request shape.
 */
export type InvestorPolicySiiSearchRequestRequest = {
  investor_names?: Array<string>
  voting_policy_names?: Array<string>
  public_security_id_names?: Array<string>
  valid_to_after?: string
  valid_to_before?: string
  valid_from_after?: string
  valid_from_before?: string
  include_deleted?: boolean
}

export type InvestorRulesEngine = {
  readonly id: number
  investor_name: string
  rules_engine_name?: string | null
  readonly created_at: Date
  readonly updated_at: Date
}

export type InvestorRulesEngineRequest = {
  investor_name: string
  rules_engine_name?: string | null
}

export type InvestorSiiBatchCreateRequest = {
  investor_name: string
  instruments: Array<InvestorSiiInputRequest>
}

export type InvestorSiiBatchDeleteRequest = {
  names: Array<string>
}

/**
 * An instrument with an associated validity period, used as input for batch create operations.
 */
export type InvestorSiiInputRequest = {
  public_security_id_name: string
  valid_from: Date
  valid_to?: Date | null
}

export type InvestorSiiResponse = {
  items: Array<InvestorSupportedIssuedInstrument>
}

/**
 * Request body for searching investor supported issued instruments.
 *
 * Domain validation (name formats, datetime parsing) is delegated to the
 * filter so behaviour matches the previous query-param-based list endpoint
 * exactly; this serializer only validates the request shape.
 */
export type InvestorSiiSearchRequestRequest = {
  investor_names?: Array<string>
  public_security_id_names?: Array<string>
  valid_to_after?: string
  valid_to_before?: string
  valid_from_after?: string
  valid_from_before?: string
  include_deleted?: boolean
}

export type InvestorSupportedIssuedInstrument = {
  readonly name: string
  public_security_id_name: string
  create_time: Date
  delete_time?: Date | null
  valid_from: Date
  valid_to?: Date | null
}

/**
 * Request serializer for getting which investor accounts can vote on given ballots.
 */
export type InvestorsCanVoteRequest = {
  /**
   * List of proxy intermediary ballot IDs to check
   */
  proxy_intermediary_ballot_ids: Array<string>
  /**
   * When True, sources meeting entitlements using an indirect lookup path instead of the direct PI ballot source ID. The indirect path uses: (1) custodian_account_fund_id from the ballot to find fund variant security IDs that map to owning_fund_security_id on meeting entitlements, (2) target_security_id to match issued_instrument_security_id, and (3) the PI ballot's linked general meeting via transparency_general_meeting_name. This approach avoids issues where multiple PI ballots exist for a single meeting entitlement.
   */
  source_meeting_entitlements_indirectly?: boolean
}

/**
 * Response serializer containing voting information for all requested ballots.
 */
export type InvestorsCanVoteResponse = {
  /**
   * Dictionary mapping proxy intermediary ballot ID to investors can vote, and requires investigation information
   */
  ballots: {
    [key: string]: BallotInvestorsCanVote
  }
}

export type Issuer = {
  /**
   * Identity id of the issuer, stable across versions.
   */
  readonly id: string
  /**
   * Id of this version row.
   */
  readonly version_id: string
  /**
   * The LSEG OrgPermID for the issuer.
   */
  readonly org_perm_id: string
  /**
   * The issuer's common name, which may differ from its registered legal name.
   */
  readonly display_name: string | null
  /**
   * The legal name for the issuer.
   */
  readonly legal_name: string | null
  /**
   * The country of incorporation for the issuer. ISO 3166-1 alpha-2 country code.
   */
  readonly country_of_incorporation: string | null
  /**
   * The country of the issuer's headquarters. ISO 3166-1 alpha-2 country code.
   */
  readonly hq_country: string | null
  /**
   * The primary listing exchange for the issuer.
   */
  primary_listing_exchange: Exchange | null
  /**
   * The TRBC activity code for the issuer. 10-digit TRBC level-5 code.
   */
  readonly trbc_code: string | null
  /**
   * Whether the issuer is a constituent of the S&P 500 index.
   */
  readonly is_sp500: boolean | null
  /**
   * The date the issuer first went public.
   */
  readonly first_public_date: Date | null
  /**
   * The date the issuer completed its de-SPAC merger.
   */
  readonly despac_date: Date | null
  /**
   * The kind of organisation the issuer is. LSEG Symbology organization type code.
   *
   * * `CBNK` - Central Bank
   * * `CINV` - Collective Investment
   * * `CLGUN` - Academic Institution
   * * `COM` - Business Organization
   * * `GVT` - Government
   * * `GVTDA` - Government Department/Agency
   * * `MKP` - Market Participant
   * * `NGO` - Non-Governmental Organization
   * * `SUPN` - Supranational
   * * `UNK` - Unknown
   */
  organization_type: OrganizationTypeEnum | null
  /**
   * The SEC Central Index Key for the issuer.
   */
  readonly cik: string | null
  /**
   * Monotonic version number of this issuer.
   */
  readonly version_number: number
  /**
   * Time this issuer version was created.
   */
  readonly create_time: Date
}

export type IssuerInstrument = {
  /**
   * Identity id of the instrument, stable across versions.
   */
  readonly id: string
  /**
   * Id of this version row.
   */
  readonly version_id: string
  /**
   * The LSEG InstrPermID for the instrument.
   */
  readonly instr_perm_id: string
  /**
   * Id of the issuer that issued this instrument.
   */
  readonly issuer_id: string
  /**
   * The identifier value, in the format given by identifier_type.
   */
  readonly identifier: string
  /**
   * The kind of identifier held in identifier.
   *
   * * `isin` - ISIN
   * * `cusip` - CUSIP
   */
  identifier_type: InstrumentIdentifierTypeEnum
  /**
   * Whether the instrument is currently active.
   */
  readonly is_active: boolean
  /**
   * Whether this is the issuer's primary instrument.
   */
  readonly is_primary_instrument: boolean
  /**
   * The asset class of the instrument. LSEG asset-class code.
   *
   * * `ORD` - ORD
   * * `FULLPAID` - FULLPAID
   * * `PARTPAID` - PARTPAID
   * * `DEFER` - DEFER
   * * `EQU` - EQU
   * * `PAIDSUBSHS` - PAIDSUBSHS
   * * `STAPLED` - STAPLED
   * * `REDEM` - REDEM
   * * `ORDSUBR` - ORDSUBR
   * * `PRF` - PRF
   * * `PREFERRED` - PREFERRED
   * * `CPR` - CPR
   * * `CUM` - CUM
   * * `NONCUM` - NONCUM
   * * `REDEEM` - REDEEM
   * * `PRFSUBR` - PRFSUBR
   * * `ADR` - ADR
   * * `DRC` - DRC
   * * `GDR` - GDR
   * * `BDR` - BDR
   * * `CEDEAR` - CEDEAR
   * * `CHESS` - CHESS
   * * `DEPOSITSHS` - DEPOSITSHS
   */
  asset_class: AssetClassEnum | null
  /**
   * Monotonic version number of this instrument.
   */
  readonly version_number: number
  /**
   * Time this instrument version was created.
   */
  readonly create_time: Date
}

export type IssuerInstrumentSearchRequestRequest = {
  /**
   * Restrict to instruments with these identity ids.
   */
  ids?: Array<string>
  /**
   * Restrict to instruments whose current version is one of these version ids.
   */
  version_ids?: Array<string>
  /**
   * Restrict to instruments with these LSEG InstrPermIDs.
   */
  instr_perm_ids?: Array<string>
  /**
   * Restrict to instruments issued by the issuers with these identity ids.
   */
  issuer_ids?: Array<string>
  /**
   * Restrict to instruments with these identifier values. Must be sent with identifier_type.
   */
  identifiers?: Array<string>
  /**
   * Restrict to instruments whose identifier is of this kind. Must be sent with identifiers.
   *
   * * `isin` - ISIN
   * * `cusip` - CUSIP
   */
  identifier_type?: InstrumentIdentifierTypeEnum
}

export type IssuerSearchRequestRequest = {
  /**
   * Restrict to issuers with these identity ids.
   */
  ids?: Array<string>
  /**
   * Restrict to issuers whose current version is one of these version ids.
   */
  version_ids?: Array<string>
  /**
   * Restrict to issuers with these LSEG OrgPermIDs.
   */
  org_perm_ids?: Array<string>
  /**
   * Restrict to issuers with these SEC Central Index Keys, zero-padded to 10 digits (e.g. 0000320193).
   */
  ciks?: Array<string>
  /**
   * Restrict to issuers whose display name or legal name contains this text, ignoring case.
   */
  search?: string
}

/**
 * Write shape for the upsert endpoint.
 *
 * A field left out carries forward from the current version; a field sent as
 * null is set to null.
 */
export type IssuerUpsertRequestRequest = {
  /**
   * The LSEG OrgPermID for the issuer.
   */
  org_perm_id: string
  /**
   * The issuer's common name, which may differ from its registered legal name.
   */
  display_name?: string | null
  /**
   * The legal name for the issuer.
   */
  legal_name?: string | null
  /**
   * The country of incorporation for the issuer. ISO 3166-1 alpha-2 country code.
   */
  country_of_incorporation?: string | null
  /**
   * The country of the issuer's headquarters. ISO 3166-1 alpha-2 country code.
   */
  hq_country?: string | null
  /**
   * The ISO 10383 MIC code of the issuer's primary listing exchange. Rejected if no exchange with this code exists.
   */
  primary_listing_exchange?: string | null
  /**
   * The TRBC activity code for the issuer. 10-digit TRBC level-5 code.
   */
  trbc_code?: string | null
  /**
   * Whether the issuer is a constituent of the S&P 500 index.
   */
  is_sp500?: boolean | null
  /**
   * The date the issuer first went public.
   */
  first_public_date?: Date | null
  /**
   * The date the issuer completed its de-SPAC merger.
   */
  despac_date?: Date | null
  /**
   * The kind of organisation the issuer is. LSEG Symbology organization type code.
   *
   * * `CBNK` - Central Bank
   * * `CINV` - Collective Investment
   * * `CLGUN` - Academic Institution
   * * `COM` - Business Organization
   * * `GVT` - Government
   * * `GVTDA` - Government Department/Agency
   * * `MKP` - Market Participant
   * * `NGO` - Non-Governmental Organization
   * * `SUPN` - Supranational
   * * `UNK` - Unknown
   */
  organization_type?: OrganizationTypeEnum | null
  /**
   * The SEC Central Index Key for the issuer.
   */
  cik?: string | null
}

export type IssuerUpsertResponse = {
  /**
   * The stable id of the issuer, for linking its instruments to it.
   */
  issuer_id: string
  /**
   * Whether the issuer was created, versioned, or left unchanged.
   *
   * * `STATUS_CREATED` - STATUS_CREATED
   * * `STATUS_UPDATED` - STATUS_UPDATED
   * * `STATUS_NO_OPERATION` - STATUS_NO_OPERATION
   */
  status: UpsertStatusEnum
}

/**
 * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL
 * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED
 * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED
 */
export const LinkedEnum = {
  PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL: 'PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL',
  PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED: 'PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED',
  PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED: 'PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED',
} as const

/**
 * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL
 * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED
 * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED
 */
export type LinkedEnum = (typeof LinkedEnum)[keyof typeof LinkedEnum]

export type ListProposalCategoriesRequest = {
  /**
   * The proxy intermediaries to filter categories by.
   */
  proxy_intermediary_names: Array<ProxyIntermediaryEnum>
  /**
   * The ids of the transparency proposals to filter categories by.
   */
  transparency_proposal_ids: Array<string>
}

export type ListProposalCategoriesResponse = {
  proposal_categories: Array<ProposalCategory>
}

export type ListRequestRequest = {
  /**
   * A list of ballot identity ids to filter by.
   */
  ids?: Array<string>
  /**
   * A list of ballot resource names to filter by, 'proxyIntermediaries/{uuid}/ballots/{uuid}'.
   */
  names?: Array<string>
  /**
   * Resource name of the proxy intermediary to filter by, 'proxyIntermediaries/{uuid}'.
   */
  proxy_intermediary_name?: string
  /**
   * The proxy intermediary to filter by. Preferred over proxy_intermediary_name when set.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary?: ProxyIntermediaryEnum
  /**
   * External ids to filter by. Requires proxy_intermediary or proxy_intermediary_name to be set.
   */
  external_ids?: Array<string>
  /**
   * Return ballots in the state they were in at this point in time; later ballots are excluded.
   */
  version_create_time_before?: Date
  /**
   * Meeting IDs to filter by.
   */
  proxy_intermediary_meeting_ids?: Array<string>
  /**
   * Meeting resource names to filter by, 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  proxy_intermediary_meeting_names?: Array<string>
  /**
   * Filter ballots by cancellation state. If not set, all ballots are returned.
   *
   * * `BALLOT_CANCELLED_FILTER_ALL` - BALLOT_CANCELLED_FILTER_ALL
   * * `BALLOT_CANCELLED_FILTER_NOT_CANCELLED` - BALLOT_CANCELLED_FILTER_NOT_CANCELLED
   * * `BALLOT_CANCELLED_FILTER_CANCELLED` - BALLOT_CANCELLED_FILTER_CANCELLED
   */
  cancelled?: BallotCancelledFilterEnum
  /**
   * Public security ID names to filter by, 'securityIDTypes/{type}/securityIDs/{value}'.
   */
  public_security_id_names?: Array<string>
  /**
   * Filter for ballots whose submission deadline is on or after this time.
   */
  submission_deadline_after?: Date
  /**
   * Filter for ballots whose submission deadline is before this time.
   */
  submission_deadline_before?: Date
  /**
   * Filter for ballots linked (true) or not linked (false) to a transparency meeting.
   */
  linked_to_transparency_meeting?: boolean | null
  /**
   * Case-insensitive search across organization title, external id, and public security id.
   */
  search?: string
  /**
   * Custodian account numbers to filter by.
   */
  custodian_account_numbers?: Array<string>
  /**
   * Filter for ballots whose vote allocation time is before this time.
   */
  vote_allocation_time_before?: Date
  /**
   * Broadridge agenda ids to filter by.
   */
  broadridge_agenda_ids?: Array<string>
}

export type MarketCapitalisation = {
  /**
   * Identity id of the issuer the market capitalisation is reported on.
   */
  readonly issuer_id: string
  /**
   * The market capitalisation.
   */
  readonly value: string
  /**
   * The currency of the market capitalisation. ISO 4217 currency code.
   */
  readonly currency: string
  /**
   * The date the market capitalisation is valid for.
   */
  readonly valid_date: Date
}

export type MarketCapitalisationUpsertRequest = {
  /**
   * The market capitalisation.
   */
  value: string
  /**
   * The currency of the market capitalisation. ISO 4217 currency code.
   */
  currency: string
  /**
   * The date the market capitalisation is valid for.
   */
  valid_date: Date
}

/**
 * Request body for creating a proxy intermediary voting recommendation from a provider voting recommendation.
 */
export type MatchProxyIntermediaryVotingRecommendationFromPvrRequest = {
  /**
   * The provider voting recommendation to copy the recommendation details from.
   */
  provider_voting_recommendation_id: string
  /**
   * The proxy intermediary proposal to attach the recommendation to.
   */
  proxy_intermediary_proposal_id: string
}

/**
 * * `no_proposals` - no_proposals
 * * `unmatched` - unmatched
 * * `partially_matched` - partially_matched
 * * `fully_matched` - fully_matched
 */
export const MatchStatusEnum = {
  NO_PROPOSALS: 'no_proposals',
  UNMATCHED: 'unmatched',
  PARTIALLY_MATCHED: 'partially_matched',
  FULLY_MATCHED: 'fully_matched',
} as const

/**
 * * `no_proposals` - no_proposals
 * * `unmatched` - unmatched
 * * `partially_matched` - partially_matched
 * * `fully_matched` - fully_matched
 */
export type MatchStatusEnum = (typeof MatchStatusEnum)[keyof typeof MatchStatusEnum]

/**
 * Request body for matching a provider voting recommendation to a proposal.
 */
export type MatchVotingRecommendationFromPvrRequest = {
  /**
   * The proposal to create a recommendation for, in the form organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}.
   */
  proposal_name: string
}

export type MeasureUpsertResponse = {
  /**
   * Whether the measure was created, updated, left unchanged, or not sent.
   *
   * * `STATUS_CREATED` - STATUS_CREATED
   * * `STATUS_UPDATED` - STATUS_UPDATED
   * * `STATUS_NO_OPERATION` - STATUS_NO_OPERATION
   * * `STATUS_NOT_SUPPLIED` - STATUS_NOT_SUPPLIED
   */
  status: MeasureUpsertStatusEnum
}

/**
 * * `STATUS_CREATED` - STATUS_CREATED
 * * `STATUS_UPDATED` - STATUS_UPDATED
 * * `STATUS_NO_OPERATION` - STATUS_NO_OPERATION
 * * `STATUS_NOT_SUPPLIED` - STATUS_NOT_SUPPLIED
 */
export const MeasureUpsertStatusEnum = {
  STATUS_CREATED: 'STATUS_CREATED',
  STATUS_UPDATED: 'STATUS_UPDATED',
  STATUS_NO_OPERATION: 'STATUS_NO_OPERATION',
  STATUS_NOT_SUPPLIED: 'STATUS_NOT_SUPPLIED',
} as const

/**
 * * `STATUS_CREATED` - STATUS_CREATED
 * * `STATUS_UPDATED` - STATUS_UPDATED
 * * `STATUS_NO_OPERATION` - STATUS_NO_OPERATION
 * * `STATUS_NOT_SUPPLIED` - STATUS_NOT_SUPPLIED
 */
export type MeasureUpsertStatusEnum = (typeof MeasureUpsertStatusEnum)[keyof typeof MeasureUpsertStatusEnum]

export type Meeting = {
  /**
   * Unique identifier for the general meeting
   */
  general_meeting_id: string
  /**
   * Resource name for the general meeting in the format
   * 'organizations/{organization_id}/generalMeetings/{general_meeting_id}'
   */
  readonly general_meeting_name: string
  /**
   * Resource name for the organization in the format 'organizations/{organization_id}'
   */
  readonly organization_name: string
  /**
   * Resource name for the meeting ballot in the format
   * 'habitats/{habitat_id}/meetingBallots/{meeting_ballot_id}'
   */
  readonly meeting_ballot_name: string
  /**
   * Resource name for the scheme in the format 'habitats/{habitat_id}/schemes/{scheme_id}'
   */
  readonly scheme_name: string
  /**
   * Date and time when the meeting is scheduled
   */
  meeting_date: Date
  /**
   * Identifier for the habitat this meeting belongs to
   */
  habitat_id: string
  /**
   * Unique identifier for the organization holding the meeting
   */
  organization_id: string
  /**
   * Display name of the organization
   */
  organization_display_title: string
  /**
   * URL to the organization's logo image
   */
  organization_logo_url?: string | null
  /**
   * NAICS industry classification title for the organization
   */
  organization_naics_title: string
  /**
   * Identifier for the meeting ballot
   */
  meeting_ballot_id: string
  /**
   * Deadline for voting/taking action on meeting proposals
   */
  action_deadline: Date
  /**
   * Identifier for the investment scheme
   */
  scheme_id: string
  /**
   * List of theme/classification codes for proposals in this meeting (e.g., CC, OE, PR)
   */
  proposal_classification_codes?: Array<string>
}

/**
 * A tenant's meeting on the assignment page; issuer fields are null when no ballot's ISIN resolves.
 */
export type MeetingAssignment = {
  /**
   * Identity id of the proxy intermediary meeting, stable across versions.
   */
  proxy_intermediary_meeting_id: string
  /**
   * The proxy intermediary's id for the meeting.
   */
  external_id: string
  /**
   * The issuer name as ingested from the proxy intermediary.
   */
  organization_title: string
  /**
   * ISIN of one of the tenant's ballots on the meeting; null when none holds an ISIN.
   */
  isin: string | null
  /**
   * Identity id of the issuer the ballots' ISIN resolves to.
   */
  issuer_id: string | null
  /**
   * Display name of the resolved issuer.
   */
  issuer_display_name: string | null
  /**
   * ISO 3166-1 alpha-2 country the resolved issuer is headquartered in.
   */
  hq_country: string | null
  /**
   * Two-digit TRBC economic sector code of the resolved issuer; null when unknown.
   */
  sector_code: string | null
  /**
   * Name of the resolved issuer's TRBC economic sector; null when unknown.
   */
  sector: string | null
  /**
   * The date and time the meeting is held.
   */
  meeting_date: Date
  /**
   * The date and time votes must be submitted to the proxy intermediary by.
   */
  meeting_deadline: Date
  /**
   * Every one of the tenant's ballots on the meeting, ordered by ballot id, with its assignment.
   */
  readonly ballots: Array<MeetingAssignmentBallot>
}

export type MeetingAssignmentBallot = {
  /**
   * Identity id of the proxy intermediary ballot.
   */
  ballot_id: string
  /**
   * Tumelo GCIP subject of the user the ballot is assigned to; null when it is unassigned or the user has no GCIP subject.
   */
  assigned_to: string | null
  /**
   * Tumelo GCIP subject of the user who assigned the ballot; null when it is unassigned or the user has no GCIP subject.
   */
  assigned_by: string | null
}

/**
 * * `issuer_name` - issuer_name
 * * `isin` - isin
 * * `meeting_date` - meeting_date
 * * `meeting_deadline` - meeting_deadline
 * * `sector` - sector
 */
export const MeetingAssignmentOrderingFieldEnum = {
  ISSUER_NAME: 'issuer_name',
  ISIN: 'isin',
  MEETING_DATE: 'meeting_date',
  MEETING_DEADLINE: 'meeting_deadline',
  SECTOR: 'sector',
} as const

/**
 * * `issuer_name` - issuer_name
 * * `isin` - isin
 * * `meeting_date` - meeting_date
 * * `meeting_deadline` - meeting_deadline
 * * `sector` - sector
 */
export type MeetingAssignmentOrderingFieldEnum =
  (typeof MeetingAssignmentOrderingFieldEnum)[keyof typeof MeetingAssignmentOrderingFieldEnum]

export type MeetingAssignmentOrderingRequest = {
  /**
   * The meeting field to order by. `issuer_name` orders by `organization_title` and `sector` by economic sector name, with unknown sectors last when ascending.
   *
   * * `issuer_name` - issuer_name
   * * `isin` - isin
   * * `meeting_date` - meeting_date
   * * `meeting_deadline` - meeting_deadline
   * * `sector` - sector
   */
  field?: MeetingAssignmentOrderingFieldEnum
  /**
   * The direction to order in.
   *
   * * `ASC` - ASC
   * * `DESC` - DESC
   */
  direction?: DirectionEnum
}

export type MeetingAssignmentSearchRequestRequest = {
  /**
   * Match meetings whose title, or the issuer name or ISIN of any of the tenant's ballots, contains this text, ignoring case.
   */
  search?: string
  /**
   * Only meetings held at or after this time.
   */
  meeting_date_after?: Date
  /**
   * Only meetings held strictly before this time.
   */
  meeting_date_before?: Date
  /**
   * Only meetings whose submission deadline is at or after this time.
   */
  meeting_deadline_after?: Date
  /**
   * Only meetings whose submission deadline is strictly before this time.
   */
  meeting_deadline_before?: Date
  /**
   * Only meetings with a ballot assigned to one of these users, named by Tumelo GCIP subject. Combined with `assigned_by`, the same ballot must match both.
   */
  assigned_to?: Array<string>
  /**
   * When true, only meetings none of whose ballots is assigned. Combined with `assigned_to` or `assigned_by`, meetings matching either are returned.
   */
  unassigned?: boolean
  /**
   * Only meetings with a ballot assigned by one of these users, named by Tumelo GCIP subject. Combined with `assigned_to`, the same ballot must match both.
   */
  assigned_by?: Array<string>
  /**
   * Only meetings with a ballot carrying a membership stamp whose label is one of these, matched exactly.
   */
  membership_labels?: Array<string>
  /**
   * Only meetings with a ballot whose issuer is headquartered in one of these ISO 3166-1 alpha-2 countries.
   */
  hq_countries?: Array<string>
  /**
   * Only meetings with a ballot whose issuer is on one of the tenant's watchlists with these titles, matched exactly.
   */
  watchlist_titles?: Array<string>
  /**
   * Only meetings with a ballot carrying a stamp of one of these types.
   */
  stamp_types?: Array<StampTypesEnum>
  ordering?: MeetingAssignmentOrderingRequest
}

export type MeetingBallot = {
  /**
   * Unique identifier for the meeting ballot
   */
  readonly id: string
  /**
   * The investor this ballot belongs to
   */
  investor: string
  /**
   * The habitat this meeting ballot belongs to
   */
  habitat: string
  /**
   * General meeting this ballot is associated with
   */
  general_meeting: string
  /**
   * Earliest voting deadline across all PI ballots linked to this meeting ballot
   */
  earliest_voting_deadline: Date
  /**
   * Latest voting deadline across all PI ballots linked to this meeting ballot
   */
  latest_voting_deadline: Date
  readonly create_time: Date
  readonly update_time: Date
  complete_time?: Date | null
}

export type MeetingBallotSource = {
  /**
   * Unique identifier for the meeting ballot source
   */
  readonly id: string
  /**
   * The meeting ballot this source contributes to
   */
  meeting_ballot: string
  /**
   * The PI ballot whose entitlements contributed to the meeting ballot
   */
  proxy_intermediary_ballot: string
  /**
   * Investor SII context at the time the source was created
   */
  investor_supported_issued_instrument_id?: string | null
  /**
   * Investor policy SII context at the time the source was created
   */
  investor_policy_supported_issued_instrument_id?: string | null
  /**
   * Fund-manager policy SII context at the time the source was created
   */
  fund_manager_policy_supported_issued_instrument_id?: string | null
  readonly create_time: Date
  readonly update_time: Date
  /**
   * When this source was soft-invalidated; NULL for active sources
   */
  invalid_time?: Date | null
}

/**
 * * `annual` - Annual
 * * `extraordinary` - Extraordinary
 * * `special` - Special
 * * `court_ordered` - Court Ordered
 * * `general` - General
 * * `postal_ballot` - Postal Ballot
 * * `bond_holder` - Bond Holder
 */
export const MeetingTypeEnum = {
  ANNUAL: 'annual',
  EXTRAORDINARY: 'extraordinary',
  SPECIAL: 'special',
  COURT_ORDERED: 'court_ordered',
  GENERAL: 'general',
  POSTAL_BALLOT: 'postal_ballot',
  BOND_HOLDER: 'bond_holder',
} as const

/**
 * * `annual` - Annual
 * * `extraordinary` - Extraordinary
 * * `special` - Special
 * * `court_ordered` - Court Ordered
 * * `general` - General
 * * `postal_ballot` - Postal Ballot
 * * `bond_holder` - Bond Holder
 */
export type MeetingTypeEnum = (typeof MeetingTypeEnum)[keyof typeof MeetingTypeEnum]

export type MinimalInstrument = {
  /**
   * Resource name of the instrument, in the format `instruments/{isin}`.
   */
  readonly name: string
  /**
   * The ISIN of the instrument as defined by ISO 6166. Used as the identifier; it is part of the resource name and so cannot be updated.
   */
  isin: string
  /**
   * A string name representation of the fund. May be thought of as the Issuer Name concatenated with the Name of the instrument.
   */
  title: string
  /**
   * The Classification of Financial Instruments — an uppercase six-letter code describing the structure and function of the instrument.
   */
  cfi: string | null
}

/**
 * Response shape for an Organization.
 *
 * Takes the dict produced by services.build_organization_view (or
 * build_organization_views). The view layer is responsible for assembling
 * that dict from the Organization row plus its joined sub-rows.
 */
export type Organization = {
  readonly name: string
  readonly create_time: Date
  readonly update_time: Date
  legal_title: string
  display_title: string | null
  url: string | null
  logo_url: string | null
  logo_thumbnail_url: string | null
  trbc: string | null
  external_identifiers: Array<OrganizationIdentifier>
  bio: OrganizationBio | null
  issued_isins: Array<string>
  headquarters: OrganizationAddress | null
  industry: Industry | null
  country_of_incorporation_iso2: string | null
}

export type OrganizationAddress = {
  country_code_iso2: string
}

export type OrganizationAddressRequest = {
  country_code_iso2: string
}

export type OrganizationBio = {
  description: string
  source_url: string
  bio_source: BioSourceEnum
}

export type OrganizationBioRequest = {
  description: string
  source_url: string
  bio_source: BioSourceEnum
}

export type OrganizationIdentifier = {
  identifier_type: IdentifierTypeEnum
  value: string
}

export type OrganizationIdentifierRequest = {
  identifier_type: IdentifierTypeEnum
  value: string
}

export type OrganizationLogoUploadRequest = {
  url?: string
  file?: Blob | File
}

/**
 * Request body for searching organizations.
 *
 * Domain validation (name format, identifier pairs, ISINs) is delegated to
 * the filter so behaviour matches the previous query-param-based list
 * endpoint exactly; this serializer only validates the request shape.
 */
export type OrganizationSearchRequestRequest = {
  names?: Array<string>
  search?: string
  identifier_types?: Array<string>
  identifier_values?: Array<string>
  issued_isins?: Array<string>
}

/**
 * * `CBNK` - Central Bank
 * * `CINV` - Collective Investment
 * * `CLGUN` - Academic Institution
 * * `COM` - Business Organization
 * * `GVT` - Government
 * * `GVTDA` - Government Department/Agency
 * * `MKP` - Market Participant
 * * `NGO` - Non-Governmental Organization
 * * `SUPN` - Supranational
 * * `UNK` - Unknown
 */
export const OrganizationTypeEnum = {
  CBNK: 'CBNK',
  CINV: 'CINV',
  CLGUN: 'CLGUN',
  COM: 'COM',
  GVT: 'GVT',
  GVTDA: 'GVTDA',
  MKP: 'MKP',
  NGO: 'NGO',
  SUPN: 'SUPN',
  UNK: 'UNK',
} as const

/**
 * * `CBNK` - Central Bank
 * * `CINV` - Collective Investment
 * * `CLGUN` - Academic Institution
 * * `COM` - Business Organization
 * * `GVT` - Government
 * * `GVTDA` - Government Department/Agency
 * * `MKP` - Market Participant
 * * `NGO` - Non-Governmental Organization
 * * `SUPN` - Supranational
 * * `UNK` - Unknown
 */
export type OrganizationTypeEnum = (typeof OrganizationTypeEnum)[keyof typeof OrganizationTypeEnum]

/**
 * Write shape for both PUT (full replace) and PATCH (partial update).
 *
 * Validation is field-level; required-ness is enforced by passing
 * ``partial=True`` for PATCH at the view layer.
 *
 * Note: ``logo_url`` and ``logo_thumbnail_url`` are read-only - the
 * dedicated logo endpoint owns them, so a generic PUT cannot accidentally
 * clear them by omitting them from the payload.
 */
export type OrganizationWriteRequest = {
  legal_title: string
  display_title?: string | null
  url?: string | null
  trbc?: string | null
  external_identifiers?: Array<OrganizationIdentifierRequest>
  bio?: OrganizationBioRequest | null
  issued_isins?: Array<string>
  headquarters?: OrganizationAddressRequest | null
  industry?: IndustryRequest | null
  country_of_incorporation_iso2?: string | null
}

export type OutstandingShares = {
  /**
   * Identity id of the instrument the share count is reported on.
   */
  readonly instrument_id: string
  /**
   * The number of shares outstanding, excluding any held in treasury.
   */
  readonly value: string
  /**
   * The date the share count is valid for.
   */
  readonly valid_date: Date
}

export type OutstandingSharesUpsertRequest = {
  /**
   * The number of shares outstanding, excluding any held in treasury.
   */
  value: string
  /**
   * The date the share count is valid for.
   */
  valid_date: Date
}

export const PiProposalCategoryEnum = {
  ELECT_DIRECTOR: 'elect_director',
  AUDIT: 'audit',
  SAY_ON_PAY: 'say_on_pay',
  COMPENSATION: 'compensation',
  SECURITY_ISSUANCE: 'security_issuance',
  CAPITAL_STRUCTURE: 'capital_structure',
  REORGANIZATION_MNA: 'reorganization_mna',
  ANTI_TAKEOVER: 'anti_takeover',
  GOVERNANCE_PROVISION: 'governance_provision',
  SHAREHOLDER_REQUEST: 'shareholder_request',
  SUSTAINABILITY_APPROVAL: 'sustainability_approval',
  ADMINISTRATIVE: 'administrative',
  OTHER: 'other',
} as const

export type PiProposalCategoryEnum = (typeof PiProposalCategoryEnum)[keyof typeof PiProposalCategoryEnum]

/**
 * * `automatic` - automatic
 * * `manual` - manual
 */
export const PiProposalCategorySourceEnum = { AUTOMATIC: 'automatic', MANUAL: 'manual' } as const

/**
 * * `automatic` - automatic
 * * `manual` - manual
 */
export type PiProposalCategorySourceEnum =
  (typeof PiProposalCategorySourceEnum)[keyof typeof PiProposalCategorySourceEnum]

/**
 * * `STATUS_PI_PROPOSAL_CATEGORY_CREATED` - STATUS_PI_PROPOSAL_CATEGORY_CREATED
 * * `STATUS_PI_PROPOSAL_CATEGORY_UPDATED` - STATUS_PI_PROPOSAL_CATEGORY_UPDATED
 * * `STATUS_PI_PROPOSAL_CATEGORY_NO_OPERATION` - STATUS_PI_PROPOSAL_CATEGORY_NO_OPERATION
 */
export const PiProposalCategoryUpsertStatusEnum = {
  STATUS_PI_PROPOSAL_CATEGORY_CREATED: 'STATUS_PI_PROPOSAL_CATEGORY_CREATED',
  STATUS_PI_PROPOSAL_CATEGORY_UPDATED: 'STATUS_PI_PROPOSAL_CATEGORY_UPDATED',
  STATUS_PI_PROPOSAL_CATEGORY_NO_OPERATION: 'STATUS_PI_PROPOSAL_CATEGORY_NO_OPERATION',
} as const

/**
 * * `STATUS_PI_PROPOSAL_CATEGORY_CREATED` - STATUS_PI_PROPOSAL_CATEGORY_CREATED
 * * `STATUS_PI_PROPOSAL_CATEGORY_UPDATED` - STATUS_PI_PROPOSAL_CATEGORY_UPDATED
 * * `STATUS_PI_PROPOSAL_CATEGORY_NO_OPERATION` - STATUS_PI_PROPOSAL_CATEGORY_NO_OPERATION
 */
export type PiProposalCategoryUpsertStatusEnum =
  (typeof PiProposalCategoryUpsertStatusEnum)[keyof typeof PiProposalCategoryUpsertStatusEnum]

export const PiProposalSubcategoryEnum = {
  ELECT_DIRECTOR: 'elect_director',
  REMOVE_DIRECTOR: 'remove_director',
  SPILL_RESOLUTION: 'spill_resolution',
  ELECT_SUPERVISORY_BOARD: 'elect_supervisory_board',
  OTHER_DIRECTOR_ELECTION: 'other_director_election',
  APPOINT_OR_RATIFY_AUDITOR: 'appoint_or_ratify_auditor',
  AUDITOR_ROTATION: 'auditor_rotation',
  AUDITOR_REMUNERATION: 'auditor_remuneration',
  DISCHARGE_OF_AUDITORS: 'discharge_of_auditors',
  ACCEPT_FINANCIAL_STATEMENTS: 'accept_financial_statements',
  SPECIAL_AUDIT_REQUEST: 'special_audit_request',
  OTHER_AUDIT: 'other_audit',
  EXECUTIVE_COMPENSATION: 'executive_compensation',
  REMUNERATION_REPORT: 'remuneration_report',
  REMUNERATION_POLICY: 'remuneration_policy',
  GOLDEN_PARACHUTE: 'golden_parachute',
  FREQUENCY: 'frequency',
  OTHER_SAY_ON_PAY: 'other_say_on_pay',
  EQUITY_INCENTIVE_PLAN: 'equity_incentive_plan',
  EMPLOYEE_SHARE_PURCHASE_PLAN: 'employee_share_purchase_plan',
  DIRECTOR_FEES_OR_EQUITY: 'director_fees_or_equity',
  CASH_OR_BONUS_PLAN: 'cash_or_bonus_plan',
  SEVERANCE_OR_PENSION: 'severance_or_pension',
  ANTI_HEDGING_OR_PLEDGING: 'anti_hedging_or_pledging',
  COMPENSATION_CLAWBACK: 'compensation_clawback',
  TRADING_PLAN_10B5_1: 'trading_plan_10b5_1',
  OTHER_COMPENSATION: 'other_compensation',
  ISSUANCE_WITH_PREEMPTIVE_RIGHTS: 'issuance_with_preemptive_rights',
  ISSUANCE_WITHOUT_PREEMPTIVE_RIGHTS: 'issuance_without_preemptive_rights',
  PRIVATE_PLACEMENT: 'private_placement',
  DEBT_OR_CONVERTIBLE: 'debt_or_convertible',
  WARRANTS_OR_RIGHTS: 'warrants_or_rights',
  OTHER_ISSUANCE: 'other_issuance',
  INCREASE_AUTHORISED_CAPITAL: 'increase_authorised_capital',
  SHARE_CLASS_OR_RIGHTS: 'share_class_or_rights',
  SHARE_REPURCHASE: 'share_repurchase',
  STOCK_SPLIT_OR_CONSOLIDATION: 'stock_split_or_consolidation',
  CAPITAL_REDUCTION: 'capital_reduction',
  DIVIDEND_OR_DISTRIBUTION: 'dividend_or_distribution',
  OTHER_CAPITAL_STRUCTURE: 'other_capital_structure',
  MERGER_OR_ACQUISITION: 'merger_or_acquisition',
  ASSET_TRANSACTION: 'asset_transaction',
  RESTRUCTURING_OR_SPINOFF: 'restructuring_or_spinoff',
  LIQUIDATION_OR_GOING_PRIVATE: 'liquidation_or_going_private',
  REINCORPORATION: 'reincorporation',
  TENDER_OFFER: 'tender_offer',
  OTHER_TRANSACTION: 'other_transaction',
  SHAREHOLDER_RIGHTS_PLAN: 'shareholder_rights_plan',
  CONTROL_SHARE_ACQUISITION: 'control_share_acquisition',
  FAIR_PRICE_PROVISION: 'fair_price_provision',
  BLANK_CHEQUE_PREFERRED: 'blank_cheque_preferred',
  ANTI_GREENMAIL: 'anti_greenmail',
  OTHER_DEFENSIVE: 'other_defensive',
  PROXY_ACCESS: 'proxy_access',
  SPECIAL_MEETING_RIGHT: 'special_meeting_right',
  WRITTEN_CONSENT_RIGHT: 'written_consent_right',
  BOARD_CLASSIFICATION: 'board_classification',
  MAJORITY_VOTING_STANDARD: 'majority_voting_standard',
  SUPERMAJORITY_REQUIREMENT: 'supermajority_requirement',
  CUMULATIVE_VOTING: 'cumulative_voting',
  CONFIDENTIAL_VOTING: 'confidential_voting',
  EXCLUSIVE_FORUM: 'exclusive_forum',
  BOARD_SIZE: 'board_size',
  DIRECTOR_TERM_OR_AGE_LIMIT: 'director_term_or_age_limit',
  SEPARATE_CHAIR_AND_CEO: 'separate_chair_and_ceo',
  INDEMNIFICATION_OR_LIABILITY: 'indemnification_or_liability',
  RELATED_PARTY_TRANSACTION: 'related_party_transaction',
  CODES_OF_ETHICS: 'codes_of_ethics',
  AMEND_ARTICLES_GENERAL: 'amend_articles_general',
  OTHER_GOVERNANCE: 'other_governance',
  REQUEST_REPORT_OR_DISCLOSURE: 'request_report_or_disclosure',
  REQUEST_POLICY_OR_TARGET: 'request_policy_or_target',
  REQUEST_INDEPENDENT_ASSESSMENT: 'request_independent_assessment',
  OTHER_SHAREHOLDER_REQUEST: 'other_shareholder_request',
  SAY_ON_CLIMATE: 'say_on_climate',
  SUSTAINABILITY_OR_ESG_REPORT: 'sustainability_or_esg_report',
  OTHER_SUSTAINABILITY_APPROVAL: 'other_sustainability_approval',
  ROUTINE_BUSINESS: 'routine_business',
  ADJOURN_MEETING: 'adjourn_meeting',
  DISCHARGE_OF_DIRECTORS: 'discharge_of_directors',
  OTHER_ADMINISTRATIVE: 'other_administrative',
} as const

export type PiProposalSubcategoryEnum = (typeof PiProposalSubcategoryEnum)[keyof typeof PiProposalSubcategoryEnum]

/**
 * * `climate_transition` - Climate Transition
 * * `ghg_emissions` - GHG Emissions
 * * `physical_climate_risk` - Physical Climate Risk
 * * `energy_mix` - Energy Mix
 * * `deforestation` - Deforestation
 * * `biodiversity` - Biodiversity
 * * `water` - Water
 * * `pollution` - Pollution
 * * `waste_circularity` - Waste Circularity
 * * `animal_welfare` - Animal Welfare
 * * `environmental_justice` - Environmental Justice
 * * `human_rights` - Human Rights
 * * `forced_labour` - Forced Labour
 * * `labour_rights` - Labour Rights
 * * `health_safety` - Health & Safety
 * * `human_capital_management` - Human Capital Management
 * * `pay_equity` - Pay Equity
 * * `board_diversity` - Board Diversity
 * * `workforce_diversity` - Workforce Diversity
 * * `indigenous_rights` - Indigenous Rights
 * * `community_relations` - Community Relations
 * * `public_health` - Public Health
 * * `product_safety` - Product Safety
 * * `political_lobbying` - Political Lobbying
 * * `political_contributions` - Political Contributions
 * * `tax_transparency` - Tax Transparency
 * * `anti_corruption` - Anti-Corruption
 * * `data_privacy` - Data Privacy
 * * `ai_governance` - AI Governance
 */
export const PiProposalTopicEnum = {
  CLIMATE_TRANSITION: 'climate_transition',
  GHG_EMISSIONS: 'ghg_emissions',
  PHYSICAL_CLIMATE_RISK: 'physical_climate_risk',
  ENERGY_MIX: 'energy_mix',
  DEFORESTATION: 'deforestation',
  BIODIVERSITY: 'biodiversity',
  WATER: 'water',
  POLLUTION: 'pollution',
  WASTE_CIRCULARITY: 'waste_circularity',
  ANIMAL_WELFARE: 'animal_welfare',
  ENVIRONMENTAL_JUSTICE: 'environmental_justice',
  HUMAN_RIGHTS: 'human_rights',
  FORCED_LABOUR: 'forced_labour',
  LABOUR_RIGHTS: 'labour_rights',
  HEALTH_SAFETY: 'health_safety',
  HUMAN_CAPITAL_MANAGEMENT: 'human_capital_management',
  PAY_EQUITY: 'pay_equity',
  BOARD_DIVERSITY: 'board_diversity',
  WORKFORCE_DIVERSITY: 'workforce_diversity',
  INDIGENOUS_RIGHTS: 'indigenous_rights',
  COMMUNITY_RELATIONS: 'community_relations',
  PUBLIC_HEALTH: 'public_health',
  PRODUCT_SAFETY: 'product_safety',
  POLITICAL_LOBBYING: 'political_lobbying',
  POLITICAL_CONTRIBUTIONS: 'political_contributions',
  TAX_TRANSPARENCY: 'tax_transparency',
  ANTI_CORRUPTION: 'anti_corruption',
  DATA_PRIVACY: 'data_privacy',
  AI_GOVERNANCE: 'ai_governance',
} as const

/**
 * * `climate_transition` - Climate Transition
 * * `ghg_emissions` - GHG Emissions
 * * `physical_climate_risk` - Physical Climate Risk
 * * `energy_mix` - Energy Mix
 * * `deforestation` - Deforestation
 * * `biodiversity` - Biodiversity
 * * `water` - Water
 * * `pollution` - Pollution
 * * `waste_circularity` - Waste Circularity
 * * `animal_welfare` - Animal Welfare
 * * `environmental_justice` - Environmental Justice
 * * `human_rights` - Human Rights
 * * `forced_labour` - Forced Labour
 * * `labour_rights` - Labour Rights
 * * `health_safety` - Health & Safety
 * * `human_capital_management` - Human Capital Management
 * * `pay_equity` - Pay Equity
 * * `board_diversity` - Board Diversity
 * * `workforce_diversity` - Workforce Diversity
 * * `indigenous_rights` - Indigenous Rights
 * * `community_relations` - Community Relations
 * * `public_health` - Public Health
 * * `product_safety` - Product Safety
 * * `political_lobbying` - Political Lobbying
 * * `political_contributions` - Political Contributions
 * * `tax_transparency` - Tax Transparency
 * * `anti_corruption` - Anti-Corruption
 * * `data_privacy` - Data Privacy
 * * `ai_governance` - AI Governance
 */
export type PiProposalTopicEnum = (typeof PiProposalTopicEnum)[keyof typeof PiProposalTopicEnum]

export type PaginatedAuditEventList = {
  next?: string | null
  previous?: string | null
  results: Array<AuditEvent>
}

export type PaginatedBallotEntitlementList = {
  next?: string | null
  previous?: string | null
  results: Array<BallotEntitlement>
}

export type PaginatedBallotList = {
  next?: string | null
  previous?: string | null
  results: Array<Ballot>
}

export type PaginatedCustodyAccountGroupList = {
  next?: string | null
  previous?: string | null
  results: Array<CustodyAccountGroup>
}

export type PaginatedCustodyAccountGroupMembershipList = {
  next?: string | null
  previous?: string | null
  results: Array<CustodyAccountGroupMembership>
}

export type PaginatedCustodyAccountList = {
  next?: string | null
  previous?: string | null
  results: Array<CustodyAccount>
}

export type PaginatedCustodyAccountTenantLinkList = {
  next?: string | null
  previous?: string | null
  results: Array<CustodyAccountTenantLink>
}

export type PaginatedCustodyAccountVotingPolicySelectionList = {
  next?: string | null
  previous?: string | null
  results: Array<CustodyAccountVotingPolicySelection>
}

export type PaginatedDirectVotingBallotStampList = {
  next?: string | null
  previous?: string | null
  results: Array<DirectVotingBallotStamp>
}

export type PaginatedDirectVotingBallotWorkflowItemList = {
  next?: string | null
  previous?: string | null
  results: Array<DirectVotingBallotWorkflowItem>
}

export type PaginatedDirectVotingBeaconRuleOutputList = {
  next?: string | null
  previous?: string | null
  results: Array<DirectVotingBeaconRuleOutput>
}

export type PaginatedDirectVotingRulesEngineRuleList = {
  next?: string | null
  previous?: string | null
  results: Array<DirectVotingRulesEngineRule>
}

export type PaginatedDirectVotingRulesEngineRulesListList = {
  next?: string | null
  previous?: string | null
  results: Array<DirectVotingRulesEngineRulesList>
}

export type PaginatedDirectVotingWatchlistItemList = {
  next?: string | null
  previous?: string | null
  results: Array<DirectVotingWatchlistItem>
}

export type PaginatedDirectVotingWatchlistList = {
  next?: string | null
  previous?: string | null
  results: Array<DirectVotingWatchlist>
}

export type PaginatedFiscalYearList = {
  next?: string | null
  previous?: string | null
  results: Array<FiscalYear>
}

export type PaginatedFundList = {
  next?: string | null
  previous?: string | null
  results: Array<Fund>
}

export type PaginatedFundManagerList = {
  next?: string | null
  previous?: string | null
  results: Array<FundManager>
}

export type PaginatedFundManagerPolicySiiList = {
  next?: string | null
  previous?: string | null
  results: Array<FundManagerPolicySii>
}

export type PaginatedFundManagerPublicSecurityIdList = {
  next?: string | null
  previous?: string | null
  results: Array<FundManagerPublicSecurityId>
}

export type PaginatedFundManagerSupportedVotingPolicyHistoricalList = {
  next?: string | null
  previous?: string | null
  results: Array<FundManagerSupportedVotingPolicyHistorical>
}

export type PaginatedFundQuantificationSnapshotList = {
  next?: string | null
  previous?: string | null
  results: Array<FundQuantificationSnapshot>
}

export type PaginatedFundVariantList = {
  next?: string | null
  previous?: string | null
  results: Array<FundVariant>
}

export type PaginatedGeneralMeetingList = {
  next?: string | null
  previous?: string | null
  results: Array<GeneralMeeting>
}

export type PaginatedInstrumentList = {
  next?: string | null
  previous?: string | null
  results: Array<Instrument>
}

export type PaginatedInvestorPolicySiiList = {
  next?: string | null
  previous?: string | null
  results: Array<InvestorPolicySii>
}

export type PaginatedInvestorSupportedIssuedInstrumentList = {
  next?: string | null
  previous?: string | null
  results: Array<InvestorSupportedIssuedInstrument>
}

export type PaginatedIssuerInstrumentList = {
  next?: string | null
  previous?: string | null
  results: Array<IssuerInstrument>
}

export type PaginatedIssuerList = {
  next?: string | null
  previous?: string | null
  results: Array<Issuer>
}

export type PaginatedMeetingAssignmentList = {
  next?: string | null
  previous?: string | null
  results: Array<MeetingAssignment>
}

export type PaginatedMeetingBallotList = {
  next?: string | null
  previous?: string | null
  results: Array<MeetingBallot>
}

export type PaginatedMeetingBallotSourceList = {
  next?: string | null
  previous?: string | null
  results: Array<MeetingBallotSource>
}

export type PaginatedMeetingList = {
  next?: string | null
  previous?: string | null
  results: Array<Meeting>
}

export type PaginatedOrganizationList = {
  next?: string | null
  previous?: string | null
  results: Array<Organization>
}

export type PaginatedPiBallotSearchList = {
  next?: string | null
  previous?: string | null
  results: Array<PiBallotSearch>
}

export type PaginatedPiMeetingSearchList = {
  next?: string | null
  previous?: string | null
  results: Array<PiMeetingSearch>
}

export type PaginatedProposalList = {
  next?: string | null
  previous?: string | null
  results: Array<Proposal>
}

export type PaginatedProposalSetRecommendationCoverageList = {
  next?: string | null
  previous?: string | null
  results: Array<ProposalSetRecommendationCoverage>
}

export type PaginatedProviderList = {
  next?: string | null
  previous?: string | null
  results: Array<Provider>
}

export type PaginatedProviderVotingRecommendationList = {
  next?: string | null
  previous?: string | null
  results: Array<ProviderVotingRecommendation>
}

export type PaginatedProxyIntermediaryList = {
  next?: string | null
  previous?: string | null
  results: Array<ProxyIntermediary>
}

export type PaginatedProxyIntermediaryMeetingAuditEventList = {
  next?: string | null
  previous?: string | null
  results: Array<ProxyIntermediaryMeetingAuditEvent>
}

export type PaginatedProxyIntermediaryMeetingList = {
  next?: string | null
  previous?: string | null
  results: Array<ProxyIntermediaryMeeting>
}

export type PaginatedProxyIntermediaryProposalList = {
  next?: string | null
  previous?: string | null
  results: Array<ProxyIntermediaryProposal>
}

export type PaginatedProxyIntermediaryVotingRecommendationList = {
  next?: string | null
  previous?: string | null
  results: Array<ProxyIntermediaryVotingRecommendation>
}

export type PaginatedPublicSecurityIdList = {
  next?: string | null
  previous?: string | null
  results: Array<PublicSecurityId>
}

export type PaginatedRoleList = {
  next?: string | null
  previous?: string | null
  results: Array<Role>
}

export type PaginatedRulesEngineDefinitionList = {
  next?: string | null
  previous?: string | null
  results: Array<RulesEngineDefinition>
}

export type PaginatedRulesEngineRuleList = {
  next?: string | null
  previous?: string | null
  results: Array<RulesEngineRule>
}

export type PaginatedSplitVoteInstructionOverwriteReasonList = {
  next?: string | null
  previous?: string | null
  results: Array<SplitVoteInstructionOverwriteReason>
}

export type PaginatedTenantBallotList = {
  next?: string | null
  previous?: string | null
  results: Array<TenantBallot>
}

export type PaginatedTenantList = {
  next?: string | null
  previous?: string | null
  results: Array<Tenant>
}

export type PaginatedTenantMeetingList = {
  next?: string | null
  previous?: string | null
  results: Array<TenantMeeting>
}

export type PaginatedUserList = {
  next?: string | null
  previous?: string | null
  results: Array<User>
}

export type PaginatedVotingPolicyDocumentList = {
  next?: string | null
  previous?: string | null
  results: Array<VotingPolicyDocument>
}

export type PaginatedVotingPolicyList = {
  next?: string | null
  previous?: string | null
  results: Array<VotingPolicy>
}

export type PaginatedVotingRecommendationList = {
  next?: string | null
  previous?: string | null
  results: Array<VotingRecommendation>
}

/**
 * A custody account group of the acting tenant; the tenant is taken from the request, never the body.
 */
export type PatchedCustodyAccountGroupRequest = {
  /**
   * Free-text label that names the group within its tenant.
   */
  title?: string
}

export type PatchedCustodyAccountRequest = {
  /**
   * The proxy intermediary that reported this custody account.
   */
  proxy_intermediary_id?: string
  /**
   * Identifier of the custodian (institution) holding the account within the proxy intermediary
   *
   * also known as custodian_account_id.
   */
  custodian_id?: string
  /**
   * Account number identifying the asset owner's account (e.g. a fund) at the custodian holding it, as reported by a proxy intermediary. Unique only in combination with the custodian within the reporting proxy intermediary.
   */
  custodian_account_number?: string
  /**
   * title of the custodian account for display purposes.
   */
  title?: string
}

/**
 * Read/write serializer for the current version of a custody account voting policy selection.
 */
export type PatchedCustodyAccountVotingPolicySelectionRequest = {
  /**
   * The tenant that votes under this policy selection.
   */
  tenant_id?: string
  /**
   * The custody account the voting policy applies to. Immutable once set.
   */
  custody_account_id?: string
  /**
   * The voting policy the custody account votes under.
   */
  voting_policy_id?: string
}

/**
 * Current version of a ballot workflow item; ``id`` is the identity, stable across versions.
 *
 * ``pi_ballot_id`` and ``custody_account_group_id`` are fixed once the item is created.
 * ``assigned_by_id`` is never written by the caller: the server records the acting user whenever
 * ``assigned_to_id`` changes.
 */
export type PatchedDirectVotingBallotWorkflowItemRequest = {
  /**
   * Identity id of the proxy intermediary ballot the workflow item tracks. Immutable once set.
   */
  pi_ballot_id?: string
  /**
   * Id of the acting tenant's custody account group the item covers the ballot for, or null for the ballot as a whole. Immutable once set.
   */
  custody_account_group_id?: string | null
  /**
   * Whether the ballot must be reviewed before it is instructed. Defaults to false.
   */
  review_required?: boolean
  /**
   * Id of the acting tenant's user the ballot is assigned to, or null to leave it unassigned.
   */
  assigned_to_id?: string | null
}

/**
 * Read/write serializer for the current version of a rule.
 *
 * The tenant is taken from the acting-tenant header rather than the body, so it is not a field.
 */
export type PatchedDirectVotingRulesEngineRuleRequest = {
  /**
   * Identity id of the rules list the rule belongs to. Fixed once the rule is created.
   */
  rules_list_id?: string
  /**
   * Free-text label that names the rule.
   */
  title?: string
  /**
   * Which parameter model and processor the rule's engine applies to its params.
   *
   * * `custody_account_group_membership` - Custody Account Group Membership
   * * `conflict_of_interest` - Conflict Of Interest
   * * `do_not_vote` - Do Not Vote
   * * `custody_account_group_isin_watchlist` - Custody Account Group Isin Watchlist
   * * `custody_account_group_watchlist` - Custody Account Group Watchlist
   * * `policy_refer` - Policy Refer
   */
  rule_type?: DirectVotingRuleTypeEnum
  /**
   * JSON object holding the rule's parameters. Its contents are interpreted by the engine that evaluates the rule, not here.
   */
  params?: unknown
}

/**
 * Read/write serializer for the current version of a rules list.
 *
 * The tenant is taken from the acting-tenant header rather than the body, so it is not a field.
 */
export type PatchedDirectVotingRulesEngineRulesListRequest = {
  /**
   * The rules engine that evaluates the list's rules. Fixed once the list is created.
   *
   * * `ballot_stamping` - Ballot Stamping
   * * `ballot_review` - Ballot Review
   */
  rules_engine?: RulesEngineEnum
  /**
   * Free-text label that names the list within its engine.
   */
  title?: string
}

/**
 * Read/write serializer for the current version of a watchlist.
 *
 * The tenant is taken from the acting-tenant header rather than the body, so it is not a field.
 */
export type PatchedDirectVotingWatchlistRequest = {
  /**
   * Free-text label that names the watchlist within its tenant.
   */
  title?: string
  /**
   * Optional free-text account of what the watchlist tracks.
   */
  description?: string | null
}

/**
 * Write shape for both POST (create) and PATCH (partial update).
 *
 * Required-ness is enforced by passing ``partial=True`` for PATCH at the view
 * layer. Generated fields (``name``, ``create_time``, ``update_time``, the
 * ``*_time`` columns derived from the boolean flags) are not writable.
 *
 * The proxy-deadline-before-meeting-date constraint depends on the resulting
 * (merged) entity, so it is enforced in the service rather than here.
 */
export type PatchedGeneralMeetingWriteRequest = {
  /**
   * The name of the organization that this general meeting is for, of the form 'organizations/{uuid}'.
   */
  organization_name?: string
  /**
   * The type of the general meeting.
   *
   * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
   * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
   * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
   * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
   * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
   * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
   * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
   */
  type?: GeneralMeetingWriteTypeEnum
  /**
   * The date of the general meeting.
   */
  meeting_date?: Date
  /**
   * The time the general meeting became invalid.
   */
  invalid_time?: Date | null
  /**
   * The time the general meeting was announced.
   */
  announcement_time?: Date | null
  /**
   * The EDI event ID for the general meeting as presented in the EDI Worldwide Corporate Actions service.
   */
  edi_event_id?: string | null
  /**
   * URL of the official general meeting announcement.
   */
  announcement_url?: string | null
  /**
   * URL linking to a page containing the proxy notice of the general meeting.
   */
  proxy_notice_url?: string | null
  /**
   * URL of the official results for the general meeting.
   */
  results_url?: string | null
  /**
   * The record date for the general meeting: the date on which shareholders must have owned shares in order to be eligible to vote.
   */
  record_date?: Date | null
  /**
   * The record date for the general meeting as reported by EDI.
   */
  edi_record_date?: Date | null
  /**
   * Set to true if voting should be enabled for this general meeting.
   */
  voting_enabled?: boolean
  /**
   * Set to true if the EDI agenda pipelines should be disabled for this general meeting.
   */
  disable_edi_agenda_pipeline_updates?: boolean
  /**
   * The proxy submission deadlines for the general meeting.
   */
  proxy_submission?: ProxySubmissionRequest | null
  /**
   * Index to distinguish duplicated general meetings for the same organization, meeting date and meeting type. Defaults to 0.
   */
  duplicate_index?: number
}

/**
 * Write shape for both PUT (full replace) and PATCH (partial update).
 *
 * Validation is field-level; required-ness is enforced by passing
 * ``partial=True`` for PATCH at the view layer.
 *
 * Note: ``logo_url`` and ``logo_thumbnail_url`` are read-only - the
 * dedicated logo endpoint owns them, so a generic PUT cannot accidentally
 * clear them by omitting them from the payload.
 */
export type PatchedOrganizationWriteRequest = {
  legal_title?: string
  display_title?: string | null
  url?: string | null
  trbc?: string | null
  external_identifiers?: Array<OrganizationIdentifierRequest>
  bio?: OrganizationBioRequest | null
  issued_isins?: Array<string>
  headquarters?: OrganizationAddressRequest | null
  industry?: IndustryRequest | null
  country_of_incorporation_iso2?: string | null
}

/**
 * Partial-update (PATCH) shape for a proposal.
 *
 * Every field is optional. Fields omitted from the request are preserved from
 * the proposal's current version by the service; a field sent with a value
 * overwrites it, and a nullable field sent as null clears it. The three code
 * lists drop the write serializer's ``default=list`` so that omitting one
 * preserves the existing codes rather than clearing them — sending an empty
 * list still clears.
 */
export type PatchedProposalPatchRequest = {
  /**
   * The alphanumeric sequence identifier for the proposal within the meeting.
   */
  sequence_identifier?: string
  /**
   * The human-readable title of the proposal.
   */
  title?: string
  /**
   * Optional long-form description of the proposal.
   */
  description?: string | null
  /**
   * The management voting recommendation.
   */
  management_recommendation?: ProposalManagementRecommendationRequest | null
  /**
   * Who proposed this: a PROPOSAL_SOURCE_* enum name.
   *
   * * `PROPOSAL_SOURCE_MANAGEMENT` - PROPOSAL_SOURCE_MANAGEMENT
   * * `PROPOSAL_SOURCE_SHAREHOLDER` - PROPOSAL_SOURCE_SHAREHOLDER
   */
  source?: SourceEnum
  /**
   * The fraction of votes required for the proposal to pass.
   */
  pass_threshold?: ProposalPassThresholdRequest | null
  /**
   * The voting outcome for this proposal.
   */
  outcome?: ProposalOutcomeRequest | null
  /**
   * The EDI numeric identifier for this proposal.
   */
  edi_proposal_identifier?: number | null
  /**
   * The resource name of the parent proposal, if this is a sub-proposal.
   */
  parent_proposal_name?: string | null
  /**
   * The EDI sequence number for this proposal.
   */
  edi_sequence_number?: number | null
  /**
   * Whether shareholders can cast votes on this proposal.
   */
  votable?: boolean
  /**
   * Full text of the proposal as supplied by EDI.
   */
  full_text?: string | null
  /**
   * Classification codes to associate with this proposal. Replaces the existing set when sent.
   */
  classification_codes?: Array<string>
  /**
   * The set of valid voting options for this proposal. Replaces the existing set when sent.
   */
  voting_options?: Array<VotingOptionsEnum>
  /**
   * The time the proposal was withdrawn. Null if not withdrawn.
   */
  withdraw_time?: Date | null
  /**
   * SEC category codes to associate with this proposal. Replaces the existing set when sent.
   */
  sec_classification_codes?: Array<string>
}

export type PatchedRoleRequest = {
  /**
   * Free-text label that names the role within its tenant.
   */
  name?: string
  /**
   * Free-text explanation of who the role is for.
   */
  description?: string
}

export type PatchedVotingPolicyDocumentUpdateRequest = {
  /**
   * The document title.
   */
  title?: string
  /**
   * The document's official publication time.
   */
  issue_time?: Date
}

/**
 * Request body for partial-updating a voting policy.
 *
 * Only the fields present in the request body are updated; absent fields are left
 * untouched. All fields are optional, but supplying `available_to_investor_type` as
 * an empty list is rejected (the policy must remain available to at least one
 * investor type).
 */
export type PatchedVotingPolicyUpdateRequest = {
  /**
   * The voting policy title. Maximum 150 characters.
   */
  title?: string
  /**
   * Optional abbreviated title for the voting policy.
   */
  title_abbreviation?: string | null
  /**
   * Title of the policy provider.
   */
  policy_provider?: string
  /**
   * The description of the voting policy.
   */
  formatted_description?: string
  /**
   * Optional external identifier used to link to upstream policy systems.
   */
  external_id?: string | null
  /**
   * Investor types this policy is available to. At least one is required if supplied.
   */
  available_to_investor_type?: Array<AvailableToInvestorTypeEnum>
  /**
   * Optional Cloudinary URL for the voting policy image.
   */
  image_url?: string | null
}

/**
 * Only voting_instruction and rationale may be updated.
 */
export type PatchedVotingRecommendationUpdateRequest = {
  /**
   * The updated voting instruction.
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `no_action` - No Action
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `do_not_vote` - Do Not Vote
   */
  voting_instruction?: VotingInstructionEnum
  /**
   * The updated rationale. Maximum 5000 characters.
   */
  rationale?: string | null
}

/**
 * The representation of a permission group returned by every tenancy endpoint.
 */
export type PermissionGroup = {
  /**
   * Unique identifier for the permission group
   */
  id: string
  /**
   * Free-text label that names the group within its tenant
   */
  name: string
  /**
   * What the group allows
   */
  description: string
  /**
   * The permissions the group grants, e.g. ballot.read
   */
  permissions: Array<string>
  /**
   * The time the group was created
   */
  create_time: Date
  /**
   * The time the group was last updated
   */
  update_time: Date
}

/**
 * The request body accepted when creating or updating a permission group.
 */
export type PermissionGroupWriteRequest = {
  /**
   * Free-text label that names the group within its tenant
   */
  name: string
  /**
   * What the group allows
   */
  description?: string
  /**
   * The permissions the group grants, e.g. ballot.read; each may appear once
   */
  permissions: Array<string>
}

/**
 * Serializer for PI ballot search results.
 */
export type PiBallotSearch = {
  /**
   * Unique identifier for this specific version of the ballot
   */
  ballot_version_id: string
  /**
   * Resource name for the proxy intermediary ballot in the format used by the workflow system.
   */
  readonly proxy_intermediary_ballot_name: string
  /**
   * Resource name for the proxy intermediary meeting in the format used by the workflow system.
   */
  readonly proxy_intermediary_meeting_name: string
  /**
   * Total number of shares available for voting on this ballot
   */
  available_shares: number
  /**
   * Unique identity identifier for the ballot across all versions
   */
  ballot_identity_id: string
  /**
   * External system identifier for the ballot (e.g., from proxy intermediary platform)
   */
  ballot_external_id: string
  /**
   * Indicates if this is the most recent active version of the ballot
   */
  ballot_version_is_current: boolean
  /**
   * Total number of ballots associated with the same proxy intermediary meeting
   */
  ballots_per_meeting: number
  /**
   * Internal identifier for the custodian account holding the shares
   */
  custodian_account_id: string
  /**
   * Account number assigned by the custodian institution
   */
  custodian_account_number: string
  /**
   * Descriptive name or title of the custodian account
   */
  custodian_account_title: string
  /**
   * Indicates if the ballot aligns with the fund manager's voting policy
   */
  fund_manager_policy_supported: boolean
  /**
   * Name of the fund manager organization that manages the fund
   */
  fund_manager_title?: string | null
  /**
   * UUID of the fund manager record
   */
  fund_manager_id?: string | null
  /**
   * Name of the investment fund that owns the shares being voted
   */
  fund_title: string
  /**
   * Official name of the shareholder meeting (e.g., Annual General Meeting 2024)
   */
  general_meeting_name: string
  /**
   * Indicates if the ballot aligns with investor voting guidelines
   */
  investor_supported: boolean
  /**
   * Indicates if the ballot is supported by formal investor policy recommendations
   */
  investor_policy_supported: boolean
  /**
   * Name of the company or organization holding the shareholder meeting
   */
  organization_title: string
  /**
   * CUSIP, ISIN, or other public identifier for the security being voted on
   */
  owned_public_security_id: string
  /**
   * Display name of the proxy intermediary service provider
   */
  proxy_intermediary_title: string
  /**
   * Meeting identifier where this ballot is being voted on
   */
  proxy_intermediary_meeting_id: string
  /**
   * Identifier for the proxy intermediary managing this ballot
   */
  proxy_intermediary_id: string
  /**
   * Indicates if additional validation is needed for split voting scenarios
   */
  split_vote_check_required: boolean
  /**
   * Cutoff date and time for submitting votes on this ballot
   */
  vote_deadline: Date
  /**
   * Current state in the voting workflow (e.g. pending, submitted, checked)
   */
  workflow_status: string
  /**
   * Username of the person who submitted the vote for processing
   */
  workflow_submitter: string
  /**
   * Username of the person who reviewed and approved the vote submission
   */
  workflow_checker: string
  /**
   * UUID of the fund record, used to construct the fund resource name
   */
  fund_id?: string | null
}

/**
 * Serializer for PI meeting search results.
 */
export type PiMeetingSearch = {
  /**
   * Unique identifier for this specific version of the meeting
   */
  meeting_version_id: string
  /**
   * Resource name for the proxy intermediary meeting in the format used by the workflow system.
   */
  readonly proxy_intermediary_meeting_name: string
  proxy_intermediary: ProxyIntermediaryEnum | null
  /**
   * Unique identity identifier for the meeting across all versions
   */
  meeting_identity_id: string
  /**
   * Indicates if this is the most recent active version of the meeting
   */
  meeting_version_is_current: boolean
  /**
   * Meeting identifier within the proxy intermediary system
   */
  proxy_intermediary_meeting_id: string
  /**
   * Identifier for the proxy intermediary managing this meeting
   */
  proxy_intermediary_id: string
  /**
   * External system identifier for the meeting (e.g., from proxy intermediary platform)
   */
  meeting_external_id: string
  /**
   * Name of the company or organization holding the shareholder meeting
   */
  organization_title: string
  /**
   * Official name of the shareholder meeting (e.g., Annual General Meeting 2024)
   */
  transparency_general_meeting_name: string
  /**
   * Type of meeting (e.g., Annual General Meeting, Extraordinary General Meeting)
   */
  meeting_type: string
  /**
   * Date and time when the meeting is scheduled to occur
   */
  meeting_time: Date
  /**
   * Cutoff date and time for submitting votes for this meeting
   */
  submission_deadline: Date
  /**
   * Record date for determining shareholder eligibility
   */
  record_date?: Date | null
  /**
   * Indicates if the meeting contains contested proposals
   */
  is_contested: boolean
  /**
   * Indicates if split voting is supported for this meeting
   */
  is_split_voting_supported?: boolean | null
  /**
   * Additional comments or notes about the meeting
   */
  meeting_comment?: string | null
  /**
   * Reason why the meeting might not be supported
   */
  unsupported_reason?: string | null
  /**
   * Date and time when the meeting was cancelled, if applicable
   */
  cancel_time?: Date | null
  /**
   * Array of security identifiers associated with this meeting
   */
  security_ids?: Array<string> | null
  /**
   * Identifier for the voting operations workflow
   */
  workflow_id?: string | null
  /**
   * Current state in the voting workflow (e.g. new, ready_for_refinement, successful)
   */
  workflow_status?: string | null
  /**
   * Username of the person assigned to refine the meeting data
   */
  workflow_refiner?: string | null
  /**
   * Username of the person assigned to check the meeting data
   */
  workflow_checker?: string | null
  /**
   * Display name of the proxy intermediary service provider
   */
  proxy_intermediary_title?: string | null
  /**
   * Indicates if any of the meeting's securities are supported by investor policies
   */
  investor_supported?: boolean
  /**
   * Indicates if any of the meeting's securities are supported by investor policy guidelines
   */
  investor_policy_supported?: boolean
  /**
   * Indicates if any of the meeting's securities are supported by fund manager policies
   */
  fund_manager_policy_supported?: boolean
  /**
   * Number of ballots associated with this meeting
   */
  ballot_count: number
  /**
   * Indicates if the meeting has associated ballots available for voting
   */
  has_ballots: boolean
  /**
   * Date and time when the meeting was first created in the proxy intermediary system
   */
  meeting_create_time: Date
  /**
   * Latest valid_to date across all SIIs for this meeting's securities, or NULL if any SII has no expiry
   */
  latest_valid_to_sii?: Date | null
  /**
   * the earliest submission deadline for ballots on the meetingnull if no ballots with submission deadlines present
   */
  earliest_ballot_submission_deadline?: Date | null
}

/**
 * Serializer for a policy.
 */
export type Policy = {
  /**
   * Unique identifier for the policy
   */
  readonly id: string
  /**
   * Identifier to be shared externally with integrated parties
   */
  readonly external_id: string
  /**
   * Title of the voting policy
   */
  title: string
  /**
   * Title of the voting policy provider
   */
  provider_title: string
  /**
   * Description of the voting policy in formatted text
   */
  formatted_description?: string | null
  /**
   * Key referencing the document associated with the voting policy
   */
  document_key?: string | null
  /**
   * Indicates if the selected policy is currently available on direct outreach
   */
  is_available?: boolean | null
  /**
   * When the voting policy was created
   */
  readonly create_time: Date
  /**
   * When the voting policy was last updated
   */
  readonly update_time: Date
}

/**
 * * `for` - For
 * * `against` - Against
 * * `abstain` - Abstain
 * * `withhold` - Withhold
 * * `no_action` - No Action
 * * `one_year` - One Year
 * * `two_years` - Two Years
 * * `three_years` - Three Years
 * * `do_not_vote` - Do Not Vote
 */
export const PolicyInstructionEnum = {
  FOR: 'for',
  AGAINST: 'against',
  ABSTAIN: 'abstain',
  WITHHOLD: 'withhold',
  NO_ACTION: 'no_action',
  ONE_YEAR: 'one_year',
  TWO_YEARS: 'two_years',
  THREE_YEARS: 'three_years',
  DO_NOT_VOTE: 'do_not_vote',
} as const

/**
 * * `for` - For
 * * `against` - Against
 * * `abstain` - Abstain
 * * `withhold` - Withhold
 * * `no_action` - No Action
 * * `one_year` - One Year
 * * `two_years` - Two Years
 * * `three_years` - Three Years
 * * `do_not_vote` - Do Not Vote
 */
export type PolicyInstructionEnum = (typeof PolicyInstructionEnum)[keyof typeof PolicyInstructionEnum]

/**
 * Serializer for a policy.
 */
export type PolicyRequest = {
  /**
   * Title of the voting policy
   */
  title: string
  /**
   * Title of the voting policy provider
   */
  provider_title: string
  /**
   * Description of the voting policy in formatted text
   */
  formatted_description?: string | null
  /**
   * Key referencing the document associated with the voting policy
   */
  document_key?: string | null
  /**
   * Indicates if the selected policy is currently available on direct outreach
   */
  is_available?: boolean | null
}

/**
 * Serializer for policy response.
 */
export type PolicyResponse = {
  /**
   * Unique identifier for the policy
   */
  readonly id: string
  /**
   * Identifier to be shared externally with integrated parties
   */
  external_id: string
  /**
   * Title of the voting policy
   */
  title: string
  /**
   * Title of the voting policy provider
   */
  provider_title: string
  /**
   * Description of the voting policy in formatted text
   */
  formatted_description?: string | null
  /**
   * Key referencing the document associated with the voting policy
   */
  document_key?: string | null
  /**
   * Indicates if the selected policy is currently available on direct outreach
   */
  is_available?: boolean | null
  /**
   * When the voting policy was created
   */
  readonly create_time: Date
  /**
   * When the voting policy was last updated
   */
  readonly update_time: Date
}

/**
 * * `PTV` - PTV
 * * `Shareholder` - Shareholder
 */
export const ProductEnum = { PTV: 'PTV', SHAREHOLDER: 'Shareholder' } as const

/**
 * * `PTV` - PTV
 * * `Shareholder` - Shareholder
 */
export type ProductEnum = (typeof ProductEnum)[keyof typeof ProductEnum]

/**
 * Response shape for a Proposal (current version).
 */
export type Proposal = {
  /**
   * The proposal resource name, of the form 'organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}'.
   */
  readonly name: string
  /**
   * The alphanumeric sequence identifier for the proposal within the meeting.
   */
  sequence_identifier: string
  /**
   * The human-readable title of the proposal.
   */
  title: string
  /**
   * Optional long-form description of the proposal.
   */
  description?: string | null
  /**
   * The management voting recommendation.
   */
  management_recommendation?: ProposalManagementRecommendation | null
  /**
   * Who proposed this: a PROPOSAL_SOURCE_* enum name.
   *
   * * `PROPOSAL_SOURCE_MANAGEMENT` - PROPOSAL_SOURCE_MANAGEMENT
   * * `PROPOSAL_SOURCE_SHAREHOLDER` - PROPOSAL_SOURCE_SHAREHOLDER
   */
  source: SourceEnum
  /**
   * The fraction of votes required for the proposal to pass.
   */
  pass_threshold?: ProposalPassThreshold | null
  /**
   * The voting outcome for this proposal.
   */
  outcome?: ProposalOutcome | null
  /**
   * The EDI numeric identifier for this proposal.
   */
  edi_proposal_identifier?: number | null
  /**
   * The resource name of the parent proposal, if this is a sub-proposal.
   */
  parent_proposal_name?: string | null
  /**
   * The EDI sequence number for this proposal.
   */
  edi_sequence_number?: number | null
  /**
   * Whether shareholders can cast votes on this proposal.
   */
  votable: boolean
  /**
   * Full text of the proposal as supplied by EDI.
   */
  full_text?: string | null
  /**
   * Classification codes linked to this proposal.
   */
  classification_codes: Array<string>
  /**
   * The set of valid voting options for this proposal.
   */
  voting_options: Array<VotingOptionsEnum>
  /**
   * The time the proposal was withdrawn. Null if not withdrawn.
   */
  withdraw_time?: Date | null
  /**
   * Computed: true when votable=true and withdraw_time is null.
   */
  readonly currently_votable: boolean | null
  /**
   * SEC category codes linked to this proposal.
   */
  sec_classification_codes: Array<string>
  /**
   * The time this proposal version was created.
   */
  readonly create_time: Date
  /**
   * The time this proposal version was last updated.
   */
  readonly update_time: Date
  /**
   * The time this version was superseded (soft-delete marker). Null if current.
   */
  readonly delete_time: Date | null
}

export type ProposalCategory = {
  /**
   * The proxy intermediary this category belongs to.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * The id of the transparency proposal this category refers to.
   */
  transparency_proposal_id: string
  /**
   * The free-text category assigned to the proposal.
   */
  proposal_category: string
}

export type ProposalClassificationCodesResponse = {
  /**
   * Map of classification code to title.
   */
  classification_codes: {
    [key: string]: string
  }
}

/**
 * Request body for counting proposals per general meeting.
 */
export type ProposalCountRequestRequest = {
  /**
   * General meeting resource names to count proposals for.
   */
  general_meeting_names: Array<string>
}

export type ProposalCountResponse = {
  /**
   * Map of general meeting resource name to proposal count.
   */
  counts: {
    [key: string]: number
  }
}

/**
 * Request body for fetching proposal resource names from identity UUIDs.
 */
export type ProposalFetchNamesFromIdsRequestRequest = {
  /**
   * Proposal identity UUIDs to resolve to resource names.
   */
  proposal_ids: Array<string>
}

export type ProposalFetchNamesFromIdsResponse = {
  /**
   * Resolved proposal resource names.
   */
  proposal_names: Array<string>
}

/**
 * Request body for fetching proposals across multiple general meetings.
 */
export type ProposalFetchRequestRequest = {
  /**
   * General meeting resource names to fetch proposals for.
   */
  general_meeting_names: Array<string>
  /**
   * When true, restrict to votable proposals.
   */
  only_votable?: boolean
  /**
   * Filter on the currently_votable computed field.
   *
   * * `CURRENTLY_VOTABLE_FILTER_UNSPECIFIED` - CURRENTLY_VOTABLE_FILTER_UNSPECIFIED
   * * `CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE
   * * `CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE
   */
  currently_votable_filter?: CurrentlyVotableFilterEnum
}

export type ProposalManagementRecommendation = {
  /**
   * The management voting recommendation.
   *
   * * `VOTING_OPTION_FOR` - for
   * * `VOTING_OPTION_AGAINST` - against
   * * `VOTING_OPTION_ABSTAIN` - abstain
   * * `VOTING_OPTION_WITHHOLD` - withhold
   * * `VOTING_OPTION_NO_ACTION` - no_action
   * * `VOTING_OPTION_ONE_YEAR` - one_year
   * * `VOTING_OPTION_TWO_YEARS` - two_years
   * * `VOTING_OPTION_THREE_YEARS` - three_years
   */
  recommendation: RecommendationEnum
  /**
   * Optional description accompanying the management recommendation.
   */
  recommendation_description?: string | null
}

export type ProposalManagementRecommendationRequest = {
  /**
   * The management voting recommendation.
   *
   * * `VOTING_OPTION_FOR` - for
   * * `VOTING_OPTION_AGAINST` - against
   * * `VOTING_OPTION_ABSTAIN` - abstain
   * * `VOTING_OPTION_WITHHOLD` - withhold
   * * `VOTING_OPTION_NO_ACTION` - no_action
   * * `VOTING_OPTION_ONE_YEAR` - one_year
   * * `VOTING_OPTION_TWO_YEARS` - two_years
   * * `VOTING_OPTION_THREE_YEARS` - three_years
   */
  recommendation: RecommendationEnum
  /**
   * Optional description accompanying the management recommendation.
   */
  recommendation_description?: string | null
}

export type ProposalOutcome = {
  /**
   * The outcome decision.
   *
   * * `PROPOSAL_OUTCOME_DECISION_FOR` - PROPOSAL_OUTCOME_DECISION_FOR
   * * `PROPOSAL_OUTCOME_DECISION_AGAINST` - PROPOSAL_OUTCOME_DECISION_AGAINST
   * * `PROPOSAL_OUTCOME_DECISION_WITHDRAWN` - PROPOSAL_OUTCOME_DECISION_WITHDRAWN
   * * `PROPOSAL_OUTCOME_DECISION_ONE_YEAR` - PROPOSAL_OUTCOME_DECISION_ONE_YEAR
   * * `PROPOSAL_OUTCOME_DECISION_TWO_YEARS` - PROPOSAL_OUTCOME_DECISION_TWO_YEARS
   * * `PROPOSAL_OUTCOME_DECISION_THREE_YEARS` - PROPOSAL_OUTCOME_DECISION_THREE_YEARS
   */
  decision: DecisionEnum
  /**
   * Detailed vote counts.
   */
  votes?: ProposalVotes | null
  /**
   * The time this outcome record was created.
   */
  readonly create_time: Date
  /**
   * The reason the proposal was withdrawn, if applicable.
   */
  withdrawal_reason?: string | null
}

export type ProposalOutcomeRequest = {
  /**
   * The outcome decision.
   *
   * * `PROPOSAL_OUTCOME_DECISION_FOR` - PROPOSAL_OUTCOME_DECISION_FOR
   * * `PROPOSAL_OUTCOME_DECISION_AGAINST` - PROPOSAL_OUTCOME_DECISION_AGAINST
   * * `PROPOSAL_OUTCOME_DECISION_WITHDRAWN` - PROPOSAL_OUTCOME_DECISION_WITHDRAWN
   * * `PROPOSAL_OUTCOME_DECISION_ONE_YEAR` - PROPOSAL_OUTCOME_DECISION_ONE_YEAR
   * * `PROPOSAL_OUTCOME_DECISION_TWO_YEARS` - PROPOSAL_OUTCOME_DECISION_TWO_YEARS
   * * `PROPOSAL_OUTCOME_DECISION_THREE_YEARS` - PROPOSAL_OUTCOME_DECISION_THREE_YEARS
   */
  decision: DecisionEnum
  /**
   * Detailed vote counts.
   */
  votes?: ProposalVotesRequest | null
  /**
   * The reason the proposal was withdrawn, if applicable.
   */
  withdrawal_reason?: string | null
}

export type ProposalPassThreshold = {
  /**
   * The fraction of votes required for the proposal to pass (0.0–1.0).
   */
  threshold: number
}

export type ProposalPassThresholdRequest = {
  /**
   * The fraction of votes required for the proposal to pass (0.0–1.0).
   */
  threshold: number
}

export type ProposalSecClassificationCodesResponse = {
  /**
   * Map of SEC category code to title.
   */
  sec_classification_codes: {
    [key: string]: string
  }
}

/**
 * Request body for searching proposals within a general meeting.
 */
export type ProposalSearchRequestRequest = {
  /**
   * Filter to proposals with these resource names.
   */
  names?: Array<string>
  /**
   * Filter to proposals with these EDI identifiers.
   */
  edi_proposal_identifiers?: Array<number>
  /**
   * Case-insensitive substring filter on proposal title.
   */
  title_query?: string
  /**
   * When true, restrict to proposals with an outcome; when false, restrict to those without.
   */
  has_outcome?: boolean | null
  /**
   * Filter on the currently_votable computed field.
   *
   * * `CURRENTLY_VOTABLE_FILTER_UNSPECIFIED` - CURRENTLY_VOTABLE_FILTER_UNSPECIFIED
   * * `CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE
   * * `CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE
   */
  currently_votable_filter?: CurrentlyVotableFilterEnum
}

/**
 * Read serializer for a proposal set recommendation coverage row.
 */
export type ProposalSetRecommendationCoverage = {
  /**
   * Title of the voting policy the coverage is reported for.
   */
  voting_policy: string
  /**
   * Name of the provider that supplies the voting policy.
   */
  voting_policy_provider: string
  /**
   * Unique identifier of the voting policy.
   */
  voting_policy_id: string
  /**
   * Identifier for the proxy intermediary the ballots were received from.
   */
  proxy_intermediary_id: string
  /**
   * Display name of the proxy intermediary service provider.
   */
  proxy_intermediary_title: string
  /**
   * Content hash identifying the set of proposals shared by the collapsed ballots.
   */
  proposal_set_id: string
  /**
   * Soonest vote deadline across the ballots collapsed into this row.
   */
  earliest_vote_deadline: Date
  /**
   * Latest vote deadline across the ballots collapsed into this row.
   */
  latest_vote_deadline: Date
  /**
   * Working day the earliest vote deadline effectively falls on in London time: the day before when that deadline is at or before midday, otherwise its own day.
   */
  earliest_adjusted_vote_deadline: Date
  /**
   * Every distinct vote deadline across the ballots collapsed into this row.
   */
  vote_deadlines: Array<Date>
  /**
   * Distinct security identifiers of the ballots collapsed into this row.
   */
  security_ids: Array<string>
  /**
   * Number of ballots collapsed into this row.
   */
  ballot_count: bigint
  /**
   * Meeting identifier within the proxy intermediary system.
   */
  proxy_intermediary_meeting_id: string
  /**
   * Unique identifier of the current version of the meeting.
   */
  meeting_version_id: string
  /**
   * Name of the company or organization holding the shareholder meeting.
   */
  organization_title: string
  /**
   * Type of meeting, for example annual or extraordinary.
   */
  meeting_type: string
  /**
   * External system identifier for the meeting.
   */
  meeting_external_id: string
  /**
   * Date and time when the meeting is scheduled to occur.
   */
  meeting_time: Date
  /**
   * Whether the meeting contains contested proposals.
   */
  is_contested: boolean
  /**
   * Number of proposals in the proposal set.
   */
  proposal_count: bigint
  /**
   * Number of proposals in the set with a current recommendation under this voting policy.
   */
  matched_proposal_count: bigint
  /**
   * Number of matched proposals whose recommendation was made manually, without a provider voting recommendation behind it.
   */
  manually_matched_proposal_count: bigint
  /**
   * Number of matched proposals whose recommendation came from a provider voting recommendation.
   */
  pvr_matched_proposal_count: bigint
  /**
   * Number of proposals in the set with no current recommendation under this voting policy.
   */
  unmatched_proposal_count: bigint
  /**
   * Matching progress for the set under this voting policy.
   *
   * * `no_proposals` - no_proposals
   * * `unmatched` - unmatched
   * * `partially_matched` - partially_matched
   * * `fully_matched` - fully_matched
   */
  match_status: MatchStatusEnum
  /**
   * checked when every current recommendation in the set has been checked, otherwise unchecked.
   *
   * * `checked` - Checked
   * * `unchecked` - Unchecked
   */
  validation_status: ValidationStatusEnum
}

/**
 * Recommendation coverage detail for one proposal set under one voting policy.
 */
export type ProposalSetRecommendationCoverageDetail = {
  /**
   * The proposal set this detail is for.
   */
  proposal_set_id: string
  /**
   * The voting policy this detail is under.
   */
  voting_policy_id: string
  /**
   * Every proposal in the set, with its recommendation when one exists.
   */
  proposals: Array<ProposalSetRecommendationCoverageProposal>
  /**
   * Provider voting recommendations in the latest batch for this meeting and policy that no current proxy intermediary voting recommendation references.
   */
  unmatched_provider_voting_recommendations: Array<ProviderVotingRecommendation>
  /**
   * Identifier of the PVR batch group for this meeting and policy; null when no batch was found.
   */
  unique_meeting_policy_id: string | null
  /**
   * Latest batch version for the meeting and policy; null when no batch was found.
   */
  meeting_batch_version: number | null
}

/**
 * A proposal in the set with its current recommendation, validation status, and provider recommendation.
 */
export type ProposalSetRecommendationCoverageProposal = {
  /**
   * The proxy intermediary proposal.
   */
  proposal: ProxyIntermediaryProposal
  /**
   * The current recommendation for this proposal under the requested policy; null when unmatched.
   */
  proxy_intermediary_voting_recommendation: ProxyIntermediaryVotingRecommendation | null
  /**
   * The provider voting recommendation the recommendation links to; null for manual recommendations.
   */
  provider_voting_recommendation: ProviderVotingRecommendation | null
  /**
   * Current validation status of the recommendation; null when unmatched or not yet recorded.
   *
   * * `checked` - Checked
   * * `unchecked` - Unchecked
   */
  validation_status: ValidationStatusEnum | null
}

/**
 * Body filters for searching proposal set recommendation coverage. All filters are optional.
 */
export type ProposalSetRecommendationCoverageSearchRequest = {
  /**
   * Return rows that still have a votable ballot and whose earliest adjusted vote deadline, the working day that deadline effectively falls on, is no more than this many days away. Rows whose ballots have all passed their deadline are excluded. Defaults to 7, maximum 90.
   */
  due_in?: number
  /**
   * Return only rows matching any of these validation statuses: checked or unchecked.
   */
  validation_statuses?: Array<ValidationStatusEnum>
}

export type ProposalVoteRequest = {
  /**
   * The proxy intermediary proposal being voted on.
   */
  pi_proposal_id: string
  /**
   * How we should vote on the proposal; must be one of that proposal's own voting options.
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `no_action` - No Action
   * * `do_not_vote` - Do Not Vote
   */
  response: ProxyIntermediaryVotingOptionsEnum
  /**
   * How the vote was submitted, manually or via an automatic voting process: 'automatic' or 'manual'.
   *
   * * `automatic` - Automatic
   * * `manual` - Manual
   */
  vote_method: VoteMethodEnum
}

export type ProposalVotes = {
  /**
   * Number of votes cast in favour of the proposal.
   */
  for_votes?: bigint | null
  /**
   * Number of votes cast against the proposal.
   */
  against_votes?: bigint | null
  /**
   * Number of abstention votes.
   */
  abstention_votes?: bigint | null
  /**
   * Number of broker non-votes.
   */
  broker_non_votes?: bigint | null
  /**
   * Number of withheld votes.
   */
  withheld_votes?: bigint | null
  /**
   * Votes in favour of a one-year frequency.
   */
  one_year_votes?: bigint | null
  /**
   * Votes in favour of a two-year frequency.
   */
  two_years_votes?: bigint | null
  /**
   * Votes in favour of a three-year frequency.
   */
  three_years_votes?: bigint | null
}

export type ProposalVotesRequest = {
  /**
   * Number of votes cast in favour of the proposal.
   */
  for_votes?: bigint | null
  /**
   * Number of votes cast against the proposal.
   */
  against_votes?: bigint | null
  /**
   * Number of abstention votes.
   */
  abstention_votes?: bigint | null
  /**
   * Number of broker non-votes.
   */
  broker_non_votes?: bigint | null
  /**
   * Number of withheld votes.
   */
  withheld_votes?: bigint | null
  /**
   * Votes in favour of a one-year frequency.
   */
  one_year_votes?: bigint | null
  /**
   * Votes in favour of a two-year frequency.
   */
  two_years_votes?: bigint | null
  /**
   * Votes in favour of a three-year frequency.
   */
  three_years_votes?: bigint | null
}

/**
 * Write shape for both POST (create) and PUT (full update).
 */
export type ProposalWriteRequest = {
  /**
   * The alphanumeric sequence identifier for the proposal within the meeting.
   */
  sequence_identifier: string
  /**
   * The human-readable title of the proposal.
   */
  title: string
  /**
   * Optional long-form description of the proposal.
   */
  description?: string | null
  /**
   * The management voting recommendation.
   */
  management_recommendation?: ProposalManagementRecommendationRequest | null
  /**
   * Who proposed this: a PROPOSAL_SOURCE_* enum name.
   *
   * * `PROPOSAL_SOURCE_MANAGEMENT` - PROPOSAL_SOURCE_MANAGEMENT
   * * `PROPOSAL_SOURCE_SHAREHOLDER` - PROPOSAL_SOURCE_SHAREHOLDER
   */
  source: SourceEnum
  /**
   * The fraction of votes required for the proposal to pass.
   */
  pass_threshold?: ProposalPassThresholdRequest | null
  /**
   * The voting outcome for this proposal.
   */
  outcome?: ProposalOutcomeRequest | null
  /**
   * The EDI numeric identifier for this proposal.
   */
  edi_proposal_identifier?: number | null
  /**
   * The resource name of the parent proposal, if this is a sub-proposal.
   */
  parent_proposal_name?: string | null
  /**
   * The EDI sequence number for this proposal.
   */
  edi_sequence_number?: number | null
  /**
   * Whether shareholders can cast votes on this proposal.
   */
  votable: boolean
  /**
   * Full text of the proposal as supplied by EDI.
   */
  full_text?: string | null
  /**
   * Classification codes to associate with this proposal.
   */
  classification_codes?: Array<string>
  /**
   * The set of valid voting options for this proposal.
   */
  voting_options?: Array<VotingOptionsEnum>
  /**
   * The time the proposal was withdrawn. Null if not withdrawn.
   */
  withdraw_time?: Date | null
  /**
   * SEC category codes to associate with this proposal.
   */
  sec_classification_codes?: Array<string>
}

export type Provider = {
  /**
   * The provider resource name in format providers/{uuid}
   */
  readonly name: string
  /**
   * The provider ID
   */
  id: string
  /**
   * The title of this provider
   */
  title: string
  /**
   * Generated at the time of provider creation
   */
  create_time: Date
  /**
   * Set to the latest update time
   */
  update_time: Date
}

/**
 * Read serializer for a ProviderVotingRecommendation.
 */
export type ProviderVotingRecommendation = {
  /**
   * Unique identifier of the provider voting recommendation.
   */
  id: string
  /**
   * Time the provider voting recommendation was created.
   */
  create_time: Date
  /**
   * ISINs of the instruments this recommendation applies to.
   */
  instrument_isins: Array<string>
  /**
   * The date of the meeting the recommendation applies to.
   */
  meeting_date: Date
  /**
   * The type of meeting: annual, extraordinary, special, court_ordered, general, postal_ballot, or bond_holder.
   */
  meeting_type: string
  /**
   * The proposal label provided by the recommendation provider.
   */
  proposal_label: string
  /**
   * Optional sequence number for the proposal provided by the recommendation provider.
   */
  proposal_sequence_number: number | null
  /**
   * The proposal text provided by the recommendation provider.
   */
  proposal_text: string
  /**
   * The voting instruction recommended by the policy: for, against, abstain, withhold, no_action, one_year, two_years, three_years, or do_not_vote.
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `no_action` - No Action
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `do_not_vote` - Do Not Vote
   */
  policy_instruction: PolicyInstructionEnum
  /**
   * Optional rationale supporting the policy instruction.
   */
  rationale: string | null
  /**
   * Optional name of the policy provider.
   */
  policy_provider: string | null
  /**
   * UUID of the parent voting policy this recommendation belongs to.
   */
  policy_id: string
  /**
   * Set when the recommendation is soft-deleted. Null means not deleted.
   */
  delete_time: Date | null
  /**
   * UUID4 identifying the meeting and policy combination this recommendation belongs to.
   */
  unique_meeting_policy_id: string
  /**
   * Integer version counter for the batch of recommendations for this meeting+policy combination.
   */
  meeting_batch_version: number
  /**
   * Optional provider's identifier for the meeting.
   */
  external_meeting_id: string | null
}

export type ProviderVotingRecommendationCreateRequest = {
  /**
   * ISINs of the instruments this recommendation applies to. Maximum 100.
   */
  instrument_isins: Array<string>
  /**
   * The date of the meeting the recommendation applies to.
   */
  meeting_date: Date
  /**
   * The type of meeting.
   *
   * * `annual` - Annual
   * * `extraordinary` - Extraordinary
   * * `special` - Special
   * * `court_ordered` - Court Ordered
   * * `general` - General
   * * `postal_ballot` - Postal Ballot
   * * `bond_holder` - Bond Holder
   */
  meeting_type: MeetingTypeEnum
  /**
   * The proposal label provided by the recommendation provider. Maximum 100 characters.
   */
  proposal_label: string
  /**
   * Optional sequence number for the proposal provided by the recommendation provider.
   */
  proposal_sequence_number?: number | null
  /**
   * The proposal text provided by the recommendation provider. Maximum 5000 characters.
   */
  proposal_text: string
  /**
   * The voting instruction recommended by the policy.
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `no_action` - No Action
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `do_not_vote` - Do Not Vote
   */
  policy_instruction: PolicyInstructionEnum
  /**
   * Optional rationale supporting the policy instruction. Maximum 5000 characters.
   */
  rationale?: string | null
  /**
   * Optional name of the policy provider. Maximum 100 characters.
   */
  policy_provider?: string | null
  /**
   * UUID of the parent voting policy this recommendation belongs to.
   */
  policy_id: string
  /**
   * UUID4 identifying the meeting and policy combination this recommendation belongs to.
   */
  unique_meeting_policy_id: string
  /**
   * Integer version counter for the batch of recommendations for this meeting+policy combination.
   */
  meeting_batch_version: number
  /**
   * Optional provider's identifier for the meeting.
   */
  external_meeting_id?: string | null
}

/**
 * Wrapper response for endpoints that return an unpaginated list of recommendations.
 */
export type ProviderVotingRecommendationListResponse = {
  provider_voting_recommendations: Array<ProviderVotingRecommendation>
}

/**
 * Body filters for searching provider voting recommendations. All filters are optional.
 */
export type ProviderVotingRecommendationSearchRequest = {
  /**
   * Return recommendations whose instrument_isins contain this ISIN.
   */
  isin?: string
  /**
   * Return recommendations whose instrument_isins overlap any ISIN in this list.
   */
  isins?: Array<string>
  /**
   * Return recommendations whose meeting_date falls on this date. Cannot be combined with meeting_date_after or meeting_date_before.
   */
  meeting_date?: Date
  /**
   * Return recommendations whose meeting_date is on or after this timestamp (inclusive). Cannot be combined with meeting_date.
   */
  meeting_date_after?: Date
  /**
   * Return recommendations whose meeting_date is on or before this timestamp (inclusive). Cannot be combined with meeting_date.
   */
  meeting_date_before?: Date
  /**
   * Return recommendations with this meeting type.
   *
   * * `annual` - Annual
   * * `extraordinary` - Extraordinary
   * * `special` - Special
   * * `court_ordered` - Court Ordered
   * * `general` - General
   * * `postal_ballot` - Postal Ballot
   * * `bond_holder` - Bond Holder
   */
  meeting_type?: MeetingTypeEnum
  /**
   * Return recommendations belonging to any of these voting policy UUIDs.
   */
  policy_ids?: Array<string>
  /**
   * Return recommendations whose unique_meeting_policy_id is any of these UUIDs.
   */
  meeting_policy_ids?: Array<string>
  /**
   * Return recommendations whose id is any of these UUIDs.
   */
  ids?: Array<string>
  /**
   * If true, only return recommendations from the latest meeting batch version per meeting+policy.
   */
  latest_batch?: boolean
}

export type ProviderWriteRequest = {
  /**
   * The title of this provider
   */
  title: string
}

export type ProxyEdgeVote = {
  /**
   * Unique identifier of the vote instruction.
   */
  id: string
  /**
   * The time the vote instruction was recorded in Tumelo's system.
   */
  create_time: Date
  /**
   * The date and time the vote instruction is valid for. The instruction with the most recent valid_time is the current one for a ballot control number.
   */
  valid_time: Date
  /**
   * The control number of the ProxyEdge ballot the vote instruction was submitted for, and the identifier the instruction is fetched by. Maximum length 50 characters.
   */
  ballot_control_number: string
  /**
   * The number of shares the fund manager voted with on the ballot, to at most 5 decimal places.
   */
  instructed_balance: string
  /**
   * The votes placed per agenda resolution. The directions for a resolution must not sum to more than the instructed balance.
   */
  vote_per_agenda_resolution: Array<ProxyEdgeVoteInstruction>
}

export type ProxyEdgeVoteCreateRequestRequest = {
  /**
   * The control number of the ProxyEdge ballot the vote instruction was submitted for, and the identifier the instruction is fetched by. Maximum length 50 characters.
   */
  ballot_control_number: string
  /**
   * The number of shares the fund manager voted with on the ballot, to at most 5 decimal places.
   */
  instructed_balance: string
  /**
   * The date and time the vote instruction is valid for. The instruction with the most recent valid_time is the current one for a ballot control number.
   */
  valid_time: Date
  /**
   * The votes placed per agenda resolution. The directions for a resolution must not sum to more than the instructed balance.
   */
  vote_per_agenda_resolution: Array<ProxyEdgeVoteInstructionCreateRequest>
}

export type ProxyEdgeVoteFetchLatestRequestRequest = {
  /**
   * The control number of the ProxyEdge ballot the vote instruction was submitted for, and the identifier the instruction is fetched by. Maximum length 50 characters.
   */
  ballot_control_number: string
}

export type ProxyEdgeVoteInstruction = {
  /**
   * The label the meeting issuer assigned to the agenda resolution this vote instruction is for. Maximum length 200 characters.
   */
  issuer_label: string
  /**
   * The number of shares the fund manager voted FOR on the agenda resolution.
   */
  vote_for: string
  /**
   * The number of shares the fund manager voted AGAINST on the agenda resolution.
   */
  vote_against: string
  /**
   * The number of shares the fund manager voted ABSTAIN on the agenda resolution.
   */
  vote_abstain: string
  /**
   * The number of shares the fund manager voted WITHHOLD on the agenda resolution.
   */
  vote_withhold: string
  /**
   * The number of shares the fund manager voted ONE YEAR on the agenda resolution.
   */
  vote_one_year: string
  /**
   * The number of shares the fund manager voted TWO YEARS on the agenda resolution.
   */
  vote_two_years: string
  /**
   * The number of shares the fund manager voted THREE YEARS on the agenda resolution.
   */
  vote_three_years: string
  /**
   * The number of shares the fund manager voted NO ACTION on the agenda resolution.
   */
  vote_no_action: string
  /**
   * The number of shares the fund manager voted BLANK on the agenda resolution.
   */
  vote_blank: string
  /**
   * The number of shares the fund manager voted DO NOT VOTE on the agenda resolution.
   */
  vote_do_not_vote: string
}

export type ProxyEdgeVoteInstructionCreateRequest = {
  /**
   * The label the meeting issuer assigned to the agenda resolution this vote instruction is for. Maximum length 200 characters.
   */
  issuer_label: string
  /**
   * The number of shares the fund manager voted FOR on the agenda resolution.
   */
  vote_for?: string
  /**
   * The number of shares the fund manager voted AGAINST on the agenda resolution.
   */
  vote_against?: string
  /**
   * The number of shares the fund manager voted ABSTAIN on the agenda resolution.
   */
  vote_abstain?: string
  /**
   * The number of shares the fund manager voted WITHHOLD on the agenda resolution.
   */
  vote_withhold?: string
  /**
   * The number of shares the fund manager voted ONE YEAR on the agenda resolution.
   */
  vote_one_year?: string
  /**
   * The number of shares the fund manager voted TWO YEARS on the agenda resolution.
   */
  vote_two_years?: string
  /**
   * The number of shares the fund manager voted THREE YEARS on the agenda resolution.
   */
  vote_three_years?: string
  /**
   * The number of shares the fund manager voted NO ACTION on the agenda resolution.
   */
  vote_no_action?: string
  /**
   * The number of shares the fund manager voted BLANK on the agenda resolution.
   */
  vote_blank?: string
  /**
   * The number of shares the fund manager voted DO NOT VOTE on the agenda resolution.
   */
  vote_do_not_vote?: string
}

export type ProxyEdgeVoteResponse = {
  /**
   * The ProxyEdge vote instruction.
   */
  proxyedge_vote: ProxyEdgeVote
}

export type ProxyIntermediary = {
  /**
   * Resource name of the proxy intermediary, in the format 'proxyIntermediaries/{uuid}'.
   */
  readonly name: string
  /**
   * What the proxy intermediary is called, e.g. "ProxyEdge" or "Proxymity".
   */
  title: string
  /**
   * The time the proxy intermediary was created.
   */
  readonly create_time: Date
}

/**
 * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
 * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
 * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
 */
export const ProxyIntermediaryEnum = {
  PROXY_INTERMEDIARY_PROXYEDGE: 'PROXY_INTERMEDIARY_PROXYEDGE',
  PROXY_INTERMEDIARY_PROXYMITY: 'PROXY_INTERMEDIARY_PROXYMITY',
  PROXY_INTERMEDIARY_PROXYEXCHANGE: 'PROXY_INTERMEDIARY_PROXYEXCHANGE',
} as const

/**
 * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
 * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
 * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
 */
export type ProxyIntermediaryEnum = (typeof ProxyIntermediaryEnum)[keyof typeof ProxyIntermediaryEnum]

export type ProxyIntermediaryMeeting = {
  /**
   * Unique identifier of the meeting.
   */
  readonly id: string
  /**
   * Resource name of the meeting, in the format 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  readonly name: string
  /**
   * Unique identifier of the proxy intermediary the meeting was sourced from.
   */
  readonly proxy_intermediary_id: string
  /**
   * Resource name of the proxy intermediary the meeting was sourced from, 'proxyIntermediaries/{uuid}'.
   */
  readonly proxy_intermediary_name: string
  /**
   * The proxy intermediary the meeting was sourced from, as a typed enum.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum | null
  /**
   * The identifier of the meeting in the proxy intermediary's system.
   */
  readonly external_id: string
  /**
   * The title of the organization holding the meeting.
   */
  readonly organization_title: string
  /**
   * Whether the meeting is contested.
   */
  readonly is_contested: boolean
  /**
   * Whether the meeting supports split voting.
   */
  readonly is_split_voting_supported: boolean | null
  /**
   * The type of the meeting as displayed by the proxy intermediary.
   */
  readonly meeting_type_code: string
  /**
   * The date and time the meeting is to be held.
   */
  readonly meeting_time: Date
  /**
   * The date and time votes must be submitted to the proxy intermediary by for this meeting.
   */
  readonly submission_deadline: Date
  /**
   * The date an investor needed to own shares by to be eligible to vote at the meeting.
   */
  readonly record_date: Date | null
  /**
   * The time the entity was created.
   */
  readonly create_time: Date
  /**
   * The time the meeting was cancelled by the proxy intermediary.
   */
  readonly cancel_time: Date | null
  /**
   * Resource name of the linked transparency general meeting, in the format 'organizations/{uuid}/generalMeetings/{uuid}', or empty when not linked.
   */
  readonly transparency_general_meeting_name: string
  /**
   * Unique identifier of the linked transparency general meeting, or null when not linked.
   */
  readonly transparency_general_meeting_id: string | null
  /**
   * Proxy intermediary comment on the meeting notification.
   */
  readonly meeting_comment: string
  /**
   * The public security ids of securities able to vote in this meeting.
   */
  readonly security_ids: Array<string>
  /**
   * The date and time the meeting version is valid for.
   */
  readonly valid_time: Date
  /**
   * The reason a meeting is unsupported.
   */
  readonly unsupported_reason: string | null
  /**
   * Whether voted shares are blocked from trading until the vote is revoked. Applies to global markets.
   */
  readonly is_blocking: boolean
}

export type ProxyIntermediaryMeetingAuditEvent = {
  /**
   * Resource name of the audit event, 'auditEvents/{uuid}'.
   */
  readonly name: string
  /**
   * Resource name of the audited meeting, 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  readonly entity_name: string
  /**
   * The original entity, serialised into JSON. '{}' when there is no original entity.
   */
  readonly original_entity_json: string
  /**
   * The difference between the original and new entity, as a JSON merge patch (RFC 7396). '{}' when there is no patch.
   */
  readonly patch_json: string
  /**
   * The time the audit event was created.
   */
  readonly create_time: Date
  /**
   * The name of the endpoint that triggered the change.
   */
  readonly endpoint_name: string
  /**
   * The pseudonymous identifier of the user that triggered the change.
   */
  readonly username: string
}

export type ProxyIntermediaryMeetingAuditEventSearchRequestRequest = {
  /**
   * Audit event resource names to filter by, 'auditEvents/{uuid}'.
   */
  audit_event_names?: Array<string>
  /**
   * Resource name of the audited meeting, 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  entity_name?: string
}

export type ProxyIntermediaryMeetingBatchCancelRequestRequest = {
  /**
   * Resource names of the meetings to cancel, 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  names: Array<string>
}

export type ProxyIntermediaryMeetingBatchCancelResponse = {
  /**
   * The cancelled meetings.
   */
  proxy_intermediary_meetings: Array<ProxyIntermediaryMeeting>
}

export type ProxyIntermediaryMeetingHardDeleteRequestRequest = {
  /**
   * The proxy intermediary whose meeting is to be deleted.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * The identifier of the meeting in the proxy intermediary's system.
   */
  external_id: string
}

export type ProxyIntermediaryMeetingHardDeleteResponse = {
  /**
   * How many meeting identities were deleted.
   */
  meetings: number
  /**
   * How many meeting versions were deleted.
   */
  meeting_versions: number
  /**
   * How many meeting version securities were deleted.
   */
  meeting_securities: number
  /**
   * How many ballot identities were deleted.
   */
  ballots: number
  /**
   * How many ballot versions were deleted.
   */
  ballot_versions: number
  /**
   * How many ballot deadlines were deleted.
   */
  ballot_deadlines: number
  /**
   * How many proposals were deleted.
   */
  proposals: number
  /**
   * How many audit events were deleted.
   */
  audit_events: number
}

export type ProxyIntermediaryMeetingLinkRequestRequest = {
  /**
   * Resource name of the meeting to link, 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  proxy_intermediary_meeting_name: string
  /**
   * Resource name of the transparency general meeting, 'organizations/{uuid}/generalMeetings/{uuid}'.
   */
  transparency_general_meeting_name: string
}

export type ProxyIntermediaryMeetingResponse = {
  /**
   * The meeting.
   */
  proxy_intermediary_meeting: ProxyIntermediaryMeeting
}

/**
 * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL
 * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED
 * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED
 */
export const ProxyIntermediaryMeetingSearchRequestCancelledEnum = {
  PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL: 'PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL',
  PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED:
    'PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED',
  PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED: 'PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED',
} as const

/**
 * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL
 * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED
 * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED
 */
export type ProxyIntermediaryMeetingSearchRequestCancelledEnum =
  (typeof ProxyIntermediaryMeetingSearchRequestCancelledEnum)[keyof typeof ProxyIntermediaryMeetingSearchRequestCancelledEnum]

export type ProxyIntermediaryMeetingSearchRequestRequest = {
  /**
   * Meeting ids to filter by.
   */
  ids?: Array<string>
  /**
   * Meeting resource names to filter by, in the format 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  names?: Array<string>
  /**
   * Resource name of the proxy intermediary to filter by, 'proxyIntermediaries/{uuid}'.
   */
  proxy_intermediary_name?: string
  /**
   * The proxy intermediary to filter by. Preferred over proxy_intermediary_name when both are set.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary?: ProxyIntermediaryEnum
  /**
   * External ids to filter by. Requires a proxy intermediary filter.
   */
  external_ids?: Array<string>
  /**
   * Transparency general meeting names to filter by, 'organizations/{uuid}/generalMeetings/{uuid}'.
   */
  transparency_general_meeting_names?: Array<string>
  /**
   * Filters the meetings by cancellation state.
   *
   * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL
   * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED
   * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED
   */
  cancelled?: ProxyIntermediaryMeetingSearchRequestCancelledEnum
  /**
   * Filters the meetings by transparency-general-meeting link state.
   *
   * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL
   * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED
   * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED
   */
  linked?: LinkedEnum
  /**
   * Case-insensitive search over organization title, external id and security id.
   */
  search?: string
  /**
   * Filters for meetings with a submission deadline on or after this time.
   */
  submission_deadline_after?: Date
  /**
   * Filters for meetings with a submission deadline before this time.
   */
  submission_deadline_before?: Date
  /**
   * Public security ids of securities able to vote in the meeting.
   */
  security_ids?: Array<string>
  /**
   * When the security_ids filter is set, also include meetings that have no security ids.
   */
  include_meetings_with_no_security_ids?: boolean
  /**
   * Filters for meetings that have ballots, or not. If unset, all meetings are returned.
   */
  has_ballots?: boolean | null
}

export type ProxyIntermediaryMeetingUnlinkRequestRequest = {
  /**
   * Resource name of the meeting to unlink, 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  proxy_intermediary_meeting_name: string
}

/**
 * Write shape for the upsert endpoint.
 *
 * ``external_id`` and ``valid_time`` identify and time-stamp the version and are always required;
 * the proxy intermediary is supplied on the request wrapper. Every other field is optional: a
 * create must still supply the core meeting fields, and an update patches only the fields present
 * in the request.
 */
export type ProxyIntermediaryMeetingUpsertRequest = {
  /**
   * The identifier of the meeting in the proxy intermediary's system.
   */
  external_id: string
  /**
   * The title of the organization holding the meeting.
   */
  organization_title?: string
  /**
   * Whether the meeting is contested.
   */
  is_contested?: boolean
  /**
   * Whether the meeting supports split voting.
   */
  is_split_voting_supported?: boolean | null
  /**
   * The type of the meeting as displayed by the proxy intermediary.
   */
  meeting_type_code?: string
  /**
   * The date and time the meeting is to be held.
   */
  meeting_time?: Date
  /**
   * The date and time votes must be submitted to the proxy intermediary by for this meeting.
   */
  submission_deadline?: Date
  /**
   * The date an investor needed to own shares by to be eligible to vote at the meeting.
   */
  record_date?: Date | null
  /**
   * The time the meeting was cancelled by the proxy intermediary.
   */
  cancel_time?: Date | null
  /**
   * Proxy intermediary comment on the meeting notification.
   */
  meeting_comment?: string
  /**
   * The public security ids of securities able to vote in this meeting.
   */
  security_ids?: Array<string>
  /**
   * Whether voted shares are blocked from trading until the vote is revoked. Applies to global markets.
   */
  is_blocking?: boolean
  /**
   * The date and time the meeting version is valid for.
   */
  valid_time: Date
}

export type ProxyIntermediaryMeetingUpsertRequestRequest = {
  /**
   * The meeting to create or update.
   */
  proxy_intermediary_meeting: ProxyIntermediaryMeetingUpsertRequest
  /**
   * The proxy intermediary the meeting is sourced from, resolved to its canonical title and id.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
}

export type ProxyIntermediaryMeetingUpsertResponse = {
  /**
   * The created or updated meeting.
   */
  proxy_intermediary_meeting: ProxyIntermediaryMeeting
  /**
   * Indicates whether the meeting was created, updated, or left unchanged.
   *
   * * `STATUS_MEETING_INVALID` - STATUS_MEETING_INVALID
   * * `STATUS_MEETING_CREATED` - STATUS_MEETING_CREATED
   * * `STATUS_MEETING_UPDATED` - STATUS_MEETING_UPDATED
   * * `STATUS_MEETING_NO_OPERATION` - STATUS_MEETING_NO_OPERATION
   */
  status: ProxyIntermediaryMeetingUpsertResponseStatusEnum
}

/**
 * * `STATUS_MEETING_INVALID` - STATUS_MEETING_INVALID
 * * `STATUS_MEETING_CREATED` - STATUS_MEETING_CREATED
 * * `STATUS_MEETING_UPDATED` - STATUS_MEETING_UPDATED
 * * `STATUS_MEETING_NO_OPERATION` - STATUS_MEETING_NO_OPERATION
 */
export const ProxyIntermediaryMeetingUpsertResponseStatusEnum = {
  STATUS_MEETING_INVALID: 'STATUS_MEETING_INVALID',
  STATUS_MEETING_CREATED: 'STATUS_MEETING_CREATED',
  STATUS_MEETING_UPDATED: 'STATUS_MEETING_UPDATED',
  STATUS_MEETING_NO_OPERATION: 'STATUS_MEETING_NO_OPERATION',
} as const

/**
 * * `STATUS_MEETING_INVALID` - STATUS_MEETING_INVALID
 * * `STATUS_MEETING_CREATED` - STATUS_MEETING_CREATED
 * * `STATUS_MEETING_UPDATED` - STATUS_MEETING_UPDATED
 * * `STATUS_MEETING_NO_OPERATION` - STATUS_MEETING_NO_OPERATION
 */
export type ProxyIntermediaryMeetingUpsertResponseStatusEnum =
  (typeof ProxyIntermediaryMeetingUpsertResponseStatusEnum)[keyof typeof ProxyIntermediaryMeetingUpsertResponseStatusEnum]

export type ProxyIntermediaryProposal = {
  /**
   * Unique identifier for the proposal
   */
  readonly id: string
  /**
   * The set of valid voting options for this proposal.
   */
  voting_options: Array<ProxyIntermediaryVotingOptionsEnum>
  /**
   * The time the proposal was created.
   */
  create_time: Date
  /**
   * The SHA256 hash of the Proposals in the set. Fields hashed: proxy_intermediary_meeting_id,broadridge_agenda_id, label, text, voting_options, source, management_recommendation,sequence_number, is_opposition, director_number, vote_group, vote_group_max_for, vote_group_max,category_code, withdrawn
   */
  proposal_set_id: string
  /**
   * The id of the agenda these proposals were sourced from in Broadridge's system.
   */
  broadridge_agenda_id?: string | null
  /**
   * The alphanumeric label for the proposal within the meeting. eg (1a, A, 1)
   */
  label: string
  /**
   * The human-readable text of the proposal.
   */
  text: string
  /**
   * Who proposed this: 'management' or 'shareholder'.
   *
   * * `management` - Management
   * * `shareholder` - Shareholder
   */
  source: ProxyIntermediaryProposalSourceEnum
  /**
   * The management voting recommendation (e.g. 'for', 'against').
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `no_action` - No Action
   * * `do_not_vote` - Do Not Vote
   */
  management_recommendation?: ProxyIntermediaryVotingOptionsEnum | null
  /**
   * The ordering sequence for the proposals from the proxy intermediary
   */
  sequence_number?: number | null
  /**
   * Whether the proposal was put to the meeting by an opposing party rather than by the issuer.
   */
  is_opposition?: boolean
  /**
   * The position of the director within a slate election, as reported by the proxy intermediary.
   */
  director_number?: number | null
  /**
   * The identifier of the group of proposals this proposal is voted within. Proposals sharing a group share a limit on how many of them may be voted.
   */
  vote_group?: number | null
  /**
   * The maximum number of proposals in the vote group that may be voted 'for'.
   */
  vote_group_max_for?: number | null
  /**
   * The maximum number of proposals in the vote group that may be voted, whatever the voting option.
   */
  vote_group_max?: number | null
  /**
   * The category code of the proposal.
   */
  category_code?: string | null
  /**
   * Whether the proxy intermediary reported the proposal as withdrawn from the meeting's agenda.
   */
  withdrawn?: boolean
  /**
   * The proxy intermediary meeting this proposal belongs to.
   */
  proxy_intermediary_meeting_id: string
}

/**
 * * `management` - Management
 * * `shareholder` - Shareholder
 */
export const ProxyIntermediaryProposalSourceEnum = { MANAGEMENT: 'management', SHAREHOLDER: 'shareholder' } as const

/**
 * * `management` - Management
 * * `shareholder` - Shareholder
 */
export type ProxyIntermediaryProposalSourceEnum =
  (typeof ProxyIntermediaryProposalSourceEnum)[keyof typeof ProxyIntermediaryProposalSourceEnum]

export type ProxyIntermediarySearchRequestRequest = {
  /**
   * Proxy intermediary resource names to filter by, in the format 'proxyIntermediaries/{uuid}'.
   */
  names?: Array<string>
  /**
   * Proxy intermediary titles to filter by. Exact string match only.
   */
  titles?: Array<string>
}

/**
 * * `for` - For
 * * `against` - Against
 * * `abstain` - Abstain
 * * `withhold` - Withhold
 * * `one_year` - One Year
 * * `two_years` - Two Years
 * * `three_years` - Three Years
 * * `no_action` - No Action
 * * `do_not_vote` - Do Not Vote
 */
export const ProxyIntermediaryVotingOptionsEnum = {
  FOR: 'for',
  AGAINST: 'against',
  ABSTAIN: 'abstain',
  WITHHOLD: 'withhold',
  ONE_YEAR: 'one_year',
  TWO_YEARS: 'two_years',
  THREE_YEARS: 'three_years',
  NO_ACTION: 'no_action',
  DO_NOT_VOTE: 'do_not_vote',
} as const

/**
 * * `for` - For
 * * `against` - Against
 * * `abstain` - Abstain
 * * `withhold` - Withhold
 * * `one_year` - One Year
 * * `two_years` - Two Years
 * * `three_years` - Three Years
 * * `no_action` - No Action
 * * `do_not_vote` - Do Not Vote
 */
export type ProxyIntermediaryVotingOptionsEnum =
  (typeof ProxyIntermediaryVotingOptionsEnum)[keyof typeof ProxyIntermediaryVotingOptionsEnum]

/**
 * Read serializer for a ProxyIntermediaryVotingRecommendation version.
 */
export type ProxyIntermediaryVotingRecommendation = {
  /**
   * Unique identifier of this recommendation version.
   */
  id: string
  /**
   * Stable identity shared across all versions of this recommendation.
   */
  identity_id: string
  /**
   * The voting policy this recommendation belongs to.
   */
  voting_policy_id: string
  /**
   * The proxy intermediary proposal this recommendation belongs to.
   */
  proxy_intermediary_proposal_id: string
  /**
   * The provider voting recommendation this recommendation was derived from, if any.
   */
  provider_voting_recommendation_id: string | null
  /**
   * The voting instruction: for, against, abstain, withhold, no_action, one_year, two_years, three_years, or do_not_vote.
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `no_action` - No Action
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `do_not_vote` - Do Not Vote
   */
  voting_instruction: VotingInstructionEnum
  /**
   * Optional rationale supporting the voting instruction.
   */
  rationale: string | null
  /**
   * Optional proposal text provided by the recommendation provider.
   */
  text: string | null
  /**
   * Optional proposal label provided by the recommendation provider.
   */
  vote_recommendation_label: string | null
  /**
   * Optional sequence number for the proposal provided by the recommendation provider.
   */
  sequence_number: number | null
  /**
   * Monotonic version number of this recommendation.
   */
  version_number: number
  /**
   * Time this recommendation version was created.
   */
  create_time: Date
  /**
   * Time this version was superseded or deleted; null while current.
   */
  delete_time: Date | null
}

export type ProxyIntermediaryVotingRecommendationConfidenceScore = {
  /**
   * The confidence score's unique id.
   */
  id: string
  /**
   * The validation confidence score, between 0.0 and 1.0.
   */
  validation_confidence_score: number
  /**
   * The name of the algorithm that produced the score.
   */
  algorithm_name: string
  /**
   * Time this confidence score was created.
   */
  create_time: Date
  /**
   * Time this confidence score was last updated.
   */
  update_time: Date
}

/**
 * Request serializer for upserting a confidence score. All fields are required.
 */
export type ProxyIntermediaryVotingRecommendationConfidenceScoreUpsertRequest = {
  /**
   * The proxy intermediary voting recommendation version this confidence score applies to.
   */
  proxy_intermediary_voting_recommendation_id: string
  /**
   * The validation confidence score. Must be between 0.0 and 1.0 inclusive.
   */
  validation_confidence_score: number
  /**
   * The name of the algorithm that produced the score. Maximum 255 characters.
   */
  algorithm_name: string
}

/**
 * Request body for creating a proxy intermediary voting recommendation.
 */
export type ProxyIntermediaryVotingRecommendationCreateRequest = {
  /**
   * The voting policy this recommendation belongs to.
   */
  voting_policy_id: string
  /**
   * The proxy intermediary proposal this recommendation belongs to.
   */
  proxy_intermediary_proposal_id: string
  /**
   * The voting instruction: for, against, abstain, withhold, one_year, two_years, three_years, or do_not_vote. no_action is rejected: a recommendation must recommend an action.
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `no_action` - No Action
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `do_not_vote` - Do Not Vote
   */
  voting_instruction: VotingInstructionEnum
  /**
   * Optional rationale supporting the voting instruction.
   */
  rationale?: string | null
  /**
   * Optional proposal text provided by the recommendation provider.
   */
  text?: string | null
  /**
   * Optional proposal label provided by the recommendation provider.
   */
  vote_recommendation_label?: string | null
  /**
   * Optional sequence number for the proposal provided by the recommendation provider.
   */
  sequence_number?: number | null
  /**
   * The provider voting recommendation this recommendation was derived from, if any.
   */
  provider_voting_recommendation_id?: string | null
}

/**
 * Body filters for searching current proxy intermediary voting recommendations. All filters are optional.
 */
export type ProxyIntermediaryVotingRecommendationSearchRequest = {
  /**
   * Return recommendations for any of these proxy intermediary proposal UUIDs.
   */
  proxy_intermediary_proposal_ids?: Array<string>
  /**
   * Return recommendations linked to any of these provider voting recommendation UUIDs.
   */
  provider_voting_recommendation_ids?: Array<string>
  /**
   * Return recommendations belonging to any of these voting policy UUIDs.
   */
  voting_policy_ids?: Array<string>
}

export type ProxyIntermediaryVotingRecommendationValidationStatus = {
  /**
   * The validation status' unique id.
   */
  id: string
  /**
   * The proxy intermediary voting recommendation version this status applies to.
   */
  proxy_intermediary_voting_recommendation_id: string
  /**
   * The validation status: checked or unchecked.
   *
   * * `checked` - Checked
   * * `unchecked` - Unchecked
   */
  status: ValidationStatusEnum
  /**
   * Time this status was recorded.
   */
  create_time: Date
  /**
   * Pseudonymous subject claim of the user or service principal that recorded this status.
   */
  created_by_sub: string
}

/**
 * Request serializer for recording a validation status. All fields are required.
 */
export type ProxyIntermediaryVotingRecommendationValidationStatusCreateRequest = {
  /**
   * The proxy intermediary voting recommendation version this status applies to.
   */
  proxy_intermediary_voting_recommendation_id: string
  /**
   * The validation status to record: checked or unchecked.
   *
   * * `checked` - Checked
   * * `unchecked` - Unchecked
   */
  status: ValidationStatusEnum
}

/**
 * Body filters for searching validation statuses. All filters are optional.
 */
export type ProxyIntermediaryVotingRecommendationValidationStatusSearchRequest = {
  /**
   * Return statuses for any of these proxy intermediary voting recommendation UUIDs.
   */
  proxy_intermediary_voting_recommendation_ids?: Array<string>
  /**
   * Return statuses matching any of these values: checked or unchecked.
   */
  statuses?: Array<ValidationStatusEnum>
  /**
   * False, the default, returns only the current status of each recommendation. True returns every status ever recorded, newest first.
   */
  include_history?: boolean
}

export type ProxySubmission = {
  /**
   * The time by which votes for this general meeting must be submitted to Broadridge's Proxy Edge to guarantee they are counted.
   */
  proxy_edge_deadline?: Date | null
}

export type ProxySubmissionRequest = {
  /**
   * The time by which votes for this general meeting must be submitted to Broadridge's Proxy Edge to guarantee they are counted.
   */
  proxy_edge_deadline?: Date | null
}

export type ProxymityVote = {
  /**
   * Unique identifier of the vote instruction.
   */
  id: string
  /**
   * The time the vote instruction was recorded in Tumelo's system.
   */
  create_time: Date
  /**
   * The date and time the vote instruction is valid for. The instruction with the most recent valid_time is the current one for a single instruction id.
   */
  valid_time: Date
  /**
   * The identifier Proxymity uses to refer to this vote instruction, so that it can later be overwritten or cancelled. Maximum length 200 characters.
   */
  single_instruction_id: string
  /**
   * The control number of the Proxymity ballot the vote instruction was submitted for. Maximum length 200 characters.
   */
  ballot_control_number: string
  /**
   * The number of votes the fund manager voted with on the ballot.
   */
  instructed_balance: bigint
  /**
   * The votes placed per agenda resolution. The directions for a resolution must not sum to more than the instructed balance.
   */
  vote_per_agenda_resolution: Array<ProxymityVoteInstruction>
}

export type ProxymityVoteCreateRequestRequest = {
  /**
   * The identifier Proxymity uses to refer to this vote instruction, so that it can later be overwritten or cancelled. Maximum length 200 characters.
   */
  single_instruction_id: string
  /**
   * The control number of the Proxymity ballot the vote instruction was submitted for. Maximum length 200 characters.
   */
  ballot_control_number: string
  /**
   * The number of votes the fund manager voted with on the ballot.
   */
  instructed_balance: bigint
  /**
   * The date and time the vote instruction is valid for. The instruction with the most recent valid_time is the current one for a single instruction id.
   */
  valid_time: Date
  /**
   * The votes placed per agenda resolution. The directions for a resolution must not sum to more than the instructed balance.
   */
  vote_per_agenda_resolution: Array<ProxymityVoteInstructionCreateRequest>
}

export type ProxymityVoteFetchLatestRequestRequest = {
  /**
   * The identifier Proxymity uses to refer to this vote instruction, so that it can later be overwritten or cancelled. Maximum length 200 characters.
   */
  single_instruction_id: string
}

export type ProxymityVoteInstruction = {
  /**
   * The label the meeting issuer assigned to the agenda resolution this vote instruction is for. Maximum length 200 characters.
   */
  issuer_label: string
  /**
   * The number of votes the fund manager placed FOR on the agenda resolution.
   */
  vote_for: bigint
  /**
   * The number of votes the fund manager placed AGAINST on the agenda resolution.
   */
  vote_against: bigint
  /**
   * The number of votes the fund manager placed ABSTAIN on the agenda resolution.
   */
  vote_abstain: bigint
  /**
   * The number of votes the fund manager placed WITHHOLD on the agenda resolution.
   */
  vote_withhold: bigint
  /**
   * The number of votes the fund manager placed WITH MANAGEMENT on the agenda resolution.
   */
  vote_with_management: bigint
  /**
   * The number of votes the fund manager placed AGAINST MANAGEMENT on the agenda resolution.
   */
  vote_against_management: bigint
  /**
   * The number of votes the fund manager placed DISCRETIONARY on the agenda resolution.
   */
  vote_discretionary: bigint
  /**
   * The number of votes the fund manager placed ONE YEAR on the agenda resolution.
   */
  vote_one_year: bigint
  /**
   * The number of votes the fund manager placed TWO YEARS on the agenda resolution.
   */
  vote_two_years: bigint
  /**
   * The number of votes the fund manager placed THREE YEARS on the agenda resolution.
   */
  vote_three_years: bigint
  /**
   * The number of votes the fund manager placed NO ACTION on the agenda resolution.
   */
  vote_no_action: bigint
  /**
   * The number of votes the fund manager placed BLANK on the agenda resolution.
   */
  vote_blank: bigint
}

export type ProxymityVoteInstructionCreateRequest = {
  /**
   * The label the meeting issuer assigned to the agenda resolution this vote instruction is for. Maximum length 200 characters.
   */
  issuer_label: string
  /**
   * The number of votes the fund manager placed FOR on the agenda resolution.
   */
  vote_for?: bigint
  /**
   * The number of votes the fund manager placed AGAINST on the agenda resolution.
   */
  vote_against?: bigint
  /**
   * The number of votes the fund manager placed ABSTAIN on the agenda resolution.
   */
  vote_abstain?: bigint
  /**
   * The number of votes the fund manager placed WITHHOLD on the agenda resolution.
   */
  vote_withhold?: bigint
  /**
   * The number of votes the fund manager placed WITH MANAGEMENT on the agenda resolution.
   */
  vote_with_management?: bigint
  /**
   * The number of votes the fund manager placed AGAINST MANAGEMENT on the agenda resolution.
   */
  vote_against_management?: bigint
  /**
   * The number of votes the fund manager placed DISCRETIONARY on the agenda resolution.
   */
  vote_discretionary?: bigint
  /**
   * The number of votes the fund manager placed ONE YEAR on the agenda resolution.
   */
  vote_one_year?: bigint
  /**
   * The number of votes the fund manager placed TWO YEARS on the agenda resolution.
   */
  vote_two_years?: bigint
  /**
   * The number of votes the fund manager placed THREE YEARS on the agenda resolution.
   */
  vote_three_years?: bigint
  /**
   * The number of votes the fund manager placed NO ACTION on the agenda resolution.
   */
  vote_no_action?: bigint
  /**
   * The number of votes the fund manager placed BLANK on the agenda resolution.
   */
  vote_blank?: bigint
}

export type ProxymityVoteResponse = {
  /**
   * The Proxymity vote instruction.
   */
  proxymity_vote: ProxymityVote
}

export type PublicSecurityId = {
  readonly name: string
  create_time: Date
}

export type PublicSecurityIdListQueryRequest = {
  names?: Array<string>
  public_security_id_type_names?: Array<string>
  values?: Array<string>
  instrument_isins?: Array<string>
}

/**
 * A quantification of a fund or fund variant expressed in a single unit type.
 */
export type Quantification = {
  /**
   * The unit type of the quantification: SHARES, an ISO-4217 currency code, or NAV_{currency}.
   */
  unit_type: string
  /**
   * The settled quantity of the quantification.
   */
  settled_quantity: number
}

/**
 * A quantification of a fund or fund variant expressed in a single unit type.
 */
export type QuantificationRequest = {
  /**
   * The unit type of the quantification: SHARES, an ISO-4217 currency code, or NAV_{currency}.
   */
  unit_type: string
  /**
   * The settled quantity of the quantification.
   */
  settled_quantity: number
}

/**
 * * `VOTING_OPTION_FOR` - for
 * * `VOTING_OPTION_AGAINST` - against
 * * `VOTING_OPTION_ABSTAIN` - abstain
 * * `VOTING_OPTION_WITHHOLD` - withhold
 * * `VOTING_OPTION_NO_ACTION` - no_action
 * * `VOTING_OPTION_ONE_YEAR` - one_year
 * * `VOTING_OPTION_TWO_YEARS` - two_years
 * * `VOTING_OPTION_THREE_YEARS` - three_years
 */
export const RecommendationEnum = {
  VOTING_OPTION_FOR: 'VOTING_OPTION_FOR',
  VOTING_OPTION_AGAINST: 'VOTING_OPTION_AGAINST',
  VOTING_OPTION_ABSTAIN: 'VOTING_OPTION_ABSTAIN',
  VOTING_OPTION_WITHHOLD: 'VOTING_OPTION_WITHHOLD',
  VOTING_OPTION_NO_ACTION: 'VOTING_OPTION_NO_ACTION',
  VOTING_OPTION_ONE_YEAR: 'VOTING_OPTION_ONE_YEAR',
  VOTING_OPTION_TWO_YEARS: 'VOTING_OPTION_TWO_YEARS',
  VOTING_OPTION_THREE_YEARS: 'VOTING_OPTION_THREE_YEARS',
} as const

/**
 * * `VOTING_OPTION_FOR` - for
 * * `VOTING_OPTION_AGAINST` - against
 * * `VOTING_OPTION_ABSTAIN` - abstain
 * * `VOTING_OPTION_WITHHOLD` - withhold
 * * `VOTING_OPTION_NO_ACTION` - no_action
 * * `VOTING_OPTION_ONE_YEAR` - one_year
 * * `VOTING_OPTION_TWO_YEARS` - two_years
 * * `VOTING_OPTION_THREE_YEARS` - three_years
 */
export type RecommendationEnum = (typeof RecommendationEnum)[keyof typeof RecommendationEnum]

/**
 * Request serializer for rendering a composition difference in a specific format.
 */
export type RenderCompositionDifferenceRequest = {
  /**
   * Name of the investor
   */
  investor_name: string
  /**
   * List of component differences to render
   */
  components: Array<ComponentDiffRequest>
  /**
   * Output format for the rendered composition difference
   *
   * * `TUMELO` - TUMELO
   * * `PIRC` - PIRC
   * * `GLASS_LEWIS` - GLASS_LEWIS
   * * `MINERVA` - MINERVA
   * * `ISS` - ISS
   * * `EOS` - EOS
   * * `ISS_RETAIL` - ISS_RETAIL
   */
  diff_format: DiffFormatEnum
}

/**
 * * `vote_adjusted_for_voting_restriction` - Vote Adjusted for Voting Restriction
 * * `vote_adjusted_for_contested_meeting` - Vote Adjusted for Contested Meeting
 * * `vote_aligned_with_fm_due_to_restriction` - Vote Aligned with FM Due to Restriction
 * * `vote_aligned_with_fm_due_to_proposal_restriction` - Vote Aligned with FM Due to Proposal Restriction
 */
export const ReportableReasonEnum = {
  VOTE_ADJUSTED_FOR_VOTING_RESTRICTION: 'vote_adjusted_for_voting_restriction',
  VOTE_ADJUSTED_FOR_CONTESTED_MEETING: 'vote_adjusted_for_contested_meeting',
  VOTE_ALIGNED_WITH_FM_DUE_TO_RESTRICTION: 'vote_aligned_with_fm_due_to_restriction',
  VOTE_ALIGNED_WITH_FM_DUE_TO_PROPOSAL_RESTRICTION: 'vote_aligned_with_fm_due_to_proposal_restriction',
} as const

/**
 * * `vote_adjusted_for_voting_restriction` - Vote Adjusted for Voting Restriction
 * * `vote_adjusted_for_contested_meeting` - Vote Adjusted for Contested Meeting
 * * `vote_aligned_with_fm_due_to_restriction` - Vote Aligned with FM Due to Restriction
 * * `vote_aligned_with_fm_due_to_proposal_restriction` - Vote Aligned with FM Due to Proposal Restriction
 */
export type ReportableReasonEnum = (typeof ReportableReasonEnum)[keyof typeof ReportableReasonEnum]

export type Role = {
  /**
   * Unique identifier for the role.
   */
  readonly id: string
  /**
   * Free-text label that names the role within its tenant.
   */
  name: string
  /**
   * Free-text explanation of who the role is for.
   */
  description?: string
  /**
   * The time the role was created.
   */
  readonly create_time: Date
  /**
   * The time the role was last updated.
   */
  readonly update_time: Date
}

export type RoleRequest = {
  /**
   * Free-text label that names the role within its tenant.
   */
  name: string
  /**
   * Free-text explanation of who the role is for.
   */
  description?: string
}

/**
 * The request body accepted when searching roles.
 */
export type RoleSearchRequestRequest = {
  /**
   * Return only the role with this exact name
   */
  name?: string
}

/**
 * * `COUNTRY_SCOPE` - Country Scope
 * * `ISIN_SCOPE` - ISIN Scope
 * * `CFI_REGEX` - CFI Regex
 */
export const RuleTypeEnum = {
  COUNTRY_SCOPE: 'COUNTRY_SCOPE',
  ISIN_SCOPE: 'ISIN_SCOPE',
  CFI_REGEX: 'CFI_REGEX',
} as const

/**
 * * `COUNTRY_SCOPE` - Country Scope
 * * `ISIN_SCOPE` - ISIN Scope
 * * `CFI_REGEX` - CFI Regex
 */
export type RuleTypeEnum = (typeof RuleTypeEnum)[keyof typeof RuleTypeEnum]

/**
 * Read serializer for RulesEngineDefinition.
 */
export type RulesEngineDefinition = {
  readonly id: string
  name: string
  valid_from: Date
  readonly create_time: Date
  readonly update_time: Date
}

/**
 * Write serializer for creating a RulesEngineDefinition.
 */
export type RulesEngineDefinitionCreateRequest = {
  name: string
  valid_from: Date
}

/**
 * * `ballot_stamping` - Ballot Stamping
 * * `ballot_review` - Ballot Review
 */
export const RulesEngineEnum = { BALLOT_STAMPING: 'ballot_stamping', BALLOT_REVIEW: 'ballot_review' } as const

/**
 * * `ballot_stamping` - Ballot Stamping
 * * `ballot_review` - Ballot Review
 */
export type RulesEngineEnum = (typeof RulesEngineEnum)[keyof typeof RulesEngineEnum]

/**
 * Response serializer for the list-by-name endpoint.
 */
export type RulesEngineNamesResponse = {
  names: Array<string>
}

/**
 * Read serializer for RulesEngineRule.
 */
export type RulesEngineRule = {
  readonly id: string
  readonly definition_id: string
  rule_type: RuleTypeEnum
  order: number
  parameters: unknown
  readonly create_time: Date
  readonly update_time: Date
}

/**
 * Write serializer for creating or updating a RulesEngineRule.
 */
export type RulesEngineRuleWriteRequest = {
  rule_type: RuleTypeEnum
  order: number
  parameters: unknown
}

export type SearchProposalRequest = {
  /**
   * The proposal set ids to filter by.
   */
  proposal_set_ids?: Array<string>
  /**
   * The proposal ids to filter by.
   */
  proposal_ids?: Array<string>
  /**
   * The proxy intermediary meeting ids to filter by.
   */
  proxy_intermediary_meeting_ids?: Array<string>
  /**
   * The Broadridge agenda ids to filter by.
   */
  broadridge_agenda_ids?: Array<string>
  /**
   * When true, proposals the proxy intermediary reported as withdrawn are left out.
   */
  exclude_withdrawn?: boolean
}

/**
 * * `ALL` - ALL
 * * `LINKED` - LINKED
 * * `UNLINKED` - UNLINKED
 */
export const SecurityIdLinkedFilterEnum = {
  ALL: 'ALL',
  LINKED: 'LINKED',
  UNLINKED: 'UNLINKED',
} as const

/**
 * * `ALL` - ALL
 * * `LINKED` - LINKED
 * * `UNLINKED` - UNLINKED
 */
export type SecurityIdLinkedFilterEnum = (typeof SecurityIdLinkedFilterEnum)[keyof typeof SecurityIdLinkedFilterEnum]

export type SelectedPolicy = {
  /**
   * Unique identifier for the selected policy record
   */
  readonly id: string
  /**
   * The title of the voter's selected policy
   */
  readonly policy_title: string | null
  /**
   * When the selected policy record was created
   */
  readonly create_time: Date
  /**
   * Reference to the voter selecting the policy
   */
  voter_id: string
  /**
   * Reference to the selected policy
   */
  policy_id: string
}

/**
 * Serializer for creating/updating a selected policy.
 */
export type SelectedPolicyRequestRequest = {
  /**
   * The ID of the policy to select
   */
  policy_id: string
}

/**
 * Serializer for the selected policy response wrapper.
 */
export type SelectedPolicyResponse = {
  /**
   * The voter's selected policy, or null if none selected
   */
  selectedPolicy: SelectedPolicy | null
}

/**
 * * `PROPOSAL_SOURCE_MANAGEMENT` - PROPOSAL_SOURCE_MANAGEMENT
 * * `PROPOSAL_SOURCE_SHAREHOLDER` - PROPOSAL_SOURCE_SHAREHOLDER
 */
export const SourceEnum = {
  PROPOSAL_SOURCE_MANAGEMENT: 'PROPOSAL_SOURCE_MANAGEMENT',
  PROPOSAL_SOURCE_SHAREHOLDER: 'PROPOSAL_SOURCE_SHAREHOLDER',
} as const

/**
 * * `PROPOSAL_SOURCE_MANAGEMENT` - PROPOSAL_SOURCE_MANAGEMENT
 * * `PROPOSAL_SOURCE_SHAREHOLDER` - PROPOSAL_SOURCE_SHAREHOLDER
 */
export type SourceEnum = (typeof SourceEnum)[keyof typeof SourceEnum]

export type SplitVoteInstructionOverwriteReason = {
  /**
   * Reportable reason for the overwrite
   *
   * * `vote_adjusted_for_voting_restriction` - Vote Adjusted for Voting Restriction
   * * `vote_adjusted_for_contested_meeting` - Vote Adjusted for Contested Meeting
   * * `vote_aligned_with_fm_due_to_restriction` - Vote Aligned with FM Due to Restriction
   * * `vote_aligned_with_fm_due_to_proposal_restriction` - Vote Aligned with FM Due to Proposal Restriction
   */
  reportable_reason: ReportableReasonEnum
  /**
   * Description of the overwrite reason for internal use
   */
  description: string
}

export type SplitVoteInstructionProposalOverwrite = {
  /**
   * Unique identifier for the SVI Proposal Overwrite
   */
  readonly id: string
  /**
   * Internal reason for the overwrite, not reportable
   */
  internal_reason?: string | null
  /**
   * Author of the overwrite
   */
  author: string
  /**
   * Investor votes FOR
   */
  investor_votes_for: number
  /**
   * Investor votes AGAINST
   */
  investor_votes_against: number
  /**
   * Investor votes ABSTAIN
   */
  investor_votes_abstain: number
  /**
   * Investor votes WITHHOLD
   */
  investor_votes_withhold: number
  /**
   * Investor votes NO VOTE
   */
  investor_votes_no_vote: number
  /**
   * Investor votes ONE YEAR
   */
  investor_votes_one_year: number
  /**
   * Investor votes TWO YEARS
   */
  investor_votes_two_years: number
  /**
   * Investor votes THREE YEARS
   */
  investor_votes_three_years: number
  /**
   * Split votes FOR
   */
  split_votes_for: number
  /**
   * Split votes AGAINST
   */
  split_votes_against: number
  /**
   * Split votes ABSTAIN
   */
  split_votes_abstain: number
  /**
   * Split votes WITHHOLD
   */
  split_votes_withhold: number
  /**
   * Split votes NO VOTE
   */
  split_votes_no_vote: number
  /**
   * Split votes ONE YEAR
   */
  split_votes_one_year: number
  /**
   * Split votes TWO YEARS
   */
  split_votes_two_years: number
  /**
   * Split votes THREE YEARS
   */
  split_votes_three_years: number
  /**
   * Percentage of split votes FOR
   */
  split_votes_percentage_for: number
  /**
   * Percentage of split votes AGAINST
   */
  split_votes_percentage_against: number
  /**
   * Percentage of split votes ABSTAIN
   */
  split_votes_percentage_abstain: number
  /**
   * Percentage of split votes WITHHOLD
   */
  split_votes_percentage_withhold: number
  /**
   * Percentage of split votes NO VOTE
   */
  split_votes_percentage_no_vote: number
  /**
   * Percentage of split votes ONE YEAR
   */
  split_votes_percentage_one_year: number
  /**
   * Percentage of split votes TWO YEARS
   */
  split_votes_percentage_two_years: number
  /**
   * Percentage of split votes THREE YEARS
   */
  split_votes_percentage_three_years: number
  /**
   * When the overwrite was created
   */
  readonly create_time: Date
  /**
   * When the overwrite was deleted
   */
  readonly delete_time: Date | null
  /**
   * Reference to the SVI Proposal being overwritten
   */
  split_vote_instruction_proposal_id: string
  /**
   * Reportable reason for overwriting the SVI Proposal
   */
  reportable_reason: ReportableReasonEnum
}

export type SplitVoteInstructionProposalOverwriteRequest = {
  /**
   * Internal reason for the overwrite, not reportable
   */
  internal_reason?: string | null
  /**
   * Author of the overwrite
   */
  author: string
  /**
   * Investor votes FOR
   */
  investor_votes_for: number
  /**
   * Investor votes AGAINST
   */
  investor_votes_against: number
  /**
   * Investor votes ABSTAIN
   */
  investor_votes_abstain: number
  /**
   * Investor votes WITHHOLD
   */
  investor_votes_withhold: number
  /**
   * Investor votes NO VOTE
   */
  investor_votes_no_vote: number
  /**
   * Investor votes ONE YEAR
   */
  investor_votes_one_year: number
  /**
   * Investor votes TWO YEARS
   */
  investor_votes_two_years: number
  /**
   * Investor votes THREE YEARS
   */
  investor_votes_three_years: number
  /**
   * Split votes FOR
   */
  split_votes_for: number
  /**
   * Split votes AGAINST
   */
  split_votes_against: number
  /**
   * Split votes ABSTAIN
   */
  split_votes_abstain: number
  /**
   * Split votes WITHHOLD
   */
  split_votes_withhold: number
  /**
   * Split votes NO VOTE
   */
  split_votes_no_vote: number
  /**
   * Split votes ONE YEAR
   */
  split_votes_one_year: number
  /**
   * Split votes TWO YEARS
   */
  split_votes_two_years: number
  /**
   * Split votes THREE YEARS
   */
  split_votes_three_years: number
  /**
   * Percentage of split votes FOR
   */
  split_votes_percentage_for: number
  /**
   * Percentage of split votes AGAINST
   */
  split_votes_percentage_against: number
  /**
   * Percentage of split votes ABSTAIN
   */
  split_votes_percentage_abstain: number
  /**
   * Percentage of split votes WITHHOLD
   */
  split_votes_percentage_withhold: number
  /**
   * Percentage of split votes NO VOTE
   */
  split_votes_percentage_no_vote: number
  /**
   * Percentage of split votes ONE YEAR
   */
  split_votes_percentage_one_year: number
  /**
   * Percentage of split votes TWO YEARS
   */
  split_votes_percentage_two_years: number
  /**
   * Percentage of split votes THREE YEARS
   */
  split_votes_percentage_three_years: number
  /**
   * Reference to the SVI Proposal being overwritten
   */
  split_vote_instruction_proposal_id: string
  /**
   * Reportable reason for overwriting the SVI Proposal
   */
  reportable_reason: ReportableReasonEnum
}

export type SplitVoteInstructionSubmission = {
  /**
   * Resource name of the submission, in the format 'splitVoteInstructions/{uuid}/submissions/{uuid}'.
   */
  name: string
  /**
   * Unique identifier of the submission.
   */
  id: string
  /**
   * The identifier of the ballot in the proxy intermediary's system the votes were submitted against.
   */
  proxy_intermediary_ballot_identifier: string
  /**
   * Resource name of the proxy intermediary, in the format 'proxyIntermediaries/{uuid}'.
   */
  proxy_intermediary_name: string
  /**
   * The time the votes were submitted to the proxy intermediary.
   */
  submit_time: Date
  /**
   * The user that submitted the votes.
   */
  submitted_by: string
  /**
   * Free-text detail recorded with the submission.
   */
  notes: string
  /**
   * The user that checked the submission. Null until it is checked.
   */
  checked_by: string | null
  /**
   * The time the submission was checked. Null until it is checked.
   */
  check_time: Date | null
  /**
   * The proxy intermediary's acknowledgement of the submission. Null until it is acknowledged.
   */
  acknowledgement: SplitVoteInstructionSubmissionAcknowledgement | null
}

export type SplitVoteInstructionSubmissionAcknowledgement = {
  /**
   * The time the proxy intermediary acknowledged the submission.
   */
  acknowledge_time: Date
  /**
   * The acknowledgement status.
   *
   * * `accepted` - Accepted by the proxy intermediary
   * * `rejected` - Rejected by the proxy intermediary
   * * `confirmed` - Confirmed as recorded and counted
   * * `overridden` - Superseded by a later decision
   */
  status: SplitVoteInstructionSubmissionAcknowledgementStatusEnum
  /**
   * Free-text detail recorded with the acknowledgement, such as a reason for a rejection.
   */
  notes: string | null
  /**
   * The user that recorded the acknowledgement.
   */
  created_by: string
  /**
   * The time the acknowledgement was recorded in Tumelo's system.
   */
  create_time: Date
}

/**
 * * `accepted` - Accepted by the proxy intermediary
 * * `rejected` - Rejected by the proxy intermediary
 * * `confirmed` - Confirmed as recorded and counted
 * * `overridden` - Superseded by a later decision
 */
export const SplitVoteInstructionSubmissionAcknowledgementStatusEnum = {
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  CONFIRMED: 'confirmed',
  OVERRIDDEN: 'overridden',
} as const

/**
 * * `accepted` - Accepted by the proxy intermediary
 * * `rejected` - Rejected by the proxy intermediary
 * * `confirmed` - Confirmed as recorded and counted
 * * `overridden` - Superseded by a later decision
 */
export type SplitVoteInstructionSubmissionAcknowledgementStatusEnum =
  (typeof SplitVoteInstructionSubmissionAcknowledgementStatusEnum)[keyof typeof SplitVoteInstructionSubmissionAcknowledgementStatusEnum]

/**
 * * `conflict_of_interest` - Conflict Of Interest
 * * `do_not_vote` - Do Not Vote
 * * `membership` - Membership
 */
export const StampTypeEnum = {
  CONFLICT_OF_INTEREST: 'conflict_of_interest',
  DO_NOT_VOTE: 'do_not_vote',
  MEMBERSHIP: 'membership',
} as const

/**
 * * `conflict_of_interest` - Conflict Of Interest
 * * `do_not_vote` - Do Not Vote
 * * `membership` - Membership
 */
export type StampTypeEnum = (typeof StampTypeEnum)[keyof typeof StampTypeEnum]

/**
 * * `do_not_vote` - do_not_vote
 * * `conflict_of_interest` - conflict_of_interest
 */
export const StampTypesEnum = { DO_NOT_VOTE: 'do_not_vote', CONFLICT_OF_INTEREST: 'conflict_of_interest' } as const

/**
 * * `do_not_vote` - do_not_vote
 * * `conflict_of_interest` - conflict_of_interest
 */
export type StampTypesEnum = (typeof StampTypesEnum)[keyof typeof StampTypesEnum]

export type SubmitVoteRequestRequest = {
  /**
   * Resource name of the proxy intermediary ballot to submit the votes against, in the format 'proxyIntermediaries/{uuid}/ballots/{uuid}'.
   */
  ballot_name: string
  /**
   * Resource name of the split vote instruction whose votes are submitted, in the format 'splitVoteInstructions/{uuid}'.
   */
  split_vote_instruction_name: string
}

export type SubmitVoteResponse = {
  /**
   * The submission that was recorded.
   */
  submission: SplitVoteInstructionSubmission
}

export type SupportedIssuedInstrumentsQueryRequest = {
  /**
   * List of component differences
   */
  components: Array<ComponentDiffRequest>
  /**
   * Date at which the supported instruments take effect
   */
  recomposition_date: Date
  investor_name: string
  /**
   * Name of the voting policy in format 'votingPolicies/{uuid}'
   */
  voting_policy_name?: string | null
}

/**
 * Response serializer for task status.
 */
export type TaskStatus = {
  /**
   * Unique task ID
   */
  task_id: number
  /**
   * Task status (todo, doing, succeeded, failed, cancelled)
   */
  status: string
  /**
   * Name of the task
   */
  task_name: string
  /**
   * Queue name
   */
  queue: string
  /**
   * When task was scheduled
   */
  scheduled_at: Date
  /**
   * When task started execution
   */
  started_at?: Date | null
}

/**
 * Response serializer when a task is successfully queued.
 */
export type TaskTriggered = {
  /**
   * Unique task ID for polling status
   */
  task_id: number
  /**
   * Confirmation message
   */
  message: string
}

/**
 * The representation of a tenant returned by every tenancy endpoint.
 */
export type Tenant = {
  /**
   * Unique identifier for the tenant
   */
  id: string
  /**
   * Free-text label that represents the tenant
   */
  name: string
  /**
   * The time the tenant was created
   */
  create_time: Date
  /**
   * The time the tenant was last updated
   */
  update_time: Date
}

export type TenantBallot = {
  /**
   * Identity id of the ballot, stable across versions.
   */
  ballot_id: string
  /**
   * Identity id of the proxy intermediary meeting this ballot is for.
   */
  proxy_intermediary_meeting_id: string
  /**
   * Unique identifier of the direct-voting custody account the ballot matched.
   */
  readonly custody_account_id: string
  /**
   * Account number identifying the asset owner's account (e.g. a fund) at the custodian holding it, as reported by a proxy intermediary. Unique only in combination with the custodian within a single proxy intermediary, not across them.
   */
  custodian_account_number: string
  /**
   * Number of shares eligible for voting, excluding shares on loan or otherwise ineligible.
   */
  available_shares: bigint
  /**
   * Public security ID of the security that gives rise to this ballot, in the form 'securityIDTypes/{type}/securityIDs/{value}'.
   */
  owned_public_security_id: string
  /**
   * The date and time votes are to be submitted to the proxy intermediary by for this ballot.
   */
  vote_deadline: Date
  /**
   * The title of the custodian account for display purposes.
   */
  readonly custodian_account_title: string
}

export type TenantBallotSearchRequestRequest = {
  /**
   * Restrict to ballots on this proxy intermediary meeting; omit to return all of the tenant's ballots.
   */
  proxy_intermediary_meeting_id?: string | null
}

export type TenantMeeting = {
  /**
   * Identity id of the proxy intermediary meeting, stable across versions.
   */
  proxy_intermediary_meeting_id: string
  /**
   * Issuer the meeting is held for.
   */
  issuer: TenantMeetingIssuer
  /**
   * The meeting type as ingested from the proxy intermediary.
   */
  type: string
  /**
   * The date and time the meeting is held.
   */
  meeting_date: Date
  /**
   * The date and time votes must be submitted to the proxy intermediary by.
   */
  meeting_deadline: Date
}

export type TenantMeetingIssuer = {
  /**
   * Transparency organization id of the issuer; null when unmatched or unlinked.
   */
  id: string | null
  /**
   * Display name of the issuer.
   */
  name: string
  /**
   * The meeting's primary resolved ISIN; null when none resolves.
   */
  isin: string | null
  /**
   * ISO 3166-1 alpha-2 country the issuer is incorporated in; null when unknown.
   */
  country_of_incorporation_iso2: string | null
  /**
   * ISO 3166-1 alpha-2 country the issuer is headquartered in; null when unknown.
   */
  headquarters_country_code_iso2: string | null
}

/**
 * * `issuer_name` - issuer_name
 * * `isin` - isin
 * * `meeting_date` - meeting_date
 * * `meeting_deadline` - meeting_deadline
 */
export const TenantMeetingOrderingFieldEnum = {
  ISSUER_NAME: 'issuer_name',
  ISIN: 'isin',
  MEETING_DATE: 'meeting_date',
  MEETING_DEADLINE: 'meeting_deadline',
} as const

/**
 * * `issuer_name` - issuer_name
 * * `isin` - isin
 * * `meeting_date` - meeting_date
 * * `meeting_deadline` - meeting_deadline
 */
export type TenantMeetingOrderingFieldEnum =
  (typeof TenantMeetingOrderingFieldEnum)[keyof typeof TenantMeetingOrderingFieldEnum]

export type TenantMeetingOrderingRequest = {
  /**
   * The meeting field to order by.
   *
   * * `issuer_name` - issuer_name
   * * `isin` - isin
   * * `meeting_date` - meeting_date
   * * `meeting_deadline` - meeting_deadline
   */
  field?: TenantMeetingOrderingFieldEnum
  /**
   * The direction to order in.
   *
   * * `ASC` - ASC
   * * `DESC` - DESC
   */
  direction?: DirectionEnum
}

export type TenantMeetingSearchRequestRequest = {
  /**
   * Match meetings whose issuer name or any resolved security ISIN contains this text.
   */
  search?: string
  /**
   * Restrict to these proxy intermediary meeting ids.
   */
  proxy_intermediary_meeting_ids?: Array<string>
  /**
   * Only meetings whose submission deadline is at or after this time.
   */
  meeting_deadline_after?: Date
  /**
   * Only meetings whose submission deadline is strictly before this time.
   */
  meeting_deadline_before?: Date
  ordering?: TenantMeetingOrderingRequest
}

/**
 * The request body accepted when searching tenants.
 */
export type TenantSearchRequestRequest = {
  /**
   * Return only the tenant with this exact name
   */
  name?: string
}

/**
 * The request body accepted when creating or updating a tenant.
 */
export type TenantWriteRequest = {
  /**
   * Free-text label that represents the tenant
   */
  name: string
}

export type TotalShareholderReturn = {
  /**
   * Identity id of the instrument the return is reported on.
   */
  readonly instrument_id: string
  /**
   * The total shareholder return, as a percentage. Negative when the return is a loss.
   */
  readonly value: string
  /**
   * The currency the return is computed in. ISO 4217 currency code.
   */
  readonly currency: string
  /**
   * The return index level the return is derived from.
   */
  readonly return_index: number | null
  /**
   * The date the return is valid for.
   */
  readonly valid_date: Date
  /**
   * The exchange the return is measured on.
   */
  exchange: Exchange
}

export type TotalShareholderReturnList = {
  results: Array<TotalShareholderReturn>
}

export type TotalShareholderReturnUpsertRequest = {
  /**
   * The total shareholder return, as a percentage. Negative when the return is a loss.
   */
  value: string
  /**
   * The currency the return is computed in. ISO 4217 currency code.
   */
  currency: string
  /**
   * The ISO 10383 MIC code of the exchange the return is measured on. Rejected if no exchange with this code exists.
   */
  exchange: string
  /**
   * The return index level the return is derived from.
   */
  return_index?: number | null
  /**
   * The date the return is valid for.
   */
  valid_date: Date
}

/**
 * Request serializer for triggering entitlements computation.
 */
export type TriggerComputeEntitlementsRequest = {
  /**
   * ID of the proxy intermediary ballot to compute entitlements for
   */
  proxy_intermediary_ballot_id: string
  /**
   * Optional list of investor IDs to filter entitlements computation. Intended for testing only. If not provided, all investors are included.
   */
  investor_ids?: Array<string>
}

/**
 * Request serializer for triggering meeting ballot handout processing.
 */
export type TriggerProcessMeetingBallotsRequest = {
  /**
   * ID of the proxy intermediary ballot to process meeting ballots for
   */
  proxy_intermediary_ballot_id: string
  /**
   * Optional habitat ID to filter meeting ballot processing. Intended for testing only. If not provided, investors for all habitats are processed.
   */
  habitat_id?: string | null
}

export type UnassociatedInstrumentsResponse = {
  instruments: Array<Instrument>
}

/**
 * * `proposal_label.proposal_label` - proposal_label.proposal_label
 * * `proposal_label.proposal_category` - proposal_label.proposal_category
 */
export const UpdateMaskEnum = {
  PROPOSAL_LABEL_PROPOSAL_LABEL: 'proposal_label.proposal_label',
  PROPOSAL_LABEL_PROPOSAL_CATEGORY: 'proposal_label.proposal_category',
} as const

/**
 * * `proposal_label.proposal_label` - proposal_label.proposal_label
 * * `proposal_label.proposal_category` - proposal_label.proposal_category
 */
export type UpdateMaskEnum = (typeof UpdateMaskEnum)[keyof typeof UpdateMaskEnum]

/**
 * Request body for updating a voting recommendation from a provider voting recommendation.
 */
export type UpdateVotingRecommendationFromPvrRequest = {
  /**
   * The provider voting recommendation to copy fields from.
   */
  provider_voting_recommendation_id: string
}

export type UpsertPiProposalCategoryRequest = {
  /**
   * The id of the PI proposal to upsert category data for.
   */
  proposal_id: string
  /**
   * The category to upsert for the proposal.
   *
   * * `elect_director` - Elect Director
   * * `audit` - Audit
   * * `say_on_pay` - Say on Pay
   * * `compensation` - Compensation
   * * `security_issuance` - Security Issuance
   * * `capital_structure` - Capital Structure
   * * `reorganization_mna` - Reorganization / M&A
   * * `anti_takeover` - Anti-Takeover
   * * `governance_provision` - Governance Provision
   * * `shareholder_request` - Shareholder Request
   * * `sustainability_approval` - Sustainability Approval
   * * `administrative` - Administrative
   * * `other` - Other
   */
  category: PiProposalCategoryEnum
  /**
   * The subcategory to upsert for the proposal, or null when it has none.
   *
   * * `elect_director` - Elect Director
   * * `remove_director` - Remove Director
   * * `spill_resolution` - Spill Resolution
   * * `elect_supervisory_board` - Elect Supervisory Board
   * * `other_director_election` - Other Director Election
   * * `appoint_or_ratify_auditor` - Appoint or Ratify Auditor
   * * `auditor_rotation` - Auditor Rotation
   * * `auditor_remuneration` - Auditor Remuneration
   * * `discharge_of_auditors` - Discharge of Auditors
   * * `accept_financial_statements` - Accept Financial Statements
   * * `special_audit_request` - Special Audit Request
   * * `other_audit` - Other Audit
   * * `executive_compensation` - Executive Compensation
   * * `remuneration_report` - Remuneration Report
   * * `remuneration_policy` - Remuneration Policy
   * * `golden_parachute` - Golden Parachute
   * * `frequency` - Frequency
   * * `other_say_on_pay` - Other Say on Pay
   * * `equity_incentive_plan` - Equity Incentive Plan
   * * `employee_share_purchase_plan` - Employee Share Purchase Plan
   * * `director_fees_or_equity` - Director Fees or Equity
   * * `cash_or_bonus_plan` - Cash or Bonus Plan
   * * `severance_or_pension` - Severance or Pension
   * * `anti_hedging_or_pledging` - Anti-Hedging or Pledging
   * * `compensation_clawback` - Compensation Clawback
   * * `trading_plan_10b5_1` - Trading Plan (10b5-1)
   * * `other_compensation` - Other Compensation
   * * `issuance_with_preemptive_rights` - Issuance with Preemptive Rights
   * * `issuance_without_preemptive_rights` - Issuance without Preemptive Rights
   * * `private_placement` - Private Placement
   * * `debt_or_convertible` - Debt or Convertible
   * * `warrants_or_rights` - Warrants or Rights
   * * `other_issuance` - Other Issuance
   * * `increase_authorised_capital` - Increase Authorised Capital
   * * `share_class_or_rights` - Share Class or Rights
   * * `share_repurchase` - Share Repurchase
   * * `stock_split_or_consolidation` - Stock Split or Consolidation
   * * `capital_reduction` - Capital Reduction
   * * `dividend_or_distribution` - Dividend or Distribution
   * * `other_capital_structure` - Other Capital Structure
   * * `merger_or_acquisition` - Merger or Acquisition
   * * `asset_transaction` - Asset Transaction
   * * `restructuring_or_spinoff` - Restructuring or Spinoff
   * * `liquidation_or_going_private` - Liquidation or Going Private
   * * `reincorporation` - Reincorporation
   * * `tender_offer` - Tender Offer
   * * `other_transaction` - Other Transaction
   * * `shareholder_rights_plan` - Shareholder Rights Plan
   * * `control_share_acquisition` - Control Share Acquisition
   * * `fair_price_provision` - Fair Price Provision
   * * `blank_cheque_preferred` - Blank Cheque Preferred
   * * `anti_greenmail` - Anti-Greenmail
   * * `other_defensive` - Other Defensive
   * * `proxy_access` - Proxy Access
   * * `special_meeting_right` - Special Meeting Right
   * * `written_consent_right` - Written Consent Right
   * * `board_classification` - Board Classification
   * * `majority_voting_standard` - Majority Voting Standard
   * * `supermajority_requirement` - Supermajority Requirement
   * * `cumulative_voting` - Cumulative Voting
   * * `confidential_voting` - Confidential Voting
   * * `exclusive_forum` - Exclusive Forum
   * * `board_size` - Board Size
   * * `director_term_or_age_limit` - Director Term or Age Limit
   * * `separate_chair_and_ceo` - Separate Chair and CEO
   * * `indemnification_or_liability` - Indemnification or Liability
   * * `related_party_transaction` - Related Party Transaction
   * * `codes_of_ethics` - Codes of Ethics
   * * `amend_articles_general` - Amend Articles General
   * * `other_governance` - Other Governance
   * * `request_report_or_disclosure` - Request Report or Disclosure
   * * `request_policy_or_target` - Request Policy or Target
   * * `request_independent_assessment` - Request Independent Assessment
   * * `other_shareholder_request` - Other Shareholder Request
   * * `say_on_climate` - Say on Climate
   * * `sustainability_or_esg_report` - Sustainability or ESG Report
   * * `other_sustainability_approval` - Other Sustainability Approval
   * * `routine_business` - Routine Business
   * * `adjourn_meeting` - Adjourn Meeting
   * * `discharge_of_directors` - Discharge of Directors
   * * `other_administrative` - Other Administrative
   */
  subcategory: PiProposalSubcategoryEnum | null
  /**
   * Zero or more topics relating to this proposal; null is treated as none.
   */
  topics: Array<PiProposalTopicEnum> | null
  /**
   * The source of the category data.
   *
   * * `automatic` - automatic
   * * `manual` - manual
   */
  source: PiProposalCategorySourceEnum
}

export type UpsertPiProposalCategoryResponse = {
  /**
   * Whether the proposal category was created, updated, or left unchanged.
   *
   * * `STATUS_PI_PROPOSAL_CATEGORY_CREATED` - STATUS_PI_PROPOSAL_CATEGORY_CREATED
   * * `STATUS_PI_PROPOSAL_CATEGORY_UPDATED` - STATUS_PI_PROPOSAL_CATEGORY_UPDATED
   * * `STATUS_PI_PROPOSAL_CATEGORY_NO_OPERATION` - STATUS_PI_PROPOSAL_CATEGORY_NO_OPERATION
   */
  status: PiProposalCategoryUpsertStatusEnum
}

export type UpsertRequestRequest = {
  /**
   * Resource name of the proxy intermediary, in the format 'proxyIntermediaries/{uuid}'.
   */
  proxy_intermediary_name?: string
  /**
   * The proxy intermediary this ballot belongs to. Preferred over proxy_intermediary_name when set.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary?: ProxyIntermediaryEnum
  /**
   * The external id of the meeting in the proxy intermediary.
   */
  proxy_intermediary_meeting_external_id: string
  /**
   * The ballot to upsert.
   */
  ballot: BallotUpsertRequest
}

export type UpsertResponse = {
  /**
   * The upserted ballot.
   */
  ballot: Ballot
  /**
   * Whether the ballot was created, updated, unchanged, or rejected.
   *
   * * `STATUS_BALLOT_INVALID` - STATUS_BALLOT_INVALID
   * * `STATUS_BALLOT_CREATED` - STATUS_BALLOT_CREATED
   * * `STATUS_BALLOT_UPDATED` - STATUS_BALLOT_UPDATED
   * * `STATUS_BALLOT_NO_OPERATION` - STATUS_BALLOT_NO_OPERATION
   */
  status: BallotStatusEnum
}

/**
 * * `STATUS_CREATED` - STATUS_CREATED
 * * `STATUS_UPDATED` - STATUS_UPDATED
 * * `STATUS_NO_OPERATION` - STATUS_NO_OPERATION
 */
export const UpsertStatusEnum = {
  STATUS_CREATED: 'STATUS_CREATED',
  STATUS_UPDATED: 'STATUS_UPDATED',
  STATUS_NO_OPERATION: 'STATUS_NO_OPERATION',
} as const

/**
 * * `STATUS_CREATED` - STATUS_CREATED
 * * `STATUS_UPDATED` - STATUS_UPDATED
 * * `STATUS_NO_OPERATION` - STATUS_NO_OPERATION
 */
export type UpsertStatusEnum = (typeof UpsertStatusEnum)[keyof typeof UpsertStatusEnum]

/**
 * The representation of a user returned by every tenancy endpoint.
 */
export type User = {
  /**
   * Unique identifier for the user
   */
  id: string
  /**
   * The user's authentication source
   *
   * * `tumelo_gcip` - Tumelo Gcip
   * * `tumelo_entra` - Tumelo Entra
   * * `tumelo_cognito` - Tumelo Cognito
   */
  identity_source: IdentitySourceEnum
  /**
   * The user's ID at their identity source, taken from their token's sub claim
   */
  external_subject: string
  /**
   * The tenant the user is a member of
   */
  tenant_id: string
  /**
   * The time the user was created
   */
  create_time: Date
  /**
   * The time the user was last updated
   */
  update_time: Date
}

/**
 * The request body accepted when searching users.
 */
export type UserSearchRequestRequest = {
  /**
   * Return only users belonging to this tenant
   */
  tenant_id?: string
  /**
   * Return only users with this authentication source
   *
   * * `tumelo_gcip` - Tumelo Gcip
   * * `tumelo_entra` - Tumelo Entra
   * * `tumelo_cognito` - Tumelo Cognito
   */
  identity_source?: IdentitySourceEnum
  /**
   * Return only the user with this exact external subject
   */
  external_subject?: string
}

/**
 * The request body accepted when creating or updating a user.
 */
export type UserWriteRequest = {
  /**
   * The user's authentication source
   *
   * * `tumelo_gcip` - Tumelo Gcip
   * * `tumelo_entra` - Tumelo Entra
   * * `tumelo_cognito` - Tumelo Cognito
   */
  identity_source: IdentitySourceEnum
  /**
   * The user's ID at their identity source, taken from their token's sub claim
   */
  external_subject: string
  /**
   * The tenant the user is a member of
   */
  tenant_id: string
}

/**
 * * `VALID` - VALID
 * * `NOT_VALID` - NOT_VALID
 * * `ALL` - ALL
 */
export const ValidEnum = {
  VALID: 'VALID',
  NOT_VALID: 'NOT_VALID',
  ALL: 'ALL',
} as const

/**
 * * `VALID` - VALID
 * * `NOT_VALID` - NOT_VALID
 * * `ALL` - ALL
 */
export type ValidEnum = (typeof ValidEnum)[keyof typeof ValidEnum]

/**
 * * `checked` - Checked
 * * `unchecked` - Unchecked
 */
export const ValidationStatusEnum = { CHECKED: 'checked', UNCHECKED: 'unchecked' } as const

/**
 * * `checked` - Checked
 * * `unchecked` - Unchecked
 */
export type ValidationStatusEnum = (typeof ValidationStatusEnum)[keyof typeof ValidationStatusEnum]

/**
 * * `automatic` - Automatic
 * * `manual` - Manual
 */
export const VoteMethodEnum = { AUTOMATIC: 'automatic', MANUAL: 'manual' } as const

/**
 * * `automatic` - Automatic
 * * `manual` - Manual
 */
export type VoteMethodEnum = (typeof VoteMethodEnum)[keyof typeof VoteMethodEnum]

export type VoteStatus = {
  /**
   * Unique identifier of the vote status.
   */
  id: string
  /**
   * Unique identifier of the proxy intermediary that reported the status.
   */
  proxy_intermediary_id: string
  /**
   * Resource name of the proxy intermediary, in the format 'proxyIntermediaries/{uuid}'.
   */
  proxy_intermediary_name: string
  /**
   * The identifier of the ballot in the proxy intermediary's system that the status applies to (in Broadridge's ProxyEdge this is the 'Control Number').
   */
  ballot_external_id: string
  /**
   * The status the proxy intermediary reports for the ballot's votes. Free text, maximum length 255 characters.
   */
  vote_status: string
  /**
   * Free-text detail accompanying the status, such as a reason for a rejection. Maximum length 5000 characters.
   */
  status_note: string
  /**
   * The time the status was recorded in Tumelo's system.
   */
  create_time: Date
  /**
   * The date and time the status is valid for. A valid_time before the most recent one is not visible.
   */
  valid_time: Date
  /**
   * The time the status was retracted; set when it should no longer be visible.
   */
  delete_time: Date | null
}

export type VoteStatusDeleteRequestRequest = {
  /**
   * Unique identifier of the vote status to retract.
   */
  id: string
}

export type VoteStatusUpsertRequestRequest = {
  /**
   * Resource name of the proxy intermediary, in the format 'proxyIntermediaries/{uuid}'.
   */
  proxy_intermediary_name?: string
  /**
   * The proxy intermediary reporting the status. Preferred over proxy_intermediary_name when set.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary?: ProxyIntermediaryEnum
  /**
   * The identifier of the ballot in the proxy intermediary's system that the status applies to (in Broadridge's ProxyEdge this is the 'Control Number').
   */
  ballot_external_id: string
  /**
   * The status the proxy intermediary reports for the ballot's votes. Free text, maximum length 255 characters.
   */
  vote_status: string
  /**
   * Free-text detail accompanying the status, such as a reason for a rejection. Maximum length 5000 characters.
   */
  status_note?: string
  /**
   * The date and time the status is valid for. A valid_time before the most recent one is not visible.
   */
  valid_time: Date
}

export type VoteStatusUpsertResponse = {
  /**
   * The vote status now visible for the ballot.
   */
  vote_status: VoteStatus
  /**
   * Whether the vote status was created, updated, or left unchanged.
   *
   * * `STATUS_VOTE_STATUS_CREATED` - STATUS_VOTE_STATUS_CREATED
   * * `STATUS_VOTE_STATUS_UPDATED` - STATUS_VOTE_STATUS_UPDATED
   * * `STATUS_VOTE_STATUS_NO_OPERATION` - STATUS_VOTE_STATUS_NO_OPERATION
   */
  status: VoteStatusUpsertStatusEnum
}

/**
 * * `STATUS_VOTE_STATUS_CREATED` - STATUS_VOTE_STATUS_CREATED
 * * `STATUS_VOTE_STATUS_UPDATED` - STATUS_VOTE_STATUS_UPDATED
 * * `STATUS_VOTE_STATUS_NO_OPERATION` - STATUS_VOTE_STATUS_NO_OPERATION
 */
export const VoteStatusUpsertStatusEnum = {
  STATUS_VOTE_STATUS_CREATED: 'STATUS_VOTE_STATUS_CREATED',
  STATUS_VOTE_STATUS_UPDATED: 'STATUS_VOTE_STATUS_UPDATED',
  STATUS_VOTE_STATUS_NO_OPERATION: 'STATUS_VOTE_STATUS_NO_OPERATION',
} as const

/**
 * * `STATUS_VOTE_STATUS_CREATED` - STATUS_VOTE_STATUS_CREATED
 * * `STATUS_VOTE_STATUS_UPDATED` - STATUS_VOTE_STATUS_UPDATED
 * * `STATUS_VOTE_STATUS_NO_OPERATION` - STATUS_VOTE_STATUS_NO_OPERATION
 */
export type VoteStatusUpsertStatusEnum = (typeof VoteStatusUpsertStatusEnum)[keyof typeof VoteStatusUpsertStatusEnum]

/**
 * Serializer for voter details response.
 */
export type VoterDetailsResponse = {
  /**
   * Unique identifier for the voter
   */
  id: string
  /**
   * Broker associated with the voter
   */
  broker_id: string
}

/**
 * Serializer for voter response without holdings.
 */
export type VoterResponse = {
  /**
   * Unique identifier for a voter
   */
  readonly id: string
  /**
   * Mediants unique identifier for the voter
   */
  mediant_id: string
  /**
   * Broker associated with the voter
   */
  broker_id: string
  /**
   * Type of voter
   *
   * * `retail` - Retail
   * * `institutional` - Institutional
   */
  type: VoterTypeEnum
  /**
   * Authorization token for the voter
   */
  token: string
}

/**
 * * `retail` - Retail
 * * `institutional` - Institutional
 */
export const VoterTypeEnum = { RETAIL: 'retail', INSTITUTIONAL: 'institutional' } as const

/**
 * * `retail` - Retail
 * * `institutional` - Institutional
 */
export type VoterTypeEnum = (typeof VoterTypeEnum)[keyof typeof VoterTypeEnum]

/**
 * Serializer for creating or updating a voter with their holdings.
 */
export type VoterWithHoldingsInputRequest = {
  /**
   * Mediants unique identifier for the voter
   */
  mediant_id: string
  /**
   * Broker associated with the voter
   */
  broker_id: string
  /**
   * Type of voter
   *
   * * `retail` - Retail
   * * `institutional` - Institutional
   */
  type: VoterTypeEnum
  /**
   * List of holdings for the voter
   */
  holdings: Array<HoldingInputRequest>
}

/**
 * Serializer for voter response with holdings.
 */
export type VoterWithHoldingsResponse = {
  /**
   * Unique identifier for a voter
   */
  readonly id: string
  /**
   * Mediants unique identifier for the voter
   */
  mediant_id: string
  /**
   * Broker associated with the voter
   */
  broker_id: string
  /**
   * Type of voter
   *
   * * `retail` - Retail
   * * `institutional` - Institutional
   */
  type: VoterTypeEnum
  /**
   * Authorization token for the voter
   */
  token: string
  /**
   * List of holdings for the voter
   */
  readonly holdings: Array<Holding>
}

/**
 * * `for` - For
 * * `against` - Against
 * * `abstain` - Abstain
 * * `withhold` - Withhold
 * * `no_action` - No Action
 * * `one_year` - One Year
 * * `two_years` - Two Years
 * * `three_years` - Three Years
 * * `do_not_vote` - Do Not Vote
 */
export const VotingInstructionEnum = {
  FOR: 'for',
  AGAINST: 'against',
  ABSTAIN: 'abstain',
  WITHHOLD: 'withhold',
  NO_ACTION: 'no_action',
  ONE_YEAR: 'one_year',
  TWO_YEARS: 'two_years',
  THREE_YEARS: 'three_years',
  DO_NOT_VOTE: 'do_not_vote',
} as const

/**
 * * `for` - For
 * * `against` - Against
 * * `abstain` - Abstain
 * * `withhold` - Withhold
 * * `no_action` - No Action
 * * `one_year` - One Year
 * * `two_years` - Two Years
 * * `three_years` - Three Years
 * * `do_not_vote` - Do Not Vote
 */
export type VotingInstructionEnum = (typeof VotingInstructionEnum)[keyof typeof VotingInstructionEnum]

/**
 * * `VOTING_OPTION_FOR` - VOTING_OPTION_FOR
 * * `VOTING_OPTION_AGAINST` - VOTING_OPTION_AGAINST
 * * `VOTING_OPTION_ABSTAIN` - VOTING_OPTION_ABSTAIN
 * * `VOTING_OPTION_WITHHOLD` - VOTING_OPTION_WITHHOLD
 * * `VOTING_OPTION_NO_ACTION` - VOTING_OPTION_NO_ACTION
 * * `VOTING_OPTION_ONE_YEAR` - VOTING_OPTION_ONE_YEAR
 * * `VOTING_OPTION_TWO_YEARS` - VOTING_OPTION_TWO_YEARS
 * * `VOTING_OPTION_THREE_YEARS` - VOTING_OPTION_THREE_YEARS
 */
export const VotingOptionsEnum = {
  VOTING_OPTION_FOR: 'VOTING_OPTION_FOR',
  VOTING_OPTION_AGAINST: 'VOTING_OPTION_AGAINST',
  VOTING_OPTION_ABSTAIN: 'VOTING_OPTION_ABSTAIN',
  VOTING_OPTION_WITHHOLD: 'VOTING_OPTION_WITHHOLD',
  VOTING_OPTION_NO_ACTION: 'VOTING_OPTION_NO_ACTION',
  VOTING_OPTION_ONE_YEAR: 'VOTING_OPTION_ONE_YEAR',
  VOTING_OPTION_TWO_YEARS: 'VOTING_OPTION_TWO_YEARS',
  VOTING_OPTION_THREE_YEARS: 'VOTING_OPTION_THREE_YEARS',
} as const

/**
 * * `VOTING_OPTION_FOR` - VOTING_OPTION_FOR
 * * `VOTING_OPTION_AGAINST` - VOTING_OPTION_AGAINST
 * * `VOTING_OPTION_ABSTAIN` - VOTING_OPTION_ABSTAIN
 * * `VOTING_OPTION_WITHHOLD` - VOTING_OPTION_WITHHOLD
 * * `VOTING_OPTION_NO_ACTION` - VOTING_OPTION_NO_ACTION
 * * `VOTING_OPTION_ONE_YEAR` - VOTING_OPTION_ONE_YEAR
 * * `VOTING_OPTION_TWO_YEARS` - VOTING_OPTION_TWO_YEARS
 * * `VOTING_OPTION_THREE_YEARS` - VOTING_OPTION_THREE_YEARS
 */
export type VotingOptionsEnum = (typeof VotingOptionsEnum)[keyof typeof VotingOptionsEnum]

/**
 * Read serializer for a VotingPolicy.
 *
 * `current_policy_document` is the latest VotingPolicyDocument for the policy by
 * issue_time descending, or null if the policy has no documents. The signed_url on
 * the document is generated at request time and is valid for 24 hours.
 */
export type VotingPolicy = {
  /**
   * Unique resource name in format votingPolicies/{uuid}.
   */
  readonly name: string
  /**
   * The voting policy title.
   */
  title: string
  /**
   * Optional abbreviated title for the voting policy.
   */
  title_abbreviation: string | null
  /**
   * Title of the policy provider.
   */
  policy_provider: string
  /**
   * The description of the voting policy.
   */
  formatted_description: string
  /**
   * Latest voting policy document for this policy, or null if none exist.
   */
  readonly current_policy_document: {
    [key: string]: unknown
  } | null
  /**
   * Optional external identifier used to link to upstream policy systems.
   */
  external_id: string | null
  /**
   * Investor types this policy is available to.
   */
  readonly available_to_investor_type: Array<AvailableToInvestorTypeEnum>
  /**
   * Time the voting policy was created.
   */
  create_time: Date
  /**
   * Time the voting policy was last updated.
   */
  update_time: Date
  /**
   * Optional Cloudinary URL for the voting policy image.
   */
  image_url: string | null
}

/**
 * Request body for creating a voting policy.
 */
export type VotingPolicyCreateRequest = {
  /**
   * The voting policy title. Maximum 150 characters.
   */
  title: string
  /**
   * Optional abbreviated title for the voting policy.
   */
  title_abbreviation?: string | null
  /**
   * Title of the policy provider.
   */
  policy_provider: string
  /**
   * The description of the voting policy.
   */
  formatted_description: string
  /**
   * Optional external identifier used to link to upstream policy systems.
   */
  external_id?: string | null
  /**
   * Investor types this policy is available to. At least one is required.
   */
  available_to_investor_type: Array<AvailableToInvestorTypeEnum>
  /**
   * Optional Cloudinary URL for the voting policy image.
   */
  image_url?: string | null
}

/**
 * Serializer for VotingPolicyDocument.
 * The signed_url is generated at request time from the stored document_key; it is
 * valid for 24 hours and is not persisted.
 */
export type VotingPolicyDocument = {
  /**
   * Resource name in format votingPolicies/{uuid}/documents/{integer}.
   */
  readonly name: string
  /**
   * Timestamp when the document record was created.
   */
  create_time: Date
  /**
   * Timestamp when the document record was last updated.
   */
  update_time: Date
  /**
   * The document's official publication time.
   */
  issue_time: Date
  /**
   * The document title.
   */
  title: string
  /**
   * Presigned S3 URL providing unauthenticated access to the PDF for 24 hours.
   */
  readonly signed_url: string
}

/**
 * Body filters for searching voting policies. All filters are optional.
 */
export type VotingPolicySearchRequest = {
  /**
   * Return only the voting policies with these UUIDs.
   */
  voting_policy_ids?: Array<string>
  /**
   * Return only voting policies available to this investor type.
   *
   * * `institutional` - Institutional
   * * `retail` - Retail
   * * `retail_ptv` - Retail PTV
   */
  investor_type?: AvailableToInvestorTypeEnum
  /**
   * Return voting policies whose title contains this substring (case insensitive).
   */
  search_title?: string
}

/**
 * Read serializer for a VotingRecommendationVersion.
 *
 * The resource name uses the version ID:
 * votingPolicies/{voting_policy_id}/votingRecommendations/{version_id}
 */
export type VotingRecommendation = {
  /**
   * Unique resource name in format votingPolicies/{uuid}/votingRecommendations/{uuid}.
   */
  readonly name: string
  /**
   * The proposal this recommendation applies to, in the form organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}.
   */
  proposal_name: string
  /**
   * The voting instruction: for, against, abstain, withhold, no_action, one_year, two_years, three_years, or do_not_vote.
   */
  voting_instruction: string
  /**
   * Optional rationale supporting the voting instruction. Maximum 5000 characters.
   */
  rationale: string | null
  /**
   * Optional proposal text provided by the recommendation provider. Maximum 5000 characters.
   */
  proposal_text: string | null
  /**
   * Optional proposal label provided by the recommendation provider. Maximum 20 characters.
   */
  proposal_label: string | null
  /**
   * Optional sequence number for the proposal provided by the recommendation provider.
   */
  proposal_sequence_number: number | null
  /**
   * The provider recommendation that led to the creation of this voting recommendation, if any.
   */
  provider_voting_recommendation_id: string | null
  /**
   * Time this recommendation version was created.
   */
  create_time: Date
  /**
   * Time this recommendation version was last updated.
   */
  update_time: Date
}

/**
 * Read serializer for a VotingRecommendationConfidenceScore.
 */
export type VotingRecommendationConfidenceScore = {
  /**
   * The validation confidence score, between 0.0 and 1.0.
   */
  validation_confidence_score: number
  /**
   * The name of the algorithm that produced the score.
   */
  algorithm_name: string
  /**
   * Time this confidence score was created.
   */
  create_time: Date
  /**
   * Time this confidence score was last updated.
   */
  update_time: Date
}

/**
 * Request serializer for upserting a confidence score. Both fields are required.
 */
export type VotingRecommendationConfidenceScoreUpsertRequest = {
  /**
   * The validation confidence score. Must be between 0.0 and 1.0 inclusive.
   */
  validation_confidence_score: number
  /**
   * The name of the algorithm that produced the score. Maximum 255 characters.
   */
  algorithm_name: string
}

export type VotingRecommendationCreateRequest = {
  /**
   * The proposal to recommend a vote for, in the form organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}.
   */
  proposal_name: string
  /**
   * The voting instruction.
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `no_action` - No Action
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `do_not_vote` - Do Not Vote
   */
  voting_instruction: VotingInstructionEnum
  /**
   * Optional rationale supporting the voting instruction. Maximum 5000 characters.
   */
  rationale?: string | null
  /**
   * Optional proposal text provided by the recommendation provider. Maximum 5000 characters.
   */
  proposal_text?: string | null
  /**
   * Optional proposal label provided by the recommendation provider. Maximum 20 characters.
   */
  proposal_label?: string | null
  /**
   * Optional sequence number for the proposal provided by the recommendation provider.
   */
  proposal_sequence_number?: number | null
  /**
   * The provider recommendation that led to the creation of this voting recommendation, if any.
   */
  provider_voting_recommendation_id?: string | null
}

/**
 * Body filters for searching voting recommendations under a voting policy. All filters are optional.
 */
export type VotingRecommendationSearchRequest = {
  /**
   * Return recommendations for any of these proposal resource names (each in the form organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}).
   */
  proposal_names?: Array<string>
  /**
   * Return recommendations linked to any of these provider voting recommendation UUIDs.
   */
  provider_voting_recommendation_ids?: Array<string>
}

/**
 * Serializer for BallotEntitlement responses.
 */
export type BallotEntitlementWritable = {
  proxy_intermediary_ballot_id: string
  investor_account_id: string
  ballot_proportion: number
  investor_supported_issued_instrument_id?: string | null
  investor_policy_supported_issued_instrument_id?: string | null
  fund_manager_policy_supported_issued_instrument_id?: string | null
  invalid_time?: Date | null
}

export type BallotProposalWritable = {
  /**
   * The SHA256 hash of the Proposals in the set. Fields hashed: proxy_intermediary_meeting_id,broadridge_agenda_id, label, text, voting_options, source, management_recommendation,sequence_number, is_opposition, director_number, vote_group, vote_group_max_for, vote_group_max,category_code, withdrawn
   */
  proposal_set_id: string
  /**
   * The alphanumeric label for the proposal within the meeting. eg (1a, A, 1)
   */
  label: string
  /**
   * The human-readable text of the proposal.
   */
  text: string
  /**
   * The set of valid voting options for this proposal.
   */
  voting_options: Array<ProxyIntermediaryVotingOptionsEnum>
  /**
   * Who proposed this: 'management' or 'shareholder'.
   *
   * * `management` - Management
   * * `shareholder` - Shareholder
   */
  source: ProxyIntermediaryProposalSourceEnum
  /**
   * The management voting recommendation (e.g. 'for', 'against').
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `no_action` - No Action
   * * `do_not_vote` - Do Not Vote
   */
  management_recommendation?: ProxyIntermediaryVotingOptionsEnum | null
  /**
   * The ordering sequence for the proposals from the proxy intermediary
   */
  sequence_number?: number | null
}

export type BallotProposalsResponseWritable = {
  proposals: Array<BallotProposalWritable>
}

export type BatchVoterWithHoldingsResponseWritable = {
  /**
   * Newly created voters
   */
  created: Array<VoterResponseWritable>
  /**
   * Updated voters
   */
  updated: Array<VoterResponseWritable>
}

export type CastVoteResponseWritable = {
  instructions: Array<unknown>
}

export type CreateProposalsResponseWritable = {
  proposals: Array<ProxyIntermediaryProposalWritable>
}

export type CustodyAccountWritable = {
  /**
   * The proxy intermediary that reported this custody account.
   */
  proxy_intermediary_id: string
  /**
   * Identifier of the custodian (institution) holding the account within the proxy intermediary
   *
   * also known as custodian_account_id.
   */
  custodian_id: string
  /**
   * Account number identifying the asset owner's account (e.g. a fund) at the custodian holding it, as reported by a proxy intermediary. Unique only in combination with the custodian within the reporting proxy intermediary.
   */
  custodian_account_number: string
  /**
   * title of the custodian account for display purposes.
   */
  title: string
}

/**
 * A custody account group of the acting tenant; the tenant is taken from the request, never the body.
 */
export type CustodyAccountGroupWritable = {
  /**
   * Free-text label that names the group within its tenant.
   */
  title: string
}

/**
 * Read/write serializer for the current version of one custody account's place in a group.
 */
export type CustodyAccountGroupMembershipWritable = {
  /**
   * The custody account group the account belongs to.
   */
  group_id: string
  /**
   * The custody account that belongs to the group.
   */
  custody_account_id: string
}

export type CustodyAccountTenantLinkWritable = {
  /**
   * The tenant that owns the custody account.
   */
  tenant: string
  /**
   * The custody account owned by the tenant.
   */
  custody_account: string
}

/**
 * Read/write serializer for the current version of a custody account voting policy selection.
 */
export type CustodyAccountVotingPolicySelectionWritable = {
  /**
   * The tenant that votes under this policy selection.
   */
  tenant_id: string
  /**
   * The custody account the voting policy applies to. Immutable once set.
   */
  custody_account_id: string
  /**
   * The voting policy the custody account votes under.
   */
  voting_policy_id: string
}

/**
 * Current version of a ballot workflow item; ``id`` is the identity, stable across versions.
 *
 * ``pi_ballot_id`` and ``custody_account_group_id`` are fixed once the item is created.
 * ``assigned_by_id`` is never written by the caller: the server records the acting user whenever
 * ``assigned_to_id`` changes.
 */
export type DirectVotingBallotWorkflowItemWritable = {
  /**
   * Identity id of the proxy intermediary ballot the workflow item tracks. Immutable once set.
   */
  pi_ballot_id: string
  /**
   * Id of the acting tenant's custody account group the item covers the ballot for, or null for the ballot as a whole. Immutable once set.
   */
  custody_account_group_id?: string | null
  /**
   * Whether the ballot must be reviewed before it is instructed. Defaults to false.
   */
  review_required?: boolean
  /**
   * Id of the acting tenant's user the ballot is assigned to, or null to leave it unassigned.
   */
  assigned_to_id?: string | null
}

/**
 * Read/write serializer for the current version of a rule.
 *
 * The tenant is taken from the acting-tenant header rather than the body, so it is not a field.
 */
export type DirectVotingRulesEngineRuleWritable = {
  /**
   * Identity id of the rules list the rule belongs to. Fixed once the rule is created.
   */
  rules_list_id: string
  /**
   * Free-text label that names the rule.
   */
  title: string
  /**
   * Which parameter model and processor the rule's engine applies to its params.
   *
   * * `custody_account_group_membership` - Custody Account Group Membership
   * * `conflict_of_interest` - Conflict Of Interest
   * * `do_not_vote` - Do Not Vote
   * * `custody_account_group_isin_watchlist` - Custody Account Group Isin Watchlist
   * * `custody_account_group_watchlist` - Custody Account Group Watchlist
   * * `policy_refer` - Policy Refer
   */
  rule_type: DirectVotingRuleTypeEnum
  /**
   * JSON object holding the rule's parameters. Its contents are interpreted by the engine that evaluates the rule, not here.
   */
  params?: unknown
}

/**
 * Read/write serializer for the current version of a rules list.
 *
 * The tenant is taken from the acting-tenant header rather than the body, so it is not a field.
 */
export type DirectVotingRulesEngineRulesListWritable = {
  /**
   * The rules engine that evaluates the list's rules. Fixed once the list is created.
   *
   * * `ballot_stamping` - Ballot Stamping
   * * `ballot_review` - Ballot Review
   */
  rules_engine: RulesEngineEnum
  /**
   * Free-text label that names the list within its engine.
   */
  title: string
}

/**
 * Read/write serializer for the current version of a watchlist.
 *
 * The tenant is taken from the acting-tenant header rather than the body, so it is not a field.
 */
export type DirectVotingWatchlistWritable = {
  /**
   * Free-text label that names the watchlist within its tenant.
   */
  title: string
  /**
   * Optional free-text account of what the watchlist tracks.
   */
  description?: string | null
}

/**
 * Read/write serializer for one version of an issuer's place on a watchlist.
 *
 * ``issuer_id`` is write-only; a response names the issuer under ``issuer``, so an instance must
 * come from ``watchlist_items``, which carries the annotations it reads.
 */
export type DirectVotingWatchlistItemWritable = {
  /**
   * Identity id of the watchlist the issuer is on.
   */
  watchlist_id: string
}

export type DirectVotingWatchlistItemBatchUpsertResponseWritable = {
  /**
   * The current item of each issuer on the watchlist, in the order the request named them.
   */
  items: Array<DirectVotingWatchlistItemWritable>
}

/**
 * Read/write serializer for one version of an issuer's place on a watchlist.
 *
 * ``issuer_id`` is write-only; a response names the issuer under ``issuer``, so an instance must
 * come from ``watchlist_items``, which carries the annotations it reads.
 */
export type DirectVotingWatchlistItemRequestWritable = {
  /**
   * Identity id of the watchlist the issuer is on.
   */
  watchlist_id: string
  /**
   * Identity id of the issuer to put on the watchlist.
   */
  issuer_id: string
}

export type FetchMinimalInstrumentsResponseWritable = {
  instruments: Array<MinimalInstrumentWritable>
}

export type FundWritable = {
  /**
   * The fund ID
   */
  id: string
  /**
   * The product that the fund exists in
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
  /**
   * The creation time of the fund
   */
  create_time: Date
  /**
   * The update time of the fund
   */
  update_time: Date
  /**
   * The title of the fund
   */
  title: string
  /**
   * The base currency of the fund. Currency is a letter code designator specified in ISO 4217, plus some additional non-ISO codes
   */
  base_currency: string | null
  /**
   * The external identifier for the fund
   */
  external_id: string | null
  /**
   * If true this signifies that the fund supports pass through voting to both institutional and retail investors. A fund must have this set in order for the vote engine to issue pass through voting entitlements for organizations owned through this fund.
   */
  institutional_pass_through_voting_enabled: boolean
  /**
   * If true this signifies that we should be receiving quantification and composition data daily for this fund and therefore it is deemed data ready.
   */
  data_ready: boolean
  /**
   * Custodian region is used to identify the public holidays for custodian accounts. It is a CAPITALISED 3-letter code as defined by ISO 3166-1 A-3.
   */
  custodian_region: string | null
}

export type FundManagerWritable = {
  id: string
  title: string
  product: ProductEnum
  website_url: string | null
  logo_url: string | null
  logo_thumbnail_url: string | null
  relationship_owner: string | null
  create_time: Date
  update_time: Date
}

export type FundManagerPolicySiiWritable = {
  fund_manager_name: string
  voting_policy_name: string
  public_security_id_name: string
  create_time: Date
  delete_time?: Date | null
  valid_from: Date
  valid_to?: Date | null
}

export type FundManagerPolicySiiResponseWritable = {
  items: Array<FundManagerPolicySiiWritable>
}

/**
 * Response serializer for batch upserting fund manager supported policies.
 */
export type FundManagerSupportedVotingPolicyBatchUpsertResponseWritable = {
  policies: Array<unknown>
}

export type FundQuantificationSnapshotWritable = {
  /**
   * The time at which the snapshot was valid.
   */
  valid_time: Date
  /**
   * The creation time of the snapshot.
   */
  create_time: Date
  /**
   * The product that the quantification snapshot is associated with.
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
}

/**
 * A fund variant is a wrapper for a fund, allowing a single fund to be represented with a
 * variety of differing titles and security IDs.
 */
export type FundVariantWritable = {
  /**
   * The fund variant ID
   */
  id: string
  /**
   * The product that the fund variant exists in
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
  /**
   * The title of the fund variant
   */
  title: string
  /**
   * The classification of financial instruments: an uppercase six-letter code describing the structure and function of the instrument.
   */
  cfi: string | null
  /**
   * The creation time of the fund variant
   */
  create_time: Date
  /**
   * The update time of the fund variant
   */
  update_time: Date
}

/**
 * Response shape for a GeneralMeeting.
 *
 * Takes the dict produced by services.build_general_meeting_view (or
 * build_general_meeting_views). The service layer is responsible for
 * assembling that dict from the GeneralMeeting row.
 */
export type GeneralMeetingWritable = {
  /**
   * The name of the organization that this general meeting is for, of the form 'organizations/{uuid}'.
   */
  organization_name: string
  /**
   * The type of the general meeting.
   *
   * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
   * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
   * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
   * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
   * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
   * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
   * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
   * * `GENERAL_MEETING_TYPE_INVALID` - GENERAL_MEETING_TYPE_INVALID
   */
  type: GeneralMeetingTypeEnum
  /**
   * The date of the general meeting.
   */
  meeting_date: Date
  /**
   * The time the general meeting became invalid.
   */
  invalid_time: Date | null
  /**
   * The time the general meeting was announced.
   */
  announcement_time: Date | null
  /**
   * The EDI event ID for the general meeting as presented in the EDI Worldwide Corporate Actions service.
   */
  edi_event_id: string | null
  /**
   * URL of the official general meeting announcement.
   */
  announcement_url: string | null
  /**
   * URL linking to a page containing the proxy notice of the general meeting.
   */
  proxy_notice_url: string | null
  /**
   * URL of the official results for the general meeting.
   */
  results_url: string | null
  /**
   * The record date for the general meeting: the date on which shareholders must have owned shares in order to be eligible to vote.
   */
  record_date: Date | null
  /**
   * The record date for the general meeting as reported by EDI.
   */
  edi_record_date: Date | null
  /**
   * Whether voting is enabled for this general meeting.
   */
  voting_enabled: boolean
  /**
   * Whether the EDI agenda pipelines are disabled for this general meeting.
   */
  disable_edi_agenda_pipeline_updates: boolean
  /**
   * The proxy submission deadlines for the general meeting.
   */
  proxy_submission: ProxySubmission | null
  /**
   * Index to distinguish duplicated general meetings for the same organization, meeting date and meeting type. Defaults to 0.
   */
  duplicate_index: number
}

export type HoldingWritable = {
  /**
   * ISIN (International Securities Identification Number). Must be 12-character alphanumeric code.
   */
  isin?: string | null
  /**
   * Number of shares held
   */
  settled_quantity: number
  /**
   * CUSIP (Committee on Uniform Securities Identification Procedures) number. A 9-character alphanumeric code that identifies North American financial securities.
   */
  cusip: string
  /**
   * When the holdings record is valid
   */
  valid_time: Date
  /**
   * Reference to the voter owning the holdings
   */
  voter_id: string
}

export type HoldingResponseWritable = {
  /**
   * List of holdings for the voter
   */
  holdings: Array<HoldingWritable>
}

export type IndustryWritable = {
  naics_2017: IndustryNaicsWritable
}

export type IndustryNaicsWritable = {
  code: string
}

export type InstrumentWritable = {
  /**
   * The ISIN of the instrument as defined by ISO 6166. Used as the identifier; it is part of the resource name and so cannot be updated.
   */
  isin: string
  /**
   * A string name representation of the fund. May be thought of as the Issuer Name concatenated with the Name of the instrument.
   */
  title: string
  /**
   * The 4-letter capital MiFIR identifier code describing the kind of financial instrument, which may be equity or non-equity. Values are: SHRS, ETFS, DPRS, CRFT, OTHE, SDRV, SFPS, BOND, ETCS, ETNS, EMAL, DERV.
   */
  mifir_identifier_code: string
  /**
   * Whether the instrument can be broken down.
   */
  is_composite: boolean
  /**
   * The Classification of Financial Instruments — an uppercase six-letter code describing the structure and function of the instrument.
   */
  cfi: string | null
}

export type InvestorPolicySiiWritable = {
  voting_policy_name: string
  public_security_id_name: string
  create_time: Date
  delete_time?: Date | null
  valid_from: Date
  valid_to?: Date | null
}

export type InvestorPolicySiiResponseWritable = {
  items: Array<InvestorPolicySiiWritable>
}

export type InvestorRulesEngineWritable = {
  investor_name: string
  rules_engine_name?: string | null
}

export type InvestorSiiResponseWritable = {
  items: Array<InvestorSupportedIssuedInstrumentWritable>
}

export type InvestorSupportedIssuedInstrumentWritable = {
  public_security_id_name: string
  create_time: Date
  delete_time?: Date | null
  valid_from: Date
  valid_to?: Date | null
}

export type MeetingWritable = {
  /**
   * Unique identifier for the general meeting
   */
  general_meeting_id: string
  /**
   * Date and time when the meeting is scheduled
   */
  meeting_date: Date
  /**
   * Identifier for the habitat this meeting belongs to
   */
  habitat_id: string
  /**
   * Unique identifier for the organization holding the meeting
   */
  organization_id: string
  /**
   * Display name of the organization
   */
  organization_display_title: string
  /**
   * URL to the organization's logo image
   */
  organization_logo_url?: string | null
  /**
   * NAICS industry classification title for the organization
   */
  organization_naics_title: string
  /**
   * Identifier for the meeting ballot
   */
  meeting_ballot_id: string
  /**
   * Deadline for voting/taking action on meeting proposals
   */
  action_deadline: Date
  /**
   * Identifier for the investment scheme
   */
  scheme_id: string
  /**
   * List of theme/classification codes for proposals in this meeting (e.g., CC, OE, PR)
   */
  proposal_classification_codes?: Array<string>
}

/**
 * A tenant's meeting on the assignment page; issuer fields are null when no ballot's ISIN resolves.
 */
export type MeetingAssignmentWritable = {
  /**
   * Identity id of the proxy intermediary meeting, stable across versions.
   */
  proxy_intermediary_meeting_id: string
  /**
   * The proxy intermediary's id for the meeting.
   */
  external_id: string
  /**
   * The issuer name as ingested from the proxy intermediary.
   */
  organization_title: string
  /**
   * ISIN of one of the tenant's ballots on the meeting; null when none holds an ISIN.
   */
  isin: string | null
  /**
   * Identity id of the issuer the ballots' ISIN resolves to.
   */
  issuer_id: string | null
  /**
   * Display name of the resolved issuer.
   */
  issuer_display_name: string | null
  /**
   * ISO 3166-1 alpha-2 country the resolved issuer is headquartered in.
   */
  hq_country: string | null
  /**
   * Two-digit TRBC economic sector code of the resolved issuer; null when unknown.
   */
  sector_code: string | null
  /**
   * Name of the resolved issuer's TRBC economic sector; null when unknown.
   */
  sector: string | null
  /**
   * The date and time the meeting is held.
   */
  meeting_date: Date
  /**
   * The date and time votes must be submitted to the proxy intermediary by.
   */
  meeting_deadline: Date
}

export type MeetingBallotWritable = {
  /**
   * The investor this ballot belongs to
   */
  investor: string
  /**
   * The habitat this meeting ballot belongs to
   */
  habitat: string
  /**
   * General meeting this ballot is associated with
   */
  general_meeting: string
  /**
   * Earliest voting deadline across all PI ballots linked to this meeting ballot
   */
  earliest_voting_deadline: Date
  /**
   * Latest voting deadline across all PI ballots linked to this meeting ballot
   */
  latest_voting_deadline: Date
  complete_time?: Date | null
}

export type MeetingBallotSourceWritable = {
  /**
   * The meeting ballot this source contributes to
   */
  meeting_ballot: string
  /**
   * The PI ballot whose entitlements contributed to the meeting ballot
   */
  proxy_intermediary_ballot: string
  /**
   * Investor SII context at the time the source was created
   */
  investor_supported_issued_instrument_id?: string | null
  /**
   * Investor policy SII context at the time the source was created
   */
  investor_policy_supported_issued_instrument_id?: string | null
  /**
   * Fund-manager policy SII context at the time the source was created
   */
  fund_manager_policy_supported_issued_instrument_id?: string | null
  /**
   * When this source was soft-invalidated; NULL for active sources
   */
  invalid_time?: Date | null
}

export type MinimalInstrumentWritable = {
  /**
   * The ISIN of the instrument as defined by ISO 6166. Used as the identifier; it is part of the resource name and so cannot be updated.
   */
  isin: string
  /**
   * A string name representation of the fund. May be thought of as the Issuer Name concatenated with the Name of the instrument.
   */
  title: string
  /**
   * The Classification of Financial Instruments — an uppercase six-letter code describing the structure and function of the instrument.
   */
  cfi: string | null
}

/**
 * Response shape for an Organization.
 *
 * Takes the dict produced by services.build_organization_view (or
 * build_organization_views). The view layer is responsible for assembling
 * that dict from the Organization row plus its joined sub-rows.
 */
export type OrganizationWritable = {
  legal_title: string
  display_title: string | null
  url: string | null
  logo_url: string | null
  logo_thumbnail_url: string | null
  trbc: string | null
  external_identifiers: Array<OrganizationIdentifier>
  bio: OrganizationBio | null
  issued_isins: Array<string>
  headquarters: OrganizationAddress | null
  industry: IndustryWritable | null
  country_of_incorporation_iso2: string | null
}

export type PaginatedAuditEventListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<unknown>
}

export type PaginatedBallotEntitlementListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<BallotEntitlementWritable>
}

export type PaginatedCustodyAccountGroupListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<CustodyAccountGroupWritable>
}

export type PaginatedCustodyAccountGroupMembershipListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<CustodyAccountGroupMembershipWritable>
}

export type PaginatedCustodyAccountListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<CustodyAccountWritable>
}

export type PaginatedCustodyAccountTenantLinkListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<CustodyAccountTenantLinkWritable>
}

export type PaginatedCustodyAccountVotingPolicySelectionListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<CustodyAccountVotingPolicySelectionWritable>
}

export type PaginatedDirectVotingBallotStampListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<unknown>
}

export type PaginatedDirectVotingBallotWorkflowItemListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<DirectVotingBallotWorkflowItemWritable>
}

export type PaginatedDirectVotingBeaconRuleOutputListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<unknown>
}

export type PaginatedDirectVotingRulesEngineRuleListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<DirectVotingRulesEngineRuleWritable>
}

export type PaginatedDirectVotingRulesEngineRulesListListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<DirectVotingRulesEngineRulesListWritable>
}

export type PaginatedDirectVotingWatchlistItemListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<DirectVotingWatchlistItemWritable>
}

export type PaginatedDirectVotingWatchlistListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<DirectVotingWatchlistWritable>
}

export type PaginatedFiscalYearListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<unknown>
}

export type PaginatedFundListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<FundWritable>
}

export type PaginatedFundManagerListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<FundManagerWritable>
}

export type PaginatedFundManagerPolicySiiListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<FundManagerPolicySiiWritable>
}

export type PaginatedFundQuantificationSnapshotListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<FundQuantificationSnapshotWritable>
}

export type PaginatedFundVariantListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<FundVariantWritable>
}

export type PaginatedGeneralMeetingListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<GeneralMeetingWritable>
}

export type PaginatedInstrumentListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<InstrumentWritable>
}

export type PaginatedInvestorPolicySiiListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<InvestorPolicySiiWritable>
}

export type PaginatedInvestorSupportedIssuedInstrumentListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<InvestorSupportedIssuedInstrumentWritable>
}

export type PaginatedIssuerInstrumentListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<unknown>
}

export type PaginatedIssuerListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<unknown>
}

export type PaginatedMeetingAssignmentListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<MeetingAssignmentWritable>
}

export type PaginatedMeetingBallotListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<MeetingBallotWritable>
}

export type PaginatedMeetingBallotSourceListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<MeetingBallotSourceWritable>
}

export type PaginatedMeetingListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<MeetingWritable>
}

export type PaginatedOrganizationListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<OrganizationWritable>
}

export type PaginatedPiBallotSearchListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<PiBallotSearchWritable>
}

export type PaginatedPiMeetingSearchListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<PiMeetingSearchWritable>
}

export type PaginatedProposalListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<ProposalWritable>
}

export type PaginatedProviderListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<ProviderWritable>
}

export type PaginatedProxyIntermediaryListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<ProxyIntermediaryWritable>
}

export type PaginatedProxyIntermediaryMeetingAuditEventListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<unknown>
}

export type PaginatedProxyIntermediaryMeetingListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<unknown>
}

export type PaginatedProxyIntermediaryProposalListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<ProxyIntermediaryProposalWritable>
}

export type PaginatedPublicSecurityIdListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<PublicSecurityIdWritable>
}

export type PaginatedRoleListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<RoleWritable>
}

export type PaginatedRulesEngineDefinitionListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<RulesEngineDefinitionWritable>
}

export type PaginatedRulesEngineRuleListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<RulesEngineRuleWritable>
}

export type PaginatedTenantBallotListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<TenantBallotWritable>
}

export type PaginatedVotingPolicyDocumentListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<VotingPolicyDocumentWritable>
}

export type PaginatedVotingPolicyListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<VotingPolicyWritable>
}

export type PaginatedVotingRecommendationListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<VotingRecommendationWritable>
}

/**
 * Serializer for PI ballot search results.
 */
export type PiBallotSearchWritable = {
  /**
   * Unique identifier for this specific version of the ballot
   */
  ballot_version_id: string
  /**
   * Total number of shares available for voting on this ballot
   */
  available_shares: number
  /**
   * Unique identity identifier for the ballot across all versions
   */
  ballot_identity_id: string
  /**
   * External system identifier for the ballot (e.g., from proxy intermediary platform)
   */
  ballot_external_id: string
  /**
   * Indicates if this is the most recent active version of the ballot
   */
  ballot_version_is_current: boolean
  /**
   * Total number of ballots associated with the same proxy intermediary meeting
   */
  ballots_per_meeting: number
  /**
   * Internal identifier for the custodian account holding the shares
   */
  custodian_account_id: string
  /**
   * Account number assigned by the custodian institution
   */
  custodian_account_number: string
  /**
   * Descriptive name or title of the custodian account
   */
  custodian_account_title: string
  /**
   * Indicates if the ballot aligns with the fund manager's voting policy
   */
  fund_manager_policy_supported: boolean
  /**
   * Name of the fund manager organization that manages the fund
   */
  fund_manager_title?: string | null
  /**
   * UUID of the fund manager record
   */
  fund_manager_id?: string | null
  /**
   * Name of the investment fund that owns the shares being voted
   */
  fund_title: string
  /**
   * Official name of the shareholder meeting (e.g., Annual General Meeting 2024)
   */
  general_meeting_name: string
  /**
   * Indicates if the ballot aligns with investor voting guidelines
   */
  investor_supported: boolean
  /**
   * Indicates if the ballot is supported by formal investor policy recommendations
   */
  investor_policy_supported: boolean
  /**
   * Name of the company or organization holding the shareholder meeting
   */
  organization_title: string
  /**
   * CUSIP, ISIN, or other public identifier for the security being voted on
   */
  owned_public_security_id: string
  /**
   * Display name of the proxy intermediary service provider
   */
  proxy_intermediary_title: string
  /**
   * Meeting identifier where this ballot is being voted on
   */
  proxy_intermediary_meeting_id: string
  /**
   * Identifier for the proxy intermediary managing this ballot
   */
  proxy_intermediary_id: string
  /**
   * Indicates if additional validation is needed for split voting scenarios
   */
  split_vote_check_required: boolean
  /**
   * Cutoff date and time for submitting votes on this ballot
   */
  vote_deadline: Date
  /**
   * Current state in the voting workflow (e.g. pending, submitted, checked)
   */
  workflow_status: string
  /**
   * Username of the person who submitted the vote for processing
   */
  workflow_submitter: string
  /**
   * Username of the person who reviewed and approved the vote submission
   */
  workflow_checker: string
  /**
   * UUID of the fund record, used to construct the fund resource name
   */
  fund_id?: string | null
}

/**
 * Serializer for PI meeting search results.
 */
export type PiMeetingSearchWritable = {
  /**
   * Unique identifier for this specific version of the meeting
   */
  meeting_version_id: string
  /**
   * Unique identity identifier for the meeting across all versions
   */
  meeting_identity_id: string
  /**
   * Indicates if this is the most recent active version of the meeting
   */
  meeting_version_is_current: boolean
  /**
   * Meeting identifier within the proxy intermediary system
   */
  proxy_intermediary_meeting_id: string
  /**
   * Identifier for the proxy intermediary managing this meeting
   */
  proxy_intermediary_id: string
  /**
   * External system identifier for the meeting (e.g., from proxy intermediary platform)
   */
  meeting_external_id: string
  /**
   * Name of the company or organization holding the shareholder meeting
   */
  organization_title: string
  /**
   * Official name of the shareholder meeting (e.g., Annual General Meeting 2024)
   */
  transparency_general_meeting_name: string
  /**
   * Type of meeting (e.g., Annual General Meeting, Extraordinary General Meeting)
   */
  meeting_type: string
  /**
   * Date and time when the meeting is scheduled to occur
   */
  meeting_time: Date
  /**
   * Cutoff date and time for submitting votes for this meeting
   */
  submission_deadline: Date
  /**
   * Record date for determining shareholder eligibility
   */
  record_date?: Date | null
  /**
   * Indicates if the meeting contains contested proposals
   */
  is_contested: boolean
  /**
   * Indicates if split voting is supported for this meeting
   */
  is_split_voting_supported?: boolean | null
  /**
   * Additional comments or notes about the meeting
   */
  meeting_comment?: string | null
  /**
   * Reason why the meeting might not be supported
   */
  unsupported_reason?: string | null
  /**
   * Date and time when the meeting was cancelled, if applicable
   */
  cancel_time?: Date | null
  /**
   * Array of security identifiers associated with this meeting
   */
  security_ids?: Array<string> | null
  /**
   * Identifier for the voting operations workflow
   */
  workflow_id?: string | null
  /**
   * Current state in the voting workflow (e.g. new, ready_for_refinement, successful)
   */
  workflow_status?: string | null
  /**
   * Username of the person assigned to refine the meeting data
   */
  workflow_refiner?: string | null
  /**
   * Username of the person assigned to check the meeting data
   */
  workflow_checker?: string | null
  /**
   * Display name of the proxy intermediary service provider
   */
  proxy_intermediary_title?: string | null
  /**
   * Indicates if any of the meeting's securities are supported by investor policies
   */
  investor_supported?: boolean
  /**
   * Indicates if any of the meeting's securities are supported by investor policy guidelines
   */
  investor_policy_supported?: boolean
  /**
   * Indicates if any of the meeting's securities are supported by fund manager policies
   */
  fund_manager_policy_supported?: boolean
  /**
   * Number of ballots associated with this meeting
   */
  ballot_count: number
  /**
   * Indicates if the meeting has associated ballots available for voting
   */
  has_ballots: boolean
  /**
   * Date and time when the meeting was first created in the proxy intermediary system
   */
  meeting_create_time: Date
  /**
   * Latest valid_to date across all SIIs for this meeting's securities, or NULL if any SII has no expiry
   */
  latest_valid_to_sii?: Date | null
  /**
   * the earliest submission deadline for ballots on the meetingnull if no ballots with submission deadlines present
   */
  earliest_ballot_submission_deadline?: Date | null
}

/**
 * Serializer for a policy.
 */
export type PolicyWritable = {
  /**
   * Title of the voting policy
   */
  title: string
  /**
   * Title of the voting policy provider
   */
  provider_title: string
  /**
   * Description of the voting policy in formatted text
   */
  formatted_description?: string | null
  /**
   * Key referencing the document associated with the voting policy
   */
  document_key?: string | null
  /**
   * Indicates if the selected policy is currently available on direct outreach
   */
  is_available?: boolean | null
}

/**
 * Serializer for policy response.
 */
export type PolicyResponseWritable = {
  /**
   * Identifier to be shared externally with integrated parties
   */
  external_id: string
  /**
   * Title of the voting policy
   */
  title: string
  /**
   * Title of the voting policy provider
   */
  provider_title: string
  /**
   * Description of the voting policy in formatted text
   */
  formatted_description?: string | null
  /**
   * Key referencing the document associated with the voting policy
   */
  document_key?: string | null
  /**
   * Indicates if the selected policy is currently available on direct outreach
   */
  is_available?: boolean | null
}

/**
 * Response shape for a Proposal (current version).
 */
export type ProposalWritable = {
  /**
   * The alphanumeric sequence identifier for the proposal within the meeting.
   */
  sequence_identifier: string
  /**
   * The human-readable title of the proposal.
   */
  title: string
  /**
   * Optional long-form description of the proposal.
   */
  description?: string | null
  /**
   * The management voting recommendation.
   */
  management_recommendation?: ProposalManagementRecommendation | null
  /**
   * Who proposed this: a PROPOSAL_SOURCE_* enum name.
   *
   * * `PROPOSAL_SOURCE_MANAGEMENT` - PROPOSAL_SOURCE_MANAGEMENT
   * * `PROPOSAL_SOURCE_SHAREHOLDER` - PROPOSAL_SOURCE_SHAREHOLDER
   */
  source: SourceEnum
  /**
   * The fraction of votes required for the proposal to pass.
   */
  pass_threshold?: ProposalPassThreshold | null
  /**
   * The voting outcome for this proposal.
   */
  outcome?: ProposalOutcomeWritable | null
  /**
   * The EDI numeric identifier for this proposal.
   */
  edi_proposal_identifier?: number | null
  /**
   * The resource name of the parent proposal, if this is a sub-proposal.
   */
  parent_proposal_name?: string | null
  /**
   * The EDI sequence number for this proposal.
   */
  edi_sequence_number?: number | null
  /**
   * Whether shareholders can cast votes on this proposal.
   */
  votable: boolean
  /**
   * Full text of the proposal as supplied by EDI.
   */
  full_text?: string | null
  /**
   * Classification codes linked to this proposal.
   */
  classification_codes: Array<string>
  /**
   * The set of valid voting options for this proposal.
   */
  voting_options: Array<VotingOptionsEnum>
  /**
   * The time the proposal was withdrawn. Null if not withdrawn.
   */
  withdraw_time?: Date | null
  /**
   * SEC category codes linked to this proposal.
   */
  sec_classification_codes: Array<string>
}

export type ProposalOutcomeWritable = {
  /**
   * The outcome decision.
   *
   * * `PROPOSAL_OUTCOME_DECISION_FOR` - PROPOSAL_OUTCOME_DECISION_FOR
   * * `PROPOSAL_OUTCOME_DECISION_AGAINST` - PROPOSAL_OUTCOME_DECISION_AGAINST
   * * `PROPOSAL_OUTCOME_DECISION_WITHDRAWN` - PROPOSAL_OUTCOME_DECISION_WITHDRAWN
   * * `PROPOSAL_OUTCOME_DECISION_ONE_YEAR` - PROPOSAL_OUTCOME_DECISION_ONE_YEAR
   * * `PROPOSAL_OUTCOME_DECISION_TWO_YEARS` - PROPOSAL_OUTCOME_DECISION_TWO_YEARS
   * * `PROPOSAL_OUTCOME_DECISION_THREE_YEARS` - PROPOSAL_OUTCOME_DECISION_THREE_YEARS
   */
  decision: DecisionEnum
  /**
   * Detailed vote counts.
   */
  votes?: ProposalVotes | null
  /**
   * The reason the proposal was withdrawn, if applicable.
   */
  withdrawal_reason?: string | null
}

/**
 * Recommendation coverage detail for one proposal set under one voting policy.
 */
export type ProposalSetRecommendationCoverageDetailWritable = {
  /**
   * The proposal set this detail is for.
   */
  proposal_set_id: string
  /**
   * The voting policy this detail is under.
   */
  voting_policy_id: string
  /**
   * Every proposal in the set, with its recommendation when one exists.
   */
  proposals: Array<ProposalSetRecommendationCoverageProposalWritable>
  /**
   * Provider voting recommendations in the latest batch for this meeting and policy that no current proxy intermediary voting recommendation references.
   */
  unmatched_provider_voting_recommendations: Array<ProviderVotingRecommendation>
  /**
   * Identifier of the PVR batch group for this meeting and policy; null when no batch was found.
   */
  unique_meeting_policy_id: string | null
  /**
   * Latest batch version for the meeting and policy; null when no batch was found.
   */
  meeting_batch_version: number | null
}

/**
 * A proposal in the set with its current recommendation, validation status, and provider recommendation.
 */
export type ProposalSetRecommendationCoverageProposalWritable = {
  /**
   * The proxy intermediary proposal.
   */
  proposal: ProxyIntermediaryProposalWritable
  /**
   * The current recommendation for this proposal under the requested policy; null when unmatched.
   */
  proxy_intermediary_voting_recommendation: ProxyIntermediaryVotingRecommendation | null
  /**
   * The provider voting recommendation the recommendation links to; null for manual recommendations.
   */
  provider_voting_recommendation: ProviderVotingRecommendation | null
  /**
   * Current validation status of the recommendation; null when unmatched or not yet recorded.
   *
   * * `checked` - Checked
   * * `unchecked` - Unchecked
   */
  validation_status: ValidationStatusEnum | null
}

export type ProviderWritable = {
  /**
   * The provider ID
   */
  id: string
  /**
   * The title of this provider
   */
  title: string
  /**
   * Generated at the time of provider creation
   */
  create_time: Date
  /**
   * Set to the latest update time
   */
  update_time: Date
}

export type ProxyIntermediaryWritable = {
  /**
   * What the proxy intermediary is called, e.g. "ProxyEdge" or "Proxymity".
   */
  title: string
}

export type ProxyIntermediaryMeetingBatchCancelResponseWritable = {
  /**
   * The cancelled meetings.
   */
  proxy_intermediary_meetings: Array<unknown>
}

export type ProxyIntermediaryMeetingResponseWritable = {
  /**
   * The meeting.
   */
  proxy_intermediary_meeting: unknown
}

export type ProxyIntermediaryMeetingUpsertResponseWritable = {
  /**
   * The created or updated meeting.
   */
  proxy_intermediary_meeting: unknown
  /**
   * Indicates whether the meeting was created, updated, or left unchanged.
   *
   * * `STATUS_MEETING_INVALID` - STATUS_MEETING_INVALID
   * * `STATUS_MEETING_CREATED` - STATUS_MEETING_CREATED
   * * `STATUS_MEETING_UPDATED` - STATUS_MEETING_UPDATED
   * * `STATUS_MEETING_NO_OPERATION` - STATUS_MEETING_NO_OPERATION
   */
  status: ProxyIntermediaryMeetingUpsertResponseStatusEnum
}

export type ProxyIntermediaryProposalWritable = {
  /**
   * The set of valid voting options for this proposal.
   */
  voting_options: Array<ProxyIntermediaryVotingOptionsEnum>
  /**
   * The time the proposal was created.
   */
  create_time: Date
  /**
   * The SHA256 hash of the Proposals in the set. Fields hashed: proxy_intermediary_meeting_id,broadridge_agenda_id, label, text, voting_options, source, management_recommendation,sequence_number, is_opposition, director_number, vote_group, vote_group_max_for, vote_group_max,category_code, withdrawn
   */
  proposal_set_id: string
  /**
   * The id of the agenda these proposals were sourced from in Broadridge's system.
   */
  broadridge_agenda_id?: string | null
  /**
   * The alphanumeric label for the proposal within the meeting. eg (1a, A, 1)
   */
  label: string
  /**
   * The human-readable text of the proposal.
   */
  text: string
  /**
   * Who proposed this: 'management' or 'shareholder'.
   *
   * * `management` - Management
   * * `shareholder` - Shareholder
   */
  source: ProxyIntermediaryProposalSourceEnum
  /**
   * The management voting recommendation (e.g. 'for', 'against').
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `no_action` - No Action
   * * `do_not_vote` - Do Not Vote
   */
  management_recommendation?: ProxyIntermediaryVotingOptionsEnum | null
  /**
   * The ordering sequence for the proposals from the proxy intermediary
   */
  sequence_number?: number | null
  /**
   * Whether the proposal was put to the meeting by an opposing party rather than by the issuer.
   */
  is_opposition?: boolean
  /**
   * The position of the director within a slate election, as reported by the proxy intermediary.
   */
  director_number?: number | null
  /**
   * The identifier of the group of proposals this proposal is voted within. Proposals sharing a group share a limit on how many of them may be voted.
   */
  vote_group?: number | null
  /**
   * The maximum number of proposals in the vote group that may be voted 'for'.
   */
  vote_group_max_for?: number | null
  /**
   * The maximum number of proposals in the vote group that may be voted, whatever the voting option.
   */
  vote_group_max?: number | null
  /**
   * The category code of the proposal.
   */
  category_code?: string | null
  /**
   * Whether the proxy intermediary reported the proposal as withdrawn from the meeting's agenda.
   */
  withdrawn?: boolean
  /**
   * The proxy intermediary meeting this proposal belongs to.
   */
  proxy_intermediary_meeting_id: string
}

export type PublicSecurityIdWritable = {
  create_time: Date
}

export type RoleWritable = {
  /**
   * Free-text label that names the role within its tenant.
   */
  name: string
  /**
   * Free-text explanation of who the role is for.
   */
  description?: string
}

/**
 * Read serializer for RulesEngineDefinition.
 */
export type RulesEngineDefinitionWritable = {
  name: string
  valid_from: Date
}

/**
 * Read serializer for RulesEngineRule.
 */
export type RulesEngineRuleWritable = {
  rule_type: RuleTypeEnum
  order: number
  parameters: unknown
}

export type SelectedPolicyWritable = {
  /**
   * Reference to the voter selecting the policy
   */
  voter_id: string
  /**
   * Reference to the selected policy
   */
  policy_id: string
}

/**
 * Serializer for the selected policy response wrapper.
 */
export type SelectedPolicyResponseWritable = {
  /**
   * The voter's selected policy, or null if none selected
   */
  selectedPolicy: SelectedPolicyWritable | null
}

export type SplitVoteInstructionProposalOverwriteWritable = {
  /**
   * Internal reason for the overwrite, not reportable
   */
  internal_reason?: string | null
  /**
   * Author of the overwrite
   */
  author: string
  /**
   * Investor votes FOR
   */
  investor_votes_for: number
  /**
   * Investor votes AGAINST
   */
  investor_votes_against: number
  /**
   * Investor votes ABSTAIN
   */
  investor_votes_abstain: number
  /**
   * Investor votes WITHHOLD
   */
  investor_votes_withhold: number
  /**
   * Investor votes NO VOTE
   */
  investor_votes_no_vote: number
  /**
   * Investor votes ONE YEAR
   */
  investor_votes_one_year: number
  /**
   * Investor votes TWO YEARS
   */
  investor_votes_two_years: number
  /**
   * Investor votes THREE YEARS
   */
  investor_votes_three_years: number
  /**
   * Split votes FOR
   */
  split_votes_for: number
  /**
   * Split votes AGAINST
   */
  split_votes_against: number
  /**
   * Split votes ABSTAIN
   */
  split_votes_abstain: number
  /**
   * Split votes WITHHOLD
   */
  split_votes_withhold: number
  /**
   * Split votes NO VOTE
   */
  split_votes_no_vote: number
  /**
   * Split votes ONE YEAR
   */
  split_votes_one_year: number
  /**
   * Split votes TWO YEARS
   */
  split_votes_two_years: number
  /**
   * Split votes THREE YEARS
   */
  split_votes_three_years: number
  /**
   * Percentage of split votes FOR
   */
  split_votes_percentage_for: number
  /**
   * Percentage of split votes AGAINST
   */
  split_votes_percentage_against: number
  /**
   * Percentage of split votes ABSTAIN
   */
  split_votes_percentage_abstain: number
  /**
   * Percentage of split votes WITHHOLD
   */
  split_votes_percentage_withhold: number
  /**
   * Percentage of split votes NO VOTE
   */
  split_votes_percentage_no_vote: number
  /**
   * Percentage of split votes ONE YEAR
   */
  split_votes_percentage_one_year: number
  /**
   * Percentage of split votes TWO YEARS
   */
  split_votes_percentage_two_years: number
  /**
   * Percentage of split votes THREE YEARS
   */
  split_votes_percentage_three_years: number
  /**
   * Reference to the SVI Proposal being overwritten
   */
  split_vote_instruction_proposal_id: string
  /**
   * Reportable reason for overwriting the SVI Proposal
   */
  reportable_reason: ReportableReasonEnum
}

export type TenantBallotWritable = {
  /**
   * Identity id of the ballot, stable across versions.
   */
  ballot_id: string
  /**
   * Identity id of the proxy intermediary meeting this ballot is for.
   */
  proxy_intermediary_meeting_id: string
  /**
   * Account number identifying the asset owner's account (e.g. a fund) at the custodian holding it, as reported by a proxy intermediary. Unique only in combination with the custodian within a single proxy intermediary, not across them.
   */
  custodian_account_number: string
  /**
   * Number of shares eligible for voting, excluding shares on loan or otherwise ineligible.
   */
  available_shares: bigint
  /**
   * Public security ID of the security that gives rise to this ballot, in the form 'securityIDTypes/{type}/securityIDs/{value}'.
   */
  owned_public_security_id: string
  /**
   * The date and time votes are to be submitted to the proxy intermediary by for this ballot.
   */
  vote_deadline: Date
}

export type TotalShareholderReturnListWritable = {
  results: Array<unknown>
}

export type UnassociatedInstrumentsResponseWritable = {
  instruments: Array<InstrumentWritable>
}

/**
 * Serializer for voter response without holdings.
 */
export type VoterResponseWritable = {
  /**
   * Mediants unique identifier for the voter
   */
  mediant_id: string
  /**
   * Broker associated with the voter
   */
  broker_id: string
  /**
   * Type of voter
   *
   * * `retail` - Retail
   * * `institutional` - Institutional
   */
  type: VoterTypeEnum
  /**
   * Authorization token for the voter
   */
  token: string
}

/**
 * Serializer for voter response with holdings.
 */
export type VoterWithHoldingsResponseWritable = {
  /**
   * Mediants unique identifier for the voter
   */
  mediant_id: string
  /**
   * Broker associated with the voter
   */
  broker_id: string
  /**
   * Type of voter
   *
   * * `retail` - Retail
   * * `institutional` - Institutional
   */
  type: VoterTypeEnum
  /**
   * Authorization token for the voter
   */
  token: string
}

/**
 * Read serializer for a VotingPolicy.
 *
 * `current_policy_document` is the latest VotingPolicyDocument for the policy by
 * issue_time descending, or null if the policy has no documents. The signed_url on
 * the document is generated at request time and is valid for 24 hours.
 */
export type VotingPolicyWritable = {
  /**
   * The voting policy title.
   */
  title: string
  /**
   * Optional abbreviated title for the voting policy.
   */
  title_abbreviation: string | null
  /**
   * Title of the policy provider.
   */
  policy_provider: string
  /**
   * The description of the voting policy.
   */
  formatted_description: string
  /**
   * Optional external identifier used to link to upstream policy systems.
   */
  external_id: string | null
  /**
   * Time the voting policy was created.
   */
  create_time: Date
  /**
   * Time the voting policy was last updated.
   */
  update_time: Date
  /**
   * Optional Cloudinary URL for the voting policy image.
   */
  image_url: string | null
}

/**
 * Serializer for VotingPolicyDocument.
 * The signed_url is generated at request time from the stored document_key; it is
 * valid for 24 hours and is not persisted.
 */
export type VotingPolicyDocumentWritable = {
  /**
   * Timestamp when the document record was created.
   */
  create_time: Date
  /**
   * Timestamp when the document record was last updated.
   */
  update_time: Date
  /**
   * The document's official publication time.
   */
  issue_time: Date
  /**
   * The document title.
   */
  title: string
}

/**
 * Read serializer for a VotingRecommendationVersion.
 *
 * The resource name uses the version ID:
 * votingPolicies/{voting_policy_id}/votingRecommendations/{version_id}
 */
export type VotingRecommendationWritable = {
  /**
   * The proposal this recommendation applies to, in the form organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}.
   */
  proposal_name: string
  /**
   * The voting instruction: for, against, abstain, withhold, no_action, one_year, two_years, three_years, or do_not_vote.
   */
  voting_instruction: string
  /**
   * Optional rationale supporting the voting instruction. Maximum 5000 characters.
   */
  rationale: string | null
  /**
   * Optional proposal text provided by the recommendation provider. Maximum 5000 characters.
   */
  proposal_text: string | null
  /**
   * Optional proposal label provided by the recommendation provider. Maximum 20 characters.
   */
  proposal_label: string | null
  /**
   * Optional sequence number for the proposal provided by the recommendation provider.
   */
  proposal_sequence_number: number | null
  /**
   * The provider recommendation that led to the creation of this voting recommendation, if any.
   */
  provider_voting_recommendation_id: string | null
  /**
   * Time this recommendation version was created.
   */
  create_time: Date
  /**
   * Time this recommendation version was last updated.
   */
  update_time: Date
}

export type ApiSchemaRetrieveData = {
  body?: never
  path?: never
  query?: {
    format?: 'json' | 'yaml'
    lang?:
      | 'af'
      | 'ar'
      | 'ar-dz'
      | 'ast'
      | 'az'
      | 'be'
      | 'bg'
      | 'bn'
      | 'br'
      | 'bs'
      | 'ca'
      | 'ckb'
      | 'cs'
      | 'cy'
      | 'da'
      | 'de'
      | 'dsb'
      | 'el'
      | 'en'
      | 'en-au'
      | 'en-gb'
      | 'eo'
      | 'es'
      | 'es-ar'
      | 'es-co'
      | 'es-mx'
      | 'es-ni'
      | 'es-ve'
      | 'et'
      | 'eu'
      | 'fa'
      | 'fi'
      | 'fr'
      | 'fy'
      | 'ga'
      | 'gd'
      | 'gl'
      | 'he'
      | 'hi'
      | 'hr'
      | 'hsb'
      | 'hu'
      | 'hy'
      | 'ia'
      | 'id'
      | 'ig'
      | 'io'
      | 'is'
      | 'it'
      | 'ja'
      | 'ka'
      | 'kab'
      | 'kk'
      | 'km'
      | 'kn'
      | 'ko'
      | 'ky'
      | 'lb'
      | 'lt'
      | 'lv'
      | 'mk'
      | 'ml'
      | 'mn'
      | 'mr'
      | 'ms'
      | 'my'
      | 'nb'
      | 'ne'
      | 'nl'
      | 'nn'
      | 'os'
      | 'pa'
      | 'pl'
      | 'pt'
      | 'pt-br'
      | 'ro'
      | 'ru'
      | 'sk'
      | 'sl'
      | 'sq'
      | 'sr'
      | 'sr-latn'
      | 'sv'
      | 'sw'
      | 'ta'
      | 'te'
      | 'tg'
      | 'th'
      | 'tk'
      | 'tr'
      | 'tt'
      | 'udm'
      | 'ug'
      | 'uk'
      | 'ur'
      | 'uz'
      | 'vi'
      | 'zh-hans'
      | 'zh-hant'
  }
  url: '/api/schema/'
}

export type ApiSchemaRetrieveResponses = {
  200: {
    [key: string]: unknown
  }
}

export type ApiSchemaRetrieveResponse = ApiSchemaRetrieveResponses[keyof ApiSchemaRetrieveResponses]

export type BackgroundTasksTasksRetrieveData = {
  body?: never
  path: {
    task_id: number
  }
  query?: never
  url: '/background-tasks/tasks/{task_id}/'
}

export type BackgroundTasksTasksRetrieveErrors = {
  /**
   * No response body
   */
  404: unknown
}

export type BackgroundTasksTasksRetrieveResponses = {
  200: TaskStatus
}

export type BackgroundTasksTasksRetrieveResponse =
  BackgroundTasksTasksRetrieveResponses[keyof BackgroundTasksTasksRetrieveResponses]

export type DirectoutreachBetanxtVoterPolicySnapshotExportCreateData = {
  body?: never
  path?: never
  query: {
    /**
     * ISO 8601 datetime with timezone for which to export holdings. Must include timezone (e.g., '2024-01-15T10:30:00Z' or '2024-01-15T10:30:00+00:00'). When multiple holdings exist for the same date, selects the most recent by create_time.
     */
    valid_time: string
  }
  url: '/directoutreach/betanxt/voter-policy-snapshot:export/'
}

export type DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses = {
  200: ExportResult
}

export type DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponse =
  DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses[keyof DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses]

export type DirectoutreachPolicyCreateData = {
  body: PolicyRequest
  path?: never
  query?: never
  url: '/directoutreach/policy/'
}

export type DirectoutreachPolicyCreateResponses = {
  201: Policy
}

export type DirectoutreachPolicyCreateResponse =
  DirectoutreachPolicyCreateResponses[keyof DirectoutreachPolicyCreateResponses]

export type DirectoutreachPolicyAvailableListData = {
  body?: never
  path?: never
  query?: never
  url: '/directoutreach/policy/available/'
}

export type DirectoutreachPolicyAvailableListResponses = {
  200: Array<PolicyResponse>
}

export type DirectoutreachPolicyAvailableListResponse =
  DirectoutreachPolicyAvailableListResponses[keyof DirectoutreachPolicyAvailableListResponses]

export type DirectoutreachPolicyAvailableRetrieveData = {
  body?: never
  path: {
    /**
     * Unique identifier for the policy
     */
    id: string
  }
  query?: never
  url: '/directoutreach/policy/available/{id}/'
}

export type DirectoutreachPolicyAvailableRetrieveResponses = {
  200: PolicyResponse
}

export type DirectoutreachPolicyAvailableRetrieveResponse =
  DirectoutreachPolicyAvailableRetrieveResponses[keyof DirectoutreachPolicyAvailableRetrieveResponses]

export type DirectoutreachVotersRetrieveData = {
  body?: never
  path: {
    /**
     * Unique identifier for a voter
     */
    id: string
  }
  query?: never
  url: '/directoutreach/voters/{id}/'
}

export type DirectoutreachVotersRetrieveErrors = {
  /**
   * No response body
   */
  404: unknown
}

export type DirectoutreachVotersRetrieveResponses = {
  200: VoterDetailsResponse
}

export type DirectoutreachVotersRetrieveResponse =
  DirectoutreachVotersRetrieveResponses[keyof DirectoutreachVotersRetrieveResponses]

export type DirectoutreachVotersHoldingsRetrieveData = {
  body?: never
  path: {
    /**
     * Unique identifier for a voter
     */
    id: string
  }
  query?: never
  url: '/directoutreach/voters/{id}/holdings/'
}

export type DirectoutreachVotersHoldingsRetrieveErrors = {
  /**
   * No response body
   */
  404: unknown
}

export type DirectoutreachVotersHoldingsRetrieveResponses = {
  200: HoldingResponse
}

export type DirectoutreachVotersHoldingsRetrieveResponse =
  DirectoutreachVotersHoldingsRetrieveResponses[keyof DirectoutreachVotersHoldingsRetrieveResponses]

export type DirectoutreachVotersSelectedPolicyRetrieveData = {
  body?: never
  path: {
    /**
     * Unique identifier for a voter
     */
    id: string
  }
  query?: never
  url: '/directoutreach/voters/{id}/selected-policy/'
}

export type DirectoutreachVotersSelectedPolicyRetrieveErrors = {
  /**
   * No response body
   */
  404: unknown
}

export type DirectoutreachVotersSelectedPolicyRetrieveResponses = {
  200: SelectedPolicyResponse
}

export type DirectoutreachVotersSelectedPolicyRetrieveResponse =
  DirectoutreachVotersSelectedPolicyRetrieveResponses[keyof DirectoutreachVotersSelectedPolicyRetrieveResponses]

export type DirectoutreachVotersSelectedPolicyCreateData = {
  body: SelectedPolicyRequestRequest
  path: {
    /**
     * Unique identifier for a voter
     */
    id: string
  }
  query?: never
  url: '/directoutreach/voters/{id}/selected-policy/'
}

export type DirectoutreachVotersSelectedPolicyCreateErrors = {
  /**
   * No response body
   */
  400: unknown
  /**
   * No response body
   */
  404: unknown
}

export type DirectoutreachVotersSelectedPolicyCreateResponses = {
  201: SelectedPolicyResponse
}

export type DirectoutreachVotersSelectedPolicyCreateResponse =
  DirectoutreachVotersSelectedPolicyCreateResponses[keyof DirectoutreachVotersSelectedPolicyCreateResponses]

export type DirectoutreachVotersBatchCreateCreateData = {
  body: BatchVoterWithHoldingsInputRequest
  path?: never
  query?: never
  url: '/directoutreach/voters:batch-create/'
}

export type DirectoutreachVotersBatchCreateCreateErrors = {
  /**
   * Validation error - no voters created
   */
  400: unknown
  /**
   * Server error - no voters created
   */
  500: unknown
}

export type DirectoutreachVotersBatchCreateCreateResponses = {
  200: BatchVoterWithHoldingsResponse
  201: BatchVoterWithHoldingsResponse
}

export type DirectoutreachVotersBatchCreateCreateResponse =
  DirectoutreachVotersBatchCreateCreateResponses[keyof DirectoutreachVotersBatchCreateCreateResponses]

export type DirectoutreachVotersCreateCreateData = {
  body: VoterWithHoldingsInputRequest
  path?: never
  query?: never
  url: '/directoutreach/voters:create/'
}

export type DirectoutreachVotersCreateCreateResponses = {
  200: VoterWithHoldingsResponse
  201: VoterWithHoldingsResponse
}

export type DirectoutreachVotersCreateCreateResponse =
  DirectoutreachVotersCreateCreateResponses[keyof DirectoutreachVotersCreateCreateResponses]

export type DirectvotingBallotStampsRetrieveData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/ballot-stamps/{identity_id}/'
}

export type DirectvotingBallotStampsRetrieveErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Ballot stamp not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingBallotStampsRetrieveResponses = {
  200: DirectVotingBallotStamp
}

export type DirectvotingBallotStampsRetrieveResponse =
  DirectvotingBallotStampsRetrieveResponses[keyof DirectvotingBallotStampsRetrieveResponses]

export type DirectvotingBallotStampsSearchCreateData = {
  body?: BallotStampSearchRequestRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/directvoting/ballot-stamps/search/'
}

export type DirectvotingBallotStampsSearchCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type DirectvotingBallotStampsSearchCreateResponses = {
  200: PaginatedDirectVotingBallotStampList
}

export type DirectvotingBallotStampsSearchCreateResponse =
  DirectvotingBallotStampsSearchCreateResponses[keyof DirectvotingBallotStampsSearchCreateResponses]

export type DirectvotingBallotWorkflowItemsCreateData = {
  body: DirectVotingBallotWorkflowItemRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
    /**
     * The calling service's user, by their subject at their identity source. Beacon must name a user of the acting tenant.
     */
    'X-Acting-User'?: string
  }
  path?: never
  query?: never
  url: '/directvoting/ballot-workflow-items/'
}

export type DirectvotingBallotWorkflowItemsCreateErrors = {
  /**
   * Request body failed validation, the X-Acting-Tenant header is missing or is not a valid UUID, or the request assigns the ballot without an X-Acting-User header.
   */
  400: unknown
  /**
   * Caller is either not authenticated, lacks a required role, sent an acting tenant that is not available to them, or is Beacon naming a user not in the acting tenant. The response does not distinguish these.
   */
  403: unknown
  /**
   * The acting tenant already has a live workflow item for this ballot and custody account group.
   */
  409: unknown
}

export type DirectvotingBallotWorkflowItemsCreateResponses = {
  201: DirectVotingBallotWorkflowItem
}

export type DirectvotingBallotWorkflowItemsCreateResponse =
  DirectvotingBallotWorkflowItemsCreateResponses[keyof DirectvotingBallotWorkflowItemsCreateResponses]

export type DirectvotingBallotWorkflowItemsDestroyData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
    /**
     * The calling service's user, by their subject at their identity source. Beacon must name a user of the acting tenant.
     */
    'X-Acting-User'?: string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/ballot-workflow-items/{identity_id}/'
}

export type DirectvotingBallotWorkflowItemsDestroyErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is either not authenticated, lacks a required role, sent an acting tenant that is not available to them, or is Beacon naming a user not in the acting tenant. The response does not distinguish these.
   */
  403: unknown
  /**
   * Ballot workflow item not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingBallotWorkflowItemsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type DirectvotingBallotWorkflowItemsDestroyResponse =
  DirectvotingBallotWorkflowItemsDestroyResponses[keyof DirectvotingBallotWorkflowItemsDestroyResponses]

export type DirectvotingBallotWorkflowItemsRetrieveData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/ballot-workflow-items/{identity_id}/'
}

export type DirectvotingBallotWorkflowItemsRetrieveErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Ballot workflow item not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingBallotWorkflowItemsRetrieveResponses = {
  200: DirectVotingBallotWorkflowItem
}

export type DirectvotingBallotWorkflowItemsRetrieveResponse =
  DirectvotingBallotWorkflowItemsRetrieveResponses[keyof DirectvotingBallotWorkflowItemsRetrieveResponses]

export type DirectvotingBallotWorkflowItemsPartialUpdateData = {
  body?: PatchedDirectVotingBallotWorkflowItemRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
    /**
     * The calling service's user, by their subject at their identity source. Beacon must name a user of the acting tenant.
     */
    'X-Acting-User'?: string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/ballot-workflow-items/{identity_id}/'
}

export type DirectvotingBallotWorkflowItemsPartialUpdateErrors = {
  /**
   * Request body failed validation, the X-Acting-Tenant header is missing or is not a valid UUID, or the request assigns the ballot without an X-Acting-User header.
   */
  400: unknown
  /**
   * Caller is either not authenticated, lacks a required role, sent an acting tenant that is not available to them, or is Beacon naming a user not in the acting tenant. The response does not distinguish these.
   */
  403: unknown
  /**
   * Ballot workflow item not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingBallotWorkflowItemsPartialUpdateResponses = {
  200: DirectVotingBallotWorkflowItem
}

export type DirectvotingBallotWorkflowItemsPartialUpdateResponse =
  DirectvotingBallotWorkflowItemsPartialUpdateResponses[keyof DirectvotingBallotWorkflowItemsPartialUpdateResponses]

export type DirectvotingBallotWorkflowItemsSearchCreateData = {
  body?: DirectVotingBallotWorkflowItemSearchRequestRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/directvoting/ballot-workflow-items/search/'
}

export type DirectvotingBallotWorkflowItemsSearchCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type DirectvotingBallotWorkflowItemsSearchCreateResponses = {
  200: PaginatedDirectVotingBallotWorkflowItemList
}

export type DirectvotingBallotWorkflowItemsSearchCreateResponse =
  DirectvotingBallotWorkflowItemsSearchCreateResponses[keyof DirectvotingBallotWorkflowItemsSearchCreateResponses]

export type DirectvotingBallotsCastVoteCreateData = {
  body: CastVoteRequestRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
    /**
     * The calling service's user, by their subject at their identity source. Beacon must name a user of the acting tenant.
     */
    'X-Acting-User'?: string
  }
  path: {
    ballot_id: string
  }
  query?: never
  url: '/directvoting/ballots/{ballot_id}/cast-vote/'
}

export type DirectvotingBallotsCastVoteCreateErrors = {
  /**
   * The submitted proposals do not exactly match the ballot's proposal set, a response is not one of its proposal's voting options, or the ballot no longer accepts votes. Also returned when the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is either not authenticated, lacks a required role, sent an acting tenant that is not available to them, or is Beacon naming a user not in the acting tenant. The response does not distinguish these.
   */
  403: unknown
  /**
   * Ballot not found for the acting tenant, or the ballot's meeting has no current version.
   */
  404: unknown
  /**
   * A concurrent cast on the same ballot recorded an instruction first; retry the request.
   */
  409: unknown
}

export type DirectvotingBallotsCastVoteCreateResponses = {
  200: CastVoteResponse
}

export type DirectvotingBallotsCastVoteCreateResponse =
  DirectvotingBallotsCastVoteCreateResponses[keyof DirectvotingBallotsCastVoteCreateResponses]

export type DirectvotingBallotsProposalsRetrieveData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
    /**
     * The calling service's user, by their subject at their identity source. Beacon must name a user of the acting tenant.
     */
    'X-Acting-User'?: string
  }
  path: {
    ballot_id: string
  }
  query?: never
  url: '/directvoting/ballots/{ballot_id}/proposals/'
}

export type DirectvotingBallotsProposalsRetrieveErrors = {
  /**
   * The X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is either not authenticated, lacks a required role, sent an acting tenant that is not available to them, or is Beacon naming a user not in the acting tenant. The response does not distinguish these.
   */
  403: unknown
  /**
   * Ballot not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingBallotsProposalsRetrieveResponses = {
  200: BallotProposalsResponse
}

export type DirectvotingBallotsProposalsRetrieveResponse =
  DirectvotingBallotsProposalsRetrieveResponses[keyof DirectvotingBallotsProposalsRetrieveResponses]

export type DirectvotingBallotsSearchCreateData = {
  body?: TenantBallotSearchRequestRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
    /**
     * The calling service's user, by their subject at their identity source. Beacon must name a user of the acting tenant.
     */
    'X-Acting-User'?: string
  }
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/directvoting/ballots/search/'
}

export type DirectvotingBallotsSearchCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is either not authenticated, lacks a required role, sent an acting tenant that is not available to them, or is Beacon naming a user not in the acting tenant. The response does not distinguish these.
   */
  403: unknown
}

export type DirectvotingBallotsSearchCreateResponses = {
  200: PaginatedTenantBallotList
}

export type DirectvotingBallotsSearchCreateResponse =
  DirectvotingBallotsSearchCreateResponses[keyof DirectvotingBallotsSearchCreateResponses]

export type DirectvotingBeaconRuleOutputsCreateData = {
  body: DirectVotingBeaconRuleOutputUpsertRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
    /**
     * The calling service's user, by their subject at their identity source. Beacon must name a user of the acting tenant.
     */
    'X-Acting-User'?: string
  }
  path?: never
  query?: never
  url: '/directvoting/beacon-rule-outputs/'
}

export type DirectvotingBeaconRuleOutputsCreateErrors = {
  /**
   * Request body failed validation, including when proposals is empty, the proposal set was never the ballot's, a proposal id is repeated or names no proposal in the set, or an outcome or refer status is unknown. Also returned when the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is either not authenticated, lacks a required role, sent an acting tenant that is not available to them, or is Beacon naming a user not in the acting tenant. The response does not distinguish these.
   */
  403: unknown
  /**
   * Ballot not found for the acting tenant.
   */
  404: unknown
  /**
   * A concurrent write on the same ballot recorded its output first; retry the request.
   */
  409: unknown
}

export type DirectvotingBeaconRuleOutputsCreateResponses = {
  200: DirectVotingBeaconRuleOutput
}

export type DirectvotingBeaconRuleOutputsCreateResponse =
  DirectvotingBeaconRuleOutputsCreateResponses[keyof DirectvotingBeaconRuleOutputsCreateResponses]

export type DirectvotingBeaconRuleOutputsDestroyData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
    /**
     * The calling service's user, by their subject at their identity source. Beacon must name a user of the acting tenant.
     */
    'X-Acting-User'?: string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/beacon-rule-outputs/{identity_id}/'
}

export type DirectvotingBeaconRuleOutputsDestroyErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is either not authenticated, lacks a required role, sent an acting tenant that is not available to them, or is Beacon naming a user not in the acting tenant. The response does not distinguish these.
   */
  403: unknown
  /**
   * Beacon rule output not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingBeaconRuleOutputsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type DirectvotingBeaconRuleOutputsDestroyResponse =
  DirectvotingBeaconRuleOutputsDestroyResponses[keyof DirectvotingBeaconRuleOutputsDestroyResponses]

export type DirectvotingBeaconRuleOutputsRetrieveData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
    /**
     * The calling service's user, by their subject at their identity source. Beacon must name a user of the acting tenant.
     */
    'X-Acting-User'?: string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/beacon-rule-outputs/{identity_id}/'
}

export type DirectvotingBeaconRuleOutputsRetrieveErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is either not authenticated, lacks a required role, sent an acting tenant that is not available to them, or is Beacon naming a user not in the acting tenant. The response does not distinguish these.
   */
  403: unknown
  /**
   * Beacon rule output not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingBeaconRuleOutputsRetrieveResponses = {
  200: DirectVotingBeaconRuleOutput
}

export type DirectvotingBeaconRuleOutputsRetrieveResponse =
  DirectvotingBeaconRuleOutputsRetrieveResponses[keyof DirectvotingBeaconRuleOutputsRetrieveResponses]

export type DirectvotingBeaconRuleOutputsSearchCreateData = {
  body?: DirectVotingBeaconRuleOutputSearchRequestRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
    /**
     * The calling service's user, by their subject at their identity source. Beacon must name a user of the acting tenant.
     */
    'X-Acting-User'?: string
  }
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/directvoting/beacon-rule-outputs/search/'
}

export type DirectvotingBeaconRuleOutputsSearchCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is either not authenticated, lacks a required role, sent an acting tenant that is not available to them, or is Beacon naming a user not in the acting tenant. The response does not distinguish these.
   */
  403: unknown
}

export type DirectvotingBeaconRuleOutputsSearchCreateResponses = {
  200: PaginatedDirectVotingBeaconRuleOutputList
}

export type DirectvotingBeaconRuleOutputsSearchCreateResponse =
  DirectvotingBeaconRuleOutputsSearchCreateResponses[keyof DirectvotingBeaconRuleOutputsSearchCreateResponses]

export type DirectvotingCustodyAccountGroupMembershipsCreateData = {
  body: CustodyAccountGroupMembershipRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: never
  url: '/directvoting/custody-account-group-memberships/'
}

export type DirectvotingCustodyAccountGroupMembershipsCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * The custody account is already in the group.
   */
  409: unknown
}

export type DirectvotingCustodyAccountGroupMembershipsCreateResponses = {
  201: CustodyAccountGroupMembership
}

export type DirectvotingCustodyAccountGroupMembershipsCreateResponse =
  DirectvotingCustodyAccountGroupMembershipsCreateResponses[keyof DirectvotingCustodyAccountGroupMembershipsCreateResponses]

export type DirectvotingCustodyAccountGroupMembershipsDestroyData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/custody-account-group-memberships/{identity_id}/'
}

export type DirectvotingCustodyAccountGroupMembershipsDestroyErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Custody account group membership not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingCustodyAccountGroupMembershipsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type DirectvotingCustodyAccountGroupMembershipsDestroyResponse =
  DirectvotingCustodyAccountGroupMembershipsDestroyResponses[keyof DirectvotingCustodyAccountGroupMembershipsDestroyResponses]

export type DirectvotingCustodyAccountGroupMembershipsSearchCreateData = {
  body?: CustodyAccountGroupMembershipSearchRequestRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/directvoting/custody-account-group-memberships/search/'
}

export type DirectvotingCustodyAccountGroupMembershipsSearchCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type DirectvotingCustodyAccountGroupMembershipsSearchCreateResponses = {
  200: PaginatedCustodyAccountGroupMembershipList
}

export type DirectvotingCustodyAccountGroupMembershipsSearchCreateResponse =
  DirectvotingCustodyAccountGroupMembershipsSearchCreateResponses[keyof DirectvotingCustodyAccountGroupMembershipsSearchCreateResponses]

export type DirectvotingCustodyAccountGroupsCreateData = {
  body: CustodyAccountGroupRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: never
  url: '/directvoting/custody-account-groups/'
}

export type DirectvotingCustodyAccountGroupsCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * The acting tenant already has a group with this title.
   */
  409: unknown
}

export type DirectvotingCustodyAccountGroupsCreateResponses = {
  201: CustodyAccountGroup
}

export type DirectvotingCustodyAccountGroupsCreateResponse =
  DirectvotingCustodyAccountGroupsCreateResponses[keyof DirectvotingCustodyAccountGroupsCreateResponses]

export type DirectvotingCustodyAccountGroupsDestroyData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    id: string
  }
  query?: never
  url: '/directvoting/custody-account-groups/{id}/'
}

export type DirectvotingCustodyAccountGroupsDestroyErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Custody account group not found for the acting tenant.
   */
  404: unknown
  /**
   * The custody account group holds custody account membership history.
   */
  409: unknown
}

export type DirectvotingCustodyAccountGroupsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type DirectvotingCustodyAccountGroupsDestroyResponse =
  DirectvotingCustodyAccountGroupsDestroyResponses[keyof DirectvotingCustodyAccountGroupsDestroyResponses]

export type DirectvotingCustodyAccountGroupsRetrieveData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    id: string
  }
  query?: never
  url: '/directvoting/custody-account-groups/{id}/'
}

export type DirectvotingCustodyAccountGroupsRetrieveErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Custody account group not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingCustodyAccountGroupsRetrieveResponses = {
  200: CustodyAccountGroup
}

export type DirectvotingCustodyAccountGroupsRetrieveResponse =
  DirectvotingCustodyAccountGroupsRetrieveResponses[keyof DirectvotingCustodyAccountGroupsRetrieveResponses]

export type DirectvotingCustodyAccountGroupsPartialUpdateData = {
  body?: PatchedCustodyAccountGroupRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    id: string
  }
  query?: never
  url: '/directvoting/custody-account-groups/{id}/'
}

export type DirectvotingCustodyAccountGroupsPartialUpdateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Custody account group not found for the acting tenant.
   */
  404: unknown
  /**
   * The acting tenant already has a group with this title.
   */
  409: unknown
}

export type DirectvotingCustodyAccountGroupsPartialUpdateResponses = {
  200: CustodyAccountGroup
}

export type DirectvotingCustodyAccountGroupsPartialUpdateResponse =
  DirectvotingCustodyAccountGroupsPartialUpdateResponses[keyof DirectvotingCustodyAccountGroupsPartialUpdateResponses]

export type DirectvotingCustodyAccountGroupsUpdateData = {
  body: CustodyAccountGroupRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    id: string
  }
  query?: never
  url: '/directvoting/custody-account-groups/{id}/'
}

export type DirectvotingCustodyAccountGroupsUpdateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Custody account group not found for the acting tenant.
   */
  404: unknown
  /**
   * The acting tenant already has a group with this title.
   */
  409: unknown
}

export type DirectvotingCustodyAccountGroupsUpdateResponses = {
  200: CustodyAccountGroup
}

export type DirectvotingCustodyAccountGroupsUpdateResponse =
  DirectvotingCustodyAccountGroupsUpdateResponses[keyof DirectvotingCustodyAccountGroupsUpdateResponses]

export type DirectvotingCustodyAccountGroupsSearchCreateData = {
  body?: CustodyAccountGroupSearchRequestRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/directvoting/custody-account-groups/search/'
}

export type DirectvotingCustodyAccountGroupsSearchCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type DirectvotingCustodyAccountGroupsSearchCreateResponses = {
  200: PaginatedCustodyAccountGroupList
}

export type DirectvotingCustodyAccountGroupsSearchCreateResponse =
  DirectvotingCustodyAccountGroupsSearchCreateResponses[keyof DirectvotingCustodyAccountGroupsSearchCreateResponses]

export type DirectvotingCustodyAccountTenantLinksListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Filter by custody account identifier - exact match.
     */
    custody_account?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Filter by tenant identifier - exact match.
     */
    tenant?: string
  }
  url: '/directvoting/custody-account-tenant-links/'
}

export type DirectvotingCustodyAccountTenantLinksListErrors = {
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type DirectvotingCustodyAccountTenantLinksListResponses = {
  200: PaginatedCustodyAccountTenantLinkList
}

export type DirectvotingCustodyAccountTenantLinksListResponse =
  DirectvotingCustodyAccountTenantLinksListResponses[keyof DirectvotingCustodyAccountTenantLinksListResponses]

export type DirectvotingCustodyAccountTenantLinksLinkCreateData = {
  body: CustodyAccountTenantLinkRequestRequest
  path?: never
  query?: never
  url: '/directvoting/custody-account-tenant-links/link/'
}

export type DirectvotingCustodyAccountTenantLinksLinkCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type DirectvotingCustodyAccountTenantLinksLinkCreateResponses = {
  200: CustodyAccountTenantLink
  201: CustodyAccountTenantLink
}

export type DirectvotingCustodyAccountTenantLinksLinkCreateResponse =
  DirectvotingCustodyAccountTenantLinksLinkCreateResponses[keyof DirectvotingCustodyAccountTenantLinksLinkCreateResponses]

export type DirectvotingCustodyAccountTenantLinksUnlinkCreateData = {
  body: CustodyAccountTenantLinkUnlinkRequestRequest
  path?: never
  query?: never
  url: '/directvoting/custody-account-tenant-links/unlink/'
}

export type DirectvotingCustodyAccountTenantLinksUnlinkCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Custody account has no tenant link.
   */
  404: unknown
}

export type DirectvotingCustodyAccountTenantLinksUnlinkCreateResponses = {
  /**
   * No response body
   */
  204: void
}

export type DirectvotingCustodyAccountTenantLinksUnlinkCreateResponse =
  DirectvotingCustodyAccountTenantLinksUnlinkCreateResponses[keyof DirectvotingCustodyAccountTenantLinksUnlinkCreateResponses]

export type DirectvotingCustodyAccountVotingPolicySelectionsCreateData = {
  body: CustodyAccountVotingPolicySelectionRequest
  path?: never
  query?: never
  url: '/directvoting/custody-account-voting-policy-selections/'
}

export type DirectvotingCustodyAccountVotingPolicySelectionsCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * The custody account already has a current voting policy selection.
   */
  409: unknown
}

export type DirectvotingCustodyAccountVotingPolicySelectionsCreateResponses = {
  201: CustodyAccountVotingPolicySelection
}

export type DirectvotingCustodyAccountVotingPolicySelectionsCreateResponse =
  DirectvotingCustodyAccountVotingPolicySelectionsCreateResponses[keyof DirectvotingCustodyAccountVotingPolicySelectionsCreateResponses]

export type DirectvotingCustodyAccountVotingPolicySelectionsDestroyData = {
  body?: never
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/custody-account-voting-policy-selections/{identity_id}/'
}

export type DirectvotingCustodyAccountVotingPolicySelectionsDestroyErrors = {
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Custody account voting policy selection not found.
   */
  404: unknown
}

export type DirectvotingCustodyAccountVotingPolicySelectionsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type DirectvotingCustodyAccountVotingPolicySelectionsDestroyResponse =
  DirectvotingCustodyAccountVotingPolicySelectionsDestroyResponses[keyof DirectvotingCustodyAccountVotingPolicySelectionsDestroyResponses]

export type DirectvotingCustodyAccountVotingPolicySelectionsRetrieveData = {
  body?: never
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/custody-account-voting-policy-selections/{identity_id}/'
}

export type DirectvotingCustodyAccountVotingPolicySelectionsRetrieveErrors = {
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Custody account voting policy selection not found.
   */
  404: unknown
}

export type DirectvotingCustodyAccountVotingPolicySelectionsRetrieveResponses = {
  200: CustodyAccountVotingPolicySelection
}

export type DirectvotingCustodyAccountVotingPolicySelectionsRetrieveResponse =
  DirectvotingCustodyAccountVotingPolicySelectionsRetrieveResponses[keyof DirectvotingCustodyAccountVotingPolicySelectionsRetrieveResponses]

export type DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateData = {
  body?: PatchedCustodyAccountVotingPolicySelectionRequest
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/custody-account-voting-policy-selections/{identity_id}/'
}

export type DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Custody account voting policy selection not found.
   */
  404: unknown
}

export type DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponses = {
  200: CustodyAccountVotingPolicySelection
}

export type DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponse =
  DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponses[keyof DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponses]

export type DirectvotingCustodyAccountVotingPolicySelectionsUpdateData = {
  body: CustodyAccountVotingPolicySelectionRequest
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/custody-account-voting-policy-selections/{identity_id}/'
}

export type DirectvotingCustodyAccountVotingPolicySelectionsUpdateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Custody account voting policy selection not found.
   */
  404: unknown
}

export type DirectvotingCustodyAccountVotingPolicySelectionsUpdateResponses = {
  200: CustodyAccountVotingPolicySelection
}

export type DirectvotingCustodyAccountVotingPolicySelectionsUpdateResponse =
  DirectvotingCustodyAccountVotingPolicySelectionsUpdateResponses[keyof DirectvotingCustodyAccountVotingPolicySelectionsUpdateResponses]

export type DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateData = {
  body?: CustodyAccountVotingPolicySelectionSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/directvoting/custody-account-voting-policy-selections/search/'
}

export type DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateResponses = {
  200: PaginatedCustodyAccountVotingPolicySelectionList
}

export type DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateResponse =
  DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateResponses[keyof DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateResponses]

export type DirectvotingMeetingsAssignmentSearchCreateData = {
  body?: MeetingAssignmentSearchRequestRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
    /**
     * The calling service's user, by their subject at their identity source. Beacon must name a user of the acting tenant.
     */
    'X-Acting-User'?: string
  }
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/directvoting/meetings/assignment/search/'
}

export type DirectvotingMeetingsAssignmentSearchCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is either not authenticated, lacks a required role, sent an acting tenant that is not available to them, or is Beacon naming a user not in the acting tenant. The response does not distinguish these.
   */
  403: unknown
}

export type DirectvotingMeetingsAssignmentSearchCreateResponses = {
  200: PaginatedMeetingAssignmentList
}

export type DirectvotingMeetingsAssignmentSearchCreateResponse =
  DirectvotingMeetingsAssignmentSearchCreateResponses[keyof DirectvotingMeetingsAssignmentSearchCreateResponses]

export type DirectvotingMeetingsSearchCreateData = {
  body?: TenantMeetingSearchRequestRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
    /**
     * The calling service's user, by their subject at their identity source. Beacon must name a user of the acting tenant.
     */
    'X-Acting-User'?: string
  }
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/directvoting/meetings/search/'
}

export type DirectvotingMeetingsSearchCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is either not authenticated, lacks a required role, sent an acting tenant that is not available to them, or is Beacon naming a user not in the acting tenant. The response does not distinguish these.
   */
  403: unknown
}

export type DirectvotingMeetingsSearchCreateResponses = {
  200: PaginatedTenantMeetingList
}

export type DirectvotingMeetingsSearchCreateResponse =
  DirectvotingMeetingsSearchCreateResponses[keyof DirectvotingMeetingsSearchCreateResponses]

export type DirectvotingRulesEngineRulesCreateData = {
  body: DirectVotingRulesEngineRuleRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: never
  url: '/directvoting/rules-engine/rules/'
}

export type DirectvotingRulesEngineRulesCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * A concurrent write created the rule first; retry the request.
   */
  409: unknown
}

export type DirectvotingRulesEngineRulesCreateResponses = {
  201: DirectVotingRulesEngineRule
}

export type DirectvotingRulesEngineRulesCreateResponse =
  DirectvotingRulesEngineRulesCreateResponses[keyof DirectvotingRulesEngineRulesCreateResponses]

export type DirectvotingRulesEngineRulesListsCreateData = {
  body: DirectVotingRulesEngineRulesListRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: never
  url: '/directvoting/rules-engine/rules-lists/'
}

export type DirectvotingRulesEngineRulesListsCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * The acting tenant already has a rules list with this title for the rules engine.
   */
  409: unknown
}

export type DirectvotingRulesEngineRulesListsCreateResponses = {
  201: DirectVotingRulesEngineRulesList
}

export type DirectvotingRulesEngineRulesListsCreateResponse =
  DirectvotingRulesEngineRulesListsCreateResponses[keyof DirectvotingRulesEngineRulesListsCreateResponses]

export type DirectvotingRulesEngineRulesListsDestroyData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/rules-engine/rules-lists/{identity_id}/'
}

export type DirectvotingRulesEngineRulesListsDestroyErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Rules list not found for the acting tenant.
   */
  404: unknown
  /**
   * The rules list still holds rules.
   */
  409: unknown
}

export type DirectvotingRulesEngineRulesListsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type DirectvotingRulesEngineRulesListsDestroyResponse =
  DirectvotingRulesEngineRulesListsDestroyResponses[keyof DirectvotingRulesEngineRulesListsDestroyResponses]

export type DirectvotingRulesEngineRulesListsRetrieveData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/rules-engine/rules-lists/{identity_id}/'
}

export type DirectvotingRulesEngineRulesListsRetrieveErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Rules list not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingRulesEngineRulesListsRetrieveResponses = {
  200: DirectVotingRulesEngineRulesList
}

export type DirectvotingRulesEngineRulesListsRetrieveResponse =
  DirectvotingRulesEngineRulesListsRetrieveResponses[keyof DirectvotingRulesEngineRulesListsRetrieveResponses]

export type DirectvotingRulesEngineRulesListsPartialUpdateData = {
  body?: PatchedDirectVotingRulesEngineRulesListRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/rules-engine/rules-lists/{identity_id}/'
}

export type DirectvotingRulesEngineRulesListsPartialUpdateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Rules list not found for the acting tenant.
   */
  404: unknown
  /**
   * The acting tenant already has a rules list with this title for the rules engine.
   */
  409: unknown
}

export type DirectvotingRulesEngineRulesListsPartialUpdateResponses = {
  200: DirectVotingRulesEngineRulesList
}

export type DirectvotingRulesEngineRulesListsPartialUpdateResponse =
  DirectvotingRulesEngineRulesListsPartialUpdateResponses[keyof DirectvotingRulesEngineRulesListsPartialUpdateResponses]

export type DirectvotingRulesEngineRulesListsSearchCreateData = {
  body?: DirectVotingRulesEngineRulesListSearchRequestRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/directvoting/rules-engine/rules-lists/search/'
}

export type DirectvotingRulesEngineRulesListsSearchCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type DirectvotingRulesEngineRulesListsSearchCreateResponses = {
  200: PaginatedDirectVotingRulesEngineRulesListList
}

export type DirectvotingRulesEngineRulesListsSearchCreateResponse =
  DirectvotingRulesEngineRulesListsSearchCreateResponses[keyof DirectvotingRulesEngineRulesListsSearchCreateResponses]

export type DirectvotingRulesEngineRulesDestroyData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/rules-engine/rules/{identity_id}/'
}

export type DirectvotingRulesEngineRulesDestroyErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Rule not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingRulesEngineRulesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type DirectvotingRulesEngineRulesDestroyResponse =
  DirectvotingRulesEngineRulesDestroyResponses[keyof DirectvotingRulesEngineRulesDestroyResponses]

export type DirectvotingRulesEngineRulesRetrieveData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/rules-engine/rules/{identity_id}/'
}

export type DirectvotingRulesEngineRulesRetrieveErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Rule not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingRulesEngineRulesRetrieveResponses = {
  200: DirectVotingRulesEngineRule
}

export type DirectvotingRulesEngineRulesRetrieveResponse =
  DirectvotingRulesEngineRulesRetrieveResponses[keyof DirectvotingRulesEngineRulesRetrieveResponses]

export type DirectvotingRulesEngineRulesPartialUpdateData = {
  body?: PatchedDirectVotingRulesEngineRuleRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/rules-engine/rules/{identity_id}/'
}

export type DirectvotingRulesEngineRulesPartialUpdateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Rule not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingRulesEngineRulesPartialUpdateResponses = {
  200: DirectVotingRulesEngineRule
}

export type DirectvotingRulesEngineRulesPartialUpdateResponse =
  DirectvotingRulesEngineRulesPartialUpdateResponses[keyof DirectvotingRulesEngineRulesPartialUpdateResponses]

export type DirectvotingRulesEngineRulesSearchCreateData = {
  body?: DirectVotingRulesEngineRuleSearchRequestRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/directvoting/rules-engine/rules/search/'
}

export type DirectvotingRulesEngineRulesSearchCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type DirectvotingRulesEngineRulesSearchCreateResponses = {
  200: PaginatedDirectVotingRulesEngineRuleList
}

export type DirectvotingRulesEngineRulesSearchCreateResponse =
  DirectvotingRulesEngineRulesSearchCreateResponses[keyof DirectvotingRulesEngineRulesSearchCreateResponses]

export type DirectvotingWatchlistItemsCreateData = {
  body: DirectVotingWatchlistItemRequestWritable
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: never
  url: '/directvoting/watchlist-items/'
}

export type DirectvotingWatchlistItemsCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * The issuer is already on the watchlist.
   */
  409: unknown
}

export type DirectvotingWatchlistItemsCreateResponses = {
  201: DirectVotingWatchlistItem
}

export type DirectvotingWatchlistItemsCreateResponse =
  DirectvotingWatchlistItemsCreateResponses[keyof DirectvotingWatchlistItemsCreateResponses]

export type DirectvotingWatchlistItemsDestroyData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/watchlist-items/{identity_id}/'
}

export type DirectvotingWatchlistItemsDestroyErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Watchlist item not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingWatchlistItemsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type DirectvotingWatchlistItemsDestroyResponse =
  DirectvotingWatchlistItemsDestroyResponses[keyof DirectvotingWatchlistItemsDestroyResponses]

export type DirectvotingWatchlistItemsRetrieveData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/watchlist-items/{identity_id}/'
}

export type DirectvotingWatchlistItemsRetrieveErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Watchlist item not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingWatchlistItemsRetrieveResponses = {
  200: DirectVotingWatchlistItem
}

export type DirectvotingWatchlistItemsRetrieveResponse =
  DirectvotingWatchlistItemsRetrieveResponses[keyof DirectvotingWatchlistItemsRetrieveResponses]

export type DirectvotingWatchlistItemsBatchCreateData = {
  body: DirectVotingWatchlistItemBatchUpsertRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: never
  url: '/directvoting/watchlist-items/batch/'
}

export type DirectvotingWatchlistItemsBatchCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type DirectvotingWatchlistItemsBatchCreateResponses = {
  200: DirectVotingWatchlistItemBatchUpsertResponse
}

export type DirectvotingWatchlistItemsBatchCreateResponse =
  DirectvotingWatchlistItemsBatchCreateResponses[keyof DirectvotingWatchlistItemsBatchCreateResponses]

export type DirectvotingWatchlistItemsSearchCreateData = {
  body?: DirectVotingWatchlistItemSearchRequestRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/directvoting/watchlist-items/search/'
}

export type DirectvotingWatchlistItemsSearchCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type DirectvotingWatchlistItemsSearchCreateResponses = {
  200: PaginatedDirectVotingWatchlistItemList
}

export type DirectvotingWatchlistItemsSearchCreateResponse =
  DirectvotingWatchlistItemsSearchCreateResponses[keyof DirectvotingWatchlistItemsSearchCreateResponses]

export type DirectvotingWatchlistsCreateData = {
  body: DirectVotingWatchlistRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: never
  url: '/directvoting/watchlists/'
}

export type DirectvotingWatchlistsCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * The acting tenant already has a live watchlist with this title.
   */
  409: unknown
}

export type DirectvotingWatchlistsCreateResponses = {
  201: DirectVotingWatchlist
}

export type DirectvotingWatchlistsCreateResponse =
  DirectvotingWatchlistsCreateResponses[keyof DirectvotingWatchlistsCreateResponses]

export type DirectvotingWatchlistsDestroyData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/watchlists/{identity_id}/'
}

export type DirectvotingWatchlistsDestroyErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Watchlist not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingWatchlistsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type DirectvotingWatchlistsDestroyResponse =
  DirectvotingWatchlistsDestroyResponses[keyof DirectvotingWatchlistsDestroyResponses]

export type DirectvotingWatchlistsRetrieveData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/watchlists/{identity_id}/'
}

export type DirectvotingWatchlistsRetrieveErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Watchlist not found for the acting tenant.
   */
  404: unknown
}

export type DirectvotingWatchlistsRetrieveResponses = {
  200: DirectVotingWatchlist
}

export type DirectvotingWatchlistsRetrieveResponse =
  DirectvotingWatchlistsRetrieveResponses[keyof DirectvotingWatchlistsRetrieveResponses]

export type DirectvotingWatchlistsPartialUpdateData = {
  body?: PatchedDirectVotingWatchlistRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    identity_id: string
  }
  query?: never
  url: '/directvoting/watchlists/{identity_id}/'
}

export type DirectvotingWatchlistsPartialUpdateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Watchlist not found for the acting tenant.
   */
  404: unknown
  /**
   * The acting tenant already has a live watchlist with this title.
   */
  409: unknown
}

export type DirectvotingWatchlistsPartialUpdateResponses = {
  200: DirectVotingWatchlist
}

export type DirectvotingWatchlistsPartialUpdateResponse =
  DirectvotingWatchlistsPartialUpdateResponses[keyof DirectvotingWatchlistsPartialUpdateResponses]

export type DirectvotingWatchlistsSearchCreateData = {
  body?: DirectVotingWatchlistSearchRequestRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/directvoting/watchlists/search/'
}

export type DirectvotingWatchlistsSearchCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type DirectvotingWatchlistsSearchCreateResponses = {
  200: PaginatedDirectVotingWatchlistList
}

export type DirectvotingWatchlistsSearchCreateResponse =
  DirectvotingWatchlistsSearchCreateResponses[keyof DirectvotingWatchlistsSearchCreateResponses]

export type FundManagerFundManagersCreateData = {
  body: FundManagerWriteRequest
  path?: never
  query?: never
  url: '/fund-manager/fund-managers/'
}

export type FundManagerFundManagersCreateResponses = {
  201: FundManager
}

export type FundManagerFundManagersCreateResponse =
  FundManagerFundManagersCreateResponses[keyof FundManagerFundManagersCreateResponses]

export type FundManagerFundManagersPoliciesRetrieveData = {
  body?: never
  path: {
    fund_manager_id: string
  }
  query?: never
  url: '/fund-manager/fund-managers/{fund_manager_id}/policies/'
}

export type FundManagerFundManagersPoliciesRetrieveResponses = {
  200: FundManagerPolicyListResponse
}

export type FundManagerFundManagersPoliciesRetrieveResponse =
  FundManagerFundManagersPoliciesRetrieveResponses[keyof FundManagerFundManagersPoliciesRetrieveResponses]

export type FundManagerFundManagersPoliciesCreateData = {
  body?: Blob | File
  path: {
    fund_manager_id: string
  }
  query: {
    /**
     * The policy filename, ending in '.pdf'.
     */
    filename: string
  }
  url: '/fund-manager/fund-managers/{fund_manager_id}/policies/'
}

export type FundManagerFundManagersPoliciesCreateResponses = {
  201: FundManagerPolicy
}

export type FundManagerFundManagersPoliciesCreateResponse =
  FundManagerFundManagersPoliciesCreateResponses[keyof FundManagerFundManagersPoliciesCreateResponses]

export type FundManagerFundManagersRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/fund-managers/{id}/'
}

export type FundManagerFundManagersRetrieveResponses = {
  200: FundManager
}

export type FundManagerFundManagersRetrieveResponse =
  FundManagerFundManagersRetrieveResponses[keyof FundManagerFundManagersRetrieveResponses]

export type FundManagerFundManagersUpdateData = {
  body: FundManagerWriteRequest
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/fund-managers/{id}/'
}

export type FundManagerFundManagersUpdateResponses = {
  200: FundManager
}

export type FundManagerFundManagersUpdateResponse =
  FundManagerFundManagersUpdateResponses[keyof FundManagerFundManagersUpdateResponses]

export type FundManagerFundManagersSearchCreateData = {
  body?: FundManagerSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/fund-manager/fund-managers/search/'
}

export type FundManagerFundManagersSearchCreateResponses = {
  200: PaginatedFundManagerList
}

export type FundManagerFundManagersSearchCreateResponse =
  FundManagerFundManagersSearchCreateResponses[keyof FundManagerFundManagersSearchCreateResponses]

export type FundManagerFundVariantsCreateData = {
  body: FundVariantWriteRequest
  path?: never
  query?: never
  url: '/fund-manager/fund-variants/'
}

export type FundManagerFundVariantsCreateResponses = {
  201: FundVariant
}

export type FundManagerFundVariantsCreateResponse =
  FundManagerFundVariantsCreateResponses[keyof FundManagerFundVariantsCreateResponses]

export type FundManagerFundVariantsDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/fund-variants/{id}/'
}

export type FundManagerFundVariantsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type FundManagerFundVariantsDestroyResponse =
  FundManagerFundVariantsDestroyResponses[keyof FundManagerFundVariantsDestroyResponses]

export type FundManagerFundVariantsRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/fund-variants/{id}/'
}

export type FundManagerFundVariantsRetrieveResponses = {
  200: FundVariant
}

export type FundManagerFundVariantsRetrieveResponse =
  FundManagerFundVariantsRetrieveResponses[keyof FundManagerFundVariantsRetrieveResponses]

export type FundManagerFundVariantsUpdateData = {
  body: FundVariantWriteRequest
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/fund-variants/{id}/'
}

export type FundManagerFundVariantsUpdateResponses = {
  200: FundVariant
}

export type FundManagerFundVariantsUpdateResponse =
  FundManagerFundVariantsUpdateResponses[keyof FundManagerFundVariantsUpdateResponses]

export type FundManagerFundVariantsSearchCreateData = {
  body?: FundVariantSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/fund-manager/fund-variants/search/'
}

export type FundManagerFundVariantsSearchCreateResponses = {
  200: PaginatedFundVariantList
}

export type FundManagerFundVariantsSearchCreateResponse =
  FundManagerFundVariantsSearchCreateResponses[keyof FundManagerFundVariantsSearchCreateResponses]

export type FundManagerFundsCreateData = {
  body: FundWriteRequest
  path?: never
  query?: never
  url: '/fund-manager/funds/'
}

export type FundManagerFundsCreateResponses = {
  201: Fund
}

export type FundManagerFundsCreateResponse = FundManagerFundsCreateResponses[keyof FundManagerFundsCreateResponses]

export type FundManagerFundsQuantificationSnapshotsCreateData = {
  body: FundQuantificationSnapshotWriteRequest
  path: {
    fund_id: string
  }
  query?: never
  url: '/fund-manager/funds/{fund_id}/quantification-snapshots/'
}

export type FundManagerFundsQuantificationSnapshotsCreateResponses = {
  201: FundQuantificationSnapshot
}

export type FundManagerFundsQuantificationSnapshotsCreateResponse =
  FundManagerFundsQuantificationSnapshotsCreateResponses[keyof FundManagerFundsQuantificationSnapshotsCreateResponses]

export type FundManagerFundsRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: {
    /**
     * The product that owns the fund.
     */
    product?: ProductEnum
  }
  url: '/fund-manager/funds/{id}/'
}

export type FundManagerFundsRetrieveResponses = {
  200: Fund
}

export type FundManagerFundsRetrieveResponse =
  FundManagerFundsRetrieveResponses[keyof FundManagerFundsRetrieveResponses]

export type FundManagerFundsUpdateData = {
  body: FundWriteRequest
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/funds/{id}/'
}

export type FundManagerFundsUpdateResponses = {
  200: Fund
}

export type FundManagerFundsUpdateResponse = FundManagerFundsUpdateResponses[keyof FundManagerFundsUpdateResponses]

export type FundManagerFundsSearchCreateData = {
  body: FundSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/fund-manager/funds/search/'
}

export type FundManagerFundsSearchCreateResponses = {
  200: PaginatedFundList
}

export type FundManagerFundsSearchCreateResponse =
  FundManagerFundsSearchCreateResponses[keyof FundManagerFundsSearchCreateResponses]

export type FundManagerProvidersListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    names?: Array<string>
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Case-insensitive substring match on title.
     */
    search_title?: string
    titles?: Array<string>
  }
  url: '/fund-manager/providers/'
}

export type FundManagerProvidersListResponses = {
  200: PaginatedProviderList
}

export type FundManagerProvidersListResponse =
  FundManagerProvidersListResponses[keyof FundManagerProvidersListResponses]

export type FundManagerProvidersCreateData = {
  body: ProviderWriteRequest
  path?: never
  query?: never
  url: '/fund-manager/providers/'
}

export type FundManagerProvidersCreateResponses = {
  201: Provider
}

export type FundManagerProvidersCreateResponse =
  FundManagerProvidersCreateResponses[keyof FundManagerProvidersCreateResponses]

export type FundManagerProvidersRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/providers/{id}/'
}

export type FundManagerProvidersRetrieveResponses = {
  200: Provider
}

export type FundManagerProvidersRetrieveResponse =
  FundManagerProvidersRetrieveResponses[keyof FundManagerProvidersRetrieveResponses]

export type FundManagerProvidersUpdateData = {
  body: ProviderWriteRequest
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/providers/{id}/'
}

export type FundManagerProvidersUpdateResponses = {
  200: Provider
}

export type FundManagerProvidersUpdateResponse =
  FundManagerProvidersUpdateResponses[keyof FundManagerProvidersUpdateResponses]

export type FundManagerPublicSecurityIdsCreateData = {
  body: FundManagerPublicSecurityIdWriteRequest
  path?: never
  query?: never
  url: '/fund-manager/public-security-ids/'
}

export type FundManagerPublicSecurityIdsCreateResponses = {
  201: FundManagerPublicSecurityId
}

export type FundManagerPublicSecurityIdsCreateResponse =
  FundManagerPublicSecurityIdsCreateResponses[keyof FundManagerPublicSecurityIdsCreateResponses]

export type FundManagerPublicSecurityIdsSearchCreateData = {
  body?: FundManagerPublicSecurityIdSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/fund-manager/public-security-ids/search/'
}

export type FundManagerPublicSecurityIdsSearchCreateResponses = {
  200: PaginatedFundManagerPublicSecurityIdList
}

export type FundManagerPublicSecurityIdsSearchCreateResponse =
  FundManagerPublicSecurityIdsSearchCreateResponses[keyof FundManagerPublicSecurityIdsSearchCreateResponses]

export type FundManagerQuantificationSnapshotsSearchCreateData = {
  body: FundQuantificationSnapshotSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/fund-manager/quantification-snapshots/search/'
}

export type FundManagerQuantificationSnapshotsSearchCreateResponses = {
  200: PaginatedFundQuantificationSnapshotList
}

export type FundManagerQuantificationSnapshotsSearchCreateResponse =
  FundManagerQuantificationSnapshotsSearchCreateResponses[keyof FundManagerQuantificationSnapshotsSearchCreateResponses]

export type InstitutionalMeetingsearchListData = {
  body?: never
  path?: never
  query: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Search for organizations by display title (case insensitive)
     */
    organization_title_search?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Scheme name in format 'habitats/{habitat_id}/schemes/{scheme_id}'
     */
    scheme_name: string
    /**
     * Sort order by voting deadline (action_deadline). 'asc' shows meetings with soonest deadlines first. Default is 'asc'.
     */
    sort_order?: 'asc' | 'desc'
    /**
     * Filter meetings by status.
     * Note:
     * 'OPEN' status filters for Meetings that have an 'Action Deadline' of 00:01:00 today.
     * 'CLOSED' status filters for Meetings that have an 'Action Deadline'
     * before 'now' and a 'Meeting Date' after 'now'.
     * 'ALL' status filters for Meetings that have a 'Meeting Date' after 'now'.
     */
    status?: 'all' | 'closed' | 'open'
    /**
     * Comma-separated list of theme codes to filter by
     */
    theme_codes?: string
  }
  url: '/institutional/meetingsearch'
}

export type InstitutionalMeetingsearchListResponses = {
  200: PaginatedMeetingList
}

export type InstitutionalMeetingsearchListResponse =
  InstitutionalMeetingsearchListResponses[keyof InstitutionalMeetingsearchListResponses]

export type IssuerFiscalYearsCreateData = {
  body: FiscalYearUpsertRequestRequest
  path?: never
  query?: never
  url: '/issuer/fiscal-years/'
}

export type IssuerFiscalYearsCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type IssuerFiscalYearsCreateResponses = {
  200: FiscalYearUpsertResponse
}

export type IssuerFiscalYearsCreateResponse = IssuerFiscalYearsCreateResponses[keyof IssuerFiscalYearsCreateResponses]

export type IssuerFiscalYearsSearchCreateData = {
  body?: FiscalYearSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/issuer/fiscal-years/search/'
}

export type IssuerFiscalYearsSearchCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Issuer not found.
   */
  404: unknown
}

export type IssuerFiscalYearsSearchCreateResponses = {
  200: PaginatedFiscalYearList
}

export type IssuerFiscalYearsSearchCreateResponse =
  IssuerFiscalYearsSearchCreateResponses[keyof IssuerFiscalYearsSearchCreateResponses]

export type IssuerInstrumentsCreateData = {
  body: InstrumentUpsertRequestRequest
  path?: never
  query?: never
  url: '/issuer/instruments/'
}

export type IssuerInstrumentsCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type IssuerInstrumentsCreateResponses = {
  200: InstrumentUpsertResponse
}

export type IssuerInstrumentsCreateResponse = IssuerInstrumentsCreateResponses[keyof IssuerInstrumentsCreateResponses]

export type IssuerInstrumentsRetrieveData = {
  body?: never
  path: {
    identity_id: string
  }
  query?: never
  url: '/issuer/instruments/{identity_id}/'
}

export type IssuerInstrumentsRetrieveErrors = {
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Instrument not found.
   */
  404: unknown
}

export type IssuerInstrumentsRetrieveResponses = {
  200: IssuerInstrument
}

export type IssuerInstrumentsRetrieveResponse =
  IssuerInstrumentsRetrieveResponses[keyof IssuerInstrumentsRetrieveResponses]

export type IssuerInstrumentsOutstandingSharesRetrieveData = {
  body?: never
  path: {
    identity_id: string
  }
  query?: {
    /**
     * Return the latest measure valid on or before this date. Omit for the latest held.
     */
    valid_at?: Date
  }
  url: '/issuer/instruments/{identity_id}/outstanding-shares/'
}

export type IssuerInstrumentsOutstandingSharesRetrieveErrors = {
  /**
   * Query parameters failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Instrument not found, or it holds no share count for the requested date.
   */
  404: unknown
}

export type IssuerInstrumentsOutstandingSharesRetrieveResponses = {
  200: OutstandingShares
}

export type IssuerInstrumentsOutstandingSharesRetrieveResponse =
  IssuerInstrumentsOutstandingSharesRetrieveResponses[keyof IssuerInstrumentsOutstandingSharesRetrieveResponses]

export type IssuerInstrumentsOutstandingSharesCreateData = {
  body: OutstandingSharesUpsertRequest
  path: {
    identity_id: string
  }
  query?: never
  url: '/issuer/instruments/{identity_id}/outstanding-shares/'
}

export type IssuerInstrumentsOutstandingSharesCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Instrument not found.
   */
  404: unknown
}

export type IssuerInstrumentsOutstandingSharesCreateResponses = {
  200: MeasureUpsertResponse
}

export type IssuerInstrumentsOutstandingSharesCreateResponse =
  IssuerInstrumentsOutstandingSharesCreateResponses[keyof IssuerInstrumentsOutstandingSharesCreateResponses]

export type IssuerInstrumentsTotalShareholderReturnRetrieveData = {
  body?: never
  path: {
    identity_id: string
  }
  query?: {
    /**
     * Restrict to the return measured on this exchange, by ISO 10383 MIC code. Rejected if no exchange with this code exists.
     */
    exchange?: string
    /**
     * Return the latest measure valid on or before this date. Omit for the latest held.
     */
    valid_at?: Date
  }
  url: '/issuer/instruments/{identity_id}/total-shareholder-return/'
}

export type IssuerInstrumentsTotalShareholderReturnRetrieveErrors = {
  /**
   * Query parameters failed validation, or the exchange code is not held.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Instrument not found.
   */
  404: unknown
}

export type IssuerInstrumentsTotalShareholderReturnRetrieveResponses = {
  200: TotalShareholderReturnList
}

export type IssuerInstrumentsTotalShareholderReturnRetrieveResponse =
  IssuerInstrumentsTotalShareholderReturnRetrieveResponses[keyof IssuerInstrumentsTotalShareholderReturnRetrieveResponses]

export type IssuerInstrumentsTotalShareholderReturnCreateData = {
  body: TotalShareholderReturnUpsertRequest
  path: {
    identity_id: string
  }
  query?: never
  url: '/issuer/instruments/{identity_id}/total-shareholder-return/'
}

export type IssuerInstrumentsTotalShareholderReturnCreateErrors = {
  /**
   * Request body failed validation, or the exchange code is not held.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Instrument not found.
   */
  404: unknown
}

export type IssuerInstrumentsTotalShareholderReturnCreateResponses = {
  200: MeasureUpsertResponse
}

export type IssuerInstrumentsTotalShareholderReturnCreateResponse =
  IssuerInstrumentsTotalShareholderReturnCreateResponses[keyof IssuerInstrumentsTotalShareholderReturnCreateResponses]

export type IssuerInstrumentsSearchCreateData = {
  body?: IssuerInstrumentSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/issuer/instruments/search/'
}

export type IssuerInstrumentsSearchCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type IssuerInstrumentsSearchCreateResponses = {
  200: PaginatedIssuerInstrumentList
}

export type IssuerInstrumentsSearchCreateResponse =
  IssuerInstrumentsSearchCreateResponses[keyof IssuerInstrumentsSearchCreateResponses]

export type IssuerIssuersCreateData = {
  body: IssuerUpsertRequestRequest
  path?: never
  query?: never
  url: '/issuer/issuers/'
}

export type IssuerIssuersCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type IssuerIssuersCreateResponses = {
  200: IssuerUpsertResponse
}

export type IssuerIssuersCreateResponse = IssuerIssuersCreateResponses[keyof IssuerIssuersCreateResponses]

export type IssuerIssuersRetrieveData = {
  body?: never
  path: {
    identity_id: string
  }
  query?: never
  url: '/issuer/issuers/{identity_id}/'
}

export type IssuerIssuersRetrieveErrors = {
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Issuer not found.
   */
  404: unknown
}

export type IssuerIssuersRetrieveResponses = {
  200: Issuer
}

export type IssuerIssuersRetrieveResponse = IssuerIssuersRetrieveResponses[keyof IssuerIssuersRetrieveResponses]

export type IssuerIssuersMarketCapitalisationRetrieveData = {
  body?: never
  path: {
    identity_id: string
  }
  query?: {
    /**
     * Return the latest measure valid on or before this date. Omit for the latest held.
     */
    valid_at?: Date
  }
  url: '/issuer/issuers/{identity_id}/market-capitalisation/'
}

export type IssuerIssuersMarketCapitalisationRetrieveErrors = {
  /**
   * Query parameters failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Issuer not found, or it holds no market capitalisation for the requested date.
   */
  404: unknown
}

export type IssuerIssuersMarketCapitalisationRetrieveResponses = {
  200: MarketCapitalisation
}

export type IssuerIssuersMarketCapitalisationRetrieveResponse =
  IssuerIssuersMarketCapitalisationRetrieveResponses[keyof IssuerIssuersMarketCapitalisationRetrieveResponses]

export type IssuerIssuersMarketCapitalisationCreateData = {
  body: MarketCapitalisationUpsertRequest
  path: {
    identity_id: string
  }
  query?: never
  url: '/issuer/issuers/{identity_id}/market-capitalisation/'
}

export type IssuerIssuersMarketCapitalisationCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Issuer not found.
   */
  404: unknown
}

export type IssuerIssuersMarketCapitalisationCreateResponses = {
  200: MeasureUpsertResponse
}

export type IssuerIssuersMarketCapitalisationCreateResponse =
  IssuerIssuersMarketCapitalisationCreateResponses[keyof IssuerIssuersMarketCapitalisationCreateResponses]

export type IssuerIssuersSearchCreateData = {
  body?: IssuerSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/issuer/issuers/search/'
}

export type IssuerIssuersSearchCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type IssuerIssuersSearchCreateResponses = {
  200: PaginatedIssuerList
}

export type IssuerIssuersSearchCreateResponse =
  IssuerIssuersSearchCreateResponses[keyof IssuerIssuersSearchCreateResponses]

export type ProxyIntermediaryBallotsVersionsListData = {
  body?: never
  path: {
    /**
     * Identity id of the ballot, stable across all its versions.
     */
    ballot_id: string
  }
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxy-intermediary/ballots/{ballot_id}/versions/'
}

export type ProxyIntermediaryBallotsVersionsListResponses = {
  200: PaginatedBallotList
}

export type ProxyIntermediaryBallotsVersionsListResponse =
  ProxyIntermediaryBallotsVersionsListResponses[keyof ProxyIntermediaryBallotsVersionsListResponses]

export type ProxyIntermediaryBallotsFetchByVersionIdsCreateData = {
  body: FetchByVersionIdsRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/ballots/fetch-by-version-ids/'
}

export type ProxyIntermediaryBallotsFetchByVersionIdsCreateResponses = {
  200: BallotListResponse
}

export type ProxyIntermediaryBallotsFetchByVersionIdsCreateResponse =
  ProxyIntermediaryBallotsFetchByVersionIdsCreateResponses[keyof ProxyIntermediaryBallotsFetchByVersionIdsCreateResponses]

export type ProxyIntermediaryBallotsProxymityStaleProposalSetListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxy-intermediary/ballots/proxymity-stale-proposal-set/'
}

export type ProxyIntermediaryBallotsProxymityStaleProposalSetListResponses = {
  200: PaginatedBallotList
}

export type ProxyIntermediaryBallotsProxymityStaleProposalSetListResponse =
  ProxyIntermediaryBallotsProxymityStaleProposalSetListResponses[keyof ProxyIntermediaryBallotsProxymityStaleProposalSetListResponses]

export type ProxyIntermediaryBallotsSearchCreateData = {
  body?: ListRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxy-intermediary/ballots/search/'
}

export type ProxyIntermediaryBallotsSearchCreateResponses = {
  200: PaginatedBallotList
}

export type ProxyIntermediaryBallotsSearchCreateResponse =
  ProxyIntermediaryBallotsSearchCreateResponses[keyof ProxyIntermediaryBallotsSearchCreateResponses]

export type ProxyIntermediaryBallotsUpsertCreateData = {
  body: UpsertRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/ballots/upsert/'
}

export type ProxyIntermediaryBallotsUpsertCreateResponses = {
  200: UpsertResponse
}

export type ProxyIntermediaryBallotsUpsertCreateResponse =
  ProxyIntermediaryBallotsUpsertCreateResponses[keyof ProxyIntermediaryBallotsUpsertCreateResponses]

export type ProxyIntermediaryCustodyAccountsCreateData = {
  body: CustodyAccountRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/custody-accounts/'
}

export type ProxyIntermediaryCustodyAccountsCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type ProxyIntermediaryCustodyAccountsCreateResponses = {
  201: CustodyAccount
}

export type ProxyIntermediaryCustodyAccountsCreateResponse =
  ProxyIntermediaryCustodyAccountsCreateResponses[keyof ProxyIntermediaryCustodyAccountsCreateResponses]

export type ProxyIntermediaryCustodyAccountsDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/proxy-intermediary/custody-accounts/{id}/'
}

export type ProxyIntermediaryCustodyAccountsDestroyErrors = {
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Custody account not found.
   */
  404: unknown
}

export type ProxyIntermediaryCustodyAccountsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyIntermediaryCustodyAccountsDestroyResponse =
  ProxyIntermediaryCustodyAccountsDestroyResponses[keyof ProxyIntermediaryCustodyAccountsDestroyResponses]

export type ProxyIntermediaryCustodyAccountsRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/proxy-intermediary/custody-accounts/{id}/'
}

export type ProxyIntermediaryCustodyAccountsRetrieveErrors = {
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Custody account not found.
   */
  404: unknown
}

export type ProxyIntermediaryCustodyAccountsRetrieveResponses = {
  200: CustodyAccount
}

export type ProxyIntermediaryCustodyAccountsRetrieveResponse =
  ProxyIntermediaryCustodyAccountsRetrieveResponses[keyof ProxyIntermediaryCustodyAccountsRetrieveResponses]

export type ProxyIntermediaryCustodyAccountsPartialUpdateData = {
  body?: PatchedCustodyAccountRequest
  path: {
    id: string
  }
  query?: never
  url: '/proxy-intermediary/custody-accounts/{id}/'
}

export type ProxyIntermediaryCustodyAccountsPartialUpdateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Custody account not found.
   */
  404: unknown
}

export type ProxyIntermediaryCustodyAccountsPartialUpdateResponses = {
  200: CustodyAccount
}

export type ProxyIntermediaryCustodyAccountsPartialUpdateResponse =
  ProxyIntermediaryCustodyAccountsPartialUpdateResponses[keyof ProxyIntermediaryCustodyAccountsPartialUpdateResponses]

export type ProxyIntermediaryCustodyAccountsUpdateData = {
  body: CustodyAccountRequest
  path: {
    id: string
  }
  query?: never
  url: '/proxy-intermediary/custody-accounts/{id}/'
}

export type ProxyIntermediaryCustodyAccountsUpdateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Custody account not found.
   */
  404: unknown
}

export type ProxyIntermediaryCustodyAccountsUpdateResponses = {
  200: CustodyAccount
}

export type ProxyIntermediaryCustodyAccountsUpdateResponse =
  ProxyIntermediaryCustodyAccountsUpdateResponses[keyof ProxyIntermediaryCustodyAccountsUpdateResponses]

export type ProxyIntermediaryCustodyAccountsSearchCreateData = {
  body?: CustodyAccountSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxy-intermediary/custody-accounts/search/'
}

export type ProxyIntermediaryCustodyAccountsSearchCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type ProxyIntermediaryCustodyAccountsSearchCreateResponses = {
  200: PaginatedCustodyAccountList
}

export type ProxyIntermediaryCustodyAccountsSearchCreateResponse =
  ProxyIntermediaryCustodyAccountsSearchCreateResponses[keyof ProxyIntermediaryCustodyAccountsSearchCreateResponses]

export type ProxyIntermediaryPiProposalCategoriesUpsertCreateData = {
  body: UpsertPiProposalCategoryRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/pi-proposal-categories/upsert/'
}

export type ProxyIntermediaryPiProposalCategoriesUpsertCreateResponses = {
  200: UpsertPiProposalCategoryResponse
}

export type ProxyIntermediaryPiProposalCategoriesUpsertCreateResponse =
  ProxyIntermediaryPiProposalCategoriesUpsertCreateResponses[keyof ProxyIntermediaryPiProposalCategoriesUpsertCreateResponses]

export type ProxyIntermediaryProposalCategoriesAssignCreateData = {
  body: AssignProposalCategoryRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proposal-categories/assign/'
}

export type ProxyIntermediaryProposalCategoriesAssignCreateResponses = {
  200: AssignProposalCategoryResponse
}

export type ProxyIntermediaryProposalCategoriesAssignCreateResponse =
  ProxyIntermediaryProposalCategoriesAssignCreateResponses[keyof ProxyIntermediaryProposalCategoriesAssignCreateResponses]

export type ProxyIntermediaryProposalCategoriesListCreateData = {
  body: ListProposalCategoriesRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proposal-categories/list/'
}

export type ProxyIntermediaryProposalCategoriesListCreateResponses = {
  200: ListProposalCategoriesResponse
}

export type ProxyIntermediaryProposalCategoriesListCreateResponse =
  ProxyIntermediaryProposalCategoriesListCreateResponses[keyof ProxyIntermediaryProposalCategoriesListCreateResponses]

export type ProxyIntermediaryProposalLabelsAssignCreateData = {
  body: AssignProposalLabelRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proposal-labels/assign/'
}

export type ProxyIntermediaryProposalLabelsAssignCreateResponses = {
  200: AssignProposalLabelResponse
}

export type ProxyIntermediaryProposalLabelsAssignCreateResponse =
  ProxyIntermediaryProposalLabelsAssignCreateResponses[keyof ProxyIntermediaryProposalLabelsAssignCreateResponses]

export type ProxyIntermediaryProposalLabelsFetchCreateData = {
  body: FetchProposalLabelsRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proposal-labels/fetch/'
}

export type ProxyIntermediaryProposalLabelsFetchCreateResponses = {
  200: FetchProposalLabelsResponse
}

export type ProxyIntermediaryProposalLabelsFetchCreateResponse =
  ProxyIntermediaryProposalLabelsFetchCreateResponses[keyof ProxyIntermediaryProposalLabelsFetchCreateResponses]

export type ProxyIntermediaryProposalsBroadridgeProposalSetFetchLatestCreateData = {
  body: FetchLatestBroadridgeProposalSetRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proposals/broadridge-proposal-set/fetch-latest/'
}

export type ProxyIntermediaryProposalsBroadridgeProposalSetFetchLatestCreateResponses = {
  200: FetchLatestBroadridgeProposalSetResponse
}

export type ProxyIntermediaryProposalsBroadridgeProposalSetFetchLatestCreateResponse =
  ProxyIntermediaryProposalsBroadridgeProposalSetFetchLatestCreateResponses[keyof ProxyIntermediaryProposalsBroadridgeProposalSetFetchLatestCreateResponses]

export type ProxyIntermediaryProposalsCreateCreateData = {
  body: CreateProposalsRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proposals/create/'
}

export type ProxyIntermediaryProposalsCreateCreateResponses = {
  201: CreateProposalsResponse
}

export type ProxyIntermediaryProposalsCreateCreateResponse =
  ProxyIntermediaryProposalsCreateCreateResponses[keyof ProxyIntermediaryProposalsCreateCreateResponses]

export type ProxyIntermediaryProposalsDeleteCreateData = {
  body: DeleteProposalSetRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proposals/delete/'
}

export type ProxyIntermediaryProposalsDeleteCreateResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyIntermediaryProposalsDeleteCreateResponse =
  ProxyIntermediaryProposalsDeleteCreateResponses[keyof ProxyIntermediaryProposalsDeleteCreateResponses]

export type ProxyIntermediaryProposalsProxymityProposalSetFetchLatestCreateData = {
  body: FetchLatestProxymityProposalSetRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proposals/proxymity-proposal-set/fetch-latest/'
}

export type ProxyIntermediaryProposalsProxymityProposalSetFetchLatestCreateResponses = {
  200: FetchLatestProxymityProposalSetResponse
}

export type ProxyIntermediaryProposalsProxymityProposalSetFetchLatestCreateResponse =
  ProxyIntermediaryProposalsProxymityProposalSetFetchLatestCreateResponses[keyof ProxyIntermediaryProposalsProxymityProposalSetFetchLatestCreateResponses]

export type ProxyIntermediaryProposalsSearchCreateData = {
  body?: SearchProposalRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxy-intermediary/proposals/search/'
}

export type ProxyIntermediaryProposalsSearchCreateResponses = {
  200: PaginatedProxyIntermediaryProposalList
}

export type ProxyIntermediaryProposalsSearchCreateResponse =
  ProxyIntermediaryProposalsSearchCreateResponses[keyof ProxyIntermediaryProposalsSearchCreateResponses]

export type ProxyIntermediaryProxyIntermediariesSearchCreateData = {
  body?: ProxyIntermediarySearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxy-intermediary/proxy-intermediaries/search/'
}

export type ProxyIntermediaryProxyIntermediariesSearchCreateResponses = {
  200: PaginatedProxyIntermediaryList
}

export type ProxyIntermediaryProxyIntermediariesSearchCreateResponse =
  ProxyIntermediaryProxyIntermediariesSearchCreateResponses[keyof ProxyIntermediaryProxyIntermediariesSearchCreateResponses]

export type ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateData = {
  body?: ProxyIntermediaryMeetingAuditEventSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxy-intermediary/proxy-intermediary-meetings/audit-events/search/'
}

export type ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponses = {
  200: PaginatedProxyIntermediaryMeetingAuditEventList
}

export type ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponse =
  ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponses[keyof ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponses]

export type ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateData = {
  body: ProxyIntermediaryMeetingBatchCancelRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proxy-intermediary-meetings/cancel/'
}

export type ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponses = {
  200: ProxyIntermediaryMeetingBatchCancelResponse
}

export type ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponse =
  ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponses[keyof ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponses]

export type ProxyIntermediaryProxyIntermediaryMeetingsHardDeleteCreateData = {
  body: ProxyIntermediaryMeetingHardDeleteRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proxy-intermediary-meetings/hard-delete/'
}

export type ProxyIntermediaryProxyIntermediaryMeetingsHardDeleteCreateResponses = {
  200: ProxyIntermediaryMeetingHardDeleteResponse
}

export type ProxyIntermediaryProxyIntermediaryMeetingsHardDeleteCreateResponse =
  ProxyIntermediaryProxyIntermediaryMeetingsHardDeleteCreateResponses[keyof ProxyIntermediaryProxyIntermediaryMeetingsHardDeleteCreateResponses]

export type ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateData = {
  body: ProxyIntermediaryMeetingLinkRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proxy-intermediary-meetings/link-transparency-general-meeting/'
}

export type ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponses = {
  200: ProxyIntermediaryMeetingResponse
}

export type ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponse =
  ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponses[keyof ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponses]

export type ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateData = {
  body?: ProxyIntermediaryMeetingSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxy-intermediary/proxy-intermediary-meetings/search/'
}

export type ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponses = {
  200: PaginatedProxyIntermediaryMeetingList
}

export type ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponse =
  ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponses[keyof ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponses]

export type ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateData = {
  body: ProxyIntermediaryMeetingUnlinkRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proxy-intermediary-meetings/unlink-transparency-general-meeting/'
}

export type ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponses = {
  200: ProxyIntermediaryMeetingResponse
}

export type ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponse =
  ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponses[keyof ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponses]

export type ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateData = {
  body: ProxyIntermediaryMeetingUpsertRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proxy-intermediary-meetings/upsert/'
}

export type ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponses = {
  200: ProxyIntermediaryMeetingUpsertResponse
}

export type ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponse =
  ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponses[keyof ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponses]

export type ProxyIntermediaryProxyedgeVotesCreateCreateData = {
  body: ProxyEdgeVoteCreateRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proxyedge-votes/create/'
}

export type ProxyIntermediaryProxyedgeVotesCreateCreateResponses = {
  201: ProxyEdgeVoteResponse
}

export type ProxyIntermediaryProxyedgeVotesCreateCreateResponse =
  ProxyIntermediaryProxyedgeVotesCreateCreateResponses[keyof ProxyIntermediaryProxyedgeVotesCreateCreateResponses]

export type ProxyIntermediaryProxyedgeVotesFetchLatestCreateData = {
  body: ProxyEdgeVoteFetchLatestRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proxyedge-votes/fetch-latest/'
}

export type ProxyIntermediaryProxyedgeVotesFetchLatestCreateResponses = {
  200: ProxyEdgeVoteResponse
}

export type ProxyIntermediaryProxyedgeVotesFetchLatestCreateResponse =
  ProxyIntermediaryProxyedgeVotesFetchLatestCreateResponses[keyof ProxyIntermediaryProxyedgeVotesFetchLatestCreateResponses]

export type ProxyIntermediaryProxymityVotesCreateCreateData = {
  body: ProxymityVoteCreateRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proxymity-votes/create/'
}

export type ProxyIntermediaryProxymityVotesCreateCreateResponses = {
  201: ProxymityVoteResponse
}

export type ProxyIntermediaryProxymityVotesCreateCreateResponse =
  ProxyIntermediaryProxymityVotesCreateCreateResponses[keyof ProxyIntermediaryProxymityVotesCreateCreateResponses]

export type ProxyIntermediaryProxymityVotesFetchLatestCreateData = {
  body: ProxymityVoteFetchLatestRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proxymity-votes/fetch-latest/'
}

export type ProxyIntermediaryProxymityVotesFetchLatestCreateResponses = {
  200: ProxymityVoteResponse
}

export type ProxyIntermediaryProxymityVotesFetchLatestCreateResponse =
  ProxyIntermediaryProxymityVotesFetchLatestCreateResponses[keyof ProxyIntermediaryProxymityVotesFetchLatestCreateResponses]

export type ProxyIntermediaryVoteStatusesDeleteCreateData = {
  body: VoteStatusDeleteRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/vote-statuses/delete/'
}

export type ProxyIntermediaryVoteStatusesDeleteCreateResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyIntermediaryVoteStatusesDeleteCreateResponse =
  ProxyIntermediaryVoteStatusesDeleteCreateResponses[keyof ProxyIntermediaryVoteStatusesDeleteCreateResponses]

export type ProxyIntermediaryVoteStatusesUpsertCreateData = {
  body: VoteStatusUpsertRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/vote-statuses/upsert/'
}

export type ProxyIntermediaryVoteStatusesUpsertCreateResponses = {
  200: VoteStatusUpsertResponse
}

export type ProxyIntermediaryVoteStatusesUpsertCreateResponse =
  ProxyIntermediaryVoteStatusesUpsertCreateResponses[keyof ProxyIntermediaryVoteStatusesUpsertCreateResponses]

export type ProxyvotingEntitlementsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Include invalidated entitlements (default: false, only returns active entitlements).
     */
    include_invalid?: boolean
    /**
     * Filter by investor account UUID - exact match.
     */
    investor_account_id?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Filter by proxy intermediary ballot UUID - exact match.
     */
    proxy_intermediary_ballot_id?: string
  }
  url: '/proxyvoting/entitlements'
}

export type ProxyvotingEntitlementsListResponses = {
  200: PaginatedBallotEntitlementList
}

export type ProxyvotingEntitlementsListResponse =
  ProxyvotingEntitlementsListResponses[keyof ProxyvotingEntitlementsListResponses]

export type ProxyvotingEntitlementsBreakdownCreateData = {
  body: ComputeBreakdownRequestRequest
  path?: never
  query?: never
  url: '/proxyvoting/entitlements/breakdown'
}

export type ProxyvotingEntitlementsBreakdownCreateResponses = {
  200: BreakdownResponse
}

export type ProxyvotingEntitlementsBreakdownCreateResponse =
  ProxyvotingEntitlementsBreakdownCreateResponses[keyof ProxyvotingEntitlementsBreakdownCreateResponses]

export type ProxyvotingEntitlementsComputeCreateData = {
  body: TriggerComputeEntitlementsRequest
  path?: never
  query?: never
  url: '/proxyvoting/entitlements:compute'
}

export type ProxyvotingEntitlementsComputeCreateResponses = {
  202: TaskTriggered
}

export type ProxyvotingEntitlementsComputeCreateResponse =
  ProxyvotingEntitlementsComputeCreateResponses[keyof ProxyvotingEntitlementsComputeCreateResponses]

export type ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateData = {
  body: FundManagerSupportedIssuedInstrumentsQueryRequest
  path?: never
  query?: never
  url: '/proxyvoting/fund-manager/compositions/sii/from-composition-difference'
}

export type ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateResponses = {
  /**
   * No response body
   */
  200: unknown
}

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateData = {
  body: FundManagerPolicySiiBatchCreateRequest
  path?: never
  query?: never
  url: '/proxyvoting/fund-manager/policy-supported-issued-instruments'
}

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses = {
  200: FundManagerPolicySiiResponse
}

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponse =
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses[keyof ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses]

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateData = {
  body: FundManagerPolicySiiBatchDeleteRequest
  path?: never
  query?: never
  url: '/proxyvoting/fund-manager/policy-supported-issued-instruments/batch-delete'
}

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponse =
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses[keyof ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses]

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateData = {
  body?: FundManagerPolicySiiSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxyvoting/fund-manager/policy-supported-issued-instruments/search'
}

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponses = {
  200: PaginatedFundManagerPolicySiiList
}

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponse =
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponses[keyof ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponses]

export type ProxyvotingFundManagerSupportedPoliciesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Return the state of policies as they were at this datetime (ISO 8601). Returns historical records.
     */
    as_of?: Date
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Filter by FundManager UUID - exact match.
     */
    fund_manager_id?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    voting_policy_id?: Array<string>
  }
  url: '/proxyvoting/fund-manager/supported-policies'
}

export type ProxyvotingFundManagerSupportedPoliciesListResponses = {
  200: PaginatedFundManagerSupportedVotingPolicyHistoricalList
}

export type ProxyvotingFundManagerSupportedPoliciesListResponse =
  ProxyvotingFundManagerSupportedPoliciesListResponses[keyof ProxyvotingFundManagerSupportedPoliciesListResponses]

export type ProxyvotingFundManagerSupportedPoliciesCreateData = {
  body: FundManagerSupportedVotingPolicyBatchUpsertRequest
  path?: never
  query?: never
  url: '/proxyvoting/fund-manager/supported-policies'
}

export type ProxyvotingFundManagerSupportedPoliciesCreateResponses = {
  200: FundManagerSupportedVotingPolicyBatchUpsertResponse
}

export type ProxyvotingFundManagerSupportedPoliciesCreateResponse =
  ProxyvotingFundManagerSupportedPoliciesCreateResponses[keyof ProxyvotingFundManagerSupportedPoliciesCreateResponses]

export type ProxyvotingFundManagerSupportedPoliciesDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/proxyvoting/fund-manager/supported-policies/{id}'
}

export type ProxyvotingFundManagerSupportedPoliciesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyvotingFundManagerSupportedPoliciesDestroyResponse =
  ProxyvotingFundManagerSupportedPoliciesDestroyResponses[keyof ProxyvotingFundManagerSupportedPoliciesDestroyResponses]

export type ProxyvotingInvestorCompositionsDifferenceListData = {
  body?: never
  path?: never
  query: {
    /**
     * latest composition date time
     */
    end_time: string
    /**
     * Investors to fetch compositions for
     */
    investor_names: Array<string>
    /**
     * original composition date time
     */
    start_time: string
  }
  url: '/proxyvoting/investor/compositions/difference'
}

export type ProxyvotingInvestorCompositionsDifferenceListResponses = {
  200: Array<CompositionDifferenceResponse>
}

export type ProxyvotingInvestorCompositionsDifferenceListResponse =
  ProxyvotingInvestorCompositionsDifferenceListResponses[keyof ProxyvotingInvestorCompositionsDifferenceListResponses]

export type ProxyvotingInvestorCompositionsRenderCreateData = {
  body: RenderCompositionDifferenceRequest
  path?: never
  query?: never
  url: '/proxyvoting/investor/compositions/render'
}

export type ProxyvotingInvestorCompositionsRenderCreateResponses = {
  200: Blob | File
}

export type ProxyvotingInvestorCompositionsRenderCreateResponse =
  ProxyvotingInvestorCompositionsRenderCreateResponses[keyof ProxyvotingInvestorCompositionsRenderCreateResponses]

export type ProxyvotingInvestorCompositionsRulesEngineRetrieveData = {
  body?: never
  path?: never
  query: {
    /**
     * Investor resource name in format habitats/{habitat_id}/investors/{investor_id}
     */
    investor_name: string
  }
  url: '/proxyvoting/investor/compositions/rules-engine'
}

export type ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses = {
  200: InvestorRulesEngine
}

export type ProxyvotingInvestorCompositionsRulesEngineRetrieveResponse =
  ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses[keyof ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses]

export type ProxyvotingInvestorCompositionsRulesEngineUpdateData = {
  body: InvestorRulesEngineRequest
  path?: never
  query?: never
  url: '/proxyvoting/investor/compositions/rules-engine'
}

export type ProxyvotingInvestorCompositionsRulesEngineUpdateResponses = {
  200: InvestorRulesEngine
  201: InvestorRulesEngine
}

export type ProxyvotingInvestorCompositionsRulesEngineUpdateResponse =
  ProxyvotingInvestorCompositionsRulesEngineUpdateResponses[keyof ProxyvotingInvestorCompositionsRulesEngineUpdateResponses]

export type ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateData = {
  body: SupportedIssuedInstrumentsQueryRequest
  path?: never
  query?: never
  url: '/proxyvoting/investor/compositions/sii/from-composition-difference'
}

export type ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateResponses = {
  /**
   * No response body
   */
  200: unknown
}

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateData = {
  body: InvestorPolicySiiBatchCreateRequest
  path?: never
  query?: never
  url: '/proxyvoting/investor/policy-supported-issued-instruments'
}

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses = {
  200: InvestorPolicySiiResponse
}

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponse =
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses[keyof ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses]

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateData = {
  body: InvestorPolicySiiBatchDeleteRequest
  path?: never
  query?: never
  url: '/proxyvoting/investor/policy-supported-issued-instruments/batch-delete'
}

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponse =
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses[keyof ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses]

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateData = {
  body?: InvestorPolicySiiSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxyvoting/investor/policy-supported-issued-instruments/search'
}

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponses = {
  200: PaginatedInvestorPolicySiiList
}

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponse =
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponses[keyof ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponses]

export type ProxyvotingInvestorSupportedIssuedInstrumentsCreateData = {
  body: InvestorSiiBatchCreateRequest
  path?: never
  query?: never
  url: '/proxyvoting/investor/supported-issued-instruments'
}

export type ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses = {
  200: InvestorSiiResponse
}

export type ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponse =
  ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses[keyof ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses]

export type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateData = {
  body: InvestorSiiBatchDeleteRequest
  path?: never
  query?: never
  url: '/proxyvoting/investor/supported-issued-instruments/batch-delete'
}

export type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponse =
  ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses[keyof ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses]

export type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateData = {
  body?: InvestorSiiSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxyvoting/investor/supported-issued-instruments/search'
}

export type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses = {
  200: PaginatedInvestorSupportedIssuedInstrumentList
}

export type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponse =
  ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses[keyof ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses]

export type ProxyvotingMeetingBallotSourcesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Include invalidated sources (default: false, only returns active sources).
     */
    include_invalid?: boolean
    /**
     * Filter by meeting ballot id.
     */
    meeting_ballot_id?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Filter by proxy intermediary ballot id.
     */
    proxy_intermediary_ballot_id?: string
  }
  url: '/proxyvoting/meeting-ballot-sources'
}

export type ProxyvotingMeetingBallotSourcesListResponses = {
  200: PaginatedMeetingBallotSourceList
}

export type ProxyvotingMeetingBallotSourcesListResponse =
  ProxyvotingMeetingBallotSourcesListResponses[keyof ProxyvotingMeetingBallotSourcesListResponses]

export type ProxyvotingMeetingBallotsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Filter by general meeting id.
     */
    general_meeting_id?: string
    /**
     * Filter by investor id.
     */
    investor_id?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxyvoting/meeting-ballots'
}

export type ProxyvotingMeetingBallotsListResponses = {
  200: PaginatedMeetingBallotList
}

export type ProxyvotingMeetingBallotsListResponse =
  ProxyvotingMeetingBallotsListResponses[keyof ProxyvotingMeetingBallotsListResponses]

export type ProxyvotingMeetingballotsComputeCreateData = {
  body: TriggerProcessMeetingBallotsRequest
  path?: never
  query?: never
  url: '/proxyvoting/meetingballots:compute'
}

export type ProxyvotingMeetingballotsComputeCreateResponses = {
  202: TaskTriggered
}

export type ProxyvotingMeetingballotsComputeCreateResponse =
  ProxyvotingMeetingballotsComputeCreateResponses[keyof ProxyvotingMeetingballotsComputeCreateResponses]

export type ProxyvotingPiballotsFilterListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter ballots by workflow checker email - exact string match.
     */
    checker?: string
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Custodian account identifier - exact string match.
     */
    custodian_account_number?: string
    /**
     * External ballot identifier - exact string match.
     */
    external_id?: string
    /**
     * Filter ballots by fund manager title - case-insensitive substring match.
     */
    fund_manager_title?: string
    /**
     * Filter ballots by fund title - case-insensitive substring match.
     */
    fund_title?: string
    /**
     * Filter ballots by whether they have a workflow checker email assigned. True for ballots with checker, False for ballots without checker, omit for all.
     */
    has_checker?: boolean
    /**
     * Filter ballots by whether they have a workflow submitter email assigned. True for ballots with submitter, False for ballots without submitter, omit for all.
     */
    has_submitter?: boolean
    /**
     * Filter ballots by scope. True for in-scope (any policy support field is true), False for out-of-scope (all policy support fields are false), omit for all.
     */
    in_scope?: boolean
    /**
     * ISIN (International Securities Identification Number) - exact match filter. Must be 12-character alphanumeric code.
     */
    isin?: string
    /**
     * Filter ballots by whether they are linked to a general meeting. True for linked, False for unlinked, omit for all.
     */
    linked?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * Filter ballots by organization title - case-insensitive substring match.
     */
    organization_title?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Filter ballots by whether the 'proxy_intermediary_id' and 'proxy_intermediary_meeting_id' match the provided meeting name.
     * Expected format:'proxyIntermediaries/{proxy_intermediary_id}/meetings/{proxy_intermediary_meeting_id}'
     */
    pi_meeting_name?: string
    /**
     * Proxy intermediary(s) managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
     *
     * * `Proxymity` - Proxymity
     * * `ProxyEdge` - ProxyEdge
     * * `ProxyExchange` - ProxyExchange
     */
    proxy_intermediaries?: Array<'ProxyEdge' | 'ProxyExchange' | 'Proxymity'>
    /**
     * Filter ballots by proxy intermediary title - exact string match.
     */
    proxy_intermediary?: string
    /**
     * General search across organization title, ballot external ID, and ISIN - case-insensitive substring match.
     */
    search?: string
    /**
     * Filter ballots by whether split vote checking is required. True for required, False for not required, omit for all.
     */
    split_vote_check_required?: boolean
    /**
     * Filter ballots by workflow status. Multiple values can be selected to match any of the specified statuses.
     *
     * * `invalid` - Invalid
     * * `not_submitted_in_testing` - Not Submitted in Testing
     * * `not_submitted_unvoted` - Not Submitted Unvoted
     * * `not_submitted_no_entitlements` - Not Submitted No Entitlements
     * * `not_submitted_undefined` - Not Submitted Undefined
     * * `needs_attention` - Needs Attention
     * * `ineligible` - Ineligible
     * * `cancelled` - Cancelled
     * * `meeting_needs_refining` - Meeting Needs Refining
     * * `meeting_voting_enabled` - Meeting Voting Enabled
     * * `entitled_to_vote` - Entitled to Vote
     * * `ready_for_split_vote` - Ready for Split Vote
     * * `late_vote_process` - Late Vote Process
     * * `split_vote_awaiting_check` - Split Vote Awaiting Check
     * * `split_vote_submitted` - Split Vote Submitted
     * * `successful` - Successful
     * * `rejected` - Rejected
     * * `overridden` - Overridden
     * * `in_testing` - In Testing
     */
    status?: Array<
      | 'cancelled'
      | 'entitled_to_vote'
      | 'in_testing'
      | 'ineligible'
      | 'invalid'
      | 'late_vote_process'
      | 'meeting_needs_refining'
      | 'meeting_voting_enabled'
      | 'needs_attention'
      | 'not_submitted_in_testing'
      | 'not_submitted_no_entitlements'
      | 'not_submitted_undefined'
      | 'not_submitted_unvoted'
      | 'overridden'
      | 'ready_for_split_vote'
      | 'rejected'
      | 'split_vote_awaiting_check'
      | 'split_vote_submitted'
      | 'successful'
    >
    /**
     * Filter ballots by workflow submitter email - exact string match.
     */
    submitter?: string
    /**
     * Filter ballots with vote deadline after or equal to this UTC datetime.
     */
    vote_deadline_after?: Date
    /**
     * Filter ballots with vote deadline before or equal to this UTC datetime.
     */
    vote_deadline_before?: Date
  }
  url: '/proxyvoting/piballots/filter'
}

export type ProxyvotingPiballotsFilterListResponses = {
  200: PaginatedPiBallotSearchList
}

export type ProxyvotingPiballotsFilterListResponse =
  ProxyvotingPiballotsFilterListResponses[keyof ProxyvotingPiballotsFilterListResponses]

export type ProxyvotingPiballotsInvestorsCanVoteCreateData = {
  body: InvestorsCanVoteRequest
  path?: never
  query?: never
  url: '/proxyvoting/piballots/investors-can-vote'
}

export type ProxyvotingPiballotsInvestorsCanVoteCreateResponses = {
  200: InvestorsCanVoteResponse
}

export type ProxyvotingPiballotsInvestorsCanVoteCreateResponse =
  ProxyvotingPiballotsInvestorsCanVoteCreateResponses[keyof ProxyvotingPiballotsInvestorsCanVoteCreateResponses]

export type ProxyvotingPimeetingsFilterListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter meetings by assigned checker user email address - exact match.
     */
    assigned_checker_user_id?: string
    /**
     * Filter meetings by assigned refiner user email address - exact match.
     */
    assigned_refiner_user_id?: string
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Filter meetings with earliest ballot submission deadline is after or equal to this UTC datetime,
     */
    earliest_ballot_submission_deadline_after?: Date
    /**
     * Filter meetings with earliest ballot submission before or equal to this UTC datetime.
     */
    earliest_ballot_submission_deadline_before?: Date
    /**
     * Filter meetings by ballot presence. True for meetings with ballots, False for meetings without ballots, omit for all.
     */
    has_ballots?: boolean
    /**
     * Filter meetings by checker presence. True for meetings with checker, False for meetings without checker, omit for all.
     */
    has_checker?: boolean
    /**
     * Filter meetings by refiner presence. True for meetings with refiner, False for meetings without refiner, omit for all.
     */
    has_refiner?: boolean
    /**
     * Filter meetings by scope. True for in-scope (any policy support field is true), False for out-of-scope (all policy support fields are false), omit for all.
     */
    in_scope?: boolean
    /**
     * Filter meetings by whether they are linked to Tumelo meetings. True for linked, False for unlinked, omit for all.
     */
    linked_to_tumelo_meeting?: boolean
    /**
     * Filter meetings created after or equal to this UTC datetime.
     */
    meeting_create_time_after?: Date
    /**
     * Filter meetings created before or equal to this UTC datetime.
     */
    meeting_create_time_before?: Date
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Proxy intermediary(s) managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
     *
     * * `Proxymity` - Proxymity
     * * `ProxyEdge` - ProxyEdge
     * * `ProxyExchange` - ProxyExchange
     */
    proxy_intermediaries?: Array<'ProxyEdge' | 'ProxyExchange' | 'Proxymity'>
    /**
     * Proxy intermediary managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
     *
     * * `Proxymity` - Proxymity
     * * `ProxyEdge` - ProxyEdge
     * * `ProxyExchange` - ProxyExchange
     */
    proxy_intermediary?: 'ProxyEdge' | 'ProxyExchange' | 'Proxymity'
    /**
     * General search across meeting external ID, organization title, and security IDs - case-insensitive substring match. Maximum 255 characters.
     */
    search?: string
    /**
     * Filter meetings by workflow status. Multiple values can be selected to match any of the specified statuses.
     *
     * * `invalid` - Invalid
     * * `new` - New
     * * `unlinked` - Unlinked
     * * `unsupported` - Unsupported
     * * `needs_attention` - Needs Attention
     * * `cancelled` - Cancelled
     * * `cancellation_incomplete` - Cancellation Incomplete
     * * `ready_for_refinement` - Ready for Refinement
     * * `refinement_complete` - Refinement Complete
     * * `manual_voting_enabled` - Manual Voting Enabled
     * * `entitled_to_vote` - Entitled to Vote
     * * `ready_for_split_vote` - Ready for Split Vote
     * * `split_vote_submitted` - Split Vote Submitted
     * * `successful` - Successful
     * * `rejected` - Rejected
     * * `overridden` - Overridden
     * * `partial_success` - Partial Success
     */
    status?: Array<
      | 'cancellation_incomplete'
      | 'cancelled'
      | 'entitled_to_vote'
      | 'invalid'
      | 'manual_voting_enabled'
      | 'needs_attention'
      | 'new'
      | 'overridden'
      | 'partial_success'
      | 'ready_for_refinement'
      | 'ready_for_split_vote'
      | 'refinement_complete'
      | 'rejected'
      | 'split_vote_submitted'
      | 'successful'
      | 'unlinked'
      | 'unsupported'
    >
    /**
     * Filter meetings with submission deadline after or equal to this UTC datetime, where the latest valid_to SII date is before this datetime, with an 8 month buffer.
     */
    submission_deadline_after?: Date
    /**
     * Filter meetings with submission deadline before or equal to this UTC datetime.
     */
    submission_deadline_before?: Date
  }
  url: '/proxyvoting/pimeetings/filter'
}

export type ProxyvotingPimeetingsFilterListResponses = {
  200: PaginatedPiMeetingSearchList
}

export type ProxyvotingPimeetingsFilterListResponse =
  ProxyvotingPimeetingsFilterListResponses[keyof ProxyvotingPimeetingsFilterListResponses]

export type ProxyvotingRulesEngineDefinitionsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Filter by engine name (exact match)
     */
    name?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxyvoting/rules-engine-definitions'
}

export type ProxyvotingRulesEngineDefinitionsListResponses = {
  200: PaginatedRulesEngineDefinitionList
}

export type ProxyvotingRulesEngineDefinitionsListResponse =
  ProxyvotingRulesEngineDefinitionsListResponses[keyof ProxyvotingRulesEngineDefinitionsListResponses]

export type ProxyvotingRulesEngineDefinitionsCreateData = {
  body: RulesEngineDefinitionCreateRequest
  path?: never
  query?: never
  url: '/proxyvoting/rules-engine-definitions'
}

export type ProxyvotingRulesEngineDefinitionsCreateResponses = {
  201: RulesEngineDefinition
}

export type ProxyvotingRulesEngineDefinitionsCreateResponse =
  ProxyvotingRulesEngineDefinitionsCreateResponses[keyof ProxyvotingRulesEngineDefinitionsCreateResponses]

export type ProxyvotingRulesEngineDefinitionsRulesListData = {
  body?: never
  path: {
    definition_id: string
  }
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules'
}

export type ProxyvotingRulesEngineDefinitionsRulesListResponses = {
  200: PaginatedRulesEngineRuleList
}

export type ProxyvotingRulesEngineDefinitionsRulesListResponse =
  ProxyvotingRulesEngineDefinitionsRulesListResponses[keyof ProxyvotingRulesEngineDefinitionsRulesListResponses]

export type ProxyvotingRulesEngineDefinitionsRulesCreateData = {
  body: RulesEngineRuleWriteRequest
  path: {
    definition_id: string
  }
  query?: never
  url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules'
}

export type ProxyvotingRulesEngineDefinitionsRulesCreateResponses = {
  201: RulesEngineRule
}

export type ProxyvotingRulesEngineDefinitionsRulesCreateResponse =
  ProxyvotingRulesEngineDefinitionsRulesCreateResponses[keyof ProxyvotingRulesEngineDefinitionsRulesCreateResponses]

export type ProxyvotingRulesEngineDefinitionsRulesDestroyData = {
  body?: never
  path: {
    definition_id: string
    id: string
  }
  query?: never
  url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules/{id}'
}

export type ProxyvotingRulesEngineDefinitionsRulesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyvotingRulesEngineDefinitionsRulesDestroyResponse =
  ProxyvotingRulesEngineDefinitionsRulesDestroyResponses[keyof ProxyvotingRulesEngineDefinitionsRulesDestroyResponses]

export type ProxyvotingRulesEngineDefinitionsRulesUpdateData = {
  body: RulesEngineRuleWriteRequest
  path: {
    definition_id: string
    id: string
  }
  query?: never
  url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules/{id}'
}

export type ProxyvotingRulesEngineDefinitionsRulesUpdateResponses = {
  200: RulesEngineRule
}

export type ProxyvotingRulesEngineDefinitionsRulesUpdateResponse =
  ProxyvotingRulesEngineDefinitionsRulesUpdateResponses[keyof ProxyvotingRulesEngineDefinitionsRulesUpdateResponses]

export type ProxyvotingRulesEngineDefinitionsDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/proxyvoting/rules-engine-definitions/{id}'
}

export type ProxyvotingRulesEngineDefinitionsDestroyErrors = {
  /**
   * No response body
   */
  404: unknown
  /**
   * No response body
   */
  409: unknown
}

export type ProxyvotingRulesEngineDefinitionsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyvotingRulesEngineDefinitionsDestroyResponse =
  ProxyvotingRulesEngineDefinitionsDestroyResponses[keyof ProxyvotingRulesEngineDefinitionsDestroyResponses]

export type ProxyvotingRulesEngineDefinitionsRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/proxyvoting/rules-engine-definitions/{id}'
}

export type ProxyvotingRulesEngineDefinitionsRetrieveResponses = {
  200: RulesEngineDefinition
}

export type ProxyvotingRulesEngineDefinitionsRetrieveResponse =
  ProxyvotingRulesEngineDefinitionsRetrieveResponses[keyof ProxyvotingRulesEngineDefinitionsRetrieveResponses]

export type ProxyvotingRulesEngineDefinitionsByNameDestroyData = {
  body?: never
  path: {
    name: string
  }
  query?: never
  url: '/proxyvoting/rules-engine-definitions/by-name/{name}'
}

export type ProxyvotingRulesEngineDefinitionsByNameDestroyErrors = {
  /**
   * No response body
   */
  404: unknown
  /**
   * No response body
   */
  409: unknown
}

export type ProxyvotingRulesEngineDefinitionsByNameDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyvotingRulesEngineDefinitionsByNameDestroyResponse =
  ProxyvotingRulesEngineDefinitionsByNameDestroyResponses[keyof ProxyvotingRulesEngineDefinitionsByNameDestroyResponses]

export type ProxyvotingRulesEngineDefinitionsNamesRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/proxyvoting/rules-engine-definitions/names'
}

export type ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses = {
  200: RulesEngineNamesResponse
}

export type ProxyvotingRulesEngineDefinitionsNamesRetrieveResponse =
  ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses[keyof ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses]

export type ProxyvotingSviProposalOverwriteCreateData = {
  body: SplitVoteInstructionProposalOverwriteRequest
  path?: never
  query?: never
  url: '/proxyvoting/svi/proposal/overwrite'
}

export type ProxyvotingSviProposalOverwriteCreateResponses = {
  201: SplitVoteInstructionProposalOverwrite
}

export type ProxyvotingSviProposalOverwriteCreateResponse =
  ProxyvotingSviProposalOverwriteCreateResponses[keyof ProxyvotingSviProposalOverwriteCreateResponses]

export type ProxyvotingSviProposalOverwriteReasonsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
  }
  url: '/proxyvoting/svi/proposal/overwrite/reasons'
}

export type ProxyvotingSviProposalOverwriteReasonsListResponses = {
  200: PaginatedSplitVoteInstructionOverwriteReasonList
}

export type ProxyvotingSviProposalOverwriteReasonsListResponse =
  ProxyvotingSviProposalOverwriteReasonsListResponses[keyof ProxyvotingSviProposalOverwriteReasonsListResponses]

export type ProxyvotingSviSubmitVoteCreateData = {
  body: SubmitVoteRequestRequest
  path?: never
  query?: never
  url: '/proxyvoting/svi/submit-vote'
}

export type ProxyvotingSviSubmitVoteCreateResponses = {
  200: SubmitVoteResponse
}

export type ProxyvotingSviSubmitVoteCreateResponse =
  ProxyvotingSviSubmitVoteCreateResponses[keyof ProxyvotingSviSubmitVoteCreateResponses]

export type TenancyPermissionGroupsCreateData = {
  body: PermissionGroupWriteRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: never
  url: '/tenancy/permission-groups/'
}

export type TenancyPermissionGroupsCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * The acting tenant already has a permission group with this name.
   */
  409: unknown
}

export type TenancyPermissionGroupsCreateResponses = {
  201: PermissionGroup
}

export type TenancyPermissionGroupsCreateResponse =
  TenancyPermissionGroupsCreateResponses[keyof TenancyPermissionGroupsCreateResponses]

export type TenancyPermissionGroupsDestroyData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    permission_group_id: string
  }
  query?: never
  url: '/tenancy/permission-groups/{permission_group_id}/'
}

export type TenancyPermissionGroupsDestroyErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Permission group not found for the acting tenant.
   */
  404: unknown
}

export type TenancyPermissionGroupsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type TenancyPermissionGroupsDestroyResponse =
  TenancyPermissionGroupsDestroyResponses[keyof TenancyPermissionGroupsDestroyResponses]

export type TenancyPermissionGroupsUpdateData = {
  body: PermissionGroupWriteRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    permission_group_id: string
  }
  query?: never
  url: '/tenancy/permission-groups/{permission_group_id}/'
}

export type TenancyPermissionGroupsUpdateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Permission group not found for the acting tenant.
   */
  404: unknown
  /**
   * The acting tenant already has a permission group with this name.
   */
  409: unknown
}

export type TenancyPermissionGroupsUpdateResponses = {
  200: PermissionGroup
}

export type TenancyPermissionGroupsUpdateResponse =
  TenancyPermissionGroupsUpdateResponses[keyof TenancyPermissionGroupsUpdateResponses]

export type TenancyRolesCreateData = {
  body: RoleRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: never
  url: '/tenancy/roles/'
}

export type TenancyRolesCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * The acting tenant already has a role with this name.
   */
  409: unknown
}

export type TenancyRolesCreateResponses = {
  201: Role
}

export type TenancyRolesCreateResponse = TenancyRolesCreateResponses[keyof TenancyRolesCreateResponses]

export type TenancyRolesDestroyData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    role_id: string
  }
  query?: never
  url: '/tenancy/roles/{role_id}/'
}

export type TenancyRolesDestroyErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Role not found for the acting tenant.
   */
  404: unknown
}

export type TenancyRolesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type TenancyRolesDestroyResponse = TenancyRolesDestroyResponses[keyof TenancyRolesDestroyResponses]

export type TenancyRolesRetrieveData = {
  body?: never
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    role_id: string
  }
  query?: never
  url: '/tenancy/roles/{role_id}/'
}

export type TenancyRolesRetrieveErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Role not found for the acting tenant.
   */
  404: unknown
}

export type TenancyRolesRetrieveResponses = {
  200: Role
}

export type TenancyRolesRetrieveResponse = TenancyRolesRetrieveResponses[keyof TenancyRolesRetrieveResponses]

export type TenancyRolesPartialUpdateData = {
  body?: PatchedRoleRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    role_id: string
  }
  query?: never
  url: '/tenancy/roles/{role_id}/'
}

export type TenancyRolesPartialUpdateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Role not found for the acting tenant.
   */
  404: unknown
  /**
   * The acting tenant already has a role with this name.
   */
  409: unknown
}

export type TenancyRolesPartialUpdateResponses = {
  200: Role
}

export type TenancyRolesPartialUpdateResponse =
  TenancyRolesPartialUpdateResponses[keyof TenancyRolesPartialUpdateResponses]

export type TenancyRolesUpdateData = {
  body: RoleRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path: {
    role_id: string
  }
  query?: never
  url: '/tenancy/roles/{role_id}/'
}

export type TenancyRolesUpdateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
  /**
   * Role not found for the acting tenant.
   */
  404: unknown
  /**
   * The acting tenant already has a role with this name.
   */
  409: unknown
}

export type TenancyRolesUpdateResponses = {
  200: Role
}

export type TenancyRolesUpdateResponse = TenancyRolesUpdateResponses[keyof TenancyRolesUpdateResponses]

export type TenancyRolesSearchCreateData = {
  body?: RoleSearchRequestRequest
  headers: {
    /**
     * The tenant acting on this request.
     */
    'X-Acting-Tenant': string
  }
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/tenancy/roles/search/'
}

export type TenancyRolesSearchCreateErrors = {
  /**
   * Request body failed validation, or the X-Acting-Tenant header is missing or is not a valid UUID.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type TenancyRolesSearchCreateResponses = {
  200: PaginatedRoleList
}

export type TenancyRolesSearchCreateResponse =
  TenancyRolesSearchCreateResponses[keyof TenancyRolesSearchCreateResponses]

export type TenancyTenantsCreateData = {
  body: TenantWriteRequest
  path?: never
  query?: never
  url: '/tenancy/tenants/'
}

export type TenancyTenantsCreateResponses = {
  201: Tenant
}

export type TenancyTenantsCreateResponse = TenancyTenantsCreateResponses[keyof TenancyTenantsCreateResponses]

export type TenancyTenantsDestroyData = {
  body?: never
  path: {
    tenant_id: string
  }
  query?: never
  url: '/tenancy/tenants/{tenant_id}/'
}

export type TenancyTenantsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type TenancyTenantsDestroyResponse = TenancyTenantsDestroyResponses[keyof TenancyTenantsDestroyResponses]

export type TenancyTenantsRetrieveData = {
  body?: never
  path: {
    tenant_id: string
  }
  query?: never
  url: '/tenancy/tenants/{tenant_id}/'
}

export type TenancyTenantsRetrieveResponses = {
  200: Tenant
}

export type TenancyTenantsRetrieveResponse = TenancyTenantsRetrieveResponses[keyof TenancyTenantsRetrieveResponses]

export type TenancyTenantsUpdateData = {
  body: TenantWriteRequest
  path: {
    tenant_id: string
  }
  query?: never
  url: '/tenancy/tenants/{tenant_id}/'
}

export type TenancyTenantsUpdateResponses = {
  200: Tenant
}

export type TenancyTenantsUpdateResponse = TenancyTenantsUpdateResponses[keyof TenancyTenantsUpdateResponses]

export type TenancyTenantsSearchCreateData = {
  body?: TenantSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/tenancy/tenants/search/'
}

export type TenancyTenantsSearchCreateResponses = {
  200: PaginatedTenantList
}

export type TenancyTenantsSearchCreateResponse =
  TenancyTenantsSearchCreateResponses[keyof TenancyTenantsSearchCreateResponses]

export type TenancyUsersCreateData = {
  body: UserWriteRequest
  path?: never
  query?: never
  url: '/tenancy/users/'
}

export type TenancyUsersCreateResponses = {
  201: User
}

export type TenancyUsersCreateResponse = TenancyUsersCreateResponses[keyof TenancyUsersCreateResponses]

export type TenancyUsersDestroyData = {
  body?: never
  path: {
    user_id: string
  }
  query?: never
  url: '/tenancy/users/{user_id}/'
}

export type TenancyUsersDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type TenancyUsersDestroyResponse = TenancyUsersDestroyResponses[keyof TenancyUsersDestroyResponses]

export type TenancyUsersRetrieveData = {
  body?: never
  path: {
    user_id: string
  }
  query?: never
  url: '/tenancy/users/{user_id}/'
}

export type TenancyUsersRetrieveResponses = {
  200: User
}

export type TenancyUsersRetrieveResponse = TenancyUsersRetrieveResponses[keyof TenancyUsersRetrieveResponses]

export type TenancyUsersUpdateData = {
  body: UserWriteRequest
  path: {
    user_id: string
  }
  query?: never
  url: '/tenancy/users/{user_id}/'
}

export type TenancyUsersUpdateResponses = {
  200: User
}

export type TenancyUsersUpdateResponse = TenancyUsersUpdateResponses[keyof TenancyUsersUpdateResponses]

export type TenancyUsersSearchCreateData = {
  body?: UserSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/tenancy/users/search/'
}

export type TenancyUsersSearchCreateResponses = {
  200: PaginatedUserList
}

export type TenancyUsersSearchCreateResponse =
  TenancyUsersSearchCreateResponses[keyof TenancyUsersSearchCreateResponses]

export type TransparencyAuditEventsSearchCreateData = {
  body?: AuditEventSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/transparency/audit-events/search/'
}

export type TransparencyAuditEventsSearchCreateResponses = {
  200: PaginatedAuditEventList
}

export type TransparencyAuditEventsSearchCreateResponse =
  TransparencyAuditEventsSearchCreateResponses[keyof TransparencyAuditEventsSearchCreateResponses]

export type TransparencyExternalMeetingIdsCreateData = {
  body: ExternalMeetingIdCreateRequest
  path?: never
  query?: never
  url: '/transparency/external-meeting-ids/'
}

export type TransparencyExternalMeetingIdsCreateResponses = {
  201: ExternalMeetingId
}

export type TransparencyExternalMeetingIdsCreateResponse =
  TransparencyExternalMeetingIdsCreateResponses[keyof TransparencyExternalMeetingIdsCreateResponses]

export type TransparencyExternalMeetingIdsDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/transparency/external-meeting-ids/{id}/'
}

export type TransparencyExternalMeetingIdsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type TransparencyExternalMeetingIdsDestroyResponse =
  TransparencyExternalMeetingIdsDestroyResponses[keyof TransparencyExternalMeetingIdsDestroyResponses]

export type TransparencyGeneralMeetingsCreateData = {
  body: GeneralMeetingWriteRequest
  path?: never
  query?: never
  url: '/transparency/general-meetings/'
}

export type TransparencyGeneralMeetingsCreateResponses = {
  201: GeneralMeeting
}

export type TransparencyGeneralMeetingsCreateResponse =
  TransparencyGeneralMeetingsCreateResponses[keyof TransparencyGeneralMeetingsCreateResponses]

export type TransparencyGeneralMeetingsRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/transparency/general-meetings/{id}/'
}

export type TransparencyGeneralMeetingsRetrieveResponses = {
  200: GeneralMeeting
}

export type TransparencyGeneralMeetingsRetrieveResponse =
  TransparencyGeneralMeetingsRetrieveResponses[keyof TransparencyGeneralMeetingsRetrieveResponses]

export type TransparencyGeneralMeetingsPartialUpdateData = {
  body?: PatchedGeneralMeetingWriteRequest
  path: {
    id: string
  }
  query?: never
  url: '/transparency/general-meetings/{id}/'
}

export type TransparencyGeneralMeetingsPartialUpdateResponses = {
  200: GeneralMeeting
}

export type TransparencyGeneralMeetingsPartialUpdateResponse =
  TransparencyGeneralMeetingsPartialUpdateResponses[keyof TransparencyGeneralMeetingsPartialUpdateResponses]

export type TransparencyGeneralMeetingsSearchCreateData = {
  body?: GeneralMeetingSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/transparency/general-meetings/search/'
}

export type TransparencyGeneralMeetingsSearchCreateResponses = {
  200: PaginatedGeneralMeetingList
}

export type TransparencyGeneralMeetingsSearchCreateResponse =
  TransparencyGeneralMeetingsSearchCreateResponses[keyof TransparencyGeneralMeetingsSearchCreateResponses]

export type TransparencyInstrumentsCreateData = {
  body: InstrumentWriteRequest
  path?: never
  query?: never
  url: '/transparency/instruments/'
}

export type TransparencyInstrumentsCreateResponses = {
  201: Instrument
}

export type TransparencyInstrumentsCreateResponse =
  TransparencyInstrumentsCreateResponses[keyof TransparencyInstrumentsCreateResponses]

export type TransparencyInstrumentsDestroyData = {
  body?: never
  path: {
    isin: string
  }
  query?: never
  url: '/transparency/instruments/{isin}/'
}

export type TransparencyInstrumentsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type TransparencyInstrumentsDestroyResponse =
  TransparencyInstrumentsDestroyResponses[keyof TransparencyInstrumentsDestroyResponses]

export type TransparencyInstrumentsRetrieveData = {
  body?: never
  path: {
    isin: string
  }
  query?: never
  url: '/transparency/instruments/{isin}/'
}

export type TransparencyInstrumentsRetrieveResponses = {
  200: Instrument
}

export type TransparencyInstrumentsRetrieveResponse =
  TransparencyInstrumentsRetrieveResponses[keyof TransparencyInstrumentsRetrieveResponses]

export type TransparencyInstrumentsUpdateData = {
  body: InstrumentWriteRequest
  path: {
    isin: string
  }
  query?: never
  url: '/transparency/instruments/{isin}/'
}

export type TransparencyInstrumentsUpdateResponses = {
  200: Instrument
}

export type TransparencyInstrumentsUpdateResponse =
  TransparencyInstrumentsUpdateResponses[keyof TransparencyInstrumentsUpdateResponses]

export type TransparencyInstrumentsFetchMinimalCreateData = {
  body: FetchMinimalInstrumentsRequestRequest
  path?: never
  query?: never
  url: '/transparency/instruments/fetch-minimal/'
}

export type TransparencyInstrumentsFetchMinimalCreateResponses = {
  200: FetchMinimalInstrumentsResponse
}

export type TransparencyInstrumentsFetchMinimalCreateResponse =
  TransparencyInstrumentsFetchMinimalCreateResponses[keyof TransparencyInstrumentsFetchMinimalCreateResponses]

export type TransparencyInstrumentsSearchCreateData = {
  body?: InstrumentSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/transparency/instruments/search/'
}

export type TransparencyInstrumentsSearchCreateResponses = {
  200: PaginatedInstrumentList
}

export type TransparencyInstrumentsSearchCreateResponse =
  TransparencyInstrumentsSearchCreateResponses[keyof TransparencyInstrumentsSearchCreateResponses]

export type TransparencyInstrumentsUnassociatedRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/transparency/instruments/unassociated/'
}

export type TransparencyInstrumentsUnassociatedRetrieveResponses = {
  200: UnassociatedInstrumentsResponse
}

export type TransparencyInstrumentsUnassociatedRetrieveResponse =
  TransparencyInstrumentsUnassociatedRetrieveResponses[keyof TransparencyInstrumentsUnassociatedRetrieveResponses]

export type TransparencyOrganizationsCreateData = {
  body: OrganizationWriteRequest
  path?: never
  query?: never
  url: '/transparency/organizations/'
}

export type TransparencyOrganizationsCreateResponses = {
  201: Organization
}

export type TransparencyOrganizationsCreateResponse =
  TransparencyOrganizationsCreateResponses[keyof TransparencyOrganizationsCreateResponses]

export type TransparencyOrganizationsDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/transparency/organizations/{id}/'
}

export type TransparencyOrganizationsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type TransparencyOrganizationsDestroyResponse =
  TransparencyOrganizationsDestroyResponses[keyof TransparencyOrganizationsDestroyResponses]

export type TransparencyOrganizationsRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/transparency/organizations/{id}/'
}

export type TransparencyOrganizationsRetrieveResponses = {
  200: Organization
}

export type TransparencyOrganizationsRetrieveResponse =
  TransparencyOrganizationsRetrieveResponses[keyof TransparencyOrganizationsRetrieveResponses]

export type TransparencyOrganizationsPartialUpdateData = {
  body?: PatchedOrganizationWriteRequest
  path: {
    id: string
  }
  query?: never
  url: '/transparency/organizations/{id}/'
}

export type TransparencyOrganizationsPartialUpdateResponses = {
  200: Organization
}

export type TransparencyOrganizationsPartialUpdateResponse =
  TransparencyOrganizationsPartialUpdateResponses[keyof TransparencyOrganizationsPartialUpdateResponses]

export type TransparencyOrganizationsUpdateData = {
  body: OrganizationWriteRequest
  path: {
    id: string
  }
  query?: never
  url: '/transparency/organizations/{id}/'
}

export type TransparencyOrganizationsUpdateResponses = {
  200: Organization
}

export type TransparencyOrganizationsUpdateResponse =
  TransparencyOrganizationsUpdateResponses[keyof TransparencyOrganizationsUpdateResponses]

export type TransparencyOrganizationsLogoCreateData = {
  body?: OrganizationLogoUploadRequest
  path: {
    id: string
  }
  query?: never
  url: '/transparency/organizations/{id}/logo/'
}

export type TransparencyOrganizationsLogoCreateResponses = {
  200: Organization
}

export type TransparencyOrganizationsLogoCreateResponse =
  TransparencyOrganizationsLogoCreateResponses[keyof TransparencyOrganizationsLogoCreateResponses]

export type TransparencyOrganizationsGeneralMeetingsProposalsCreateData = {
  body: ProposalWriteRequest
  path: {
    gm_id: string
    org_id: string
  }
  query?: never
  url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/'
}

export type TransparencyOrganizationsGeneralMeetingsProposalsCreateResponses = {
  201: Proposal
}

export type TransparencyOrganizationsGeneralMeetingsProposalsCreateResponse =
  TransparencyOrganizationsGeneralMeetingsProposalsCreateResponses[keyof TransparencyOrganizationsGeneralMeetingsProposalsCreateResponses]

export type TransparencyOrganizationsGeneralMeetingsProposalsRetrieveData = {
  body?: never
  path: {
    gm_id: string
    org_id: string
    proposal_id: string
  }
  query?: never
  url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/'
}

export type TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponses = {
  200: Proposal
}

export type TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponse =
  TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponses[keyof TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponses]

export type TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateData = {
  body?: PatchedProposalPatchRequest
  path: {
    gm_id: string
    org_id: string
    proposal_id: string
  }
  query?: never
  url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/'
}

export type TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponses = {
  200: Proposal
}

export type TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponse =
  TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponses[keyof TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponses]

export type TransparencyOrganizationsGeneralMeetingsProposalsUpdateData = {
  body: ProposalWriteRequest
  path: {
    gm_id: string
    org_id: string
    proposal_id: string
  }
  query?: never
  url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/'
}

export type TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponses = {
  200: Proposal
}

export type TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponse =
  TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponses[keyof TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponses]

export type TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateData = {
  body?: ProposalSearchRequestRequest
  path: {
    gm_id: string
    org_id: string
  }
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/search/'
}

export type TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponses = {
  200: PaginatedProposalList
}

export type TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponse =
  TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponses[keyof TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponses]

export type TransparencyOrganizationsGetByIdentifierCreateData = {
  body: GetOrganizationByIdentifierRequestRequest
  path?: never
  query?: never
  url: '/transparency/organizations/get-by-identifier/'
}

export type TransparencyOrganizationsGetByIdentifierCreateResponses = {
  200: Organization
}

export type TransparencyOrganizationsGetByIdentifierCreateResponse =
  TransparencyOrganizationsGetByIdentifierCreateResponses[keyof TransparencyOrganizationsGetByIdentifierCreateResponses]

export type TransparencyOrganizationsIsinsToNamesCreateData = {
  body: BatchIsinsToOrganizationNamesRequestRequest
  path?: never
  query?: never
  url: '/transparency/organizations/isins-to-names/'
}

export type TransparencyOrganizationsIsinsToNamesCreateResponses = {
  200: BatchIsinsToOrganizationNamesResponse
}

export type TransparencyOrganizationsIsinsToNamesCreateResponse =
  TransparencyOrganizationsIsinsToNamesCreateResponses[keyof TransparencyOrganizationsIsinsToNamesCreateResponses]

export type TransparencyOrganizationsSearchCreateData = {
  body?: OrganizationSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/transparency/organizations/search/'
}

export type TransparencyOrganizationsSearchCreateResponses = {
  200: PaginatedOrganizationList
}

export type TransparencyOrganizationsSearchCreateResponse =
  TransparencyOrganizationsSearchCreateResponses[keyof TransparencyOrganizationsSearchCreateResponses]

export type TransparencyProposalsClassificationCodesRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/transparency/proposals/classification-codes/'
}

export type TransparencyProposalsClassificationCodesRetrieveResponses = {
  200: ProposalClassificationCodesResponse
}

export type TransparencyProposalsClassificationCodesRetrieveResponse =
  TransparencyProposalsClassificationCodesRetrieveResponses[keyof TransparencyProposalsClassificationCodesRetrieveResponses]

export type TransparencyProposalsCountCreateData = {
  body: ProposalCountRequestRequest
  path?: never
  query?: never
  url: '/transparency/proposals/count/'
}

export type TransparencyProposalsCountCreateResponses = {
  200: ProposalCountResponse
}

export type TransparencyProposalsCountCreateResponse =
  TransparencyProposalsCountCreateResponses[keyof TransparencyProposalsCountCreateResponses]

export type TransparencyProposalsFetchCreateData = {
  body: ProposalFetchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/transparency/proposals/fetch/'
}

export type TransparencyProposalsFetchCreateResponses = {
  200: PaginatedProposalList
}

export type TransparencyProposalsFetchCreateResponse =
  TransparencyProposalsFetchCreateResponses[keyof TransparencyProposalsFetchCreateResponses]

export type TransparencyProposalsFetchNamesFromIdsCreateData = {
  body: ProposalFetchNamesFromIdsRequestRequest
  path?: never
  query?: never
  url: '/transparency/proposals/fetch-names-from-ids/'
}

export type TransparencyProposalsFetchNamesFromIdsCreateResponses = {
  200: ProposalFetchNamesFromIdsResponse
}

export type TransparencyProposalsFetchNamesFromIdsCreateResponse =
  TransparencyProposalsFetchNamesFromIdsCreateResponses[keyof TransparencyProposalsFetchNamesFromIdsCreateResponses]

export type TransparencyProposalsSecClassificationCodesRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/transparency/proposals/sec-classification-codes/'
}

export type TransparencyProposalsSecClassificationCodesRetrieveResponses = {
  200: ProposalSecClassificationCodesResponse
}

export type TransparencyProposalsSecClassificationCodesRetrieveResponse =
  TransparencyProposalsSecClassificationCodesRetrieveResponses[keyof TransparencyProposalsSecClassificationCodesRetrieveResponses]

export type TransparencyPublicSecurityIdsSearchCreateData = {
  body?: PublicSecurityIdListQueryRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/transparency/public-security-ids/search/'
}

export type TransparencyPublicSecurityIdsSearchCreateResponses = {
  200: PaginatedPublicSecurityIdList
}

export type TransparencyPublicSecurityIdsSearchCreateResponse =
  TransparencyPublicSecurityIdsSearchCreateResponses[keyof TransparencyPublicSecurityIdsSearchCreateResponses]

export type VotingOperationsPiballotsFilterListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter ballots by workflow checker email - exact string match.
     */
    checker?: string
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Custodian account identifier - exact string match.
     */
    custodian_account_number?: string
    /**
     * External ballot identifier - exact string match.
     */
    external_id?: string
    /**
     * Filter ballots by fund manager title - case-insensitive substring match.
     */
    fund_manager_title?: string
    /**
     * Filter ballots by fund title - case-insensitive substring match.
     */
    fund_title?: string
    /**
     * Filter ballots by whether they have a workflow checker email assigned. True for ballots with checker, False for ballots without checker, omit for all.
     */
    has_checker?: boolean
    /**
     * Filter ballots by whether they have a workflow submitter email assigned. True for ballots with submitter, False for ballots without submitter, omit for all.
     */
    has_submitter?: boolean
    /**
     * Filter ballots by scope. True for in-scope (any policy support field is true), False for out-of-scope (all policy support fields are false), omit for all.
     */
    in_scope?: boolean
    /**
     * ISIN (International Securities Identification Number) - exact match filter. Must be 12-character alphanumeric code.
     */
    isin?: string
    /**
     * Filter ballots by whether they are linked to a general meeting. True for linked, False for unlinked, omit for all.
     */
    linked?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * Filter ballots by organization title - case-insensitive substring match.
     */
    organization_title?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Filter ballots by whether the 'proxy_intermediary_id' and 'proxy_intermediary_meeting_id' match the provided meeting name.
     * Expected format:'proxyIntermediaries/{proxy_intermediary_id}/meetings/{proxy_intermediary_meeting_id}'
     */
    pi_meeting_name?: string
    /**
     * Proxy intermediary(s) managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
     *
     * * `Proxymity` - Proxymity
     * * `ProxyEdge` - ProxyEdge
     * * `ProxyExchange` - ProxyExchange
     */
    proxy_intermediaries?: Array<'ProxyEdge' | 'ProxyExchange' | 'Proxymity'>
    /**
     * Filter ballots by proxy intermediary title - exact string match.
     */
    proxy_intermediary?: string
    /**
     * General search across organization title, ballot external ID, and ISIN - case-insensitive substring match.
     */
    search?: string
    /**
     * Filter ballots by whether split vote checking is required. True for required, False for not required, omit for all.
     */
    split_vote_check_required?: boolean
    /**
     * Filter ballots by workflow status. Multiple values can be selected to match any of the specified statuses.
     *
     * * `invalid` - Invalid
     * * `not_submitted_in_testing` - Not Submitted in Testing
     * * `not_submitted_unvoted` - Not Submitted Unvoted
     * * `not_submitted_no_entitlements` - Not Submitted No Entitlements
     * * `not_submitted_undefined` - Not Submitted Undefined
     * * `needs_attention` - Needs Attention
     * * `ineligible` - Ineligible
     * * `cancelled` - Cancelled
     * * `meeting_needs_refining` - Meeting Needs Refining
     * * `meeting_voting_enabled` - Meeting Voting Enabled
     * * `entitled_to_vote` - Entitled to Vote
     * * `ready_for_split_vote` - Ready for Split Vote
     * * `late_vote_process` - Late Vote Process
     * * `split_vote_awaiting_check` - Split Vote Awaiting Check
     * * `split_vote_submitted` - Split Vote Submitted
     * * `successful` - Successful
     * * `rejected` - Rejected
     * * `overridden` - Overridden
     * * `in_testing` - In Testing
     */
    status?: Array<
      | 'cancelled'
      | 'entitled_to_vote'
      | 'in_testing'
      | 'ineligible'
      | 'invalid'
      | 'late_vote_process'
      | 'meeting_needs_refining'
      | 'meeting_voting_enabled'
      | 'needs_attention'
      | 'not_submitted_in_testing'
      | 'not_submitted_no_entitlements'
      | 'not_submitted_undefined'
      | 'not_submitted_unvoted'
      | 'overridden'
      | 'ready_for_split_vote'
      | 'rejected'
      | 'split_vote_awaiting_check'
      | 'split_vote_submitted'
      | 'successful'
    >
    /**
     * Filter ballots by workflow submitter email - exact string match.
     */
    submitter?: string
    /**
     * Filter ballots with vote deadline after or equal to this UTC datetime.
     */
    vote_deadline_after?: Date
    /**
     * Filter ballots with vote deadline before or equal to this UTC datetime.
     */
    vote_deadline_before?: Date
  }
  url: '/voting-operations/piballots/filter'
}

export type VotingOperationsPiballotsFilterListResponses = {
  200: PaginatedPiBallotSearchList
}

export type VotingOperationsPiballotsFilterListResponse =
  VotingOperationsPiballotsFilterListResponses[keyof VotingOperationsPiballotsFilterListResponses]

export type VotingOperationsPimeetingsFilterListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter meetings by assigned checker user email address - exact match.
     */
    assigned_checker_user_id?: string
    /**
     * Filter meetings by assigned refiner user email address - exact match.
     */
    assigned_refiner_user_id?: string
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Filter meetings with earliest ballot submission deadline is after or equal to this UTC datetime,
     */
    earliest_ballot_submission_deadline_after?: Date
    /**
     * Filter meetings with earliest ballot submission before or equal to this UTC datetime.
     */
    earliest_ballot_submission_deadline_before?: Date
    /**
     * Filter meetings by ballot presence. True for meetings with ballots, False for meetings without ballots, omit for all.
     */
    has_ballots?: boolean
    /**
     * Filter meetings by checker presence. True for meetings with checker, False for meetings without checker, omit for all.
     */
    has_checker?: boolean
    /**
     * Filter meetings by refiner presence. True for meetings with refiner, False for meetings without refiner, omit for all.
     */
    has_refiner?: boolean
    /**
     * Filter meetings by scope. True for in-scope (any policy support field is true), False for out-of-scope (all policy support fields are false), omit for all.
     */
    in_scope?: boolean
    /**
     * Filter meetings by whether they are linked to Tumelo meetings. True for linked, False for unlinked, omit for all.
     */
    linked_to_tumelo_meeting?: boolean
    /**
     * Filter meetings created after or equal to this UTC datetime.
     */
    meeting_create_time_after?: Date
    /**
     * Filter meetings created before or equal to this UTC datetime.
     */
    meeting_create_time_before?: Date
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Proxy intermediary(s) managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
     *
     * * `Proxymity` - Proxymity
     * * `ProxyEdge` - ProxyEdge
     * * `ProxyExchange` - ProxyExchange
     */
    proxy_intermediaries?: Array<'ProxyEdge' | 'ProxyExchange' | 'Proxymity'>
    /**
     * Proxy intermediary managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
     *
     * * `Proxymity` - Proxymity
     * * `ProxyEdge` - ProxyEdge
     * * `ProxyExchange` - ProxyExchange
     */
    proxy_intermediary?: 'ProxyEdge' | 'ProxyExchange' | 'Proxymity'
    /**
     * General search across meeting external ID, organization title, and security IDs - case-insensitive substring match. Maximum 255 characters.
     */
    search?: string
    /**
     * Filter meetings by workflow status. Multiple values can be selected to match any of the specified statuses.
     *
     * * `invalid` - Invalid
     * * `new` - New
     * * `unlinked` - Unlinked
     * * `unsupported` - Unsupported
     * * `needs_attention` - Needs Attention
     * * `cancelled` - Cancelled
     * * `cancellation_incomplete` - Cancellation Incomplete
     * * `ready_for_refinement` - Ready for Refinement
     * * `refinement_complete` - Refinement Complete
     * * `manual_voting_enabled` - Manual Voting Enabled
     * * `entitled_to_vote` - Entitled to Vote
     * * `ready_for_split_vote` - Ready for Split Vote
     * * `split_vote_submitted` - Split Vote Submitted
     * * `successful` - Successful
     * * `rejected` - Rejected
     * * `overridden` - Overridden
     * * `partial_success` - Partial Success
     */
    status?: Array<
      | 'cancellation_incomplete'
      | 'cancelled'
      | 'entitled_to_vote'
      | 'invalid'
      | 'manual_voting_enabled'
      | 'needs_attention'
      | 'new'
      | 'overridden'
      | 'partial_success'
      | 'ready_for_refinement'
      | 'ready_for_split_vote'
      | 'refinement_complete'
      | 'rejected'
      | 'split_vote_submitted'
      | 'successful'
      | 'unlinked'
      | 'unsupported'
    >
    /**
     * Filter meetings with submission deadline after or equal to this UTC datetime, where the latest valid_to SII date is before this datetime, with an 8 month buffer.
     */
    submission_deadline_after?: Date
    /**
     * Filter meetings with submission deadline before or equal to this UTC datetime.
     */
    submission_deadline_before?: Date
  }
  url: '/voting-operations/pimeetings/filter'
}

export type VotingOperationsPimeetingsFilterListResponses = {
  200: PaginatedPiMeetingSearchList
}

export type VotingOperationsPimeetingsFilterListResponse =
  VotingOperationsPimeetingsFilterListResponses[keyof VotingOperationsPimeetingsFilterListResponses]

export type VotingPolicyProposalSetRecommendationCoverageDetailRetrieveData = {
  body?: never
  path?: never
  query: {
    /**
     * The proposal set to return coverage detail for.
     */
    proposal_set_id: string
    /**
     * The voting policy to return coverage detail under.
     */
    voting_policy_id: string
  }
  url: '/voting-policy/proposal-set-recommendation-coverage/detail/'
}

export type VotingPolicyProposalSetRecommendationCoverageDetailRetrieveResponses = {
  200: ProposalSetRecommendationCoverageDetail
}

export type VotingPolicyProposalSetRecommendationCoverageDetailRetrieveResponse =
  VotingPolicyProposalSetRecommendationCoverageDetailRetrieveResponses[keyof VotingPolicyProposalSetRecommendationCoverageDetailRetrieveResponses]

export type VotingPolicyProposalSetRecommendationCoverageSearchCreateData = {
  body?: ProposalSetRecommendationCoverageSearchRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/voting-policy/proposal-set-recommendation-coverage/search/'
}

export type VotingPolicyProposalSetRecommendationCoverageSearchCreateErrors = {
  /**
   * Request body failed validation.
   */
  400: unknown
  /**
   * Caller is not authenticated or lacks the required role.
   */
  403: unknown
}

export type VotingPolicyProposalSetRecommendationCoverageSearchCreateResponses = {
  200: PaginatedProposalSetRecommendationCoverageList
}

export type VotingPolicyProposalSetRecommendationCoverageSearchCreateResponse =
  VotingPolicyProposalSetRecommendationCoverageSearchCreateResponses[keyof VotingPolicyProposalSetRecommendationCoverageSearchCreateResponses]

export type VotingPolicyProviderVotingRecommendationsCreateData = {
  body: ProviderVotingRecommendationCreateRequest
  path?: never
  query?: never
  url: '/voting-policy/provider-voting-recommendations/'
}

export type VotingPolicyProviderVotingRecommendationsCreateResponses = {
  201: ProviderVotingRecommendation
}

export type VotingPolicyProviderVotingRecommendationsCreateResponse =
  VotingPolicyProviderVotingRecommendationsCreateResponses[keyof VotingPolicyProviderVotingRecommendationsCreateResponses]

export type VotingPolicyProviderVotingRecommendationsDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/voting-policy/provider-voting-recommendations/{id}/'
}

export type VotingPolicyProviderVotingRecommendationsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type VotingPolicyProviderVotingRecommendationsDestroyResponse =
  VotingPolicyProviderVotingRecommendationsDestroyResponses[keyof VotingPolicyProviderVotingRecommendationsDestroyResponses]

export type VotingPolicyProviderVotingRecommendationsMatchCreateData = {
  body: MatchVotingRecommendationFromPvrRequest
  path: {
    id: string
  }
  query?: never
  url: '/voting-policy/provider-voting-recommendations/{id}/match/'
}

export type VotingPolicyProviderVotingRecommendationsMatchCreateResponses = {
  201: VotingRecommendation
}

export type VotingPolicyProviderVotingRecommendationsMatchCreateResponse =
  VotingPolicyProviderVotingRecommendationsMatchCreateResponses[keyof VotingPolicyProviderVotingRecommendationsMatchCreateResponses]

export type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveData = {
  body?: never
  path?: never
  query: {
    /**
     * The meeting batch version to fetch. Must be a positive integer.
     */
    meeting_batch_version: number
    /**
     * UUID4 identifying the meeting and policy combination.
     */
    unique_meeting_policy_id: string
  }
  url: '/voting-policy/provider-voting-recommendations/fetch-by-version/'
}

export type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses = {
  200: ProviderVotingRecommendationListResponse
}

export type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponse =
  VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses[keyof VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses]

export type VotingPolicyProviderVotingRecommendationsSearchCreateData = {
  body?: ProviderVotingRecommendationSearchRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/voting-policy/provider-voting-recommendations/search/'
}

export type VotingPolicyProviderVotingRecommendationsSearchCreateResponses = {
  200: PaginatedProviderVotingRecommendationList
}

export type VotingPolicyProviderVotingRecommendationsSearchCreateResponse =
  VotingPolicyProviderVotingRecommendationsSearchCreateResponses[keyof VotingPolicyProviderVotingRecommendationsSearchCreateResponses]

export type VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateData = {
  body: ProxyIntermediaryVotingRecommendationConfidenceScoreUpsertRequest
  path?: never
  query?: never
  url: '/voting-policy/proxy-intermediary-voting-recommendation-confidence-scores/'
}

export type VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponses = {
  200: ProxyIntermediaryVotingRecommendationConfidenceScore
  201: ProxyIntermediaryVotingRecommendationConfidenceScore
}

export type VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponse =
  VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponses[keyof VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponses]

export type VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateData = {
  body: ProxyIntermediaryVotingRecommendationValidationStatusCreateRequest
  path?: never
  query?: never
  url: '/voting-policy/proxy-intermediary-voting-recommendation-validation-statuses/'
}

export type VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponses = {
  201: ProxyIntermediaryVotingRecommendationValidationStatus
}

export type VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponse =
  VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponses[keyof VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponses]

export type VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateData = {
  body?: ProxyIntermediaryVotingRecommendationValidationStatusSearchRequest
  path?: never
  query?: never
  url: '/voting-policy/proxy-intermediary-voting-recommendation-validation-statuses/search/'
}

export type VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponses = {
  200: ProxyIntermediaryVotingRecommendationValidationStatus
}

export type VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponse =
  VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponses[keyof VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponses]

export type VotingPolicyProxyIntermediaryVotingRecommendationsCreateData = {
  body: ProxyIntermediaryVotingRecommendationCreateRequest
  path?: never
  query?: never
  url: '/voting-policy/proxy-intermediary-voting-recommendations/'
}

export type VotingPolicyProxyIntermediaryVotingRecommendationsCreateResponses = {
  201: ProxyIntermediaryVotingRecommendation
}

export type VotingPolicyProxyIntermediaryVotingRecommendationsCreateResponse =
  VotingPolicyProxyIntermediaryVotingRecommendationsCreateResponses[keyof VotingPolicyProxyIntermediaryVotingRecommendationsCreateResponses]

export type VotingPolicyProxyIntermediaryVotingRecommendationsDestroyData = {
  body?: never
  path: {
    identity_id: string
  }
  query?: never
  url: '/voting-policy/proxy-intermediary-voting-recommendations/{identity_id}/'
}

export type VotingPolicyProxyIntermediaryVotingRecommendationsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type VotingPolicyProxyIntermediaryVotingRecommendationsDestroyResponse =
  VotingPolicyProxyIntermediaryVotingRecommendationsDestroyResponses[keyof VotingPolicyProxyIntermediaryVotingRecommendationsDestroyResponses]

export type VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateData = {
  body: MatchProxyIntermediaryVotingRecommendationFromPvrRequest
  path?: never
  query?: never
  url: '/voting-policy/proxy-intermediary-voting-recommendations/match-from-pvr/'
}

export type VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponses = {
  201: ProxyIntermediaryVotingRecommendation
}

export type VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponse =
  VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponses[keyof VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponses]

export type VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateData = {
  body?: ProxyIntermediaryVotingRecommendationSearchRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/voting-policy/proxy-intermediary-voting-recommendations/search/'
}

export type VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponses = {
  200: PaginatedProxyIntermediaryVotingRecommendationList
}

export type VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponse =
  VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponses[keyof VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponses]

export type VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/voting-policy/proxy-intermediary-voting-recommendations/versions/{id}/'
}

export type VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponses = {
  200: ProxyIntermediaryVotingRecommendation
}

export type VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponse =
  VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponses[keyof VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponses]

export type VotingPolicyVotingPoliciesCreateData = {
  body: VotingPolicyCreateRequest
  path?: never
  query?: never
  url: '/voting-policy/voting-policies/'
}

export type VotingPolicyVotingPoliciesCreateResponses = {
  201: VotingPolicy
}

export type VotingPolicyVotingPoliciesCreateResponse =
  VotingPolicyVotingPoliciesCreateResponses[keyof VotingPolicyVotingPoliciesCreateResponses]

export type VotingPolicyVotingPoliciesDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{id}/'
}

export type VotingPolicyVotingPoliciesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type VotingPolicyVotingPoliciesDestroyResponse =
  VotingPolicyVotingPoliciesDestroyResponses[keyof VotingPolicyVotingPoliciesDestroyResponses]

export type VotingPolicyVotingPoliciesRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{id}/'
}

export type VotingPolicyVotingPoliciesRetrieveResponses = {
  200: VotingPolicy
}

export type VotingPolicyVotingPoliciesRetrieveResponse =
  VotingPolicyVotingPoliciesRetrieveResponses[keyof VotingPolicyVotingPoliciesRetrieveResponses]

export type VotingPolicyVotingPoliciesPartialUpdateData = {
  body?: PatchedVotingPolicyUpdateRequest
  path: {
    id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{id}/'
}

export type VotingPolicyVotingPoliciesPartialUpdateResponses = {
  200: VotingPolicy
}

export type VotingPolicyVotingPoliciesPartialUpdateResponse =
  VotingPolicyVotingPoliciesPartialUpdateResponses[keyof VotingPolicyVotingPoliciesPartialUpdateResponses]

export type VotingPolicyVotingPoliciesDocumentsListData = {
  body?: never
  path: {
    voting_policy_id: string
  }
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/voting-policy/voting-policies/{voting_policy_id}/documents/'
}

export type VotingPolicyVotingPoliciesDocumentsListResponses = {
  200: PaginatedVotingPolicyDocumentList
}

export type VotingPolicyVotingPoliciesDocumentsListResponse =
  VotingPolicyVotingPoliciesDocumentsListResponses[keyof VotingPolicyVotingPoliciesDocumentsListResponses]

export type VotingPolicyVotingPoliciesDocumentsCreateData = {
  body?: Blob | File
  path: {
    voting_policy_id: string
  }
  query: {
    /**
     * The document's official publication time.
     */
    issue_time: Date
    /**
     * The document title.
     */
    title: string
  }
  url: '/voting-policy/voting-policies/{voting_policy_id}/documents/'
}

export type VotingPolicyVotingPoliciesDocumentsCreateResponses = {
  201: VotingPolicyDocument
}

export type VotingPolicyVotingPoliciesDocumentsCreateResponse =
  VotingPolicyVotingPoliciesDocumentsCreateResponses[keyof VotingPolicyVotingPoliciesDocumentsCreateResponses]

export type VotingPolicyVotingPoliciesDocumentsRetrieveData = {
  body?: never
  path: {
    id: number
    voting_policy_id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{voting_policy_id}/documents/{id}/'
}

export type VotingPolicyVotingPoliciesDocumentsRetrieveResponses = {
  200: VotingPolicyDocument
}

export type VotingPolicyVotingPoliciesDocumentsRetrieveResponse =
  VotingPolicyVotingPoliciesDocumentsRetrieveResponses[keyof VotingPolicyVotingPoliciesDocumentsRetrieveResponses]

export type VotingPolicyVotingPoliciesDocumentsPartialUpdateData = {
  body?: PatchedVotingPolicyDocumentUpdateRequest
  path: {
    id: number
    voting_policy_id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{voting_policy_id}/documents/{id}/'
}

export type VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses = {
  200: VotingPolicyDocument
}

export type VotingPolicyVotingPoliciesDocumentsPartialUpdateResponse =
  VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses[keyof VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses]

export type VotingPolicyVotingPoliciesVotingRecommendationsCreateData = {
  body: VotingRecommendationCreateRequest
  path: {
    voting_policy_id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/'
}

export type VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses = {
  201: VotingRecommendation
}

export type VotingPolicyVotingPoliciesVotingRecommendationsCreateResponse =
  VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses[keyof VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses]

export type VotingPolicyVotingPoliciesVotingRecommendationsDestroyData = {
  body?: never
  path: {
    id: string
    voting_policy_id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/'
}

export type VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponse =
  VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses[keyof VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses]

export type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveData = {
  body?: never
  path: {
    id: string
    voting_policy_id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/'
}

export type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses = {
  200: VotingRecommendation
}

export type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponse =
  VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses[keyof VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses]

export type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateData = {
  body?: PatchedVotingRecommendationUpdateRequest
  path: {
    id: string
    voting_policy_id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/'
}

export type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses = {
  200: VotingRecommendation
}

export type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponse =
  VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses[keyof VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses]

export type VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateData = {
  body: UpdateVotingRecommendationFromPvrRequest
  path: {
    id: string
    voting_policy_id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/update-from-pvr/'
}

export type VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponses = {
  200: VotingRecommendation
}

export type VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponse =
  VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponses[keyof VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponses]

export type VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateData = {
  body?: VotingRecommendationSearchRequest
  path: {
    voting_policy_id: string
  }
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/search/'
}

export type VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponses = {
  200: PaginatedVotingRecommendationList
}

export type VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponse =
  VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponses[keyof VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponses]

export type VotingPolicyVotingPoliciesSearchCreateData = {
  body?: VotingPolicySearchRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/voting-policy/voting-policies/search/'
}

export type VotingPolicyVotingPoliciesSearchCreateResponses = {
  200: PaginatedVotingPolicyList
}

export type VotingPolicyVotingPoliciesSearchCreateResponse =
  VotingPolicyVotingPoliciesSearchCreateResponses[keyof VotingPolicyVotingPoliciesSearchCreateResponses]

export type VotingPolicyVotingRecommendationConfidenceScoresUpdateData = {
  body: VotingRecommendationConfidenceScoreUpsertRequest
  path: {
    version_id: string
  }
  query?: never
  url: '/voting-policy/voting-recommendation-confidence-scores/{version_id}/'
}

export type VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses = {
  200: VotingRecommendationConfidenceScore
  201: VotingRecommendationConfidenceScore
}

export type VotingPolicyVotingRecommendationConfidenceScoresUpdateResponse =
  VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses[keyof VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses]
